var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMinciencias(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#radial-gradient-157);}.cls-2{fill:#f29b98;}.cls-3{fill:url(#linear-gradient-75);}.cls-4{fill:url(#linear-gradient-374);}.cls-5{fill:url(#radial-gradient-177);}.cls-6{fill:#f3a6a5;}.cls-7{fill:url(#radial-gradient-99);}.cls-8{fill:url(#linear-gradient-119);}.cls-9{fill:url(#radial-gradient-39);}.cls-10{fill:#db7568;}.cls-11{fill:url(#linear-gradient-304);}.cls-12{fill:url(#linear-gradient-390);}.cls-13{fill:#f8c6c3;}.cls-14{fill:url(#linear-gradient-291);}.cls-15{fill:url(#radial-gradient-167);}.cls-16{fill:#e58179;}.cls-17{fill:#8d1d15;}.cls-18{fill:url(#radial-gradient-46);}.cls-19{fill:#d56858;}.cls-20{fill:url(#radial-gradient-230);}.cls-21{fill:url(#linear-gradient-277);}.cls-22{fill:#f5b3b0;}.cls-23{fill:url(#linear-gradient-2);}.cls-24{fill:url(#radial-gradient-162);}.cls-25{fill:url(#radial-gradient-211);}.cls-26{fill:#941e17;}.cls-27{fill:url(#radial-gradient-120);}.cls-28{fill:#fbe3e3;}.cls-29{fill:url(#radial-gradient-128);}.cls-30{fill:#cb5243;}.cls-31{fill:url(#radial-gradient-7);}.cls-32{fill:url(#linear-gradient-343);}.cls-33{fill:url(#linear-gradient-51);}.cls-34{fill:url(#radial-gradient-91);}.cls-35{fill:url(#radial-gradient-34);}.cls-36{fill:url(#radial-gradient-10);}.cls-37{fill:url(#radial-gradient-47);}.cls-38{fill:#ba281d;}.cls-39{fill:#be3224;}.cls-40{fill:#6f150f;}.cls-41{fill:url(#linear-gradient-138);}.cls-42{fill:url(#linear-gradient-367);}.cls-43{fill:url(#linear-gradient-257);}.cls-44{fill:#801b14;}.cls-45{fill:url(#linear-gradient-365);}.cls-46{fill:#fffbfb;}.cls-47{fill:url(#linear-gradient-308);}.cls-48{fill:url(#linear-gradient-265);}.cls-49{fill:#d16150;}.cls-50{fill:url(#linear-gradient-246);}.cls-51{fill:url(#radial-gradient-236);}.cls-52{fill:#5d5e63;}.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61{mix-blend-mode:multiply;}.cls-52,.cls-62{opacity:.4;}.cls-63{fill:url(#radial-gradient-125);}.cls-64{fill:#fff;}.cls-65{fill:url(#linear-gradient-168);}.cls-66{fill:#c34432;}.cls-67{fill:url(#linear-gradient-122);}.cls-68{fill:url(#linear-gradient-17);}.cls-69{fill:url(#radial-gradient-198);}.cls-70{fill:url(#radial-gradient-48);}.cls-71{fill:#ec8e87;}.cls-72{fill:url(#radial-gradient-31);}.cls-73{fill:url(#linear-gradient-87);}.cls-74{fill:#f3a1a0;}.cls-75{fill:#a62318;}.cls-76{fill:#e5817a;}.cls-77{fill:#f9fcff;}.cls-78{fill:url(#linear-gradient-332);}.cls-79{fill:url(#radial-gradient-72);}.cls-80{fill:url(#linear-gradient-258);}.cls-81{fill:url(#linear-gradient-150);}.cls-82{fill:#f8c8c7;}.cls-83{fill:#d05d4d;}.cls-84{fill:#fffdfd;}.cls-85{fill:url(#linear-gradient-93);}.cls-53{fill:url(#linear-gradient-385);}.cls-53,.cls-56{opacity:.5;}.cls-86{fill:url(#linear-gradient-92);}.cls-87{fill:url(#radial-gradient-100);}.cls-88{fill:url(#radial-gradient-146);}.cls-89{fill:url(#linear-gradient-238);}.cls-90{fill:url(#linear-gradient-147);}.cls-91{fill:#fcebea;}.cls-92{fill:url(#linear-gradient-80);}.cls-93{fill:url(#linear-gradient-192);}.cls-94{fill:url(#linear-gradient-364);}.cls-95{fill:url(#linear-gradient-188);}.cls-96{fill:url(#radial-gradient-175);}.cls-97{fill:#901f16;}.cls-98{fill:#ee938c;}.cls-99{fill:#881d14;}.cls-100{fill:url(#linear-gradient-109);}.cls-101{fill:url(#linear-gradient-43);}.cls-102{fill:url(#linear-gradient-125);}.cls-103{fill:#a52219;}.cls-104{fill:url(#radial-gradient-192);}.cls-105{fill:url(#radial-gradient-160);}.cls-106{fill:url(#linear-gradient-133);}.cls-107{fill:url(#radial-gradient-209);}.cls-108{fill:#f6b7b5;}.cls-109{fill:url(#linear-gradient-244);}.cls-110{fill:url(#radial-gradient-94);}.cls-111{stroke:#4ba137;stroke-width:.02px;}.cls-111,.cls-112,.cls-113,.cls-114,.cls-115{stroke-miterlimit:10;}.cls-111,.cls-112,.cls-113,.cls-114,.cls-116{fill:none;}.cls-117{fill:url(#radial-gradient-224);}.cls-118{fill:#af2619;}.cls-119{fill:url(#linear-gradient-164);}.cls-112{stroke:#522f16;}.cls-112,.cls-115{stroke-width:.1px;}.cls-120{fill:#be3626;}.cls-121{fill:url(#linear-gradient-263);}.cls-122{fill:url(#radial-gradient-111);}.cls-123{fill:url(#linear-gradient-333);}.cls-124{fill:url(#radial-gradient-207);}.cls-125{fill:#f8c9c7;}.cls-126{fill:url(#linear-gradient-347);}.cls-127{fill:url(#linear-gradient-306);}.cls-128{fill:#661e0f;}.cls-129{fill:#fad9d7;}.cls-130{fill:url(#linear-gradient-334);}.cls-131{fill:url(#linear-gradient-151);}.cls-132{fill:url(#linear-gradient-330);}.cls-133{fill:url(#linear-gradient-369);}.cls-134{fill:#f6e9b5;}.cls-135{fill:#b2261a;}.cls-136{fill:url(#linear-gradient-205);}.cls-137{fill:url(#linear-gradient-368);}.cls-138{fill:#f5afae;}.cls-139{fill:url(#radial-gradient-101);}.cls-140{fill:url(#radial-gradient-108);}.cls-141{fill:#9d2119;}.cls-142{fill:url(#linear-gradient-203);}.cls-143{fill:#c03e2d;}.cls-144{fill:url(#radial-gradient-28);}.cls-113{stroke:#ede319;}.cls-113,.cls-114{stroke-width:.78px;}.cls-145{fill:url(#linear-gradient-174);}.cls-146{fill:url(#linear-gradient-228);}.cls-147{fill:url(#linear-gradient-379);}.cls-148{fill:url(#linear-gradient-15);}.cls-149{fill:url(#linear-gradient-173);}.cls-150{fill:url(#linear-gradient-58);}.cls-151{fill:url(#radial-gradient-103);}.cls-152{fill:#b4261a;}.cls-153{fill:#fbe2e0;}.cls-154{fill:url(#linear-gradient-225);}.cls-155{fill:url(#radial-gradient-169);}.cls-156{fill:url(#linear-gradient-217);}.cls-157{fill:#671410;}.cls-158{fill:url(#linear-gradient-345);}.cls-159{fill:url(#radial-gradient-213);}.cls-160{fill:url(#linear-gradient-214);}.cls-161{fill:url(#linear-gradient-202);}.cls-162{fill:url(#linear-gradient-69);}.cls-163{fill:#f8cccb;}.cls-164{fill:url(#radial-gradient-89);}.cls-165{fill:url(#linear-gradient-282);}.cls-166{fill:#f8cecd;}.cls-167{fill:url(#linear-gradient-320);}.cls-168{fill:url(#linear-gradient-81);}.cls-169{fill:url(#linear-gradient-301);}.cls-170{fill:#e17d71;}.cls-171{fill:#e4e8e9;}.cls-172{fill:url(#radial-gradient-229);}.cls-173{fill:url(#linear-gradient-170);}.cls-174{fill:#fceeed;}.cls-175{fill:url(#linear-gradient-18);}.cls-176{fill:url(#linear-gradient-179);}.cls-177{fill:#f09691;}.cls-178{fill:url(#linear-gradient-56);}.cls-179{fill:url(#linear-gradient-270);}.cls-180{fill:url(#linear-gradient-167);}.cls-181{fill:#c94939;}.cls-182{fill:url(#radial-gradient-116);}.cls-183{fill:url(#radial-gradient-196);}.cls-184{fill:#b9261a;}.cls-185{fill:url(#radial-gradient-65);}.cls-186{fill:url(#radial-gradient-200);}.cls-187{fill:url(#linear-gradient-187);}.cls-188{fill:url(#linear-gradient-40);}.cls-189{fill:url(#linear-gradient-342);}.cls-190{fill:url(#radial-gradient-170);}.cls-191{fill:url(#radial-gradient-159);}.cls-192{fill:#ca5041;}.cls-193{fill:#ef948e;}.cls-194{fill:url(#linear-gradient-328);}.cls-195{fill:#cb5142;}.cls-196{fill:url(#linear-gradient-131);}.cls-54{fill:url(#linear-gradient-178);opacity:.66;}.cls-197{fill:url(#linear-gradient-52);}.cls-198{fill:url(#linear-gradient-28);}.cls-199{fill:url(#radial-gradient-16);}.cls-200{fill:url(#linear-gradient-186);}.cls-201{fill:url(#radial-gradient-234);}.cls-202{fill:url(#radial-gradient-57);}.cls-203{fill:url(#radial-gradient-144);}.cls-204{fill:url(#linear-gradient-160);}.cls-205{fill:url(#radial-gradient-140);}.cls-206{fill:url(#linear-gradient-221);}.cls-207{fill:#821b14;}.cls-208{fill:url(#radial-gradient-50);}.cls-209{fill:url(#radial-gradient-20);}.cls-210{fill:url(#linear-gradient-14);}.cls-211{fill:#db7366;}.cls-212{fill:url(#radial-gradient-21);}.cls-213{fill:#eabdad;}.cls-214{fill:url(#radial-gradient-8);}.cls-215{fill:url(#linear-gradient-361);}.cls-216{fill:#f9d0ce;}.cls-217{fill:url(#radial-gradient-168);}.cls-218{fill:url(#linear-gradient-208);}.cls-219{fill:#f7c3c2;}.cls-220{fill:url(#radial-gradient-119);}.cls-221{fill:url(#linear-gradient-36);}.cls-222{fill:#de766a;}.cls-223{fill:url(#radial-gradient-126);}.cls-224{fill:url(#linear-gradient-78);}.cls-225{fill:url(#linear-gradient-20);}.cls-226{fill:url(#radial-gradient-163);}.cls-227{fill:url(#linear-gradient-6);}.cls-228{fill:url(#linear-gradient-389);}.cls-229{fill:url(#linear-gradient-130);}.cls-230{fill:url(#radial-gradient-5);}.cls-231{fill:url(#linear-gradient-337);}.cls-232{fill:#4a8f3c;}.cls-233{fill:url(#radial-gradient-98);}.cls-234{fill:url(#linear-gradient-53);}.cls-235{fill:#a67923;}.cls-236{fill:url(#radial-gradient-4);}.cls-237{fill:url(#linear-gradient-329);}.cls-238{fill:#2b5c29;}.cls-239{fill:url(#radial-gradient-226);}.cls-240{isolation:isolate;}.cls-241{fill:#6f1510;}.cls-242{fill:#62130e;}.cls-243{fill:url(#radial-gradient-88);}.cls-244{fill:url(#linear-gradient-271);}.cls-55{fill:url(#linear-gradient-158);}.cls-245{fill:url(#radial-gradient-195);}.cls-246{fill:url(#linear-gradient-378);}.cls-247{fill:#e98980;}.cls-248{fill:url(#linear-gradient-315);}.cls-249{fill:url(#linear-gradient-319);}.cls-250{fill:url(#linear-gradient-296);}.cls-251{fill:#9a2018;}.cls-252{fill:url(#radial-gradient-121);}.cls-253{fill:url(#radial-gradient-90);}.cls-254{fill:url(#radial-gradient-225);}.cls-255{fill:#d6695c;}.cls-256{fill:url(#linear-gradient-339);}.cls-257{fill:url(#radial-gradient-67);}.cls-258{fill:#f9cfce;}.cls-259{fill:url(#linear-gradient-165);}.cls-260{fill:url(#linear-gradient-91);}.cls-261{fill:url(#radial-gradient-68);}.cls-262{fill:url(#radial-gradient-165);}.cls-263{fill:url(#radial-gradient-40);}.cls-264{fill:#a82318;}.cls-265{fill:#bf3a2b;}.cls-266{fill:url(#linear-gradient-60);}.cls-267{fill:url(#linear-gradient-240);}.cls-268{fill:#f4a9a7;}.cls-269{fill:#eae2ba;}.cls-270{fill:url(#radial-gradient-218);}.cls-271{fill:#f7c0bd;}.cls-272{fill:#f4abaa;}.cls-273{fill:#851b15;}.cls-274{fill:#c54635;}.cls-275{fill:#e28077;}.cls-276{fill:url(#linear-gradient-233);}.cls-277{fill:url(#linear-gradient-108);}.cls-278{fill:url(#linear-gradient-305);}.cls-279{fill:url(#linear-gradient-84);}.cls-280{fill:url(#radial-gradient-114);}.cls-281{fill:url(#radial-gradient-222);}.cls-282{fill:#6d1510;}.cls-283{fill:url(#radial-gradient-96);}.cls-284{fill:#f8cdca;}.cls-285{fill:url(#linear-gradient-331);}.cls-286{fill:url(#linear-gradient-199);}.cls-287{fill:url(#linear-gradient-229);}.cls-288{fill:url(#radial-gradient-64);}.cls-289{fill:#f6bcb9;}.cls-290{fill:#f7c1bf;}.cls-291{fill:url(#linear-gradient-191);}.cls-292{fill:url(#linear-gradient-136);}.cls-293{fill:url(#linear-gradient-312);}.cls-294{fill:#c54636;}.cls-295{fill:#d96d5e;}.cls-296{fill:url(#linear-gradient-104);}.cls-297{fill:url(#linear-gradient-128);}.cls-298{fill:url(#radial-gradient-161);}.cls-299{fill:url(#radial-gradient-148);}.cls-300{fill:url(#linear-gradient-357);}.cls-301{fill:#781613;}.cls-302{fill:#fadcd8;}.cls-303{fill:url(#linear-gradient-35);}.cls-304{fill:url(#linear-gradient-212);}.cls-305{fill:url(#radial-gradient-97);}.cls-306{fill:url(#linear-gradient-48);}.cls-307{fill:#fff9fa;}.cls-308{fill:url(#linear-gradient-210);}.cls-309{fill:url(#linear-gradient-381);}.cls-310{fill:url(#radial-gradient-32);}.cls-311{fill:#f4adab;}.cls-312{fill:url(#linear-gradient-213);}.cls-313{fill:url(#linear-gradient-275);}.cls-314{fill:url(#linear-gradient-32);}.cls-315{fill:url(#linear-gradient-241);}.cls-316{fill:url(#linear-gradient-120);}.cls-317{fill:url(#linear-gradient-335);}.cls-318{fill:url(#linear-gradient-317);}.cls-319{fill:url(#radial-gradient-147);}.cls-320{fill:url(#radial-gradient-78);}.cls-321{fill:#ad2519;}.cls-322{fill:url(#linear-gradient-146);}.cls-323{fill:url(#linear-gradient-232);}.cls-324{fill:url(#linear-gradient-201);}.cls-325{fill:url(#linear-gradient-97);}.cls-326{fill:url(#linear-gradient-185);}.cls-327{fill:url(#radial-gradient-52);}.cls-328{fill:#f4adac;}.cls-329{fill:url(#linear-gradient-382);}.cls-330{fill:#d86e60;}.cls-331{fill:url(#linear-gradient-182);}.cls-332{fill:url(#linear-gradient-349);}.cls-333{fill:#d46557;}.cls-334{fill:#b9281c;}.cls-335{fill:#ba2a1e;}.cls-336{fill:url(#radial-gradient-54);}.cls-337{fill:url(#linear-gradient-11);}.cls-338{fill:url(#radial-gradient-76);}.cls-339{fill:url(#radial-gradient-25);}.cls-340{fill:url(#linear-gradient-50);}.cls-341{fill:#ab2319;}.cls-342{fill:#de7b70;}.cls-343{fill:url(#linear-gradient-314);}.cls-344{fill:#751611;}.cls-345{fill:url(#linear-gradient-106);}.cls-346{fill:#f3a4a2;}.cls-347{fill:#c03d2d;}.cls-348{fill:url(#linear-gradient-111);}.cls-349{fill:url(#linear-gradient-289);}.cls-350{fill:url(#linear-gradient-169);}.cls-351{fill:url(#linear-gradient-251);}.cls-352{fill:url(#radial-gradient-26);}.cls-353{fill:url(#linear-gradient-293);}.cls-354{fill:#b6261b;}.cls-355{fill:url(#radial-gradient-210);}.cls-356{fill:url(#linear-gradient-189);}.cls-357{fill:url(#radial-gradient-136);}.cls-358{fill:url(#linear-gradient-63);}.cls-359{fill:url(#linear-gradient-67);}.cls-360{fill:#8b1d15;}.cls-56{fill:url(#linear-gradient-159);}.cls-361{fill:url(#linear-gradient-207);}.cls-362{fill:url(#linear-gradient-279);}.cls-363{fill:#cf5a49;}.cls-364{fill:#713f36;}.cls-365{fill:#681410;}.cls-366{fill:url(#linear-gradient-148);}.cls-367{fill:url(#linear-gradient-95);}.cls-368{fill:#b2241a;}.cls-369{fill:#17467c;}.cls-370{fill:#bd3324;}.cls-371{fill:url(#radial-gradient-142);}.cls-372{fill:#d15e4e;}.cls-373{fill:url(#linear-gradient-348);}.cls-374{fill:#fdf3f3;}.cls-375{fill:#711510;}.cls-376{fill:url(#linear-gradient-86);}.cls-377{fill:url(#radial-gradient-22);}.cls-378{fill:url(#radial-gradient-194);}.cls-379{fill:url(#linear-gradient-39);}.cls-380{fill:url(#radial-gradient-189);}.cls-381{fill:url(#radial-gradient-6);}.cls-382{fill:url(#radial-gradient-237);}.cls-383{fill:#c8c0c1;}.cls-384{fill:url(#linear-gradient-267);}.cls-385{fill:#c3402f;}.cls-114{stroke:#a67922;}.cls-386{fill:url(#linear-gradient-141);}.cls-387{fill:url(#linear-gradient-137);}.cls-388{fill:url(#linear-gradient-156);}.cls-389{fill:#fbe0df;}.cls-390{fill:url(#radial-gradient-19);}.cls-391{fill:url(#linear-gradient-110);}.cls-392{fill:#c34434;}.cls-393{fill:#6a1510;}.cls-394{fill:url(#radial-gradient-191);}.cls-57{fill:url(#linear-gradient-387);}.cls-395{fill:url(#radial-gradient-60);}.cls-396{fill:url(#linear-gradient-266);}.cls-397{fill:url(#radial-gradient-110);}.cls-398{fill:url(#linear-gradient-124);}.cls-399{fill:#932017;}.cls-400{fill:url(#radial-gradient-12);}.cls-401{fill:url(#linear-gradient-135);}.cls-402{fill:#f8ccca;}.cls-403{fill:url(#radial-gradient-135);}.cls-404{fill:#aa2318;}.cls-405{fill:url(#radial-gradient-55);}.cls-406{fill:url(#linear-gradient-10);}.cls-407{fill:url(#radial-gradient-49);}.cls-408{fill:#fdf4f4;}.cls-409{fill:url(#radial-gradient-182);}.cls-410{fill:#f3a5a4;}.cls-411{fill:url(#radial-gradient-223);}.cls-412{fill:#e98c85;}.cls-413{fill:url(#linear-gradient-248);}.cls-414{fill:#bc3022;}.cls-415{fill:url(#linear-gradient-341);}.cls-416{fill:url(#linear-gradient-59);}.cls-417{fill:#f09993;}.cls-418{fill:#c34130;}.cls-419{fill:#f39e9b;}.cls-420{fill:url(#radial-gradient-150);}.cls-421{fill:#f29d9b;}.cls-422{fill:url(#radial-gradient-41);}.cls-423{fill:#fdf1f1;}.cls-424{fill:url(#linear-gradient-355);}.cls-425{fill:url(#linear-gradient-143);}.cls-426{fill:url(#radial-gradient-181);}.cls-427{fill:url(#linear-gradient-303);}.cls-428{fill:#cd5646;}.cls-429{fill:url(#linear-gradient-362);}.cls-430{fill:#bd3222;}.cls-431{fill:url(#radial-gradient-152);}.cls-432{fill:url(#radial-gradient-35);}.cls-433{fill:url(#linear-gradient-351);}.cls-434{fill:url(#radial-gradient);}.cls-435{fill:url(#radial-gradient-75);}.cls-436{fill:url(#radial-gradient-173);}.cls-437{fill:#8d5d4f;}.cls-438{fill:#801a14;}.cls-439{fill:url(#linear-gradient-171);}.cls-440{fill:url(#linear-gradient-190);}.cls-441{fill:#c34030;}.cls-442{fill:url(#linear-gradient-117);}.cls-443{fill:url(#linear-gradient-350);}.cls-444{fill:#ce5546;}.cls-445{fill:url(#linear-gradient-340);}.cls-446{fill:url(#linear-gradient-224);}.cls-447{fill:#bf3929;}.cls-448{fill:url(#radial-gradient-158);}.cls-58{fill:url(#linear-gradient-386);}.cls-449{fill:url(#linear-gradient-371);}.cls-450{fill:url(#linear-gradient-223);}.cls-451{fill:url(#radial-gradient-79);}.cls-452{fill:#de776b;}.cls-453{fill:#bd3325;}.cls-454{fill:url(#radial-gradient-81);}.cls-455{fill:url(#linear-gradient-272);}.cls-456{fill:url(#radial-gradient-219);}.cls-457{fill:#fadcda;}.cls-458{fill:url(#linear-gradient-376);}.cls-459{fill:url(#linear-gradient-338);}.cls-460{fill:#fce7e5;}.cls-461{fill:#eb908a;}.cls-462{fill:url(#linear-gradient-230);}.cls-463{fill:url(#linear-gradient-288);}.cls-464{fill:#c44535;}.cls-465{fill:url(#radial-gradient-123);}.cls-466{fill:url(#linear-gradient-49);}.cls-467{fill:url(#linear-gradient-37);}.cls-468{fill:#b9281d;}.cls-469{fill:url(#linear-gradient-297);}.cls-470{fill:url(#linear-gradient-307);}.cls-471{fill:url(#radial-gradient-27);}.cls-472{fill:#651410;}.cls-473{fill:url(#linear-gradient-152);}.cls-474{fill:#f6b6b3;}.cls-475{fill:url(#radial-gradient-13);}.cls-476{fill:url(#radial-gradient-208);}.cls-477{fill:url(#linear-gradient-82);}.cls-478{fill:url(#radial-gradient-69);}.cls-479{fill:#921f17;}.cls-480{fill:url(#radial-gradient-102);}.cls-115{fill:#090808;stroke:#d5491b;}.cls-481{fill:url(#linear-gradient-16);}.cls-482{fill:#c03c2b;}.cls-483{fill:#c94c3d;}.cls-484{fill:url(#radial-gradient-201);}.cls-485{fill:url(#linear-gradient-384);}.cls-486{fill:url(#linear-gradient-281);}.cls-487{fill:#fad9d6;}.cls-488{fill:url(#radial-gradient-174);}.cls-489{fill:#cf5949;}.cls-490{fill:url(#radial-gradient-105);}.cls-491{fill:url(#radial-gradient-141);}.cls-492{fill:url(#radial-gradient-178);}.cls-493{fill:url(#radial-gradient-145);}.cls-494{fill:url(#linear-gradient-353);}.cls-495{fill:url(#radial-gradient-217);}.cls-496{fill:url(#linear-gradient-250);}.cls-497{fill:#9c2119;}.cls-498{fill:#b9261c;}.cls-499{fill:url(#linear-gradient-161);}.cls-500{fill:#bb2c20;}.cls-501{fill:#f5b5b2;}.cls-502{fill:url(#linear-gradient-31);}.cls-503{fill:url(#linear-gradient-273);}.cls-504{fill:#c94e3f;}.cls-505{fill:url(#linear-gradient-85);}.cls-506{fill:url(#radial-gradient-130);}.cls-507{fill:url(#linear-gradient-287);}.cls-508{fill:url(#linear-gradient-154);}.cls-509{fill:#e6857e;}.cls-510{fill:#cb5041;}.cls-511{fill:#f9d2d0;}.cls-512{fill:url(#radial-gradient-129);}.cls-513{fill:url(#linear-gradient-127);}.cls-514{fill:url(#linear-gradient-112);}.cls-515{fill:#c03d2c;}.cls-516{fill:#f3a4a3;}.cls-517{fill:url(#linear-gradient-262);}.cls-518{fill:url(#radial-gradient-232);}.cls-519{fill:#ba2a1f;}.cls-520{fill:url(#radial-gradient-74);}.cls-521{fill:url(#linear-gradient-61);}.cls-522{fill:url(#radial-gradient-212);}.cls-523{fill:url(#radial-gradient-238);}.cls-524{fill:#c34431;}.cls-525{fill:url(#linear-gradient-114);}.cls-526{fill:url(#linear-gradient-68);}.cls-527{fill:url(#linear-gradient-194);}.cls-528{fill:url(#linear-gradient-103);}.cls-529{fill:#db7365;}.cls-530{fill:url(#linear-gradient-62);}.cls-531{fill:url(#linear-gradient-231);}.cls-532{fill:url(#radial-gradient-109);}.cls-533{fill:url(#linear-gradient-107);}.cls-534{fill:url(#linear-gradient-41);}.cls-535{fill:url(#linear-gradient-253);}.cls-536{fill:url(#radial-gradient-176);}.cls-537{fill:#f3a19f;}.cls-538{fill:url(#radial-gradient-153);}.cls-539{fill:url(#radial-gradient-127);}.cls-540{fill:url(#linear-gradient-76);}.cls-541{fill:#af241a;}.cls-542{fill:url(#linear-gradient-211);}.cls-543{fill:url(#linear-gradient-98);}.cls-544{fill:url(#radial-gradient-183);}.cls-545{fill:#f6bcba;}.cls-546{fill:#e38075;}.cls-547{fill:#6b1510;}.cls-548{fill:url(#linear-gradient-235);}.cls-549{fill:url(#radial-gradient-220);}.cls-550{fill:url(#radial-gradient-154);}.cls-551{fill:#da1413;}.cls-552{fill:#bf3727;}.cls-553{fill:url(#radial-gradient-171);}.cls-554{fill:url(#radial-gradient-92);}.cls-555{fill:url(#linear-gradient-299);}.cls-556{fill:#7d1a14;}.cls-557{fill:#901e16;}.cls-558{fill:url(#linear-gradient-21);}.cls-559{fill:#962018;}.cls-560{fill:#661410;}.cls-561{fill:url(#linear-gradient-72);}.cls-562{fill:url(#linear-gradient-356);}.cls-563{fill:url(#linear-gradient-219);}.cls-564{fill:#a22118;}.cls-565{fill:url(#linear-gradient-380);}.cls-566{fill:url(#linear-gradient-243);}.cls-567{fill:url(#linear-gradient-245);}.cls-568{fill:#c84838;}.cls-569{fill:url(#radial-gradient-104);}.cls-570{fill:url(#linear-gradient-290);}.cls-571{fill:#ce5444;}.cls-572{fill:#c34232;}.cls-573{fill:url(#radial-gradient-205);}.cls-574{fill:#fbae2a;}.cls-575{fill:#f4aaa9;}.cls-576{fill:#f8c7c4;}.cls-577{fill:url(#radial-gradient-43);}.cls-578{fill:#851b14;}.cls-579{fill:url(#linear-gradient-252);}.cls-580{fill:url(#radial-gradient-30);}.cls-581{fill:#cf5948;}.cls-582{fill:url(#radial-gradient-66);}.cls-583{fill:url(#linear-gradient-25);}.cls-584{fill:url(#radial-gradient-118);}.cls-585{fill:url(#radial-gradient-86);}.cls-586{fill:url(#linear-gradient-121);}.cls-587{fill:url(#linear-gradient-89);}.cls-588{fill:#fbdedb;}.cls-589{fill:url(#radial-gradient-95);}.cls-590{fill:#f7c0be;}.cls-591{fill:url(#radial-gradient-51);}.cls-592{fill:url(#radial-gradient-151);}.cls-593{fill:url(#radial-gradient-233);}.cls-594{fill:url(#linear-gradient-336);}.cls-595{fill:url(#linear-gradient-144);}.cls-596{fill:#df2f19;}.cls-597{fill:url(#linear-gradient-5);}.cls-598{fill:url(#linear-gradient-64);}.cls-599{fill:url(#linear-gradient-222);}.cls-600{fill:url(#linear-gradient-206);}.cls-601{fill:url(#linear-gradient-198);}.cls-602{fill:url(#radial-gradient-61);}.cls-603{fill:url(#radial-gradient-24);}.cls-604{fill:url(#linear-gradient-326);}.cls-605{fill:url(#linear-gradient-102);}.cls-606{fill:#f9d4d1;}.cls-607{fill:url(#linear-gradient-184);}.cls-608{fill:url(#radial-gradient-58);}.cls-609{fill:#f8c6c5;}.cls-59{fill:url(#linear-gradient-157);}.cls-610{fill:#8f1d15;}.cls-611{fill:url(#linear-gradient-83);}.cls-612{fill:url(#linear-gradient-318);}.cls-613{fill:url(#radial-gradient-87);}.cls-614{fill:#a32119;}.cls-615{fill:#fbdfde;}.cls-616{fill:url(#linear-gradient-313);}.cls-617{fill:url(#linear-gradient-54);}.cls-618{fill:url(#linear-gradient-373);}.cls-619{fill:url(#radial-gradient-15);}.cls-620{fill:url(#linear-gradient-370);}.cls-621{fill:url(#linear-gradient-45);}.cls-622{fill:url(#linear-gradient-278);}.cls-623{fill:#ba281e;}.cls-624{fill:#8e7450;}.cls-625{fill:url(#linear-gradient-113);}.cls-626{fill:url(#linear-gradient-55);}.cls-627{fill:#326433;}.cls-628{clip-path:url(#clippath);}.cls-629{fill:url(#radial-gradient-2);}.cls-630{fill:url(#linear-gradient-175);}.cls-631{fill:#faddda;}.cls-632{fill:#7c1914;}.cls-633{fill:#f6b9b6;}.cls-634{fill:url(#linear-gradient-259);}.cls-635{fill:url(#radial-gradient-133);}.cls-636{fill:url(#radial-gradient-215);}.cls-637{fill:url(#linear-gradient-242);}.cls-638{fill:url(#linear-gradient-34);}.cls-639{fill:url(#linear-gradient-118);}.cls-640{fill:#d46456;}.cls-641{fill:url(#linear-gradient-140);}.cls-642{fill:#d97063;}.cls-643{fill:url(#linear-gradient-283);}.cls-644{fill:url(#linear-gradient-65);}.cls-645{fill:url(#radial-gradient-203);}.cls-646{fill:url(#radial-gradient-143);}.cls-647{fill:url(#linear-gradient-70);}.cls-648{fill:url(#radial-gradient-93);}.cls-649{fill:#bb2e20;}.cls-62{fill:#7b451a;}.cls-650{fill:url(#linear-gradient-276);}.cls-651{fill:url(#radial-gradient-106);}.cls-652{fill:url(#radial-gradient-122);}.cls-653{fill:url(#linear-gradient-216);}.cls-654{fill:#965f4a;}.cls-655{fill:#8a1c14;}.cls-656{fill:#d05c4b;}.cls-657{fill:url(#linear-gradient-195);}.cls-658{fill:#891c14;}.cls-659{fill:url(#linear-gradient-260);}.cls-660{fill:url(#radial-gradient-38);}.cls-661{fill:#bb2b1e;}.cls-662{fill:url(#linear-gradient-298);}.cls-663{fill:#8b1c15;}.cls-664{fill:url(#linear-gradient-383);}.cls-665{fill:url(#linear-gradient-294);}.cls-666{fill:url(#linear-gradient-79);}.cls-667{fill:url(#radial-gradient-3);}.cls-668{fill:url(#linear-gradient-249);}.cls-669{fill:url(#radial-gradient-80);}.cls-670{fill:#831b14;}.cls-671{fill:url(#linear-gradient-153);}.cls-672{fill:url(#linear-gradient-269);}.cls-673{fill:#fcedec;}.cls-674{fill:#b9271c;}.cls-675{fill:url(#linear-gradient-88);}.cls-676{fill:url(#radial-gradient-227);}.cls-677{fill:url(#linear-gradient-220);}.cls-678{fill:url(#linear-gradient-7);}.cls-679{fill:url(#radial-gradient-188);}.cls-680{fill:url(#linear-gradient-134);}.cls-681{fill:url(#radial-gradient-56);}.cls-682{fill:url(#linear-gradient-295);}.cls-683{fill:url(#radial-gradient-187);}.cls-684{fill:url(#radial-gradient-42);}.cls-685{fill:url(#linear-gradient-149);}.cls-686{fill:url(#radial-gradient-124);}.cls-687{fill:url(#radial-gradient-53);}.cls-688{fill:url(#linear-gradient-346);}.cls-689{fill:url(#linear-gradient-163);}.cls-690{fill:url(#linear-gradient-197);}.cls-691{fill:url(#linear-gradient-66);}.cls-692{fill:#7c1913;}.cls-693{fill:url(#radial-gradient-172);}.cls-694{fill:url(#radial-gradient-190);}.cls-695{fill:#c6714f;}.cls-696{fill:#f7bfbc;}.cls-697{fill:#e5837b;}.cls-698{fill:url(#linear-gradient-352);}.cls-699{fill:url(#radial-gradient-115);}.cls-700{fill:#e98a83;}.cls-701{fill:url(#linear-gradient-302);}.cls-702{fill:url(#radial-gradient-193);}.cls-703{fill:url(#linear-gradient-286);}.cls-704{fill:#f4acaa;}.cls-705{fill:#f5b4b1;}.cls-706{fill:url(#linear-gradient-309);}.cls-707{fill:#de796c;}.cls-708{fill:url(#linear-gradient-359);}.cls-709{fill:url(#linear-gradient-96);}.cls-710{fill:#64130f;}.cls-711{fill:#de7a6f;}.cls-712{fill:url(#linear-gradient-162);}.cls-713{fill:#63130f;}.cls-714{fill:url(#linear-gradient-204);}.cls-715{fill:url(#radial-gradient-164);}.cls-716{fill:url(#radial-gradient-139);}.cls-717{fill:#d05c4c;}.cls-718{fill:url(#radial-gradient-202);}.cls-719{fill:#d16151;}.cls-720{fill:url(#linear-gradient-264);}.cls-721{fill:#781612;}.cls-722{fill:#e17e74;}.cls-723{fill:url(#linear-gradient-24);}.cls-724{fill:url(#linear-gradient-73);}.cls-725{fill:#feab29;}.cls-726{fill:url(#linear-gradient-155);}.cls-727{fill:url(#linear-gradient-360);}.cls-728{mix-blend-mode:overlay;}.cls-729{fill:#d91614;}.cls-730{fill:url(#linear-gradient-139);}.cls-731{fill:#c54838;}.cls-732{fill:#fcfafb;}.cls-733{fill:url(#linear-gradient-100);}.cls-734{fill:#f3a3a1;}.cls-735{fill:#bb2e22;}.cls-736{fill:#ab2519;}.cls-737{fill:#a5221a;}.cls-738{fill:#f5b0ae;}.cls-739{fill:#e6867e;}.cls-740{fill:#be3326;}.cls-741{fill:url(#linear-gradient-234);}.cls-742{fill:url(#radial-gradient-149);}.cls-743{fill:url(#radial-gradient-45);}.cls-744{fill:url(#radial-gradient-186);}.cls-745{fill:#741611;}.cls-746{fill:#fceae8;}.cls-747{fill:url(#linear-gradient-324);}.cls-748{fill:url(#linear-gradient-227);}.cls-749{fill:url(#linear-gradient-105);}.cls-750{fill:url(#linear-gradient-9);}.cls-751{fill:url(#radial-gradient-17);}.cls-752{fill:url(#radial-gradient-185);}.cls-753{fill:url(#linear-gradient-129);}.cls-754{fill:#d6685a;}.cls-755{fill:url(#radial-gradient-85);}.cls-756{fill:#f6bab7;}.cls-757{fill:url(#linear-gradient-22);}.cls-758{fill:#7b1913;}.cls-759{fill:url(#linear-gradient-215);}.cls-760{fill:#d26050;}.cls-761{fill:url(#linear-gradient-344);}.cls-762{fill:#fce8e6;}.cls-763{fill:#f9d3d1;}.cls-764{fill:url(#linear-gradient-239);}.cls-765{fill:#f29d9a;}.cls-766{fill:#f39f9d;}.cls-767{fill:url(#linear-gradient-74);}.cls-768{fill:url(#linear-gradient-323);}.cls-769{fill:url(#linear-gradient-358);}.cls-770{fill:url(#linear-gradient-42);}.cls-771{fill:#fbe4e2;}.cls-772{fill:url(#linear-gradient-99);}.cls-773{fill:url(#radial-gradient-33);}.cls-774{fill:url(#linear-gradient-285);}.cls-775{fill:url(#radial-gradient-84);}.cls-776{fill:url(#linear-gradient-172);}.cls-777{fill:url(#linear-gradient-274);}.cls-778{fill:url(#linear-gradient-200);}.cls-779{fill:url(#radial-gradient-14);}.cls-780{fill:url(#linear-gradient-166);}.cls-781{fill:url(#radial-gradient-83);}.cls-782{fill:url(#linear-gradient-196);}.cls-783{fill:url(#radial-gradient-216);}.cls-784{fill:url(#linear-gradient-280);}.cls-785{fill:url(#linear-gradient-226);}.cls-786{fill:url(#radial-gradient-107);}.cls-787{fill:url(#linear-gradient-3);}.cls-788{fill:url(#radial-gradient-235);}.cls-789{fill:#bb2b20;}.cls-790{fill:url(#radial-gradient-206);}.cls-60{fill:url(#linear-gradient-388);}.cls-791{fill:#d66c5d;}.cls-792{fill:url(#radial-gradient-131);}.cls-793{fill:url(#linear-gradient-322);}.cls-794{fill:url(#radial-gradient-113);}.cls-795{fill:#be3527;}.cls-796{fill:url(#linear-gradient-123);}.cls-797{fill:url(#radial-gradient-117);}.cls-798{fill:#a02119;}.cls-799{fill:#fff9f9;}.cls-800{fill:url(#linear-gradient-254);}.cls-801{fill:#3b1915;}.cls-802{fill:url(#radial-gradient-37);}.cls-803{fill:#731610;}.cls-804{fill:url(#radial-gradient-166);}.cls-805{fill:url(#linear-gradient-321);}.cls-806{fill:url(#radial-gradient-71);}.cls-807{fill:#c94c3b;}.cls-808{fill:#c94a3a;}.cls-809{fill:url(#linear-gradient-300);}.cls-810{fill:#d1604f;}.cls-811{fill:#e98780;}.cls-812{fill:url(#linear-gradient);}.cls-813{fill:url(#radial-gradient-137);}.cls-814{fill:url(#radial-gradient-197);}.cls-815{fill:url(#linear-gradient-181);}.cls-816{fill:url(#radial-gradient-180);}.cls-817{fill:url(#linear-gradient-193);}.cls-818{fill:url(#linear-gradient-237);}.cls-819{fill:url(#linear-gradient-177);}.cls-820{fill:#cb763d;}.cls-821{fill:url(#radial-gradient-29);}.cls-822{fill:#f3a29f;}.cls-823{fill:url(#linear-gradient-176);}.cls-824{fill:url(#linear-gradient-27);}.cls-825{fill:#6d150f;}.cls-826{fill:url(#linear-gradient-363);}.cls-827{fill:url(#linear-gradient-116);}.cls-828{fill:url(#linear-gradient-132);}.cls-829{fill:url(#linear-gradient-247);}.cls-830{fill:url(#radial-gradient-156);}.cls-831{fill:url(#radial-gradient-155);}.cls-832{fill:#982018;}.cls-833{fill:url(#linear-gradient-377);}.cls-834{fill:url(#radial-gradient-62);}.cls-835{fill:#d46455;}.cls-836{fill:#f4a9a6;}.cls-837{fill:#cc5443;}.cls-838{fill:#f6bdba;}.cls-839{fill:#f4a8a6;}.cls-840{fill:#871c14;}.cls-841{fill:#ede319;}.cls-842{fill:#c94d3d;}.cls-843{fill:#821a14;}.cls-844{fill:url(#radial-gradient-82);}.cls-845{fill:url(#linear-gradient-375);}.cls-846{fill:url(#linear-gradient-33);}.cls-847{fill:url(#linear-gradient-142);}.cls-848{fill:url(#radial-gradient-231);}.cls-849{fill:url(#linear-gradient-255);}.cls-850{fill:url(#linear-gradient-38);}.cls-851{fill:url(#radial-gradient-112);}.cls-852{fill:#f8cac9;}.cls-853{fill:url(#linear-gradient-366);}.cls-854{fill:#f29d9c;}.cls-855{fill:url(#linear-gradient-94);}.cls-856{fill:#fdf7f8;}.cls-857{fill:#f19995;}.cls-858{fill:url(#linear-gradient-284);}.cls-859{fill:url(#linear-gradient-29);}.cls-860{fill:#f5b2b0;}.cls-861{fill:url(#radial-gradient-138);}.cls-61{fill:#594745;opacity:.6;}.cls-862{fill:#fdf6f6;}.cls-863{fill:url(#radial-gradient-134);}.cls-864{fill:#f7c3c0;}.cls-865{fill:#bf392b;}.cls-866{fill:url(#radial-gradient-199);}.cls-867{fill:url(#linear-gradient-30);}.cls-868{fill:#a22119;}.cls-869{fill:url(#radial-gradient-59);}.cls-870{fill:#5d5550;}.cls-871{fill:url(#radial-gradient-184);}.cls-872{fill:url(#linear-gradient-218);}.cls-873{fill:url(#radial-gradient-23);}.cls-874{fill:url(#radial-gradient-179);}.cls-875{fill:#b5261b;}.cls-876{fill:url(#radial-gradient-63);}.cls-877{fill:#931e17;}.cls-878{fill:url(#linear-gradient-354);}.cls-879{fill:url(#linear-gradient-268);}.cls-880{fill:url(#linear-gradient-261);}.cls-881{fill:url(#linear-gradient-325);}.cls-882{fill:url(#radial-gradient-36);}.cls-883{fill:#d05b4a;}.cls-884{fill:url(#linear-gradient-126);}.cls-885{fill:#fdf0ef;}.cls-886{fill:#f5b0ad;}.cls-887{fill:url(#linear-gradient-23);}.cls-888{fill:url(#linear-gradient-19);}.cls-889{fill:#f9d1cf;}.cls-890{fill:#fbe1df;}.cls-891{fill:url(#radial-gradient-70);}.cls-892{fill:url(#linear-gradient-71);}.cls-893{fill:#f9d6d4;}.cls-894{fill:url(#linear-gradient-4);}.cls-895{fill:url(#linear-gradient-236);}.cls-896{fill:url(#linear-gradient-77);}.cls-897{fill:url(#radial-gradient-11);}.cls-898{fill:url(#radial-gradient-18);}.cls-899{fill:#bd3223;}.cls-900{fill:url(#radial-gradient-228);}.cls-901{fill:#c9493b;}.cls-902{fill:#972018;}.cls-903{fill:url(#radial-gradient-77);}.cls-904{fill:url(#linear-gradient-292);}.cls-905{fill:url(#linear-gradient-115);}.cls-906{fill:url(#linear-gradient-209);}.cls-907{fill:url(#linear-gradient-256);}.cls-908{fill:#131311;}.cls-909{fill:#761612;}.cls-910{fill:url(#radial-gradient-9);}.cls-911{fill:#7f1a14;}.cls-912{fill:#1d1d1b;}.cls-913{fill:#791913;}.cls-914{fill:#c13a2b;}.cls-915{fill:url(#radial-gradient-214);}.cls-916{fill:url(#linear-gradient-8);}.cls-917{fill:url(#radial-gradient-73);}.cls-918{fill:#801b15;}.cls-919{fill:url(#linear-gradient-90);}.cls-920{fill:#fdf1f0;}.cls-921{fill:url(#linear-gradient-44);}.cls-922{fill:#d46454;}.cls-923{fill:url(#linear-gradient-57);}.cls-924{fill:url(#radial-gradient-44);}.cls-925{fill:url(#radial-gradient-204);}.cls-926{fill:url(#linear-gradient-180);}.cls-927{fill:#874c1c;}.cls-928{fill:url(#linear-gradient-47);}.cls-929{fill:#a62219;}.cls-930{fill:url(#linear-gradient-46);}.cls-931{fill:url(#linear-gradient-145);}.cls-932{fill:url(#radial-gradient-221);}.cls-933{fill:url(#linear-gradient-183);}.cls-934{fill:url(#linear-gradient-311);}.cls-935{fill:url(#linear-gradient-12);}.cls-936{fill:#b1241a;}.cls-937{fill:#fceae7;}.cls-938{fill:url(#linear-gradient-316);}.cls-939{fill:url(#linear-gradient-13);}.cls-940{fill:url(#linear-gradient-372);}.cls-941{fill:url(#radial-gradient-132);}.cls-942{fill:#992018;}.cls-943{fill:url(#linear-gradient-26);}.cls-944{fill:#d97061;}.cls-945{fill:#721610;}.cls-946{fill:url(#linear-gradient-327);}.cls-947{fill:#be3525;}.cls-948{fill:url(#linear-gradient-101);}.cls-949{fill:url(#linear-gradient-310);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 109.47,
    y1: -8.85,
    x2: 106.72,
    y2: -8.85,
    gradientTransform: "translate(-9.09 74.03) rotate(7.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#885136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#7d3624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#5f2915"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#a06434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532511"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 579.71,
    y1: -559.11,
    x2: 581.17,
    y2: -560.78,
    gradientTransform: "translate(-624.41 -282.33) rotate(70.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#885136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7d3624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5f2915"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#a06434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532511"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 578.07,
    y1: -558.35,
    x2: 579.53,
    y2: -560.02,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 721.6,
    y1: -619.63,
    x2: 723.05,
    y2: -621.28,
    gradientTransform: "translate(-631.9 -333) rotate(70.57) scale(.87 .89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 719.48,
    y1: -620.21,
    x2: 720.93,
    y2: -621.86,
    gradientTransform: "translate(-631.9 -333) rotate(70.57) scale(.87 .89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 611.85,
    y1: -481.42,
    x2: 613.44,
    y2: -483.23,
    gradientTransform: "translate(-592.5 -284.58) rotate(65.76)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 610.15,
    y1: -480.66,
    x2: 611.73,
    y2: -482.46,
    gradientTransform: "translate(-592.5 -284.58) rotate(65.76)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 608.45,
    y1: -479.88,
    x2: 610.03,
    y2: -481.69,
    gradientTransform: "translate(-592.5 -284.58) rotate(65.76)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 758.07,
    y1: -530.3,
    x2: 759.64,
    y2: -532.1,
    gradientTransform: "translate(-604.16 -336.01) rotate(65.77) scale(.87 .89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 755.9,
    y1: -530.8,
    x2: 757.47,
    y2: -532.6,
    gradientTransform: "translate(-604.16 -336.01) rotate(65.77) scale(.87 .89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 635.41,
    y1: -403.89,
    x2: 637.13,
    y2: -405.85,
    gradientTransform: "translate(-561.74 -290.82) rotate(61.27)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 633.66,
    y1: -403.12,
    x2: 635.37,
    y2: -405.06,
    gradientTransform: "translate(-561.74 -290.82) rotate(61.27)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 631.91,
    y1: -402.34,
    x2: 633.61,
    y2: -404.29,
    gradientTransform: "translate(-561.74 -290.82) rotate(61.27)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 647.55,
    y1: -392.95,
    x2: 649.9,
    y2: -395.03,
    gradientTransform: "translate(-602.27 -221.6) rotate(54)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 646.65,
    y1: -392.24,
    x2: 649.02,
    y2: -394.35,
    gradientTransform: "translate(-602.27 -221.6) rotate(54)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 591.62,
    y1: -540.91,
    x2: 593.81,
    y2: -542.86,
    gradientTransform: "translate(-659.09 -203.3) rotate(62.43)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 590.87,
    y1: -540.07,
    x2: 593.04,
    y2: -542,
    gradientTransform: "translate(-659.09 -203.3) rotate(62.43)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 421.93,
    y1: -504.75,
    x2: 423.35,
    y2: -505.89,
    gradientTransform: "translate(-567.14 -199.67) rotate(66.67) scale(1.24 1) skewX(1.07)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c26d37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#7d3624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532511"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 604.44,
    y1: -493.93,
    x2: 605.75,
    y2: -495.96,
    gradientTransform: "translate(-599.25 -283.31) rotate(66.07)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 575.78,
    y1: -563.5,
    x2: 576.91,
    y2: -565.25,
    gradientTransform: "translate(-629.44 -281.33) rotate(70.12)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 747.93,
    y1: -618.19,
    x2: 749.04,
    y2: -619.91,
    gradientTransform: "translate(-637.35 -344.91) rotate(70.12) scale(.85 .89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 602.06,
    y1: -490.48,
    x2: 603.55,
    y2: -492.41,
    gradientTransform: "translate(-599.25 -283.31) rotate(66.07)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -1051.76,
    y1: -160.56,
    x2: -1054.5,
    y2: -160.56,
    gradientTransform: "translate(-944.02 -184.65) rotate(-157.01) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -90.78,
    y1: 400.71,
    x2: -89.32,
    y2: 399.05,
    gradientTransform: "translate(-233.19 -171.89) rotate(140.4) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -92.44,
    y1: 401.47,
    x2: -90.97,
    y2: 399.8,
    gradientTransform: "translate(-233.19 -171.89) rotate(140.4) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -49.62,
    y1: 465.74,
    x2: -48.16,
    y2: 464.08,
    gradientTransform: "translate(-200.75 -213.01) rotate(140.4) scale(.87 -.89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -51.73,
    y1: 465.16,
    x2: -50.28,
    y2: 463.51,
    gradientTransform: "translate(-200.75 -213.01) rotate(140.4) scale(.87 -.89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -135.63,
    y1: 419.53,
    x2: -134.04,
    y2: 417.71,
    gradientTransform: "translate(-258.99 -191.43) rotate(145.2) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -137.33,
    y1: 420.3,
    x2: -135.74,
    y2: 418.49,
    gradientTransform: "translate(-258.99 -191.43) rotate(145.2) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -139.04,
    y1: 421.06,
    x2: -137.46,
    y2: 419.25,
    gradientTransform: "translate(-258.99 -191.43) rotate(145.2) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -101.51,
    y1: 487.63,
    x2: -99.93,
    y2: 485.83,
    gradientTransform: "translate(-221.83 -230.36) rotate(145.2) scale(.87 -.89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -103.67,
    y1: 487.13,
    x2: -102.09,
    y2: 485.33,
    gradientTransform: "translate(-221.83 -230.36) rotate(145.2) scale(.87 -.89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -180.79,
    y1: 436.46,
    x2: -179.08,
    y2: 434.51,
    gradientTransform: "translate(-282.83 -213.08) rotate(149.7) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -182.54,
    y1: 437.24,
    x2: -180.83,
    y2: 435.29,
    gradientTransform: "translate(-282.83 -213.08) rotate(149.7) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -184.3,
    y1: 438.01,
    x2: -182.58,
    y2: 436.05,
    gradientTransform: "translate(-282.83 -213.08) rotate(149.7) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -269.09,
    y1: 336.23,
    x2: -266.72,
    y2: 334.13,
    gradientTransform: "translate(-283.84 -131.47) rotate(156.97) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -269.97,
    y1: 336.91,
    x2: -267.61,
    y2: 334.82,
    gradientTransform: "translate(-283.84 -131.47) rotate(156.97) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -206.91,
    y1: 314.7,
    x2: -204.73,
    y2: 312.76,
    gradientTransform: "translate(-243.39 -87.31) rotate(148.54) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -207.67,
    y1: 315.56,
    x2: -205.48,
    y2: 313.61,
    gradientTransform: "translate(-243.39 -87.31) rotate(148.54) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -187.39,
    y1: 407.46,
    x2: -185.97,
    y2: 406.32,
    gradientTransform: "translate(-324.47 -131.68) rotate(144.3) scale(1.24 -1) skewX(1.07)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -137.83,
    y1: 411.15,
    x2: -136.52,
    y2: 409.13,
    gradientTransform: "translate(-253.65 -187.18) rotate(144.89) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -100.98,
    y1: 391.86,
    x2: -99.85,
    y2: 390.11,
    gradientTransform: "translate(-228.97 -169.86) rotate(140.84) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -46.71,
    y1: 458.66,
    x2: -45.59,
    y2: 456.92,
    gradientTransform: "translate(-189.97 -219.43) rotate(140.84) scale(.85 -.89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -140.21,
    y1: 414.6,
    x2: -138.73,
    y2: 412.69,
    gradientTransform: "translate(-253.65 -187.18) rotate(144.89) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 578.07,
    y1: -558.35,
    x2: 579.53,
    y2: -560.02,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 721.6,
    y1: -619.63,
    x2: 723.05,
    y2: -621.28,
    gradientTransform: "translate(-631.9 -333) rotate(70.57) scale(.87 .89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 719.48,
    y1: -620.21,
    x2: 720.93,
    y2: -621.86,
    gradientTransform: "translate(-631.9 -333) rotate(70.57) scale(.87 .89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 611.85,
    y1: -481.42,
    x2: 613.44,
    y2: -483.23,
    gradientTransform: "translate(-592.5 -284.58) rotate(65.76)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 610.15,
    y1: -480.66,
    x2: 611.73,
    y2: -482.46,
    gradientTransform: "translate(-592.5 -284.58) rotate(65.76)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 608.45,
    y1: -479.88,
    x2: 610.03,
    y2: -481.69,
    gradientTransform: "translate(-592.5 -284.58) rotate(65.76)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 758.07,
    y1: -530.3,
    x2: 759.64,
    y2: -532.1,
    gradientTransform: "translate(-604.16 -336.01) rotate(65.77) scale(.87 .89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 755.9,
    y1: -530.8,
    x2: 757.47,
    y2: -532.6,
    gradientTransform: "translate(-604.16 -336.01) rotate(65.77) scale(.87 .89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 635.41,
    y1: -403.89,
    x2: 637.13,
    y2: -405.85,
    gradientTransform: "translate(-561.74 -290.82) rotate(61.27)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 633.66,
    y1: -403.12,
    x2: 635.37,
    y2: -405.06,
    gradientTransform: "translate(-561.74 -290.82) rotate(61.27)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 631.91,
    y1: -402.34,
    x2: 633.61,
    y2: -404.29,
    gradientTransform: "translate(-561.74 -290.82) rotate(61.27)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 647.55,
    y1: -392.95,
    x2: 649.9,
    y2: -395.03,
    gradientTransform: "translate(-602.27 -221.6) rotate(54)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 646.65,
    y1: -392.24,
    x2: 649.02,
    y2: -394.35,
    gradientTransform: "translate(-602.27 -221.6) rotate(54)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 591.62,
    y1: -540.91,
    x2: 593.81,
    y2: -542.86,
    gradientTransform: "translate(-659.09 -203.3) rotate(62.43)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 590.87,
    y1: -540.07,
    x2: 593.04,
    y2: -542,
    gradientTransform: "translate(-659.09 -203.3) rotate(62.43)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 604.44,
    y1: -493.93,
    x2: 605.75,
    y2: -495.96,
    gradientTransform: "translate(-599.25 -283.31) rotate(66.07)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 575.78,
    y1: -563.5,
    x2: 576.91,
    y2: -565.25,
    gradientTransform: "translate(-629.44 -281.33) rotate(70.12)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 747.93,
    y1: -618.19,
    x2: 749.04,
    y2: -619.91,
    gradientTransform: "translate(-637.35 -344.91) rotate(70.12) scale(.85 .89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 602.06,
    y1: -490.48,
    x2: 603.55,
    y2: -492.41,
    gradientTransform: "translate(-599.25 -283.31) rotate(66.07)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -1051.76,
    y1: -160.56,
    x2: -1054.5,
    y2: -160.56,
    gradientTransform: "translate(-944.02 -184.65) rotate(-157.01) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -90.78,
    y1: 400.71,
    x2: -89.32,
    y2: 399.05,
    gradientTransform: "translate(-233.19 -171.89) rotate(140.4) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: -92.44,
    y1: 401.47,
    x2: -90.97,
    y2: 399.8,
    gradientTransform: "translate(-233.19 -171.89) rotate(140.4) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: -49.62,
    y1: 465.74,
    x2: -48.16,
    y2: 464.08,
    gradientTransform: "translate(-200.75 -213.01) rotate(140.4) scale(.87 -.89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: -51.73,
    y1: 465.16,
    x2: -50.28,
    y2: 463.51,
    gradientTransform: "translate(-200.75 -213.01) rotate(140.4) scale(.87 -.89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: -135.63,
    y1: 419.53,
    x2: -134.04,
    y2: 417.71,
    gradientTransform: "translate(-258.99 -191.43) rotate(145.2) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: -137.33,
    y1: 420.3,
    x2: -135.74,
    y2: 418.49,
    gradientTransform: "translate(-258.99 -191.43) rotate(145.2) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: -139.04,
    y1: 421.06,
    x2: -137.46,
    y2: 419.25,
    gradientTransform: "translate(-258.99 -191.43) rotate(145.2) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: -101.51,
    y1: 487.63,
    x2: -99.93,
    y2: 485.83,
    gradientTransform: "translate(-221.83 -230.36) rotate(145.2) scale(.87 -.89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: -103.67,
    y1: 487.13,
    x2: -102.09,
    y2: 485.33,
    gradientTransform: "translate(-221.83 -230.36) rotate(145.2) scale(.87 -.89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: -180.79,
    y1: 436.46,
    x2: -179.08,
    y2: 434.51,
    gradientTransform: "translate(-282.83 -213.08) rotate(149.7) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: -182.54,
    y1: 437.24,
    x2: -180.83,
    y2: 435.29,
    gradientTransform: "translate(-282.83 -213.08) rotate(149.7) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: -184.3,
    y1: 438.01,
    x2: -182.58,
    y2: 436.05,
    gradientTransform: "translate(-282.83 -213.08) rotate(149.7) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: -269.09,
    y1: 336.23,
    x2: -266.72,
    y2: 334.13,
    gradientTransform: "translate(-283.84 -131.47) rotate(156.97) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: -269.97,
    y1: 336.91,
    x2: -267.61,
    y2: 334.82,
    gradientTransform: "translate(-283.84 -131.47) rotate(156.97) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: -206.91,
    y1: 314.7,
    x2: -204.73,
    y2: 312.76,
    gradientTransform: "translate(-243.39 -87.31) rotate(148.54) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: -207.67,
    y1: 315.56,
    x2: -205.48,
    y2: 313.61,
    gradientTransform: "translate(-243.39 -87.31) rotate(148.54) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: -187.39,
    y1: 407.46,
    x2: -185.97,
    y2: 406.32,
    gradientTransform: "translate(-324.47 -131.68) rotate(144.3) scale(1.24 -1) skewX(1.07)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: -137.83,
    y1: 411.15,
    x2: -136.52,
    y2: 409.13,
    gradientTransform: "translate(-253.65 -187.18) rotate(144.89) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: -100.98,
    y1: 391.86,
    x2: -99.85,
    y2: 390.11,
    gradientTransform: "translate(-228.97 -169.86) rotate(140.84) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: -46.71,
    y1: 458.66,
    x2: -45.59,
    y2: 456.92,
    gradientTransform: "translate(-189.97 -219.43) rotate(140.84) scale(.85 -.89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: -140.21,
    y1: 414.6,
    x2: -138.73,
    y2: 412.69,
    gradientTransform: "translate(-253.65 -187.18) rotate(144.89) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 95.88,
    y1: -16329.93,
    x2: 103.83,
    y2: -16329.93,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c2343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c2548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#1e2d5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#1f3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#1f376d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#203870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#134b85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#07619d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#10518c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#203870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1f366d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#1f3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#1d2d58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c2446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c2343"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 146.27,
    y1: -16258.05,
    x2: 147.18,
    y2: -16250.06,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#f7cfb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#e5613e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#c04e31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#8a321e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#682112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c1b0e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 146.38,
    y1: -16254.69,
    x2: 145.19,
    y2: -16252.54,
    xlinkHref: "#linear-gradient-87"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 101.84,
    y1: -16272.32,
    x2: 101.91,
    y2: -16272.54,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#a6922d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#c3ab29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#dfc225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#f0d023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#f6d623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 108.03,
    y1: -16303.04,
    x2: 126.09,
    y2: -16274.45,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#cf3b19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#d24627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#dd644c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ed9588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#f3a49b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#ed9d94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#bf6b5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9e4636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#89301d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#822815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#972d16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#af3317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#c13718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#cb3a18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#cf3b19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#c03718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#9b2e16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#822815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#972d16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#af3317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c13718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#cb3a18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#cf3b19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#c03718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#9b2e16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#822815"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 122.18,
    y1: -16273.65,
    x2: 126.66,
    y2: -16266.56,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#cf3b19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#c03718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#9b2e16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#822815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#972d16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#af3317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#c13718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#cb3a18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#cf3b19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#d24627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#dd644c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ed9588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#f3a49b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#f2a198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#e37561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#d8553a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#d14221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#cf3b19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#b73517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#9a2e16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#882915"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#822815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#7f2614"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#772113"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#691912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#661812"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -87.57,
    cy: -16302.85,
    fx: -87.57,
    fy: -16302.85,
    r: 24.32,
    gradientTransform: "translate(246.34 -25059.42) scale(1.54 -1.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3563a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#333777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#333b7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#334989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3460a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3563a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#203870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#233e77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#2c508d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#3563a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#0698d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3563a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#203870"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: -84.1,
    cy: -16297.28,
    fx: -84.1,
    fy: -16297.28,
    r: 21.14,
    gradientTransform: "translate(246.34 -25059.42) scale(1.54 -1.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#e2ab11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#e6b20e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#efc308"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#f6cf04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#f9d601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#fbd801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#bd8422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d5a514"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#eac109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#f6d203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#fbd801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#e2ab11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#c48c25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#d6a518"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#eac10b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#f6d203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#fbd801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bd8422"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 143.59,
    y1: -16252.09,
    x2: 134.75,
    y2: -16265.34,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#b37923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#bd9a25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#f3c934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f3cb3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#f5d356"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#f8e080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#fdf1b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#fff8d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#f3c934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#ebbf31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#d7a62c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#b67c23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#b37923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bd9a25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 128.85,
    y1: -16268.36,
    x2: 132.57,
    y2: -16262.62,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#81c6ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#3563a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#0698d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#24a3db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#66bce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#81c6ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#7dc4ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#71c0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5db8e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#41aee1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#1da0da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0698d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3563a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3360a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2b4e8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#24417b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#213a72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#203870"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: -82.79,
    cy: -16308.1,
    fx: -82.79,
    fy: -16308.1,
    r: 13.95,
    gradientTransform: "translate(246.34 -25059.42) scale(1.54 -1.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d49c1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#cb8d1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#be771e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ba6f1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#c37e1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#dba50f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#ecc107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f7d202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#fbd801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ba6f1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#af651d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#aa601d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#bc7819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#d09414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#dda511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#e2ab11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 149.51,
    y1: -16267.58,
    x2: 150.51,
    y2: -16258.76,
    xlinkHref: "#linear-gradient-87"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 149.62,
    y1: -16263.88,
    x2: 148.31,
    y2: -16261.52,
    xlinkHref: "#linear-gradient-87"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 100.52,
    y1: -16283.32,
    x2: 100.59,
    y2: -16283.56,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 107.35,
    y1: -16317.18,
    x2: 127.27,
    y2: -16285.65,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 122.93,
    y1: -16284.78,
    x2: 127.88,
    y2: -16276.95,
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: -87.82,
    cy: -16311.97,
    fx: -87.82,
    fy: -16311.97,
    r: 26.82,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: -83.99,
    cy: -16305.83,
    fx: -83.99,
    fy: -16305.83,
    r: 23.31,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 146.56,
    y1: -16261.02,
    x2: 136.82,
    y2: -16275.63,
    xlinkHref: "#linear-gradient-92"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 130.3,
    y1: -16278.95,
    x2: 134.4,
    y2: -16272.63,
    xlinkHref: "#linear-gradient-93"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: -82.53,
    cy: -16317.76,
    fx: -82.53,
    fy: -16317.76,
    r: 15.38,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 102.48,
    y1: -16337.73,
    x2: 103.82,
    y2: -16337.73,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#0089c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0679b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#164f88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#203870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1f366d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#1f3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#1d2d58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c2446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c2343"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 100.1,
    y1: -16326.77,
    x2: 106.06,
    y2: -16327.4,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#f3a49b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f2a198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#e37561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#d8553a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#d14221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cf3b19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c03718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#9b2e16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#822815"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 109.71,
    y1: -16334.4,
    x2: 105.94,
    y2: -16332.89,
    xlinkHref: "#linear-gradient-102"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 101.19,
    y1: -16323.54,
    x2: 110.51,
    y2: -16325.81,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#cf3b19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#d24627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#dd644c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#ed9588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#f3a49b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#f1a198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#c87061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#aa4c3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#983621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#922e19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#972f19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#af3419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#c13819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#cb3a19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#cf3b19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#c03718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#9b2e16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#822815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#822815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#822815"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 3354.81,
    y1: 71.02,
    x2: 3355.55,
    y2: 77.54,
    gradientTransform: "translate(3408.45) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-87"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 3355.54,
    y1: 71.15,
    x2: 3350.71,
    y2: 79.88,
    gradientTransform: "translate(3408.45) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-87"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 3321.99,
    y1: 92.85,
    x2: 3333.09,
    y2: 110.43,
    gradientTransform: "translate(3408.45) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 3332.92,
    y1: 86.33,
    x2: 3333.64,
    y2: 87.46,
    gradientTransform: "translate(3408.45) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 3510.61,
    cy: 98.16,
    fx: 3510.61,
    fy: 98.16,
    r: 24.33,
    gradientTransform: "translate(5511.07 -66.32) rotate(-180) scale(1.54 -1.54)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 3514.09,
    cy: 100.56,
    fx: 3514.09,
    fy: 100.56,
    r: 21.14,
    gradientTransform: "translate(5511.07 -66.32) rotate(-180) scale(1.54 -1.54)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 3347.2,
    y1: 79.88,
    x2: 3345.89,
    y2: 77.91,
    gradientTransform: "translate(3408.45) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-92"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 3338.86,
    y1: 82.61,
    x2: 3339.68,
    y2: 83.87,
    gradientTransform: "translate(3408.45) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-93"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 3515.41,
    cy: 113.95,
    fx: 3515.41,
    fy: 113.95,
    r: 13.95,
    gradientTransform: "translate(5511.07 -66.32) rotate(-180) scale(1.54 -1.54)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 3358.06,
    y1: 80.02,
    x2: 3358.87,
    y2: 87.21,
    gradientTransform: "translate(3408.45) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-87"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 3358.86,
    y1: 80.18,
    x2: 3353.53,
    y2: 89.8,
    gradientTransform: "translate(3408.45) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-87"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 3321.86,
    y1: 104.09,
    x2: 3334.1,
    y2: 123.47,
    gradientTransform: "translate(3408.45) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 3333.92,
    y1: 96.9,
    x2: 3334.71,
    y2: 98.15,
    gradientTransform: "translate(3408.45) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 3510.37,
    cy: 104.96,
    fx: 3510.37,
    fy: 104.96,
    r: 26.82,
    gradientTransform: "translate(5511.07 -66.32) rotate(-180) scale(1.54 -1.54)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 3514.21,
    cy: 107.59,
    fx: 3514.21,
    fy: 107.59,
    r: 23.31,
    gradientTransform: "translate(5511.07 -66.32) rotate(-180) scale(1.54 -1.54)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 3349.66,
    y1: 89.82,
    x2: 3348.21,
    y2: 87.64,
    gradientTransform: "translate(3408.45) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-92"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 3340.46,
    y1: 92.82,
    x2: 3341.35,
    y2: 94.2,
    gradientTransform: "translate(3408.45) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-93"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 3515.66,
    cy: 122.36,
    fx: 3515.66,
    fy: 122.36,
    r: 15.38,
    gradientTransform: "translate(5511.07 -66.32) rotate(-180) scale(1.54 -1.54)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: -808.15,
    y1: 155.73,
    x2: -806.8,
    y2: 155.73,
    gradientTransform: "translate(-710.91) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-101"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 95.74,
    y1: -16327.14,
    x2: 100.56,
    y2: -16326.76,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#e2ab11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#e6b20e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#efc308"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#f6cf04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#f9d601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#fbd801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#bd8422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d5a514"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#eac109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#f6d203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#fbd801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#e2ab11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#c48c25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#d6a518"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#eac10b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#f6d203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#fbd801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bd8422"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 95.4,
    y1: -16332,
    x2: 90.23,
    y2: -16334.58,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#8a6823"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#f6d623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 85.49,
    y1: -16325.88,
    x2: 101.43,
    y2: -16323.28,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#e2ab11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#e6b20e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#efc308"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#f6cf04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#f9d601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#fbd801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#bd8422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d5a514"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#eac109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#f6d203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#fbd801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#e2ab11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#c48c25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 100,
    y1: -16317.34,
    x2: 100,
    y2: -16306.06,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#3380bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#2ebae4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#8cd4e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#bae1ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 81.11,
    y1: -16308.69,
    x2: 114.56,
    y2: -16308.69,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2a580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#a76e4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c4624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#6c3716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#efa679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#d18d62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#a76841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#884d29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#753d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#6f3816"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d67638"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 81.11,
    y1: -16308.54,
    x2: 114.56,
    y2: -16308.54,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6da236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#619232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#426728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#365725"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#9ec66c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#92b964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#6a8f49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#4d7035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#3c5d29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#365725"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#365725"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 100.56,
    y1: -16305.41,
    x2: 100.56,
    y2: -16306.58,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a4a7ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#c8cace"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 98.05,
    x2: 98.05,
    xlinkHref: "#linear-gradient-124"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 103.2,
    x2: 103.2,
    xlinkHref: "#linear-gradient-124"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 101.94,
    y1: -16303.48,
    x2: 101.94,
    y2: -16304.67,
    xlinkHref: "#linear-gradient-124"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 99.4,
    y1: -16303.48,
    x2: 99.4,
    y2: -16304.67,
    xlinkHref: "#linear-gradient-124"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 98.4,
    y1: -16313.52,
    x2: 98.4,
    y2: -16314.69,
    xlinkHref: "#linear-gradient-124"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 100.49,
    y1: -16313.52,
    x2: 100.49,
    y2: -16314.69,
    xlinkHref: "#linear-gradient-124"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 102.59,
    y1: -16313.52,
    x2: 102.59,
    y2: -16314.69,
    xlinkHref: "#linear-gradient-124"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 76.16,
    y1: -16291.7,
    x2: 124.13,
    y2: -16291.7,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#99a2a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#a6afb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#c8d2d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#b9c5cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#92a3a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#86999e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#8c9da2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#9faaae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#bec0c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8c7c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a8b4b6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 102.89,
    y1: -16296.15,
    x2: 96.88,
    y2: -16291.93,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#cf3b19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#c03718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#9b2d16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#5f1c14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#461613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#491613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#521913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#621e13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#792514"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#822815"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 97.77,
    y1: -16294.4,
    x2: 102.14,
    y2: -16294.4,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a4a7ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#dadcdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#545153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#747377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a4a7ae"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 95.27,
    y1: -16292.07,
    x2: 106.89,
    y2: -16292.07,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#f3a49b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#f2a198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#e37561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#d8553a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#d14221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#cf3b19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#c03718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#9b2e16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#822815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#852815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#8e2b15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#9e2f16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#b53417"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#cf3b19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#c03718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#9b2e16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#822815"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "m96.53,104.91q-1.24.76-1.25,1.97c0,.55-.11,1.13.37,1.1.84-.09.71.04,1.12-.18.4-.19,3.12-1.9,4.55-2.07,1.1-.12,1.78-.18,2.4,2.66.61,2.83.93,4.51,1,5.1.06.6,0,.31.66,1.06.68.77,1.16,1.41,1.16,1.41,0,0,.11.2.58-.25.42-.46.14-.37,0-.55-.16-.2-1.53-1.2-1.51-1.55.03-.3-.5-6.56-1.49-8.69-.97-2.13-1.77-2.58-4.23-1.83-1.48.54-2.13.98-3.34,1.83Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: -93.92,
    cy: -16278.48,
    fx: -93.92,
    fy: -16278.48,
    r: 18.18,
    gradientTransform: "translate(246.34 -25059.42) scale(1.54 -1.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6cc1e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3581bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#342874"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 115.69,
    y1: -8.26,
    x2: 116.13,
    y2: -8.26,
    gradientTransform: "translate(-6.36 64.36) rotate(8.59)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#8b6224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 115.84,
    y1: -8.25,
    y2: -8.25,
    xlinkHref: "#linear-gradient-136"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 115.55,
    y1: -6.79,
    x2: 116.84,
    y2: -7.01,
    gradientTransform: "translate(-6.36 64.36) rotate(8.59)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#885136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#98867e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#94805d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#c1cee2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80766c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 113.99,
    y1: -7.32,
    x2: 114.41,
    y2: -7.32,
    xlinkHref: "#linear-gradient-136"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 114.13,
    y1: -7.33,
    x2: 114.41,
    y2: -7.33,
    xlinkHref: "#linear-gradient-136"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 113.85,
    y1: -5.86,
    x2: 115.13,
    y2: -6.08,
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 28.81,
    y1: -316.25,
    x2: 29.23,
    y2: -316.25,
    gradientTransform: "translate(-47.22 -195.94) rotate(-24.59) scale(1 -1)",
    xlinkHref: "#linear-gradient-136"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 28.95,
    y1: -316.25,
    x2: 29.23,
    y2: -316.25,
    gradientTransform: "translate(-47.22 -195.94) rotate(-24.59) scale(1 -1)",
    xlinkHref: "#linear-gradient-136"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 28.67,
    y1: -314.79,
    x2: 29.96,
    y2: -315.02,
    gradientTransform: "translate(-47.22 -195.94) rotate(-24.59) scale(1 -1)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 199.7,
    y1: -112.64,
    x2: 200.13,
    y2: -112.64,
    gradientTransform: "translate(-78.85 106.03) rotate(17.55) scale(.86 .79)",
    xlinkHref: "#linear-gradient-136"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 199.84,
    y1: -112.64,
    x2: 200.13,
    y2: -112.64,
    gradientTransform: "translate(-78.85 106.03) rotate(17.55) scale(.86 .79)",
    xlinkHref: "#linear-gradient-136"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 199.57,
    y1: -111.18,
    x2: 200.86,
    y2: -111.41,
    gradientTransform: "translate(-78.85 106.03) rotate(17.55) scale(.86 .79)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: -841.05,
    y1: 371.61,
    x2: -840.62,
    y2: 371.61,
    gradientTransform: "translate(-822.38 191.07) rotate(149.28) scale(1 -1)",
    xlinkHref: "#linear-gradient-136"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: -840.91,
    y1: 371.61,
    x2: -840.62,
    y2: 371.61,
    gradientTransform: "translate(-822.38 191.07) rotate(149.28) scale(1 -1)",
    xlinkHref: "#linear-gradient-136"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: -841.19,
    y1: 373.08,
    x2: -839.91,
    y2: 372.86,
    gradientTransform: "translate(-822.38 191.07) rotate(149.28) scale(1 -1)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: -842.76,
    y1: 372.53,
    x2: -842.34,
    y2: 372.53,
    gradientTransform: "translate(-822.38 191.07) rotate(149.28) scale(1 -1)",
    xlinkHref: "#linear-gradient-136"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: -842.62,
    y1: 372.54,
    x2: -842.34,
    y2: 372.54,
    gradientTransform: "translate(-822.38 191.07) rotate(149.28) scale(1 -1)",
    xlinkHref: "#linear-gradient-136"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: -842.9,
    y1: 374.01,
    x2: -841.61,
    y2: 373.78,
    gradientTransform: "translate(-822.38 191.07) rotate(149.28) scale(1 -1)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: -829.06,
    y1: 552.85,
    x2: -828.62,
    y2: 552.85,
    gradientTransform: "translate(-739.41 201.07) rotate(140.32) scale(.86 -.79)",
    xlinkHref: "#linear-gradient-136"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: -828.92,
    y1: 552.87,
    x2: -828.62,
    y2: 552.87,
    gradientTransform: "translate(-739.41 201.07) rotate(140.32) scale(.86 -.79)",
    xlinkHref: "#linear-gradient-136"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: -829.19,
    y1: 554.31,
    x2: -827.92,
    y2: 554.09,
    gradientTransform: "translate(-739.41 201.07) rotate(140.32) scale(.86 -.79)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 77.61,
    y1: -16261.21,
    x2: 77.75,
    y2: -16263.63,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#563114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3c934"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: -1274.41,
    y1: 82.13,
    x2: -1274.26,
    y2: 79.57,
    gradientTransform: "translate(-1151.96) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 97.98,
    y1: -16263.74,
    x2: 98.81,
    y2: -16263.19,
    xlinkHref: "#linear-gradient-157"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: -95.48,
    cy: -16266.97,
    fx: -95.48,
    fy: -16266.97,
    r: 6.04,
    gradientTransform: "translate(246.34 -25059.42) scale(1.54 -1.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c26d37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#a85c2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#8e4b25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#783d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#673218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5b2a13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#542611"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532511"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: -1127.37,
    cy: 295.59,
    fx: -1127.37,
    fy: 295.59,
    r: 3.08,
    gradientTransform: "translate(-924.3 105.11) rotate(157.91) scale(.91 -1.2) skewX(13.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c26d37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532511"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: -1160.65,
    cy: 239.17,
    fx: -1160.65,
    fy: 239.17,
    r: 3.07,
    gradientTransform: "translate(-942.45 41.27) rotate(165.4) scale(.9 -1.22) skewX(9.4)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: -1159.65,
    cy: 236.88,
    fx: -1159.65,
    fy: 236.88,
    r: 3.06,
    gradientTransform: "translate(-941.88 36.73) rotate(165.81) scale(.89 -1.22) skewX(9.16)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: -1211.46,
    cy: 93.93,
    fx: -1211.46,
    fy: 93.93,
    r: 3.1,
    gradientTransform: "translate(-962.37 -111.9) rotate(-176.37) scale(.88 -1.24) skewX(-2.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c26d37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#bf6b36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#9e552a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#824321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#6d361a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#5e2c14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#552611"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532511"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: -1210.47,
    cy: 93.8,
    fx: -1210.47,
    fy: 93.8,
    r: 3.08,
    gradientTransform: "translate(-962.37 -111.9) rotate(-176.37) scale(.88 -1.24) skewX(-2.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c26d37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c16c36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#9f562b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#834421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#6e361a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#5e2c15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#552611"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532511"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: -1209.19,
    cy: 93.92,
    fx: -1209.19,
    fy: 93.92,
    r: 3.11,
    gradientTransform: "translate(-962.37 -111.9) rotate(-176.37) scale(.88 -1.24) skewX(-2.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c26d37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#a1572b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#844522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#6e361a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#5f2c15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#552611"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532511"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: -1208.15,
    cy: 93.43,
    fx: -1208.15,
    fy: 93.43,
    r: 3.08,
    gradientTransform: "translate(-962.37 -111.9) rotate(-176.37) scale(.88 -1.24) skewX(-2.45)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: -1225.31,
    cy: -117.04,
    fx: -1225.31,
    fy: -117.04,
    r: 3.09,
    gradientTransform: "translate(-955.64 -298.92) rotate(-153.53) scale(.93 -1.18) skewX(-15.14)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: -1215.41,
    cy: -196.76,
    fx: -1215.41,
    fy: -196.76,
    r: 3.09,
    gradientTransform: "translate(-943.89 -364.55) rotate(-145.84) scale(.96 -1.14) skewX(-17.49)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: -1127.78,
    cy: 294.21,
    fx: -1127.78,
    fy: 294.21,
    r: 3.08,
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-25",
    cx: -1160.92,
    cy: 237.76,
    fx: -1160.92,
    fy: 237.76,
    r: 3.07,
    gradientTransform: "translate(-942.45 41.27) rotate(165.4) scale(.9 -1.22) skewX(9.4)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-26",
    cx: -1159.91,
    cy: 235.48,
    fx: -1159.91,
    fy: 235.48,
    r: 3.07,
    gradientTransform: "translate(-941.88 36.73) rotate(165.81) scale(.89 -1.22) skewX(9.16)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-27",
    cx: -1211.39,
    cy: 92.49,
    fx: -1211.39,
    fy: 92.49,
    r: 3.1,
    gradientTransform: "translate(-962.37 -111.9) rotate(-176.37) scale(.88 -1.24) skewX(-2.45)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-28",
    cx: -1210.4,
    cy: 92.38,
    fx: -1210.4,
    fy: 92.38,
    r: 3.08,
    gradientTransform: "translate(-962.37 -111.9) rotate(-176.37) scale(.88 -1.24) skewX(-2.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c26d37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#9d552a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#7c401f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#653117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#572812"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532511"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-29",
    cx: -1209.12,
    cy: 92.48,
    fx: -1209.12,
    fy: 92.48,
    r: 3.11,
    gradientTransform: "translate(-962.37 -111.9) rotate(-176.37) scale(.88 -1.24) skewX(-2.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c26d37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#a85c2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#894823"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#71381b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#602d15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#562712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532511"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-30",
    cx: -1208.09,
    cy: 91.99,
    fx: -1208.09,
    fy: 91.99,
    r: 3.08,
    gradientTransform: "translate(-962.37 -111.9) rotate(-176.37) scale(.88 -1.24) skewX(-2.45)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-31",
    cx: -1224.82,
    cy: -118.39,
    fx: -1224.82,
    fy: -118.39,
    r: 3.08,
    gradientTransform: "translate(-955.64 -298.92) rotate(-153.53) scale(.93 -1.18) skewX(-15.14)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-32",
    cx: -1214.77,
    cy: -198.05,
    fx: -1214.77,
    fy: -198.05,
    r: 3.1,
    gradientTransform: "translate(-943.89 -364.55) rotate(-145.84) scale(.96 -1.14) skewX(-17.49)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-33",
    cx: 69.66,
    cy: 136.2,
    fx: 69.66,
    fy: 136.2,
    r: 3.9,
    gradientTransform: "translate(18.22 -71.19) scale(1.09 1.07)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c26d37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#b96733"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#944f27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#773c1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#632f16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#572712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532511"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-34",
    cx: 7.65,
    cy: 115.99,
    fx: 7.65,
    fy: 115.99,
    r: 3.92,
    gradientTransform: "translate(86.64 -70.02) scale(1.22 1.24)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-35",
    cx: 6.76,
    cy: 114.79,
    fx: 6.76,
    fy: 114.79,
    r: 3.9,
    gradientTransform: "translate(86.64 -70.02) scale(1.22 1.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c26d37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#a2582c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#854622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#6f371a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#5f2d15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#552612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532511"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-36",
    cx: 8.62,
    cy: 114.8,
    fx: 8.62,
    fy: 114.8,
    r: 3.88,
    gradientTransform: "translate(86.64 -70.02) scale(1.22 1.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c26d37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#a65b2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#884723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70381b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#602d15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#562712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532511"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-37",
    cx: 7.71,
    cy: 113.78,
    fx: 7.71,
    fy: 113.78,
    r: 3.9,
    xlinkHref: "#radial-gradient-35"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-38",
    cx: 199.97,
    cy: 21.18,
    fx: 199.97,
    fy: 21.18,
    r: 3.95,
    gradientTransform: "translate(-82.49 13.53) rotate(10.97) scale(.92 1.07)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-39",
    cx: 255.18,
    cy: 28.15,
    fx: 255.18,
    fy: 28.15,
    r: 3.89,
    gradientTransform: "translate(-114.66 .44) rotate(10.96) scale(.86 .98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c26d37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#b76633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#985228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#7f4120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6b3419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#5d2b14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#552611"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532511"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-40",
    cx: 254.79,
    cy: 26.27,
    fx: 254.79,
    fy: 26.27,
    r: 3.89,
    gradientTransform: "translate(-114.66 .44) rotate(10.96) scale(.86 .98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c26d37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#a85c2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#8e4b25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#783d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#673218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#5b2a13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#542611"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532511"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-41",
    cx: 254.69,
    cy: 24.86,
    fx: 254.69,
    fy: 24.86,
    r: 3.9,
    xlinkHref: "#radial-gradient-40"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-42",
    cx: 28.36,
    cy: 11.87,
    fx: 28.36,
    fy: 11.87,
    r: 3.89,
    gradientTransform: "translate(64.75 46.85) rotate(10.97) scale(1.22 1.24)",
    xlinkHref: "#radial-gradient-40"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-43",
    cx: 17.49,
    cy: 71.96,
    fx: 17.49,
    fy: 71.96,
    r: 3.91,
    gradientTransform: "translate(82.75 -20.86) rotate(4.32) scale(1.22 1.24)",
    xlinkHref: "#radial-gradient-35"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-44",
    cx: -1001.75,
    cy: 266.97,
    fx: -1001.75,
    fy: 266.97,
    r: 3.87,
    gradientTransform: "translate(-1025.88 76.46) rotate(165.28) scale(1.09 -1.07)",
    xlinkHref: "#radial-gradient-28"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-45",
    cx: -949.12,
    cy: 227.77,
    fx: -949.12,
    fy: 227.77,
    r: 3.88,
    gradientTransform: "translate(-1091.78 96.03) rotate(165.27) scale(1.22 -1.24)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-46",
    cx: -950.02,
    cy: 226.58,
    fx: -950.02,
    fy: 226.58,
    r: 3.93,
    gradientTransform: "translate(-1091.78 96.03) rotate(165.27) scale(1.22 -1.24)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-47",
    cx: -948.16,
    cy: 226.59,
    fx: -948.16,
    fy: 226.59,
    r: 3.87,
    gradientTransform: "translate(-1091.78 96.03) rotate(165.27) scale(1.22 -1.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c26d37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#bd6935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#9c542a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#814321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#6c3519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#5e2c14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#552611"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532511"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-48",
    cx: -949.06,
    cy: 225.57,
    fx: -949.06,
    fy: 225.57,
    r: 3.88,
    gradientTransform: "translate(-1091.78 96.03) rotate(165.27) scale(1.22 -1.24)",
    xlinkHref: "#radial-gradient-40"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-49",
    cx: -944.03,
    cy: 362.74,
    fx: -944.03,
    fy: 362.74,
    r: 3.87,
    gradientTransform: "translate(-963.12 152.37) rotate(154.98) scale(1.05 -1.04) skewX(-1.36)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c26d37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#a95d2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#8e4b25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#783d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#673218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5b2a13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#542611"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532511"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-50",
    cx: -1019.71,
    cy: 400.65,
    fx: -1019.71,
    fy: 400.65,
    r: 3.92,
    gradientTransform: "translate(-890.71 138.7) rotate(152.64) scale(.92 -.99) skewX(3.47)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c26d37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#b26231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#944f27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7c401f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6a3318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5c2b14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#552611"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532511"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-51",
    cx: -891.46,
    cy: 300.81,
    fx: -891.46,
    fy: 300.81,
    r: 3.89,
    gradientTransform: "translate(-1041.21 203.76) rotate(154.3) scale(1.22 -1.24)",
    xlinkHref: "#radial-gradient-40"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-52",
    cx: -889.65,
    cy: 301.09,
    fx: -889.65,
    fy: 301.09,
    r: 3.9,
    gradientTransform: "translate(-1041.21 203.76) rotate(154.3) scale(1.22 -1.24)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-53",
    cx: -927.44,
    cy: 254.36,
    fx: -927.44,
    fy: 254.36,
    r: 3.88,
    gradientTransform: "translate(-1074.87 142.45) rotate(160.96) scale(1.22 -1.24)",
    xlinkHref: "#radial-gradient-29"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-54",
    cx: -1039.39,
    cy: 213.83,
    fx: -1039.39,
    fy: 213.83,
    r: 3.11,
    gradientTransform: "translate(-1044.01 41.27) rotate(168) scale(1.09 -1.24) skewX(2.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c26d37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#a4592c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#874622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#70371a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#5f2d15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#562612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532511"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-55",
    cx: -1038.56,
    cy: 212.25,
    fx: -1038.56,
    fy: 212.25,
    r: 3.11,
    gradientTransform: "translate(-1043.85 36.73) rotate(168.35) scale(1.09 -1.24) skewX(2.87)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-56",
    cx: -1087.78,
    cy: 96.62,
    fx: -1087.78,
    fy: 96.62,
    r: 3.08,
    gradientTransform: "translate(-1069.02 -111.9) rotate(-177.04) scale(1.08 -1.24) skewX(-.75)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-57",
    cx: -1086.79,
    cy: 96.5,
    fx: -1086.79,
    fy: 96.5,
    r: 3.1,
    gradientTransform: "translate(-1069.02 -111.9) rotate(-177.04) scale(1.08 -1.24) skewX(-.75)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-58",
    cx: -1085.51,
    cy: 96.62,
    fx: -1085.51,
    fy: 96.62,
    r: 3.11,
    gradientTransform: "translate(-1069.02 -111.9) rotate(-177.04) scale(1.08 -1.24) skewX(-.75)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-59",
    cx: -1084.49,
    cy: 96.13,
    fx: -1084.49,
    fy: 96.13,
    r: 3.11,
    gradientTransform: "translate(-1069.02 -111.9) rotate(-177.04) scale(1.08 -1.24) skewX(-.75)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-60",
    cx: -1010.04,
    cy: 257.68,
    fx: -1010.04,
    fy: 257.68,
    r: 3.13,
    gradientTransform: "translate(-1022.59 105.11) rotate(161.69) scale(1.09 -1.23) skewX(4.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c26d37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#b96734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#995329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#7f4220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#6b3519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#5d2b14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#552611"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532511"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-61",
    cx: -1039.6,
    cy: 212.78,
    fx: -1039.6,
    fy: 212.78,
    r: 3.11,
    gradientTransform: "translate(-1044.01 41.27) rotate(168) scale(1.09 -1.24) skewX(2.95)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-62",
    cx: -1038.75,
    cy: 211.19,
    fx: -1038.75,
    fy: 211.19,
    r: 3.11,
    gradientTransform: "translate(-1043.85 36.73) rotate(168.35) scale(1.09 -1.24) skewX(2.87)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-63",
    cx: -1087.73,
    cy: 95.55,
    fx: -1087.73,
    fy: 95.55,
    r: 3.09,
    gradientTransform: "translate(-1069.02 -111.9) rotate(-177.04) scale(1.08 -1.24) skewX(-.75)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-64",
    cx: -1086.74,
    cy: 95.42,
    fx: -1086.74,
    fy: 95.42,
    r: 3.1,
    gradientTransform: "translate(-1069.02 -111.9) rotate(-177.04) scale(1.08 -1.24) skewX(-.75)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-65",
    cx: -1085.46,
    cy: 95.55,
    fx: -1085.46,
    fy: 95.55,
    r: 3.11,
    gradientTransform: "translate(-1069.02 -111.9) rotate(-177.04) scale(1.08 -1.24) skewX(-.75)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-66",
    cx: -1084.44,
    cy: 95.06,
    fx: -1084.44,
    fy: 95.06,
    r: 3.11,
    gradientTransform: "translate(-1069.02 -111.9) rotate(-177.04) scale(1.08 -1.24) skewX(-.75)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-67",
    cx: -1108.65,
    cy: -79.74,
    fx: -1108.65,
    fy: -79.74,
    r: 3.09,
    gradientTransform: "translate(-1061.49 -298.92) rotate(-157.9) scale(1.1 -1.22) skewX(-5.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c26d37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#ac5e2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#904d26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#793e1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#683218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#5c2a14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#542611"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532511"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-68",
    cx: -1101.93,
    cy: -147.62,
    fx: -1101.93,
    fy: -147.62,
    r: 2.92,
    gradientTransform: "translate(-1045.48 -364.55) rotate(-151.03) scale(1.11 -1.21) skewX(-6.13)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-69",
    cx: -975.92,
    cy: 199.54,
    fx: -975.92,
    fy: 199.54,
    r: 3.11,
    gradientTransform: "translate(-1116.2 41.27) rotate(169.37) scale(1.22 -1.24)",
    xlinkHref: "#radial-gradient-20"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-70",
    cx: -976.6,
    cy: 199.06,
    fx: -976.6,
    fy: 199.06,
    r: 3.1,
    gradientTransform: "translate(-1116.2 41.27) rotate(169.37) scale(1.22 -1.24)",
    xlinkHref: "#radial-gradient-40"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-71",
    cx: -975.63,
    cy: 198.39,
    fx: -975.63,
    fy: 198.39,
    r: 3.08,
    gradientTransform: "translate(-1116.85 36.73) rotate(169.68) scale(1.22 -1.24)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-72",
    cx: -1022.94,
    cy: 97.04,
    fx: -1022.94,
    fy: 97.04,
    r: 3.1,
    gradientTransform: "translate(-1144.82 -111.9) rotate(-177.39) scale(1.22 -1.24)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-73",
    cx: -1021.94,
    cy: 96.92,
    fx: -1021.94,
    fy: 96.92,
    r: 3.1,
    gradientTransform: "translate(-1144.82 -111.9) rotate(-177.39) scale(1.22 -1.24)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-74",
    cx: -1020.66,
    cy: 97.02,
    fx: -1020.66,
    fy: 97.02,
    r: 3.08,
    gradientTransform: "translate(-1144.82 -111.9) rotate(-177.39) scale(1.22 -1.24)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-75",
    cx: -1019.64,
    cy: 96.53,
    fx: -1019.64,
    fy: 96.53,
    r: 3.08,
    gradientTransform: "translate(-1144.82 -111.9) rotate(-177.39) scale(1.22 -1.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c26d37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#bb6834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#9b5329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#804220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#6c3519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#5e2c14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#552611"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532511"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-76",
    cx: -1045.51,
    cy: -59.2,
    fx: -1045.51,
    fy: -59.2,
    r: 3.12,
    gradientTransform: "translate(-1134.47 -298.92) rotate(-160.28) scale(1.22 -1.24)",
    xlinkHref: "#radial-gradient-40"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-77",
    cx: -1043.44,
    cy: -119.88,
    fx: -1043.44,
    fy: -119.88,
    r: 3.07,
    gradientTransform: "translate(-1118.57 -364.55) rotate(-153.96) scale(1.22 -1.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c26d37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#af6030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#924e26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7b3f1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#693318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#5c2b14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#552611"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532511"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-78",
    cx: -976.12,
    cy: 244.74,
    fx: -976.12,
    fy: 244.74,
    r: 3.09,
    gradientTransform: "translate(-1057.93 105.11) rotate(162.8) scale(1.16 -1.24) skewX(1.91)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c26d37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#b56532"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#975128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#7e411f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6a3419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#5d2b14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#552611"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532511"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-79",
    cx: -1005.51,
    cy: 203.37,
    fx: -1005.51,
    fy: 203.37,
    r: 3.09,
    gradientTransform: "translate(-1082.04 41.27) rotate(168.75) scale(1.16 -1.24) skewX(1.29)",
    xlinkHref: "#radial-gradient-40"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-80",
    cx: -1004.18,
    cy: 201.89,
    fx: -1004.18,
    fy: 201.89,
    r: 3.09,
    gradientTransform: "translate(-1081.28 36.73) rotate(169.08) scale(1.16 -1.24) skewX(1.26)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-81",
    cx: -1052.05,
    cy: 94.12,
    fx: -1052.05,
    fy: 94.12,
    r: 3.09,
    gradientTransform: "translate(-1108.29 -111.9) rotate(-177.23) scale(1.15 -1.24) skewX(-.33)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-82",
    cx: -1051.06,
    cy: 93.99,
    fx: -1051.06,
    fy: 93.99,
    r: 3.07,
    gradientTransform: "translate(-1108.29 -111.9) rotate(-177.23) scale(1.15 -1.24) skewX(-.33)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-83",
    cx: -1049.78,
    cy: 94.1,
    fx: -1049.78,
    fy: 94.1,
    r: 3.09,
    gradientTransform: "translate(-1108.29 -111.9) rotate(-177.23) scale(1.15 -1.24) skewX(-.33)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-84",
    cx: -1048.75,
    cy: 93.61,
    fx: -1048.75,
    fy: 93.61,
    r: 3.09,
    gradientTransform: "translate(-1108.29 -111.9) rotate(-177.23) scale(1.15 -1.24) skewX(-.33)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-85",
    cx: -1072.79,
    cy: -70.55,
    fx: -1072.79,
    fy: -70.55,
    r: 3.11,
    gradientTransform: "translate(-1099.06 -298.92) rotate(-159.2) scale(1.16 -1.23) skewX(-2.24)",
    xlinkHref: "#radial-gradient-19"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-86",
    cx: -1068.42,
    cy: -133.71,
    fx: -1068.42,
    fy: -133.71,
    r: 3.1,
    gradientTransform: "translate(-1082.98 -364.55) rotate(-152.62) scale(1.17 -1.23) skewX(-2.75)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-87",
    cx: -976.53,
    cy: 243.36,
    fx: -976.53,
    fy: 243.36,
    r: 3.09,
    gradientTransform: "translate(-1057.93 105.11) rotate(162.8) scale(1.16 -1.24) skewX(1.91)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-88",
    cx: -1005.78,
    cy: 201.96,
    fx: -1005.78,
    fy: 201.96,
    r: 3.09,
    gradientTransform: "translate(-1082.04 41.27) rotate(168.75) scale(1.16 -1.24) skewX(1.29)",
    xlinkHref: "#radial-gradient-60"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-89",
    cx: -1004.44,
    cy: 200.47,
    fx: -1004.44,
    fy: 200.47,
    r: 3.09,
    gradientTransform: "translate(-1081.28 36.73) rotate(169.08) scale(1.16 -1.24) skewX(1.26)",
    xlinkHref: "#radial-gradient-36"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-90",
    cx: -1051.99,
    cy: 92.68,
    fx: -1051.99,
    fy: 92.68,
    r: 3.09,
    gradientTransform: "translate(-1108.29 -111.9) rotate(-177.23) scale(1.15 -1.24) skewX(-.33)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-91",
    cx: -1051,
    cy: 92.55,
    fx: -1051,
    fy: 92.55,
    r: 3.06,
    gradientTransform: "translate(-1108.29 -111.9) rotate(-177.23) scale(1.15 -1.24) skewX(-.33)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-92",
    cx: -1049.71,
    cy: 92.66,
    fx: -1049.71,
    fy: 92.66,
    r: 3.09,
    gradientTransform: "translate(-1108.29 -111.9) rotate(-177.23) scale(1.15 -1.24) skewX(-.33)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-93",
    cx: -1048.68,
    cy: 92.17,
    fx: -1048.68,
    fy: 92.17,
    r: 3.09,
    gradientTransform: "translate(-1108.29 -111.9) rotate(-177.23) scale(1.15 -1.24) skewX(-.33)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-94",
    cx: -1072.3,
    cy: -71.89,
    fx: -1072.3,
    fy: -71.89,
    r: 3.1,
    gradientTransform: "translate(-1099.06 -298.92) rotate(-159.2) scale(1.16 -1.23) skewX(-2.24)",
    xlinkHref: "#radial-gradient-40"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-95",
    cx: -1067.78,
    cy: -135,
    fx: -1067.78,
    fy: -135,
    r: 3.11,
    gradientTransform: "translate(-1082.98 -364.55) rotate(-152.62) scale(1.17 -1.23) skewX(-2.75)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c26d37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#b06131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#934f27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7b3f1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#693318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5c2b14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#552611"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532511"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: -918.53,
    y1: 429.22,
    x2: -916.92,
    y2: 429.22,
    gradientTransform: "translate(-862.48 370.44) rotate(138.05) scale(1 -1)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: -914.29,
    y1: 537.2,
    x2: -913.18,
    y2: 537.2,
    gradientTransform: "translate(-727.11 356.49) rotate(126.61) scale(.79 -.94)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: -853.4,
    y1: 598.96,
    x2: -852.29,
    y2: 598.96,
    gradientTransform: "translate(-703.52 383.05) rotate(121.88) scale(.81 -.88)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: -947.64,
    y1: 485.86,
    x2: -946.53,
    y2: 485.86,
    gradientTransform: "translate(-745.3 340.29) rotate(129.95) scale(.79 -1)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: -918.47,
    y1: 430.77,
    x2: -917.5,
    y2: 430.77,
    gradientTransform: "translate(-862.48 370.44) rotate(138.05) scale(1 -1)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: -918.46,
    y1: 430.06,
    x2: -917.49,
    y2: 430.06,
    gradientTransform: "translate(-862.48 370.44) rotate(138.05) scale(1 -1)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: -918.42,
    y1: 429.47,
    x2: -917.46,
    y2: 429.47,
    gradientTransform: "translate(-862.48 370.44) rotate(138.05) scale(1 -1)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: -918.45,
    y1: 428.87,
    x2: -917.45,
    y2: 428.87,
    gradientTransform: "translate(-862.48 370.44) rotate(138.05) scale(1 -1)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: -918.46,
    y1: 428.27,
    x2: -917.46,
    y2: 428.27,
    gradientTransform: "translate(-862.48 370.44) rotate(138.05) scale(1 -1)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: -886.1,
    y1: 456.6,
    x2: -884.99,
    y2: 456.6,
    gradientTransform: "translate(-836.59 397.59) rotate(133.83) scale(1 -1)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: -885.17,
    y1: 456.3,
    x2: -884.05,
    y2: 456.3,
    gradientTransform: "translate(-836.15 396.48) rotate(133.84) scale(1 -1)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: -877.42,
    y1: 462.65,
    x2: -876.37,
    y2: 462.65,
    gradientTransform: "translate(-830.44 401.83) rotate(132.88) scale(1 -1)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: -895.52,
    y1: 446.05,
    x2: -894.47,
    y2: 446.05,
    gradientTransform: "translate(-844.25 388.41) rotate(135.16) scale(1 -1)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: -850.11,
    y1: 481.85,
    x2: -849.04,
    y2: 481.85,
    gradientTransform: "translate(-808.68 419.42) rotate(129.69) scale(1 -1)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: 125.65,
    y1: -16254.49,
    x2: 132.29,
    y2: -16254.49,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#5d452a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#875920"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#f0c06e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: 101.27,
    y1: -16259.44,
    x2: 132.29,
    y2: -16259.44,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#c1932f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#f3c934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#fbf0c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#f9e49b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#f6da76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#f5d259"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#f3cd44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#f3ca38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3c934"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: -765.87,
    y1: 72.47,
    x2: -759.22,
    y2: 72.47,
    gradientTransform: "translate(-691.08) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: -857.77,
    y1: 77.36,
    x2: -826.77,
    y2: 77.36,
    gradientTransform: "translate(-758.61) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-175"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: 92.9,
    y1: -16259.39,
    x2: 94.12,
    y2: -16259.39,
    xlinkHref: "#linear-gradient-157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: 93.59,
    y1: -16259.6,
    x2: 95.2,
    y2: -16259.6,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: 253.66,
    y1: -41.58,
    x2: 254.71,
    y2: -41.58,
    gradientTransform: "translate(-110.61 79.38) rotate(11.44) scale(.79 .94)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: 230.89,
    y1: -102.96,
    x2: 231.99,
    y2: -102.96,
    gradientTransform: "translate(-110.6 115.75) rotate(16.17) scale(.81 .88)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: 255.79,
    y1: -4.81,
    x2: 256.9,
    y2: -4.81,
    gradientTransform: "translate(-107.41 55.95) rotate(8.1) scale(.79 1)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: 93.65,
    y1: -16261.19,
    x2: 94.6,
    y2: -16261.19,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: 93.66,
    y1: -16260.48,
    x2: 94.63,
    y2: -16260.48,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: 93.69,
    y1: -16259.89,
    x2: 94.65,
    y2: -16259.89,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: 93.67,
    y1: -16259.29,
    x2: 94.66,
    y2: -16259.29,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: 93.65,
    y1: -16258.69,
    x2: 94.66,
    y2: -16258.69,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: 97.47,
    y1: 32.27,
    x2: 98.58,
    y2: 32.27,
    gradientTransform: "translate(-1.21 36.69) rotate(4.22)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: 98.13,
    y1: 31.56,
    x2: 99.25,
    y2: 31.56,
    gradientTransform: "translate(-1.9 36.77) rotate(4.21)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: 99.44,
    y1: 20.72,
    x2: 100.48,
    y2: 20.72,
    gradientTransform: "translate(-3.43 45.25) rotate(5.18)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: 97.51,
    y1: 44.59,
    x2: 98.58,
    y2: 44.59,
    gradientTransform: "translate(-1.45 24.83) rotate(2.88)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    x1: 99.89,
    y1: -13.71,
    x2: 100.94,
    y2: -13.71,
    gradientTransform: "translate(-7.1 72.98) rotate(8.36)",
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    x1: -724.4,
    y1: 142.21,
    x2: -722.04,
    y2: 139.52,
    gradientTransform: "translate(-686.53 48.39) rotate(170.32) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: -722.67,
    y1: 149.91,
    x2: -720.31,
    y2: 147.23,
    gradientTransform: "translate(-684.12 54.38) rotate(169.11) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-195",
    x1: -705.01,
    y1: 182.46,
    x2: -702.37,
    y2: 179.44,
    gradientTransform: "translate(-672.1 76.49) rotate(164.62) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    x1: -711.69,
    y1: 182.83,
    x2: -709.04,
    y2: 179.82,
    gradientTransform: "translate(-672.1 76.49) rotate(164.62) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    x1: -708.23,
    y1: 182.6,
    x2: -705.58,
    y2: 179.59,
    gradientTransform: "translate(-672.1 76.49) rotate(164.62) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    x1: -758.86,
    y1: 62.23,
    x2: -756.86,
    y2: 59.96,
    gradientTransform: "translate(-701.96) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    x1: -747.43,
    y1: 98.33,
    x2: -745.18,
    y2: 95.77,
    gradientTransform: "translate(-693.81 23.71) rotate(175.5) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    x1: -749.42,
    y1: 99.13,
    x2: -747.18,
    y2: 96.58,
    gradientTransform: "translate(-693.81 23.71) rotate(175.5) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: -754.11,
    y1: 98.67,
    x2: -751.87,
    y2: 96.12,
    gradientTransform: "translate(-693.81 23.71) rotate(175.5) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: -757.14,
    y1: 98.69,
    x2: -754.9,
    y2: 96.14,
    gradientTransform: "translate(-693.81 23.71) rotate(175.5) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: -763.12,
    y1: 58.11,
    x2: -761.13,
    y2: 55.84,
    gradientTransform: "translate(-701.96) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    x1: -752,
    y1: 94.55,
    x2: -749.76,
    y2: 92,
    gradientTransform: "translate(-693.81 23.71) rotate(175.5) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: -754,
    y1: 95.36,
    x2: -751.75,
    y2: 92.8,
    gradientTransform: "translate(-693.81 23.71) rotate(175.5) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    x1: -756.56,
    y1: 95.99,
    x2: -754.31,
    y2: 93.43,
    gradientTransform: "translate(-693.81 23.71) rotate(175.5) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: -759.11,
    y1: 96.6,
    x2: -756.87,
    y2: 94.05,
    gradientTransform: "translate(-693.81 23.71) rotate(175.5) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: -761.68,
    y1: 97.24,
    x2: -759.44,
    y2: 94.69,
    gradientTransform: "translate(-693.81 23.71) rotate(175.5) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: -822.14,
    y1: 120.43,
    x2: -819.89,
    y2: 117.88,
    gradientTransform: "translate(-643.84 9.74) rotate(175.5) scale(.87 -.89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    x1: -825.77,
    y1: 119.18,
    x2: -823.54,
    y2: 116.64,
    gradientTransform: "translate(-643.84 9.74) rotate(175.5) scale(.87 -.89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-211",
    x1: -781.58,
    y1: 19.37,
    x2: -779.58,
    y2: 17.09,
    gradientTransform: "translate(-710.05 -31.37) rotate(-175.19) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-212",
    x1: -773.5,
    y1: 57.07,
    x2: -771.26,
    y2: 54.51,
    gradientTransform: "translate(-703.98 -6.74) rotate(-179.69) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-213",
    x1: -775.48,
    y1: 57.88,
    x2: -773.24,
    y2: 55.33,
    gradientTransform: "translate(-703.98 -6.74) rotate(-179.69) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-214",
    x1: -778.04,
    y1: 58.5,
    x2: -775.8,
    y2: 55.96,
    gradientTransform: "translate(-703.98 -6.74) rotate(-179.69) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-215",
    x1: -780.6,
    y1: 59.14,
    x2: -778.36,
    y2: 56.58,
    gradientTransform: "translate(-703.98 -6.74) rotate(-179.69) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-216",
    x1: -783.17,
    y1: 59.76,
    x2: -780.92,
    y2: 57.2,
    gradientTransform: "translate(-703.98 -6.74) rotate(-179.69) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-217",
    x1: -845.91,
    y1: 78.83,
    x2: -843.67,
    y2: 76.28,
    gradientTransform: "translate(-652.18 -17.14) rotate(-179.69) scale(.87 -.89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-218",
    x1: -849.55,
    y1: 77.58,
    x2: -847.32,
    y2: 75.03,
    gradientTransform: "translate(-652.18 -17.14) rotate(-179.69) scale(.87 -.89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-219",
    x1: -774.68,
    y1: 49.32,
    x2: -773.06,
    y2: 47.18,
    gradientTransform: "translate(-701.96) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-220",
    x1: -790.69,
    y1: 22.36,
    x2: -788.44,
    y2: 19.8,
    gradientTransform: "translate(-711.24 -37.54) rotate(-175.19) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-221",
    x1: -792.68,
    y1: 23.34,
    x2: -790.45,
    y2: 20.79,
    gradientTransform: "translate(-711.24 -37.54) rotate(-175.19) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-222",
    x1: -795.24,
    y1: 23.8,
    x2: -792.99,
    y2: 21.25,
    gradientTransform: "translate(-711.24 -37.54) rotate(-175.19) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-223",
    x1: -797.79,
    y1: 24.43,
    x2: -795.56,
    y2: 21.88,
    gradientTransform: "translate(-711.24 -37.54) rotate(-175.19) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-224",
    x1: -800.34,
    y1: 25.06,
    x2: -798.1,
    y2: 22.51,
    gradientTransform: "translate(-711.24 -37.54) rotate(-175.19) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-225",
    x1: -866.02,
    y1: 39.95,
    x2: -863.78,
    y2: 37.39,
    gradientTransform: "translate(-658.98 -44.17) rotate(-175.19) scale(.87 -.89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-226",
    x1: -862.84,
    y1: 49.23,
    x2: -860.27,
    y2: 47.91,
    gradientTransform: "translate(-637.73 -18.85) rotate(-177.53) scale(.83 -.91)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-227",
    x1: -864.08,
    y1: 50.12,
    x2: -861.5,
    y2: 48.8,
    gradientTransform: "translate(-637.73 -18.85) rotate(-177.53) scale(.83 -.91)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-228",
    x1: -853.43,
    y1: 82.53,
    x2: -850.87,
    y2: 81.22,
    gradientTransform: "translate(-632.34 2.72) rotate(178.44) scale(.83 -.91)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-229",
    x1: -783.58,
    y1: 60.31,
    x2: -780.32,
    y2: 58.64,
    gradientTransform: "translate(-701.96) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-230",
    x1: -731.93,
    y1: 108.81,
    x2: -729.36,
    y2: 107.5,
    gradientTransform: "translate(-697.8 91.31) rotate(168.67) scale(1.05 -1.13)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-231",
    x1: -819.35,
    y1: 155.67,
    x2: -816.79,
    y2: 154.36,
    gradientTransform: "translate(-612.91 54.47) rotate(168.67) scale(.83 -.91)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-232",
    x1: -910.06,
    y1: 192.15,
    x2: -907.48,
    y2: 190.83,
    gradientTransform: "translate(-554.19 32.93) rotate(168.66) scale(.68 -.79)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-233",
    x1: -879.72,
    y1: 323.32,
    x2: -877.15,
    y2: 322.01,
    gradientTransform: "translate(-544.2 45.44) rotate(162.67) scale(.68 -.62)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-234",
    x1: -788.35,
    y1: 60.25,
    x2: -786.42,
    y2: 59.25,
    gradientTransform: "translate(-701.96) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-235",
    x1: -789.52,
    y1: 61.11,
    x2: -787.4,
    y2: 60.02,
    gradientTransform: "translate(-701.96) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-236",
    x1: -790.49,
    y1: 61.91,
    x2: -788.38,
    y2: 61.05,
    gradientTransform: "translate(-701.96) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-237",
    x1: -793.02,
    y1: 62.47,
    x2: -789.8,
    y2: 61.24,
    gradientTransform: "translate(-701.96) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-238",
    x1: -795.57,
    y1: 62.75,
    x2: -791.84,
    y2: 62.25,
    gradientTransform: "translate(-701.96) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-239",
    x1: -797.54,
    y1: 62.48,
    x2: -793.98,
    y2: 62,
    gradientTransform: "translate(-701.96) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-240",
    x1: -783.39,
    y1: 53.98,
    x2: -780.4,
    y2: 51.32,
    gradientTransform: "translate(-701.96) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-241",
    x1: -784.53,
    y1: 54.77,
    x2: -781.53,
    y2: 52.1,
    gradientTransform: "translate(-701.96) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-242",
    x1: -757.98,
    y1: 111.31,
    x2: -754.96,
    y2: 108.63,
    gradientTransform: "translate(-682.45 56.51) rotate(171.58) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-243",
    x1: -758.95,
    y1: 112.3,
    x2: -755.94,
    y2: 109.63,
    gradientTransform: "translate(-682.45 56.51) rotate(171.58) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-244",
    x1: -811.29,
    y1: 71.12,
    x2: -807.88,
    y2: 68.1,
    gradientTransform: "translate(-587.61 66.42) rotate(171.8) scale(.81 -1.24) skewX(-11.17)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-245",
    x1: -812.43,
    y1: 71.75,
    x2: -809.07,
    y2: 68.76,
    gradientTransform: "translate(-587.61 66.42) rotate(171.8) scale(.81 -1.24) skewX(-11.17)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-246",
    x1: -783.73,
    y1: 131.58,
    x2: -780.45,
    y2: 128.67,
    gradientTransform: "translate(-553.4 132.44) rotate(158.7) scale(.8 -1.25) skewX(.53)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-247",
    x1: -784.78,
    y1: 132.45,
    x2: -781.5,
    y2: 129.53,
    gradientTransform: "translate(-553.4 132.44) rotate(158.7) scale(.8 -1.25) skewX(.53)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-248",
    x1: -766.38,
    y1: 114.79,
    x2: -762.92,
    y2: 111.72,
    gradientTransform: "translate(-560.8 115.29) rotate(162.68) scale(.81 -1.24) skewX(-11.17)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-249",
    x1: -767.6,
    y1: 115.4,
    x2: -764.14,
    y2: 112.33,
    gradientTransform: "translate(-560.8 115.29) rotate(162.68) scale(.81 -1.24) skewX(-11.17)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-250",
    x1: -732.32,
    y1: 168.44,
    x2: -729.06,
    y2: 165.54,
    gradientTransform: "translate(-516.31 174.26) rotate(149.58) scale(.8 -1.25) skewX(.52)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-251",
    x1: -733.41,
    y1: 169.24,
    x2: -730.15,
    y2: 166.34,
    gradientTransform: "translate(-516.31 174.26) rotate(149.58) scale(.8 -1.25) skewX(.52)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-252",
    x1: -696.69,
    y1: 193.82,
    x2: -694.75,
    y2: 192.26,
    gradientTransform: "translate(-740.38 41.14) rotate(169.84) scale(1.16 -.77) skewX(1.72)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-253",
    x1: -697.43,
    y1: 195.17,
    x2: -695.49,
    y2: 193.62,
    gradientTransform: "translate(-740.38 41.14) rotate(169.84) scale(1.16 -.77) skewX(1.72)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-254",
    x1: -674.85,
    y1: 325.8,
    x2: -672.9,
    y2: 324.24,
    gradientTransform: "translate(-720.95 76.63) rotate(162.76) scale(1.16 -.65) skewX(2.12)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-255",
    x1: -779.49,
    y1: 44.88,
    x2: -778.67,
    y2: 43.72,
    gradientTransform: "translate(-701.96) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-256",
    x1: -780.91,
    y1: 44.57,
    x2: -780.05,
    y2: 43.65,
    gradientTransform: "translate(-701.96) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-257",
    x1: -673.6,
    y1: 279.29,
    x2: -671.65,
    y2: 277.73,
    gradientTransform: "translate(-717.45 91.02) rotate(162.38) scale(1.16 -.72) skewX(1.9)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-258",
    x1: -706.26,
    y1: 53.1,
    x2: -704.31,
    y2: 51.54,
    gradientTransform: "translate(-792.29 5.16) rotate(179.41) scale(1.24 -1) skewX(1.07)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-259",
    x1: -707.87,
    y1: 53.31,
    x2: -705.92,
    y2: 51.76,
    gradientTransform: "translate(-792.29 5.16) rotate(179.41) scale(1.24 -1) skewX(1.07)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-260",
    x1: -668.87,
    y1: 174.3,
    x2: -665.48,
    y2: 171.29,
    gradientTransform: "translate(-497.78 193.18) rotate(146.76) scale(.81 -1.24) skewX(-11.17)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-261",
    x1: -786.63,
    y1: 50.59,
    x2: -785.03,
    y2: 48.09,
    gradientTransform: "translate(-701.96) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-262",
    x1: -774.45,
    y1: 77.96,
    x2: -773.02,
    y2: 75.75,
    gradientTransform: "translate(-692.32 28.67) rotate(175.95) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-263",
    x1: -835.55,
    y1: 105.44,
    x2: -834.11,
    y2: 103.21,
    gradientTransform: "translate(-631.19 10.1) rotate(175.95) scale(.85 -.89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-264",
    x1: -789.61,
    y1: 54.86,
    x2: -787.72,
    y2: 52.41,
    gradientTransform: "translate(-701.96) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-265",
    x1: -808.43,
    y1: 51.65,
    x2: -806.55,
    y2: 49.21,
    gradientTransform: "translate(-660.8 26.24) rotate(177.9) scale(.92 -1.11) skewX(-1.84)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-266",
    x1: -864.58,
    y1: 84.54,
    x2: -862.7,
    y2: 82.11,
    gradientTransform: "translate(-549.85 66.59) rotate(170.26) scale(.72 -1.17) skewX(-6.61)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-267",
    x1: -792.29,
    y1: 56.41,
    x2: -790.39,
    y2: 55.24,
    gradientTransform: "translate(-701.96) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-268",
    x1: -793.5,
    y1: 57.02,
    x2: -791.62,
    y2: 55.85,
    gradientTransform: "translate(-701.96) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-269",
    x1: -794.53,
    y1: 57.81,
    x2: -792.64,
    y2: 56.64,
    gradientTransform: "translate(-701.96) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-270",
    x1: -795.82,
    y1: 58.32,
    x2: -794.06,
    y2: 57.24,
    gradientTransform: "translate(-701.96) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-271",
    x1: -765.37,
    y1: 121.18,
    x2: -762.99,
    y2: 119.71,
    gradientTransform: "translate(-679.21 80.76) rotate(169.43) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-96",
    cx: -598.13,
    cy: 73.17,
    fx: -598.13,
    fy: 73.17,
    r: 3.67,
    gradientTransform: "translate(-837.53 -66.32) rotate(-180) scale(1.54 -1.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c26d37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#7d3624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532511"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-97",
    cx: -645,
    cy: 6.56,
    fx: -645,
    fy: 6.56,
    r: 2.51,
    gradientTransform: "translate(-922.65 -261.37) rotate(-163.48) scale(1.63 -1.55) skewX(1.88)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-98",
    cx: -646.58,
    cy: 6.06,
    fx: -646.58,
    fy: 6.06,
    r: 2.5,
    gradientTransform: "translate(-922.65 -261.37) rotate(-163.48) scale(1.63 -1.55) skewX(1.88)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-99",
    cx: -647.99,
    cy: 5.62,
    fx: -647.99,
    fy: 5.62,
    r: 2.5,
    gradientTransform: "translate(-922.65 -261.37) rotate(-163.48) scale(1.63 -1.55) skewX(1.88)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-100",
    cx: -649.3,
    cy: 5.38,
    fx: -649.3,
    fy: 5.38,
    r: 2.5,
    gradientTransform: "translate(-922.65 -261.37) rotate(-163.48) scale(1.63 -1.55) skewX(1.88)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-101",
    cx: -650.62,
    cy: 5.19,
    fx: -650.62,
    fy: 5.19,
    r: 2.51,
    gradientTransform: "translate(-922.65 -261.37) rotate(-163.48) scale(1.63 -1.55) skewX(1.88)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-102",
    cx: -611.74,
    cy: 46.93,
    fx: -611.74,
    fy: 46.93,
    r: 2.5,
    gradientTransform: "translate(-899.61 -106.71) rotate(-175.26) scale(1.63 -1.54) skewX(.57)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-103",
    cx: -644.92,
    cy: 5.83,
    fx: -644.92,
    fy: 5.83,
    r: 2.5,
    gradientTransform: "translate(-922.65 -261.37) rotate(-163.48) scale(1.63 -1.55) skewX(1.88)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-104",
    cx: -646.49,
    cy: 5.33,
    fx: -646.49,
    fy: 5.33,
    r: 2.5,
    gradientTransform: "translate(-922.65 -261.37) rotate(-163.48) scale(1.63 -1.55) skewX(1.88)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-105",
    cx: -647.91,
    cy: 4.89,
    fx: -647.91,
    fy: 4.89,
    r: 2.5,
    gradientTransform: "translate(-922.65 -261.37) rotate(-163.48) scale(1.63 -1.55) skewX(1.88)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-106",
    cx: -649.21,
    cy: 4.65,
    fx: -649.21,
    fy: 4.65,
    r: 2.5,
    gradientTransform: "translate(-922.65 -261.37) rotate(-163.48) scale(1.63 -1.55) skewX(1.88)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-107",
    cx: -650.53,
    cy: 4.46,
    fx: -650.53,
    fy: 4.46,
    r: 2.5,
    gradientTransform: "translate(-922.65 -261.37) rotate(-163.48) scale(1.63 -1.55) skewX(1.88)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-108",
    cx: -611.82,
    cy: 46.2,
    fx: -611.82,
    fy: 46.2,
    r: 2.51,
    gradientTransform: "translate(-899.61 -106.71) rotate(-175.26) scale(1.63 -1.54) skewX(.57)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-109",
    cx: -600.8,
    cy: 55.7,
    fx: -600.8,
    fy: 55.7,
    r: 2.5,
    gradientTransform: "translate(-888.19 -68.3) rotate(-178.2) scale(1.63 -1.54) skewX(.22)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-110",
    cx: -631.31,
    cy: 96.78,
    fx: -631.31,
    fy: 96.78,
    r: 2.51,
    gradientTransform: "translate(-776.86 -100.85) rotate(-178.36) scale(1.38 -1.3) skewX(.56)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-111",
    cx: -607.93,
    cy: 87.02,
    fx: -607.93,
    fy: 87.02,
    r: 2.5,
    gradientTransform: "translate(-783.05 -133.56) rotate(-175.41) scale(1.44 -1.32) skewX(-5.38)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-112",
    cx: -624.9,
    cy: 117.19,
    fx: -624.9,
    fy: 117.19,
    r: 2.51,
    gradientTransform: "translate(-721.45 -134.53) rotate(-176.65) scale(1.3 -1.2) skewX(-3.93)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-113",
    cx: -620.75,
    cy: 123.82,
    fx: -620.75,
    fy: 123.82,
    r: 2.5,
    gradientTransform: "translate(-646.97 -218.66) rotate(-168.42) scale(1.18 -.97) skewX(-17.8)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-114",
    cx: -621.29,
    cy: 124.59,
    fx: -621.29,
    fy: 124.59,
    r: 2.51,
    gradientTransform: "translate(-646.97 -218.66) rotate(-168.42) scale(1.18 -.97) skewX(-17.8)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-115",
    cx: -622.18,
    cy: 124.99,
    fx: -622.18,
    fy: 124.99,
    r: 2.5,
    gradientTransform: "translate(-646.97 -218.66) rotate(-168.42) scale(1.18 -.97) skewX(-17.8)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-116",
    cx: -623.22,
    cy: 125.14,
    fx: -623.22,
    fy: 125.14,
    r: 2.51,
    gradientTransform: "translate(-646.97 -218.66) rotate(-168.42) scale(1.18 -.97) skewX(-17.8)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-117",
    cx: -624.05,
    cy: 125.27,
    fx: -624.05,
    fy: 125.27,
    r: 2.51,
    gradientTransform: "translate(-646.97 -218.66) rotate(-168.42) scale(1.18 -.97) skewX(-17.8)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-118",
    cx: -521.49,
    cy: 212.65,
    fx: -521.49,
    fy: 212.65,
    r: 2.5,
    gradientTransform: "translate(-621.99 -41.13) rotate(171.3) scale(1.18 -.97) skewX(-17.79)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-119",
    cx: -645.71,
    cy: 5.03,
    fx: -645.71,
    fy: 5.03,
    r: 2.5,
    gradientTransform: "translate(-922.65 -261.37) rotate(-163.48) scale(1.63 -1.55) skewX(1.88)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-120",
    cx: -647.29,
    cy: 4.54,
    fx: -647.29,
    fy: 4.54,
    r: 2.5,
    gradientTransform: "translate(-922.65 -261.37) rotate(-163.48) scale(1.63 -1.55) skewX(1.88)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-121",
    cx: -648.69,
    cy: 4.09,
    fx: -648.69,
    fy: 4.09,
    r: 2.5,
    gradientTransform: "translate(-922.65 -261.37) rotate(-163.48) scale(1.63 -1.55) skewX(1.88)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-122",
    cx: -650.01,
    cy: 3.85,
    fx: -650.01,
    fy: 3.85,
    r: 2.51,
    gradientTransform: "translate(-922.65 -261.37) rotate(-163.48) scale(1.63 -1.55) skewX(1.88)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-123",
    cx: -651.33,
    cy: 3.66,
    fx: -651.33,
    fy: 3.66,
    r: 2.5,
    gradientTransform: "translate(-922.65 -261.37) rotate(-163.48) scale(1.63 -1.55) skewX(1.88)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-124",
    cx: -612.77,
    cy: 45.6,
    fx: -612.77,
    fy: 45.6,
    r: 2.5,
    gradientTransform: "translate(-899.61 -106.71) rotate(-175.26) scale(1.63 -1.54) skewX(.57)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-125",
    cx: -601.78,
    cy: 55.14,
    fx: -601.78,
    fy: 55.14,
    r: 2.51,
    gradientTransform: "translate(-888.19 -68.3) rotate(-178.2) scale(1.63 -1.54) skewX(.22)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-126",
    cx: -632.46,
    cy: 96.13,
    fx: -632.46,
    fy: 96.13,
    r: 2.5,
    gradientTransform: "translate(-776.86 -100.85) rotate(-178.36) scale(1.38 -1.3) skewX(.56)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-127",
    cx: -629.67,
    cy: 109.87,
    fx: -629.67,
    fy: 109.87,
    r: 2.5,
    gradientTransform: "translate(-709.31 -150.74) rotate(-174.7) scale(1.27 -1.16) skewX(-6.65)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-128",
    cx: -621.63,
    cy: 122.26,
    fx: -621.63,
    fy: 122.26,
    r: 2.51,
    gradientTransform: "translate(-646.97 -218.66) rotate(-168.42) scale(1.18 -.97) skewX(-17.8)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-129",
    cx: -621.97,
    cy: 123.15,
    fx: -621.97,
    fy: 123.15,
    r: 2.5,
    gradientTransform: "translate(-646.97 -218.66) rotate(-168.42) scale(1.18 -.97) skewX(-17.8)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-130",
    cx: -622.32,
    cy: 124.04,
    fx: -622.32,
    fy: 124.04,
    r: 2.51,
    gradientTransform: "translate(-646.97 -218.66) rotate(-168.42) scale(1.18 -.97) skewX(-17.8)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-131",
    cx: -623.35,
    cy: 124.29,
    fx: -623.35,
    fy: 124.29,
    r: 2.5,
    gradientTransform: "translate(-646.97 -218.66) rotate(-168.42) scale(1.18 -.97) skewX(-17.8)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-132",
    cx: -624.49,
    cy: 124.32,
    fx: -624.49,
    fy: 124.32,
    r: 2.5,
    gradientTransform: "translate(-646.97 -218.66) rotate(-168.42) scale(1.18 -.97) skewX(-17.8)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-133",
    cx: -625.63,
    cy: 124.11,
    fx: -625.63,
    fy: 124.11,
    r: 2.51,
    gradientTransform: "translate(-646.97 -218.66) rotate(-168.42) scale(1.18 -.97) skewX(-17.8)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-134",
    cx: -653.5,
    cy: 1.33,
    fx: -653.5,
    fy: 1.33,
    r: 2.51,
    gradientTransform: "translate(-879.48 -261.72) rotate(-162.52) scale(1.54 -1.54)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-135",
    cx: -655.07,
    cy: 0.83,
    fx: -655.07,
    fy: 0.83,
    r: 2.5,
    gradientTransform: "translate(-879.48 -261.72) rotate(-162.52) scale(1.54 -1.54)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-136",
    cx: -656.48,
    cy: 0.39,
    fx: -656.48,
    fy: 0.39,
    r: 2.5,
    gradientTransform: "translate(-879.48 -261.72) rotate(-162.52) scale(1.54 -1.54)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-137",
    cx: -657.79,
    cy: 0.15,
    fx: -657.79,
    fy: 0.15,
    r: 2.51,
    gradientTransform: "translate(-879.48 -261.72) rotate(-162.52) scale(1.54 -1.54)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-138",
    cx: -659.11,
    cy: -0.04,
    fx: -659.11,
    fy: -0.04,
    r: 2.5,
    gradientTransform: "translate(-879.48 -261.72) rotate(-162.52) scale(1.54 -1.54)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-139",
    cx: -620.1,
    cy: 43.89,
    fx: -620.1,
    fy: 43.89,
    r: 2.5,
    gradientTransform: "translate(-855.97 -106.59) rotate(-174.96) scale(1.54 -1.54)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-140",
    cx: -609.92,
    cy: 54.58,
    fx: -609.92,
    fy: 54.58,
    r: 2.5,
    gradientTransform: "translate(-846.31 -69.28) rotate(-178.08) scale(1.54 -1.54)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-141",
    cx: -641.1,
    cy: 93.82,
    fx: -641.1,
    fy: 93.82,
    r: 2.5,
    gradientTransform: "translate(-739.76 -99.64) rotate(-178.27) scale(1.3 -1.31) skewX(.37)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-142",
    cx: -641.56,
    cy: 107.61,
    fx: -641.56,
    fy: 107.61,
    r: 2.5,
    gradientTransform: "translate(-678.77 -151.13) rotate(-174.38) scale(1.2 -1.16) skewX(-7.25)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-143",
    cx: -635.35,
    cy: 116.93,
    fx: -635.35,
    fy: 116.93,
    r: 2.5,
    gradientTransform: "translate(-619.83 -218.31) rotate(-167.73) scale(1.11 -.97) skewX(-18.85)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-144",
    cx: -635.69,
    cy: 117.82,
    fx: -635.69,
    fy: 117.82,
    r: 2.5,
    gradientTransform: "translate(-619.83 -218.31) rotate(-167.73) scale(1.11 -.97) skewX(-18.85)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-145",
    cx: -636.04,
    cy: 118.71,
    fx: -636.04,
    fy: 118.71,
    r: 2.51,
    gradientTransform: "translate(-619.83 -218.31) rotate(-167.73) scale(1.11 -.97) skewX(-18.85)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-146",
    cx: -637.07,
    cy: 118.96,
    fx: -637.07,
    fy: 118.96,
    r: 2.5,
    gradientTransform: "translate(-619.83 -218.31) rotate(-167.73) scale(1.11 -.97) skewX(-18.85)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-147",
    cx: -638.23,
    cy: 118.99,
    fx: -638.23,
    fy: 118.99,
    r: 2.5,
    gradientTransform: "translate(-619.83 -218.31) rotate(-167.73) scale(1.11 -.97) skewX(-18.85)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-148",
    cx: -639.36,
    cy: 118.78,
    fx: -639.36,
    fy: 118.78,
    r: 2.5,
    gradientTransform: "translate(-619.83 -218.31) rotate(-167.73) scale(1.11 -.97) skewX(-18.85)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-149",
    cx: -605.21,
    cy: 71.59,
    fx: -605.21,
    fy: 71.59,
    r: 6.95,
    xlinkHref: "#radial-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-272",
    x1: 36.46,
    y1: 51.68,
    x2: 35.88,
    y2: 49.54,
    gradientTransform: "translate(41.72 -12.5) rotate(-3.64) scale(1.06 1.16)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-150",
    cx: -146.54,
    cy: 136.04,
    fx: -146.54,
    fy: 136.04,
    r: 2.36,
    gradientTransform: "translate(273.99 -200.42) rotate(-8.99) scale(1.54)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-151",
    cx: -104.09,
    cy: -16252.19,
    fx: -104.09,
    fy: -16252.19,
    r: 3.43,
    gradientTransform: "translate(246.34 -25059.42) scale(1.54 -1.54)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-152",
    cx: -103.25,
    cy: -16252.87,
    fx: -103.25,
    fy: -16252.87,
    r: 3.46,
    gradientTransform: "translate(246.34 -25059.42) scale(1.54 -1.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c26d37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532511"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-273",
    x1: 663.21,
    y1: -94.57,
    x2: 665.57,
    y2: -97.26,
    gradientTransform: "translate(-521.91 48.39) rotate(9.68)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-274",
    x1: 659.58,
    y1: -115.98,
    x2: 661.95,
    y2: -118.67,
    gradientTransform: "translate(-524.33 54.38) rotate(10.89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-275",
    x1: 652.1,
    y1: -190.96,
    x2: 654.75,
    y2: -193.97,
    gradientTransform: "translate(-536.34 76.49) rotate(15.38)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-276",
    x1: 645.42,
    y1: -190.58,
    x2: 648.07,
    y2: -193.59,
    gradientTransform: "translate(-536.34 76.49) rotate(15.38)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-277",
    x1: 648.88,
    y1: -190.81,
    x2: 651.53,
    y2: -193.82,
    gradientTransform: "translate(-536.34 76.49) rotate(15.38)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-278",
    x1: 648.74,
    y1: 62.23,
    x2: 650.73,
    y2: 59.95,
    gradientTransform: "translate(-506.48)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-279",
    x1: 655.86,
    y1: -12.03,
    x2: 658.11,
    y2: -14.6,
    gradientTransform: "translate(-514.63 23.71) rotate(4.5)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-280",
    x1: 653.87,
    y1: -11.23,
    x2: 656.11,
    y2: -13.78,
    gradientTransform: "translate(-514.63 23.71) rotate(4.5)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-281",
    x1: 649.19,
    y1: -11.69,
    x2: 651.42,
    y2: -14.24,
    gradientTransform: "translate(-514.63 23.71) rotate(4.5)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-282",
    x1: 646.15,
    y1: -11.67,
    x2: 648.39,
    y2: -14.21,
    gradientTransform: "translate(-514.63 23.71) rotate(4.5)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-283",
    x1: 644.48,
    y1: 58.11,
    x2: 646.48,
    y2: 55.84,
    gradientTransform: "translate(-506.48)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-284",
    x1: 651.29,
    y1: -15.82,
    x2: 653.53,
    y2: -18.37,
    gradientTransform: "translate(-514.63 23.71) rotate(4.5)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-285",
    x1: 649.3,
    y1: -15,
    x2: 651.54,
    y2: -17.55,
    gradientTransform: "translate(-514.63 23.71) rotate(4.5)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-286",
    x1: 646.73,
    y1: -14.36,
    x2: 648.98,
    y2: -16.92,
    gradientTransform: "translate(-514.63 23.71) rotate(4.5)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-287",
    x1: 644.18,
    y1: -13.76,
    x2: 646.42,
    y2: -16.31,
    gradientTransform: "translate(-514.63 23.71) rotate(4.5)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-288",
    x1: 641.61,
    y1: -13.12,
    x2: 643.86,
    y2: -15.68,
    gradientTransform: "translate(-514.63 23.71) rotate(4.5)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-289",
    x1: 794.03,
    y1: -4.25,
    x2: 796.27,
    y2: -6.81,
    gradientTransform: "translate(-564.6 9.74) rotate(4.5) scale(.87 .89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-290",
    x1: 790.38,
    y1: -5.49,
    x2: 792.62,
    y2: -8.05,
    gradientTransform: "translate(-564.6 9.74) rotate(4.5) scale(.87 .89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-291",
    x1: 621.05,
    y1: 137.33,
    x2: 623.05,
    y2: 135.05,
    gradientTransform: "translate(-498.39 -31.37) rotate(-4.81)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-292",
    x1: 634.06,
    y1: 64.67,
    x2: 636.3,
    y2: 62.11,
    gradientTransform: "translate(-504.46 -6.74) rotate(-.31)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-293",
    x1: 632.08,
    y1: 65.49,
    x2: 634.32,
    y2: 62.93,
    gradientTransform: "translate(-504.46 -6.74) rotate(-.31)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-294",
    x1: 629.52,
    y1: 66.11,
    x2: 631.76,
    y2: 63.56,
    gradientTransform: "translate(-504.46 -6.74) rotate(-.31)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-295",
    x1: 626.95,
    y1: 66.73,
    x2: 629.19,
    y2: 64.18,
    gradientTransform: "translate(-504.46 -6.74) rotate(-.31)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-296",
    x1: 624.38,
    y1: 67.37,
    x2: 626.63,
    y2: 64.81,
    gradientTransform: "translate(-504.46 -6.74) rotate(-.31)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-297",
    x1: 775.14,
    y1: 87.44,
    x2: 777.38,
    y2: 84.89,
    gradientTransform: "translate(-556.26 -17.14) rotate(-.31) scale(.87 .89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-298",
    x1: 771.49,
    y1: 86.19,
    x2: 773.73,
    y2: 83.64,
    gradientTransform: "translate(-556.26 -17.14) rotate(-.31) scale(.87 .89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-299",
    x1: 632.92,
    y1: 49.33,
    x2: 634.55,
    y2: 47.18,
    gradientTransform: "translate(-506.48)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-300",
    x1: 611.95,
    y1: 140.31,
    x2: 614.19,
    y2: 137.76,
    gradientTransform: "translate(-497.2 -37.54) rotate(-4.81)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-301",
    x1: 609.95,
    y1: 141.29,
    x2: 612.18,
    y2: 138.75,
    gradientTransform: "translate(-497.2 -37.54) rotate(-4.81)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-302",
    x1: 607.39,
    y1: 141.75,
    x2: 609.63,
    y2: 139.2,
    gradientTransform: "translate(-497.2 -37.54) rotate(-4.81)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-303",
    x1: 604.84,
    y1: 142.39,
    x2: 607.08,
    y2: 139.83,
    gradientTransform: "translate(-497.2 -37.54) rotate(-4.81)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-304",
    x1: 602.28,
    y1: 143.01,
    x2: 604.51,
    y2: 140.46,
    gradientTransform: "translate(-497.2 -37.54) rotate(-4.81)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-305",
    x1: 749.47,
    y1: 173.24,
    x2: 751.7,
    y2: 170.69,
    gradientTransform: "translate(-549.47 -44.17) rotate(-4.81) scale(.87 .89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-306",
    x1: 827.67,
    y1: 115.83,
    x2: 830.23,
    y2: 114.53,
    gradientTransform: "translate(-570.71 -18.85) rotate(-2.47) scale(.83 .91)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-307",
    x1: 826.43,
    y1: 116.73,
    x2: 828.99,
    y2: 115.42,
    gradientTransform: "translate(-570.71 -18.85) rotate(-2.47) scale(.83 .91)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-308",
    x1: 837.96,
    y1: 40.59,
    x2: 840.51,
    y2: 39.29,
    gradientTransform: "translate(-576.1 2.72) rotate(1.56) scale(.83 .91)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-309",
    x1: 624.02,
    y1: 60.31,
    x2: 627.29,
    y2: 58.64,
    gradientTransform: "translate(-506.48)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-310",
    x1: 577.59,
    y1: -136.11,
    x2: 580.15,
    y2: -137.42,
    gradientTransform: "translate(-510.64 91.31) rotate(11.33) scale(1.05 1.13)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-311",
    x1: 839.62,
    y1: -147.73,
    x2: 842.19,
    y2: -149.05,
    gradientTransform: "translate(-595.53 54.47) rotate(11.33) scale(.83 .91)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-312",
    x1: 1112.99,
    y1: -157.72,
    x2: 1115.57,
    y2: -159.04,
    gradientTransform: "translate(-654.25 32.93) rotate(11.34) scale(.68 .79)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-313",
    x1: 1101.19,
    y1: -350.32,
    x2: 1103.76,
    y2: -351.63,
    gradientTransform: "translate(-664.24 45.44) rotate(17.33) scale(.68 .62)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-314",
    x1: 619.24,
    y1: 60.25,
    x2: 621.18,
    y2: 59.25,
    gradientTransform: "translate(-506.48)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-315",
    x1: 618.08,
    y1: 61.11,
    x2: 620.21,
    y2: 60.02,
    gradientTransform: "translate(-506.48)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-316",
    x1: 617.12,
    y1: 61.91,
    x2: 619.24,
    y2: 61.05,
    gradientTransform: "translate(-506.48)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-317",
    x1: 614.58,
    y1: 62.47,
    x2: 617.81,
    y2: 61.24,
    gradientTransform: "translate(-506.48)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-318",
    x1: 612.04,
    y1: 62.75,
    x2: 615.76,
    y2: 62.25,
    gradientTransform: "translate(-506.48)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-319",
    x1: 609.95,
    y1: 62.05,
    x2: 613.49,
    y2: 61.57,
    gradientTransform: "translate(-506.48)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-320",
    x1: 624.21,
    y1: 53.99,
    x2: 627.2,
    y2: 51.32,
    gradientTransform: "translate(-506.48)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-321",
    x1: 623.06,
    y1: 54.77,
    x2: 626.06,
    y2: 52.1,
    gradientTransform: "translate(-506.48)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-322",
    x1: 634.45,
    y1: -94.91,
    x2: 637.45,
    y2: -97.58,
    gradientTransform: "translate(-525.99 56.51) rotate(8.42)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-323",
    x1: 633.48,
    y1: -93.93,
    x2: 636.48,
    y2: -96.59,
    gradientTransform: "translate(-525.99 56.51) rotate(8.42)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-324",
    x1: 877.51,
    y1: -91.49,
    x2: 880.88,
    y2: -94.48,
    gradientTransform: "translate(-620.83 66.42) rotate(8.2) scale(.81 1.24) skewX(-11.17)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-325",
    x1: 876.34,
    y1: -90.84,
    x2: 879.7,
    y2: -93.83,
    gradientTransform: "translate(-620.83 66.42) rotate(8.2) scale(.81 1.24) skewX(-11.17)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-326",
    x1: 862.93,
    y1: -276.61,
    x2: 866.19,
    y2: -279.51,
    gradientTransform: "translate(-655.04 132.44) rotate(21.3) scale(.8 1.25) skewX(.53)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-327",
    x1: 861.88,
    y1: -275.74,
    x2: 865.15,
    y2: -278.65,
    gradientTransform: "translate(-655.04 132.44) rotate(21.3) scale(.8 1.25) skewX(.53)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-328",
    x1: 826.29,
    y1: -224.58,
    x2: 829.73,
    y2: -227.64,
    gradientTransform: "translate(-647.64 115.29) rotate(17.32) scale(.81 1.24) skewX(-11.17)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-329",
    x1: 825.06,
    y1: -223.97,
    x2: 828.51,
    y2: -227.04,
    gradientTransform: "translate(-647.64 115.29) rotate(17.32) scale(.81 1.24) skewX(-11.17)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-330",
    x1: 793.54,
    y1: -400.52,
    x2: 796.79,
    y2: -403.42,
    gradientTransform: "translate(-692.13 174.26) rotate(30.42) scale(.8 1.25) skewX(.52)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-331",
    x1: 792.41,
    y1: -399.69,
    x2: 795.69,
    y2: -402.61,
    gradientTransform: "translate(-692.13 174.26) rotate(30.42) scale(.8 1.25) skewX(.52)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-332",
    x1: 505.85,
    y1: -127.7,
    x2: 507.8,
    y2: -129.25,
    gradientTransform: "translate(-468.06 41.14) rotate(10.16) scale(1.16 .77) skewX(1.72)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-333",
    x1: 505.11,
    y1: -126.34,
    x2: 507.06,
    y2: -127.9,
    gradientTransform: "translate(-468.06 41.14) rotate(10.16) scale(1.16 .77) skewX(1.72)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-334",
    x1: 506.76,
    y1: -320.48,
    x2: 508.71,
    y2: -322.05,
    gradientTransform: "translate(-487.49 76.63) rotate(17.24) scale(1.16 .65) skewX(2.12)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-335",
    x1: 628.1,
    y1: 44.87,
    x2: 628.92,
    y2: 43.72,
    gradientTransform: "translate(-506.48)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-336",
    x1: 626.69,
    y1: 44.57,
    x2: 627.54,
    y2: 43.64,
    gradientTransform: "translate(-506.48)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-337",
    x1: 501.14,
    y1: -313.4,
    x2: 503.09,
    y2: -314.95,
    gradientTransform: "translate(-490.99 91.02) rotate(17.62) scale(1.16 .72) skewX(1.9)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-338",
    x1: 430.89,
    y1: 38.55,
    x2: 432.83,
    y2: 37,
    gradientTransform: "translate(-416.15 5.16) rotate(.59) scale(1.24 1) skewX(1.07)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-339",
    x1: 429.28,
    y1: 38.77,
    x2: 431.22,
    y2: 37.21,
    gradientTransform: "translate(-416.15 5.16) rotate(.59) scale(1.24 1) skewX(1.07)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-340",
    x1: 660.17,
    y1: -449.39,
    x2: 664.86,
    y2: -453.55,
    gradientTransform: "translate(-710.66 193.18) rotate(33.24) scale(.81 1.24) skewX(-11.17)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-341",
    x1: 620.96,
    y1: 50.6,
    x2: 622.58,
    y2: 48.09,
    gradientTransform: "translate(-506.48)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-342",
    x1: 629.64,
    y1: -21.41,
    x2: 631.07,
    y2: -23.63,
    gradientTransform: "translate(-516.12 28.67) rotate(4.05)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-343",
    x1: 810.85,
    y1: -6.6,
    x2: 812.29,
    y2: -8.83,
    gradientTransform: "translate(-577.25 10.1) rotate(4.05) scale(.85 .89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-344",
    x1: 617.99,
    y1: 54.86,
    x2: 619.88,
    y2: 52.41,
    gradientTransform: "translate(-506.48)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-345",
    x1: 714.86,
    y1: 5.25,
    x2: 716.75,
    y2: 2.8,
    gradientTransform: "translate(-547.64 26.24) rotate(2.1) scale(.92 1.11) skewX(-1.84)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-346",
    x1: 1032.45,
    y1: -119.25,
    x2: 1034.33,
    y2: -121.68,
    gradientTransform: "translate(-658.59 66.59) rotate(9.74) scale(.72 1.17) skewX(-6.61)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-347",
    x1: 615.31,
    y1: 56.41,
    x2: 617.21,
    y2: 55.25,
    gradientTransform: "translate(-506.48)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-348",
    x1: 614.09,
    y1: 57.02,
    x2: 615.98,
    y2: 55.85,
    gradientTransform: "translate(-506.48)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-349",
    x1: 613.07,
    y1: 57.81,
    x2: 614.96,
    y2: 56.64,
    gradientTransform: "translate(-506.48)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-350",
    x1: 611.78,
    y1: 58.33,
    x2: 613.54,
    y2: 57.24,
    gradientTransform: "translate(-506.48)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-351",
    x1: 618.85,
    y1: -137.65,
    x2: 620.7,
    y2: -138.79,
    gradientTransform: "translate(-529.23 80.76) rotate(10.57)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-153",
    cx: 420.08,
    fx: 420.08,
    r: 3.67,
    gradientTransform: "translate(-535.92 -66.32) scale(1.54)",
    xlinkHref: "#radial-gradient-96"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-154",
    cx: 273.07,
    cy: 295.67,
    fx: 273.07,
    fy: 295.67,
    r: 2.51,
    gradientTransform: "translate(-450.81 -261.37) rotate(-16.52) scale(1.63 1.55) skewX(1.88)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-155",
    cx: 271.49,
    cy: 295.17,
    fx: 271.49,
    fy: 295.17,
    r: 2.5,
    gradientTransform: "translate(-450.81 -261.37) rotate(-16.52) scale(1.63 1.55) skewX(1.88)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-156",
    cx: 270.08,
    cy: 294.73,
    fx: 270.08,
    fy: 294.73,
    r: 2.5,
    gradientTransform: "translate(-450.81 -261.37) rotate(-16.52) scale(1.63 1.55) skewX(1.88)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-157",
    cx: 268.77,
    cy: 294.49,
    fx: 268.77,
    fy: 294.49,
    r: 2.51,
    gradientTransform: "translate(-450.81 -261.37) rotate(-16.52) scale(1.63 1.55) skewX(1.88)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-158",
    cx: 267.45,
    cy: 294.3,
    fx: 267.45,
    fy: 294.3,
    r: 2.5,
    gradientTransform: "translate(-450.81 -261.37) rotate(-16.52) scale(1.63 1.55) skewX(1.88)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-159",
    cx: 347.02,
    cy: 131.45,
    fx: 347.02,
    fy: 131.45,
    r: 2.5,
    gradientTransform: "translate(-473.85 -106.71) rotate(-4.74) scale(1.63 1.54) skewX(.57)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-160",
    cx: 273.15,
    cy: 294.94,
    fx: 273.15,
    fy: 294.94,
    r: 2.5,
    gradientTransform: "translate(-450.81 -261.37) rotate(-16.52) scale(1.63 1.55) skewX(1.88)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-161",
    cx: 271.58,
    cy: 294.44,
    fx: 271.58,
    fy: 294.44,
    r: 2.5,
    gradientTransform: "translate(-450.81 -261.37) rotate(-16.52) scale(1.63 1.55) skewX(1.88)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-162",
    cx: 270.16,
    cy: 294,
    fx: 270.16,
    fy: 294,
    r: 2.5,
    gradientTransform: "translate(-450.81 -261.37) rotate(-16.52) scale(1.63 1.55) skewX(1.88)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-163",
    cx: 268.85,
    cy: 293.76,
    fx: 268.85,
    fy: 293.76,
    r: 2.5,
    gradientTransform: "translate(-450.81 -261.37) rotate(-16.52) scale(1.63 1.55) skewX(1.88)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-164",
    cx: 267.54,
    cy: 293.57,
    fx: 267.54,
    fy: 293.57,
    r: 2.51,
    gradientTransform: "translate(-450.81 -261.37) rotate(-16.52) scale(1.63 1.55) skewX(1.88)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-165",
    cx: 346.95,
    cy: 130.72,
    fx: 346.95,
    fy: 130.72,
    r: 2.51,
    gradientTransform: "translate(-473.85 -106.71) rotate(-4.74) scale(1.63 1.54) skewX(.57)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-166",
    cx: 361.2,
    cy: 87.85,
    fx: 361.2,
    fy: 87.85,
    r: 2.5,
    gradientTransform: "translate(-485.27 -68.3) rotate(-1.8) scale(1.63 1.54) skewX(.22)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-167",
    cx: 507.08,
    cy: 131.27,
    fx: 507.08,
    fy: 131.27,
    r: 2.51,
    gradientTransform: "translate(-596.6 -100.85) rotate(-1.64) scale(1.38 1.3) skewX(.56)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-168",
    cx: 493.21,
    cy: 182.51,
    fx: 493.21,
    fy: 182.51,
    r: 2.5,
    gradientTransform: "translate(-590.41 -133.56) rotate(-4.59) scale(1.44 1.32) skewX(-5.38)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-169",
    cx: 592.02,
    cy: 194.12,
    fx: 592.02,
    fy: 194.12,
    r: 2.52,
    gradientTransform: "translate(-652.01 -134.53) rotate(-3.35) scale(1.3 1.2) skewX(-3.93)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-170",
    cx: 794.91,
    cy: 450.53,
    fx: 794.91,
    fy: 450.53,
    r: 2.51,
    gradientTransform: "translate(-726.49 -218.66) rotate(-11.58) scale(1.18 .97) skewX(-17.8)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-171",
    cx: 794.36,
    cy: 451.3,
    fx: 794.36,
    fy: 451.3,
    r: 2.51,
    gradientTransform: "translate(-726.49 -218.66) rotate(-11.58) scale(1.18 .97) skewX(-17.8)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-172",
    cx: 793.48,
    cy: 451.7,
    fx: 793.48,
    fy: 451.7,
    r: 2.5,
    gradientTransform: "translate(-726.49 -218.66) rotate(-11.58) scale(1.18 .97) skewX(-17.8)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-173",
    cx: 792.43,
    cy: 451.85,
    fx: 792.43,
    fy: 451.85,
    r: 2.51,
    gradientTransform: "translate(-726.49 -218.66) rotate(-11.58) scale(1.18 .97) skewX(-17.8)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-174",
    cx: 791.6,
    cy: 451.98,
    fx: 791.6,
    fy: 451.98,
    r: 2.51,
    gradientTransform: "translate(-726.49 -218.66) rotate(-11.58) scale(1.18 .97) skewX(-17.8)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-175",
    cx: 722.04,
    cy: -33.48,
    fx: 722.04,
    fy: -33.48,
    r: 2.49,
    gradientTransform: "translate(-751.46 -41.13) rotate(8.7) scale(1.18 .97) skewX(-17.79)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-176",
    cx: 272.36,
    cy: 294.14,
    fx: 272.36,
    fy: 294.14,
    r: 2.5,
    gradientTransform: "translate(-450.81 -261.37) rotate(-16.52) scale(1.63 1.55) skewX(1.88)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-177",
    cx: 270.79,
    cy: 293.65,
    fx: 270.79,
    fy: 293.65,
    r: 2.5,
    gradientTransform: "translate(-450.81 -261.37) rotate(-16.52) scale(1.63 1.55) skewX(1.88)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-178",
    cx: 269.38,
    cy: 293.2,
    fx: 269.38,
    fy: 293.2,
    r: 2.5,
    gradientTransform: "translate(-450.81 -261.37) rotate(-16.52) scale(1.63 1.55) skewX(1.88)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-179",
    cx: 268.06,
    cy: 292.96,
    fx: 268.06,
    fy: 292.96,
    r: 2.51,
    gradientTransform: "translate(-450.81 -261.37) rotate(-16.52) scale(1.63 1.55) skewX(1.88)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-180",
    cx: 266.74,
    cy: 292.77,
    fx: 266.74,
    fy: 292.77,
    r: 2.51,
    gradientTransform: "translate(-450.81 -261.37) rotate(-16.52) scale(1.63 1.55) skewX(1.88)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-181",
    cx: 346,
    cy: 130.11,
    fx: 346,
    fy: 130.11,
    r: 2.5,
    gradientTransform: "translate(-473.85 -106.71) rotate(-4.74) scale(1.63 1.54) skewX(.57)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-182",
    cx: 360.23,
    cy: 87.3,
    fx: 360.23,
    fy: 87.3,
    r: 2.5,
    gradientTransform: "translate(-485.27 -68.3) rotate(-1.8) scale(1.63 1.54) skewX(.22)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-183",
    cx: 505.93,
    cy: 130.62,
    fx: 505.93,
    fy: 130.62,
    r: 2.51,
    gradientTransform: "translate(-596.6 -100.85) rotate(-1.64) scale(1.38 1.3) skewX(.56)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-184",
    cx: 619.1,
    cy: 235.28,
    fx: 619.1,
    fy: 235.28,
    r: 2.5,
    gradientTransform: "translate(-664.15 -150.74) rotate(-5.3) scale(1.27 1.16) skewX(-6.65)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-185",
    cx: 794.03,
    cy: 448.97,
    fx: 794.03,
    fy: 448.97,
    r: 2.51,
    gradientTransform: "translate(-726.49 -218.66) rotate(-11.58) scale(1.18 .97) skewX(-17.8)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-186",
    cx: 793.69,
    cy: 449.86,
    fx: 793.69,
    fy: 449.86,
    r: 2.51,
    gradientTransform: "translate(-726.49 -218.66) rotate(-11.58) scale(1.18 .97) skewX(-17.8)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-187",
    cx: 793.34,
    cy: 450.76,
    fx: 793.34,
    fy: 450.76,
    r: 2.5,
    gradientTransform: "translate(-726.49 -218.66) rotate(-11.58) scale(1.18 .97) skewX(-17.8)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-188",
    cx: 792.31,
    cy: 451,
    fx: 792.31,
    fy: 451,
    r: 2.5,
    gradientTransform: "translate(-726.49 -218.66) rotate(-11.58) scale(1.18 .97) skewX(-17.8)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-189",
    cx: 791.16,
    cy: 451.04,
    fx: 791.16,
    fy: 451.04,
    r: 2.5,
    gradientTransform: "translate(-726.49 -218.66) rotate(-11.58) scale(1.18 .97) skewX(-17.8)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-190",
    cx: 790.02,
    cy: 450.82,
    fx: 790.02,
    fy: 450.82,
    r: 2.51,
    gradientTransform: "translate(-726.49 -218.66) rotate(-11.58) scale(1.18 .97) skewX(-17.8)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-191",
    cx: 317.65,
    cy: 307.2,
    fx: 317.65,
    fy: 307.2,
    r: 2.51,
    gradientTransform: "translate(-493.98 -261.72) rotate(-17.48) scale(1.54)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-192",
    cx: 316.08,
    cy: 306.7,
    fx: 316.08,
    fy: 306.7,
    r: 2.51,
    gradientTransform: "translate(-493.98 -261.72) rotate(-17.48) scale(1.54)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-193",
    cx: 314.67,
    cy: 306.26,
    fx: 314.67,
    fy: 306.26,
    r: 2.5,
    gradientTransform: "translate(-493.98 -261.72) rotate(-17.48) scale(1.54)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-194",
    cx: 313.35,
    cy: 306.02,
    fx: 313.35,
    fy: 306.02,
    r: 2.5,
    gradientTransform: "translate(-493.98 -261.72) rotate(-17.48) scale(1.54)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-195",
    cx: 312.03,
    cy: 305.83,
    fx: 312.03,
    fy: 305.83,
    r: 2.51,
    gradientTransform: "translate(-493.98 -261.72) rotate(-17.48) scale(1.54)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-196",
    cx: 394.2,
    cy: 133.29,
    fx: 394.2,
    fy: 133.29,
    r: 2.5,
    gradientTransform: "translate(-517.49 -106.59) rotate(-5.04) scale(1.54)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-197",
    cx: 407.73,
    cy: 88.66,
    fx: 407.73,
    fy: 88.66,
    r: 2.5,
    gradientTransform: "translate(-527.15 -69.28) rotate(-1.92) scale(1.54)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-198",
    cx: 563.28,
    cy: 130.25,
    fx: 563.28,
    fy: 130.25,
    r: 2.5,
    gradientTransform: "translate(-633.7 -99.64) rotate(-1.73) scale(1.3) skewX(.37)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-199",
    cx: 679.35,
    cy: 240.22,
    fx: 679.35,
    fy: 240.22,
    r: 2.5,
    gradientTransform: "translate(-694.69 -151.13) rotate(-5.62) scale(1.2 1.16) skewX(-7.25)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-200",
    cx: 861.94,
    cy: 462.34,
    fx: 861.94,
    fy: 462.34,
    r: 2.5,
    gradientTransform: "translate(-753.63 -218.31) rotate(-12.27) scale(1.11 .97) skewX(-18.85)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-201",
    cx: 861.6,
    cy: 463.23,
    fx: 861.6,
    fy: 463.23,
    r: 2.5,
    gradientTransform: "translate(-753.63 -218.31) rotate(-12.27) scale(1.11 .97) skewX(-18.85)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-202",
    cx: 861.25,
    cy: 464.11,
    fx: 861.25,
    fy: 464.11,
    r: 2.5,
    gradientTransform: "translate(-753.63 -218.31) rotate(-12.27) scale(1.11 .97) skewX(-18.85)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-203",
    cx: 860.22,
    cy: 464.37,
    fx: 860.22,
    fy: 464.37,
    r: 2.5,
    gradientTransform: "translate(-753.63 -218.31) rotate(-12.27) scale(1.11 .97) skewX(-18.85)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-204",
    cx: 859.07,
    cy: 464.39,
    fx: 859.07,
    fy: 464.39,
    r: 2.5,
    gradientTransform: "translate(-753.63 -218.31) rotate(-12.27) scale(1.11 .97) skewX(-18.85)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-205",
    cx: 857.93,
    cy: 464.19,
    fx: 857.93,
    fy: 464.19,
    r: 2.51,
    gradientTransform: "translate(-753.63 -218.31) rotate(-12.27) scale(1.11 .97) skewX(-18.85)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-206",
    cx: 414.46,
    cy: 71.59,
    fx: 414.46,
    fy: 71.59,
    r: 6.32,
    gradientTransform: "translate(-535.92 -66.32) scale(1.54)",
    xlinkHref: "#radial-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-352",
    x1: -1289.5,
    y1: -25.57,
    x2: -1290.07,
    y2: -27.7,
    gradientTransform: "translate(-1250.16 -12.5) rotate(-176.36) scale(1.06 -1.16)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-207",
    cx: -1152.24,
    cy: -23.11,
    fx: -1152.24,
    fy: -23.11,
    r: 2.36,
    gradientTransform: "translate(-1647.45 -200.42) rotate(-171.01) scale(1.54 -1.54)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-208",
    cx: -1122.3,
    cy: 70.12,
    fx: -1122.3,
    fy: 70.12,
    r: 3.43,
    gradientTransform: "translate(-1619.8 -66.32) rotate(-180) scale(1.54 -1.54)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-209",
    cx: -1121.46,
    cy: 69.42,
    fx: -1121.46,
    fy: 69.42,
    r: 3.45,
    gradientTransform: "translate(-1619.8 -66.32) rotate(-180) scale(1.54 -1.54)",
    xlinkHref: "#radial-gradient-152"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-353",
    x1: 125.65,
    y1: -16249.96,
    x2: 141.63,
    y2: -16249.96,
    xlinkHref: "#linear-gradient-175"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-354",
    x1: -833.42,
    y1: 67.93,
    x2: -817.41,
    y2: 67.93,
    gradientTransform: "translate(-758.61) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-175"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-355",
    x1: 102.19,
    y1: -16264.43,
    x2: 100.09,
    y2: -16266,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#9f591e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#bd9a25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#f3c934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#e9c031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#d0aa2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bd9a25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-356",
    x1: 98.91,
    y1: -16272.39,
    x2: 100.65,
    y2: -16279.91,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#9f591e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#f3c934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#bd9a25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-357",
    x1: 102.06,
    y1: -16272.5,
    x2: 103.28,
    y2: -16277.89,
    xlinkHref: "#linear-gradient-356"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-358",
    x1: -1016.43,
    y1: 192.91,
    x2: -1014.56,
    y2: 184.67,
    gradientTransform: "translate(-935.25 74.19) rotate(170.5) scale(1 -1)",
    xlinkHref: "#linear-gradient-356"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-210",
    cx: -94.6,
    cy: -16281.99,
    fx: -94.6,
    fy: -16281.99,
    r: 1.51,
    gradientTransform: "translate(246.34 -25059.42) scale(1.54 -1.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#f8dac8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#f3b9a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ef9788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ee8b7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#b54d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#843719"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-211",
    cx: -94.93,
    cy: -16284.09,
    fx: -94.93,
    fy: -16284.09,
    r: 0.97,
    xlinkHref: "#radial-gradient-210"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-212",
    cx: -94.27,
    cy: -16282.51,
    fx: -94.27,
    fy: -16282.51,
    r: 0.73,
    xlinkHref: "#radial-gradient-210"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-213",
    cx: -95.95,
    cy: -16281.81,
    fx: -95.95,
    fy: -16281.81,
    r: 0.71,
    xlinkHref: "#radial-gradient-210"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-214",
    cx: -93.96,
    cy: -16281.64,
    fx: -93.96,
    fy: -16281.64,
    r: 0.74,
    xlinkHref: "#radial-gradient-210"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-215",
    cx: -94.09,
    cy: -16280.86,
    fx: -94.09,
    fy: -16280.86,
    r: 0.66,
    xlinkHref: "#radial-gradient-210"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-216",
    cx: -94.45,
    cy: -16280.72,
    fx: -94.45,
    fy: -16280.72,
    r: 0.58,
    xlinkHref: "#radial-gradient-210"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-217",
    cx: -94.32,
    cy: -16280.32,
    fx: -94.32,
    fy: -16280.32,
    r: 0.43,
    xlinkHref: "#radial-gradient-210"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-218",
    cx: -94.99,
    cy: -16279.83,
    fx: -94.99,
    fy: -16279.83,
    r: 0.87,
    xlinkHref: "#radial-gradient-210"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-219",
    cx: -94.2,
    cy: -16283.05,
    fx: -94.2,
    fy: -16283.05,
    r: 0.76,
    xlinkHref: "#radial-gradient-210"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-220",
    cx: -95.96,
    cy: -16283.56,
    fx: -95.96,
    fy: -16283.56,
    r: 0.57,
    xlinkHref: "#radial-gradient-210"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-221",
    cx: -96.23,
    cy: -16281.42,
    fx: -96.23,
    fy: -16281.42,
    r: 0.57,
    xlinkHref: "#radial-gradient-210"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-222",
    cx: -95.53,
    cy: -16280.68,
    fx: -95.53,
    fy: -16280.68,
    r: 0.91,
    xlinkHref: "#radial-gradient-210"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-223",
    cx: -95.52,
    cy: -16283.05,
    fx: -95.52,
    fy: -16283.05,
    r: 1.51,
    xlinkHref: "#radial-gradient-210"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-224",
    cx: -94.86,
    cy: -16281.71,
    fx: -94.86,
    fy: -16281.71,
    r: 0.93,
    xlinkHref: "#radial-gradient-210"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-359",
    x1: 101.7,
    y1: -16266.3,
    x2: 101.79,
    y2: -16271.66,
    xlinkHref: "#linear-gradient-355"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-360",
    x1: -1033.43,
    y1: 91.54,
    x2: -1033.34,
    y2: 86.18,
    gradientTransform: "translate(-935.65) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-355"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-225",
    cx: 25.73,
    cy: 751.6,
    fx: 25.73,
    fy: 751.6,
    r: 4.04,
    gradientTransform: "translate(-234 -204.04) rotate(-48.26) scale(.64 .61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#f7f4d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#f3efc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#ebe1af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#ddcc85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#caae4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#bd9a25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#8b5322"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-226",
    cx: -74.45,
    cy: 411.62,
    fx: -74.45,
    fy: 411.62,
    r: 4.04,
    gradientTransform: "translate(-133.12 -293.88) rotate(-42.26) scale(.98 1.09)",
    xlinkHref: "#radial-gradient-225"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-227",
    cx: -37.58,
    cy: 234.31,
    fx: -37.58,
    fy: 234.31,
    r: 4.05,
    gradientTransform: "translate(56.81 -215.6) rotate(-19.3) scale(1.22 1.32)",
    xlinkHref: "#radial-gradient-225"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-228",
    cx: -86.19,
    cy: -16287.5,
    fx: -86.19,
    fy: -16287.5,
    r: 4.05,
    gradientTransform: "translate(246.34 -25059.42) scale(1.54 -1.54)",
    xlinkHref: "#radial-gradient-225"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-229",
    cx: -147.33,
    cy: 96.97,
    fx: -147.33,
    fy: 96.97,
    r: 4.74,
    gradientTransform: "translate(385.13 -81.35) scale(1.87 1.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#f7f4d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#f3efc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ebe1af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#ddcc85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#caae4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#bd9a25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#aa7f32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-361",
    x1: 108.2,
    y1: -16273.81,
    x2: 107.75,
    y2: -16280.09,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#bd9a25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#764219"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-230",
    cx: -1280.54,
    cy: -3856.39,
    fx: -1280.54,
    fy: -3856.39,
    r: 1.54,
    gradientTransform: "translate(-2592.24 11419.03) rotate(-176.36) scale(1.54 -2.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#764219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#bd9a25"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-231",
    cx: -90.67,
    cy: -16288.84,
    fx: -90.67,
    fy: -16288.84,
    r: 1.46,
    gradientTransform: "translate(246.34 -25059.42) scale(1.54 -1.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#faf6cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#f9e3a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f8d17e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#f8c462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#f8bc52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#f8ba4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#e0a43f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#aa7221"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-232",
    cx: -92.58,
    cy: -16289.42,
    fx: -92.58,
    fy: -16289.42,
    r: 1.83,
    gradientTransform: "translate(246.34 -25059.42) scale(1.54 -1.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#f9d5d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#f29d9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#e78782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#cc4f46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#b9261a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62130e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-233",
    cx: -1031.17,
    cy: -497.07,
    fx: -1031.17,
    fy: -497.07,
    r: 4.06,
    gradientTransform: "translate(-580.04 -204.04) rotate(-131.74) scale(.64 -.61)",
    xlinkHref: "#radial-gradient-225"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-234",
    cx: -839.86,
    cy: -211.56,
    fx: -839.86,
    fy: -211.56,
    r: 4.05,
    gradientTransform: "translate(-680.92 -293.88) rotate(-137.74) scale(.98 -1.09)",
    xlinkHref: "#radial-gradient-225"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-235",
    cx: -820.23,
    cy: -20.41,
    fx: -820.23,
    fy: -20.41,
    r: 4.04,
    gradientTransform: "translate(-870.86 -215.6) rotate(-160.7) scale(1.22 -1.32)",
    xlinkHref: "#radial-gradient-225"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-236",
    cx: -742.74,
    cy: 102.36,
    fx: -742.74,
    fy: 102.36,
    r: 4.05,
    gradientTransform: "translate(-1060.38 -66.32) rotate(-180) scale(1.54 -1.54)",
    xlinkHref: "#radial-gradient-225"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-237",
    cx: -688.18,
    fx: -688.18,
    r: 4.74,
    gradientTransform: "translate(-1199.18 -81.35) rotate(-180) scale(1.87 -1.76)",
    xlinkHref: "#radial-gradient-229"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-362",
    x1: -938.05,
    y1: 97.4,
    x2: -938.49,
    y2: 91.11,
    gradientTransform: "translate(-846.25) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-361"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-238",
    cx: -101.25,
    cy: -3836.86,
    fx: -101.25,
    fy: -3836.86,
    r: 1.54,
    gradientTransform: "translate(246.34 11509.47) scale(1.54 2.98)",
    xlinkHref: "#radial-gradient-230"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-363",
    x1: 89.25,
    y1: -16278.59,
    x2: 92.11,
    y2: -16278.59,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#e7c751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#e7c752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ebd05e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#eed565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#efd768"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#bd9a25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#825b20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#efd768"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#bd9a25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-364",
    x1: 90.01,
    y1: -16277.49,
    x2: 90.84,
    y2: -16278.38,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7f4d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#f6f0c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f5e0a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#f4d283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#f3c86a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#f3c058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#f3bc4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#f3bb4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#af7822"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-365",
    x1: 95.2,
    y1: -16280.45,
    x2: 98.04,
    y2: -16280.45,
    xlinkHref: "#linear-gradient-363"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-366",
    x1: 98.16,
    y1: -16280.13,
    x2: 96.95,
    y2: -16280.08,
    xlinkHref: "#linear-gradient-364"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-367",
    x1: 94.07,
    y1: -16279.36,
    x2: 96.9,
    y2: -16279.36,
    xlinkHref: "#linear-gradient-363"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-368",
    x1: 95.58,
    y1: -16278.35,
    x2: 95.46,
    y2: -16279.18,
    xlinkHref: "#linear-gradient-364"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-369",
    x1: 90.06,
    y1: -16279.87,
    x2: 92.91,
    y2: -16279.87,
    xlinkHref: "#linear-gradient-363"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-370",
    x1: 91.29,
    y1: -16280.17,
    x2: 91.51,
    y2: -16279.37,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7f4d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f6e6b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#f4ce7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#f3c057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3bb4b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-371",
    x1: 92.03,
    y1: -16280.89,
    x2: 94.86,
    y2: -16280.89,
    xlinkHref: "#linear-gradient-363"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-372",
    x1: 92.32,
    y1: -16279.95,
    x2: 93.37,
    y2: -16280.48,
    xlinkHref: "#linear-gradient-364"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-373",
    x1: 93.38,
    y1: -16280.24,
    x2: 96.24,
    y2: -16280.24,
    xlinkHref: "#linear-gradient-363"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-374",
    x1: 94.9,
    y1: -16279.26,
    x2: 94.78,
    y2: -16280.08,
    xlinkHref: "#linear-gradient-364"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-375",
    x1: 92.03,
    y1: -16279.56,
    x2: 94.86,
    y2: -16279.56,
    xlinkHref: "#linear-gradient-363"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-376",
    x1: 93.15,
    y1: -16278.46,
    x2: 93.48,
    y2: -16279.25,
    xlinkHref: "#linear-gradient-364"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-377",
    x1: 92.47,
    y1: -16278.58,
    x2: 95.31,
    y2: -16278.58,
    xlinkHref: "#linear-gradient-363"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-378",
    x1: 93.62,
    y1: -16277.34,
    x2: 93.93,
    y2: -16278.34,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7f4d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6ecc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#f5dfa1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#f4d486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f4ca70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#f3c35f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#f3be53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#f3bb4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#f3bb4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#daa33c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#c78f30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#b98228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#b17a23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#af7822"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#69481a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-379",
    x1: 94.16,
    y1: -16278.18,
    x2: 97,
    y2: -16278.18,
    xlinkHref: "#linear-gradient-363"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-380",
    x1: 95.4,
    y1: -16278.47,
    x2: 95.62,
    y2: -16277.67,
    xlinkHref: "#linear-gradient-370"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-381",
    x1: 90.52,
    y1: -16278.18,
    x2: 93.37,
    y2: -16278.18,
    xlinkHref: "#linear-gradient-363"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-382",
    x1: 91.76,
    y1: -16278.48,
    x2: 91.98,
    y2: -16277.68,
    xlinkHref: "#linear-gradient-370"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-383",
    x1: 92.1,
    y1: -16277.25,
    x2: 94.95,
    y2: -16277.25,
    xlinkHref: "#linear-gradient-363"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-384",
    x1: 93.34,
    y1: -16277.55,
    x2: 93.56,
    y2: -16276.75,
    xlinkHref: "#linear-gradient-370"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-385",
    x1: -109.23,
    y1: 310.59,
    x2: -107.14,
    y2: 311.99,
    gradientTransform: "translate(99.57 -263.98) rotate(-23.7) scale(1.31 1)",
    xlinkHref: "#linear-gradient-157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-386",
    x1: 96.37,
    y1: -16261.61,
    x2: 97.32,
    y2: -16260.98,
    xlinkHref: "#linear-gradient-157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-387",
    x1: 96.47,
    y1: -16259.28,
    x2: 96.89,
    y2: -16259,
    xlinkHref: "#linear-gradient-157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-388",
    x1: 100.01,
    y1: -16263.28,
    x2: 101.94,
    y2: -16261.98,
    xlinkHref: "#linear-gradient-157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-389",
    x1: 95.18,
    y1: -16238.94,
    x2: 105.66,
    y2: -16238.94,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7b1b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ede6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7b1b0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-390",
    x1: 94.54,
    y1: -16231.61,
    x2: 94.8,
    y2: -16229.15,
    gradientTransform: "translate(0 -16182) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fce7bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#df2537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#d12333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#ae202b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#761a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3c150f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#76231d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e13e39"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image",
    width: 644,
    height: 439,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAnUAAAGpCAYAAADr48CdAAAACXBIWXMAAM+dAADPnQEv1NlxAAAEJElEQVR4nO3BMQEAAADCoPVPbQdvIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC4VANTjQAB3WSi+QAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image-2",
    width: 644,
    height: 439,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAoEAAAGpCAYAAADyROx+AAAACXBIWXMAAM+dAADPnQEv1NlxAAAEOElEQVR4nO3BMQEAAADCoPVPbQlPIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAE6qAaM9AAGiaw2jAAAAAElFTkSuQmCC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-240"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-64",
    cx: 100.16,
    cy: 100.05,
    r: 99.18
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-812",
    d: "m99.6,76.88c-1.12,4.86-.84,6.51-2.53,6.59-1.66.05.97-5.8.93-6.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m98.35,75.58s-.81,5.75-2.52,6.56c-1.73.81.95-5.77.9-6.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-787",
    d: "m97.07,74.25s-.78,5.8-2.51,6.62c-1.72.78.96-5.8.92-6.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-894",
    d: "m96.3,72.83s-.76,5.03-2.29,5.76c-1.54.7.89-5.04.86-5.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-597",
    d: "m96.16,70.94s-.76,5.03-2.29,5.72c-1.52.72.89-5.03.86-5.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-227",
    d: "m100.12,72.77s-.09,5.85-1.68,6.77c-1.61.9.23-5.89.05-6.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-678",
    d: "m98.72,71.53s-.1,5.85-1.69,6.75c-1.6.93.24-5.86.07-6.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-916",
    d: "m97.32,70.29s-.11,5.85-1.69,6.77c-1.6.9.25-5.89.07-6.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-750",
    d: "m96.36,68.9s-.14,5.1-1.56,5.91c-1.42.8.28-5.14.13-6.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-406",
    d: "m95.99,67s-.12,5.09-1.56,5.9c-1.41.8.29-5.12.13-6.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-337",
    d: "m100.07,69.07s.58,5.89-.91,6.91c-1.48,1-.43-5.93-.72-6.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-935",
    d: "m98.53,67.91s.57,5.89-.89,6.89c-1.48,1-.44-5.92-.72-6.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-939",
    d: "m97.01,66.75s.58,5.88-.89,6.89c-1.48,1-.44-5.92-.72-6.96"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-801",
    d: "m97.72,70.48l1.37.2s-.81,3.74-2.35,3.46c-1.53-.28.71-2.37.98-3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-801",
    d: "m96.79,69.98l1.36.22s-.81,3.75-2.34,3.46c-1.53-.28.68-2.36.98-3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-801",
    d: "m96.06,69.82l1.35.36s-1.6,3.56-3.09,3.1c-1.51-.44,1.17-2.21,1.74-3.46Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "m97.88,69.97l1.4-.04s.47,3.91-1.13,3.9c-1.58,0-.11-2.5-.27-3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "m96.79,69.65l1.41-.04s.46,3.93-1.14,3.91c-1.57,0-.1-2.49-.28-3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-481",
    d: "m96.04,69.61l1.42.1s-.36,3.86-1.97,3.69c-1.59-.16.42-2.45.54-3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m94.94,69.33l1.41.11s-.36,3.86-1.97,3.69c-1.58-.18.44-2.44.56-3.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "m100.18,67.56s1.08,3.41.19,4.37c-.9.95-.93.02-1.33-.44-.41-.44-.3-3.78-.37-3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-801",
    d: "m99.47,67.42s.71,2.78-.27,3.61c-.96.83-.93.05-1.25-.31-.37-.34.09-3.12.03-3.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-801",
    d: "m98.17,67.37s.37,2.48-.59,3.17c-.96.68-.81,0-1.11-.33-.27-.33.4-2.74.36-2.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-801",
    d: "m96.8,67.49s.29,2.12-.56,2.71c-.85.58-.75,0-.98-.28-.24-.29.39-2.35.35-2.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-801",
    d: "m95.71,67.54s.12,1.64-.67,2.13c-.81.47-.67.03-.86-.2-.19-.21.49-1.84.45-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-888",
    d: "m99.52,67.14s.91,2.78.02,3.64c-.9.85-.91.1-1.29-.26-.36-.34-.12-3.14-.2-3.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-225",
    d: "m98.24,67.13s.55,2.47-.36,3.19c-.88.73-.82.04-1.11-.28-.31-.33.17-2.77.1-2.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-558",
    d: "m96.87,67.3s.45,2.13-.35,2.75c-.81.64-.73.04-.99-.24-.27-.27.2-2.37.16-2.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-757",
    d: "m95.8,67.39s.24,1.64-.51,2.17c-.75.51-.65.04-.87-.17-.21-.2.35-1.86.3-1.92"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-887",
    d: "m89.58,75.66c-1.54,4.73-2.63,5.99-1.23,6.93,1.41.93,2.16-5.44,2.74-6.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-723",
    d: "m91.34,75.19s-2.3,5.36-1.24,6.95c1.06,1.56,2.15-5.47,2.74-6.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-583",
    d: "m93.09,74.72s-2.29,5.36-1.23,6.94c1.04,1.58,2.15-5.45,2.74-6.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-943",
    d: "m94.5,73.91s-1.94,4.71-1,6.08c.93,1.41,1.84-4.78,2.33-5.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-824",
    d: "m95.59,72.35s-1.95,4.7-1,6.08c.94,1.4,1.82-4.79,2.32-5.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "m91.26,71.87s-2.95,5.07-2.05,6.67c.91,1.6,2.83-5.17,3.51-5.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-859",
    d: "m93.09,71.53s-2.94,5.05-2.04,6.68c.9,1.59,2.83-5.19,3.51-5.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-867",
    d: "m94.94,71.18s-2.94,5.08-2.04,6.68c.89,1.61,2.81-5.16,3.5-5.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-502",
    d: "m96.47,70.48s-2.51,4.44-1.71,5.86c.83,1.43,2.4-4.53,3.01-5.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-314",
    d: "m97.74,69.04s-2.48,4.44-1.7,5.87c.81,1.41,2.42-4.53,3.01-5.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-846",
    d: "m93.21,68.73s-3.54,4.75-2.78,6.39c.76,1.62,3.42-4.87,4.2-5.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-638",
    d: "m95.11,68.52s-3.54,4.75-2.78,6.38c.75,1.61,3.42-4.87,4.19-5.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-303",
    d: "m97.01,68.3s-3.53,4.76-2.78,6.37c.76,1.63,3.44-4.87,4.21-5.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-801",
    d: "m94.49,71.13l-1.29-.52s-1.24,3.64.23,4.18c1.45.55.61-2.38,1.06-3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-801",
    d: "m95.54,71.22l-1.28-.53s-1.25,3.63.23,4.18c1.45.54.62-2.38,1.05-3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-801",
    d: "m96.25,71.42l-1.33-.38s-.45,3.88,1.05,4.26c1.49.37.11-2.51.29-3.88Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m94.62,70.61l-1.19-.74s-2.41,3.11-1.05,3.92c1.36.81,1.4-2.07,2.24-3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-467",
    d: "m95.7,70.9l-1.19-.76s-2.4,3.13-1.04,3.94c1.36.81,1.39-2.1,2.23-3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-850",
    d: "m96.36,71.25l-1.25-.64s-1.69,3.52-.23,4.18c1.45.67.92-2.3,1.48-3.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-379",
    d: "m97.46,71.58l-1.28-.64s-1.67,3.5-.2,4.18c1.45.68.9-2.32,1.49-3.54Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "m93.87,67.39s-2.67,2.37-2.41,3.65c.3,1.26.8.47,1.39.29.57-.18,2.19-3.09,2.3-3.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-801",
    d: "m94.56,67.63s-2.04,2.02-1.63,3.24c.4,1.2.76.5,1.24.37.47-.13,1.52-2.71,1.62-2.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-801",
    d: "m95.7,68.23s-1.6,1.95-1.14,3.01c.47,1.08.71.45,1.14.3.39-.13,1.06-2.56,1.15-2.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-801",
    d: "m96.79,69.04s-1.33,1.68-.91,2.62c.45.95.64.4.99.28.34-.12.86-2.23.95-2.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-801",
    d: "m97.72,69.65s-.94,1.34-.52,2.17c.44.82.56.36.84.28.28-.07.54-1.84.59-1.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-534",
    d: "m94.67,67.37s-2.22,1.89-1.89,3.1c.33,1.2.74.53,1.23.44.49-.12,1.74-2.63,1.83-2.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-770",
    d: "m95.77,67.99s-1.75,1.86-1.36,2.93c.4,1.08.7.45,1.12.33.41-.12,1.26-2.45,1.36-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m96.83,68.86s-1.47,1.58-1.11,2.53c.37.95.61.38.97.29.37-.09,1.05-2.13,1.14-2.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-921",
    d: "m97.73,69.48s-1.07,1.29-.68,2.13c.37.83.53.37.83.29.28-.07.67-1.78.72-1.81"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-812",
    d: "m99.6,76.88c-1.12,4.86-.84,6.51-2.53,6.59-1.66.05.97-5.8.93-6.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m98.35,75.58s-.81,5.75-2.52,6.56c-1.73.81.95-5.77.9-6.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-621",
    d: "m97.07,74.25s-.78,5.8-2.51,6.62c-1.72.78.96-5.8.92-6.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-930",
    d: "m96.3,72.83s-.76,5.03-2.29,5.76c-1.54.7.89-5.04.86-5.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-928",
    d: "m96.16,70.94s-.76,5.03-2.29,5.72c-1.52.72.89-5.03.86-5.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-306",
    d: "m100.12,72.77s-.09,5.85-1.68,6.77c-1.61.9.23-5.89.05-6.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-466",
    d: "m98.72,71.53s-.1,5.85-1.69,6.75c-1.6.93.24-5.86.07-6.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-340",
    d: "m97.32,70.29s-.11,5.85-1.69,6.77c-1.6.9.25-5.89.07-6.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m96.36,68.9s-.14,5.1-1.56,5.91c-1.42.8.28-5.14.13-6.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "m95.99,67s-.12,5.09-1.56,5.9c-1.41.8.29-5.12.13-6.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "m100.07,69.07s.58,5.89-.91,6.91c-1.48,1-.43-5.93-.72-6.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-617",
    d: "m98.53,67.91s.57,5.89-.89,6.89c-1.48,1-.44-5.92-.72-6.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-626",
    d: "m97.01,66.75s.58,5.88-.89,6.89c-1.48,1-.44-5.92-.72-6.96"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-801",
    d: "m97.72,70.48l1.37.2s-.81,3.74-2.35,3.46c-1.53-.28.71-2.37.98-3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-801",
    d: "m96.79,69.98l1.36.22s-.81,3.75-2.34,3.46c-1.53-.28.68-2.36.98-3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-801",
    d: "m96.06,69.82l1.35.36s-1.6,3.56-3.09,3.1c-1.51-.44,1.17-2.21,1.74-3.46Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "m97.88,69.97l1.4-.04s.47,3.91-1.13,3.9c-1.58,0-.11-2.5-.27-3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-923",
    d: "m96.79,69.65l1.41-.04s.46,3.93-1.14,3.91c-1.57,0-.1-2.49-.28-3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "m96.04,69.61l1.42.1s-.36,3.86-1.97,3.69c-1.59-.16.42-2.45.54-3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-416",
    d: "m94.94,69.33l1.41.11s-.36,3.86-1.97,3.69c-1.58-.18.44-2.44.56-3.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "m100.18,67.56s1.08,3.41.19,4.37c-.9.95-.93.02-1.33-.44-.41-.44-.3-3.78-.37-3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-801",
    d: "m99.47,67.42s.71,2.78-.27,3.61c-.96.83-.93.05-1.25-.31-.37-.34.09-3.12.03-3.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-801",
    d: "m98.17,67.37s.37,2.48-.59,3.17c-.96.68-.81,0-1.11-.33-.27-.33.4-2.74.36-2.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-801",
    d: "m96.8,67.49s.29,2.12-.56,2.71c-.85.58-.75,0-.98-.28-.24-.29.39-2.35.35-2.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-801",
    d: "m95.71,67.54s.12,1.64-.67,2.13c-.81.47-.67.03-.86-.2-.19-.21.49-1.84.45-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "m99.52,67.14s.91,2.78.02,3.64c-.9.85-.91.1-1.29-.26-.36-.34-.12-3.14-.2-3.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-521",
    d: "m98.24,67.13s.55,2.47-.36,3.19c-.88.73-.82.04-1.11-.28-.31-.33.17-2.77.1-2.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-530",
    d: "m96.87,67.3s.45,2.13-.35,2.75c-.81.64-.73.04-.99-.24-.27-.27.2-2.37.16-2.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-358",
    d: "m95.8,67.39s.24,1.64-.51,2.17c-.75.51-.65.04-.87-.17-.21-.2.35-1.86.3-1.92"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-598",
    d: "m89.58,75.66c-1.54,4.73-2.63,5.99-1.23,6.93,1.41.93,2.16-5.44,2.74-6.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-644",
    d: "m91.34,75.19s-2.3,5.36-1.24,6.95c1.06,1.56,2.15-5.47,2.74-6.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-691",
    d: "m93.09,74.72s-2.29,5.36-1.23,6.94c1.04,1.58,2.15-5.45,2.74-6.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-359",
    d: "m94.5,73.91s-1.94,4.71-1,6.08c.93,1.41,1.84-4.78,2.33-5.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-526",
    d: "m95.59,72.35s-1.95,4.7-1,6.08c.94,1.4,1.82-4.79,2.32-5.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "m91.26,71.87s-2.95,5.07-2.05,6.67c.91,1.6,2.83-5.17,3.51-5.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-647",
    d: "m93.09,71.53s-2.94,5.05-2.04,6.68c.9,1.59,2.83-5.19,3.51-5.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-892",
    d: "m94.94,71.18s-2.94,5.08-2.04,6.68c.89,1.61,2.81-5.16,3.5-5.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-561",
    d: "m96.47,70.48s-2.51,4.44-1.71,5.86c.83,1.43,2.4-4.53,3.01-5.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-724",
    d: "m97.74,69.04s-2.48,4.44-1.7,5.87c.81,1.41,2.42-4.53,3.01-5.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-767",
    d: "m93.21,68.73s-3.54,4.75-2.78,6.39c.76,1.62,3.42-4.87,4.2-5.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m95.11,68.52s-3.54,4.75-2.78,6.38c.75,1.61,3.42-4.87,4.19-5.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-540",
    d: "m97.01,68.3s-3.53,4.76-2.78,6.37c.76,1.63,3.44-4.87,4.21-5.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-801",
    d: "m94.49,71.13l-1.29-.52s-1.24,3.64.23,4.18c1.45.55.61-2.38,1.06-3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-801",
    d: "m95.54,71.22l-1.28-.53s-1.25,3.63.23,4.18c1.45.54.62-2.38,1.05-3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-801",
    d: "m96.25,71.42l-1.33-.38s-.45,3.88,1.05,4.26c1.49.37.11-2.51.29-3.88Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-896",
    d: "m94.62,70.61l-1.19-.74s-2.41,3.11-1.05,3.92c1.36.81,1.4-2.07,2.24-3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "m95.7,70.9l-1.19-.76s-2.4,3.13-1.04,3.94c1.36.81,1.39-2.1,2.23-3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-666",
    d: "m96.36,71.25l-1.25-.64s-1.69,3.52-.23,4.18c1.45.67.92-2.3,1.48-3.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "m97.46,71.58l-1.28-.64s-1.67,3.5-.2,4.18c1.45.68.9-2.32,1.49-3.54Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "m93.87,67.39s-2.67,2.37-2.41,3.65c.3,1.26.8.47,1.39.29.57-.18,2.19-3.09,2.3-3.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-801",
    d: "m94.56,67.63s-2.04,2.02-1.63,3.24c.4,1.2.76.5,1.24.37.47-.13,1.52-2.71,1.62-2.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-801",
    d: "m95.7,68.23s-1.6,1.95-1.14,3.01c.47,1.08.71.45,1.14.3.39-.13,1.06-2.56,1.15-2.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-801",
    d: "m96.79,69.04s-1.33,1.68-.91,2.62c.45.95.64.4.99.28.34-.12.86-2.23.95-2.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-801",
    d: "m97.72,69.65s-.94,1.34-.52,2.17c.44.82.56.36.84.28.28-.07.54-1.84.59-1.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-477",
    d: "m94.67,67.37s-2.22,1.89-1.89,3.1c.33,1.2.74.53,1.23.44.49-.12,1.74-2.63,1.83-2.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-611",
    d: "m95.77,67.99s-1.75,1.86-1.36,2.93c.4,1.08.7.45,1.12.33.41-.12,1.26-2.45,1.36-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-279",
    d: "m96.83,68.86s-1.47,1.58-1.11,2.53c.37.95.61.38.97.29.37-.09,1.05-2.13,1.14-2.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-505",
    d: "m97.73,69.48s-1.07,1.29-.68,2.13c.37.83.53.37.83.29.28-.07.67-1.78.72-1.81"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-376",
    d: "m101.47,137.32s2.22,18.44,2.3,19.51c.09,1.07.51,1.83-3.9,1.69-4.08.05-4.13-.34-3.94-1.74.21-1.7,2.3-19.46,2.3-19.46h3.23Z"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(102.04 111.25) scale(.05)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(102.04 111.25) scale(.05)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-728"
  }, /*#__PURE__*/React.createElement("image", {
    width: 678,
    height: 432,
    transform: "translate(100.97 111.97) scale(.05)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAApYAAAGwCAYAAAAT7yW8AAAACXBIWXMAAM+dAADPnQEv1NlxAAAEbElEQVR4nO3BMQEAAADCoPVPbQ0PIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgQzV3LwABIuLBpQAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-695",
    d: "m142.71,76.1l-1.09.2-.05-.11,8.89-5.87s.53-.36.6-.41c.09-.04.09,0,.04,0-.05.04-8.38,6.17-8.38,6.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "142.09 76.25 145.51 76.57 151.12 69.92 142.09 76.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-675",
    points: "141.93 76 142.89 72.72 151.11 69.91 141.93 76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-587",
    d: "m101.62,89.93l1.18-.79s0,.07,0,.12c0,.15.26,1.9-.68,2.65,0,0-.42.2-.89-.04-.4-.12-.46-.75-.46-.75l.85-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-919",
    d: "m120.87,88.79l8.26-5.37s3.09,21.56-15.09,40.44c-7.01-2.14-8.41-13.56-8.41-13.56l15.25-21.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "m122.95,88.15s3.04-2.53,3.98-3.3c.71,7.5-1.31,7.07-1.16,12.66.26,3.26-.33,4.67-1.43,6.5-2.07,3.14-2.13,6.43-3.38,9.22-2.36,6.46-4.36,4.78-4.36,4.78l-4.93-9.32,11.27-20.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-260",
    d: "m120.87,88.79l8.26-5.37s.1.43.17,1.89c-3.6,2.35-8.7,5.19-8.7,5.19l.27-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-434",
    d: "m128.07,84.1l5.58-3.64s2.28,28.68-16.18,44.7c-1.11-.31-2.27-.76-3.42-1.32-.75-.25-1.16-.13-1.47-.99,16.71-15.1,15.49-38.76,15.49-38.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-629",
    d: "m133.64,80.47l8.6-5.6s.33,1.2,0,1.8c.18,2.72,4.71,34.92-12.21,47.6,0,0-5.76,2.92-12.85.81,18.48-14.46,16.46-44.61,16.46-44.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "m133.64,80.47l8.6-5.6s.33,1.2,0,1.8c-2.96,2.06-4.98,3.32-8.6,5.77v-1.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "m128.07,84.1l5.58-3.64s.48,1.07,0,1.98c-.27.17-5.58,3.66-5.58,3.66v-2.01Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-667",
    d: "m109.54,111.09c4.08,10.25,14.1,16.66,23.83,10.16-3.77,5.03-18.19,14.11-32.76-3.64-2.72-5.75,7.74-9.49,8.93-6.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m109.54,111.09c1.17,2.94,3.46,6.17,4.08,6.82-1.41,5.32-4.81,7.12-5.17,6.88-2.56-1.64-5.2-3.98-7.84-7.19-2.72-5.75,7.74-9.49,8.93-6.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m109.54,111.09c.46,1.17,1.02,2.29,1.66,3.37.62,1.09,1.34,2.12,2.14,3.09,1.58,1.95,3.54,3.61,5.76,4.73,1.12.59,2.31,1.01,3.53,1.27,1.22.26,2.48.34,3.73.23,2.51-.2,4.92-1.17,7-2.53-1.04.7-2.14,1.31-3.33,1.76-1.17.44-2.41.74-3.66.85-1.26.12-2.54.03-3.76-.23-1.24-.26-2.43-.68-3.55-1.25-2.24-1.16-4.2-2.85-5.78-4.79-.79-.97-1.51-2.01-2.13-3.09-.62-1.09-1.17-2.24-1.62-3.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-695",
    d: "m145.57,85.63l-1.22.26-.04-.14,9.81-6.46s.57-.39.68-.47c.06-.04.09,0,.02.03-.04.05-9.24,6.79-9.24,6.79Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-855",
    points: "144.9 85.81 148.67 86.14 154.86 78.82 144.9 85.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "144.71 85.53 145.78 81.92 154.84 78.81 144.71 85.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-709",
    d: "m100.28,100.87l1.3-.85s.02.06,0,.12c.02.16.29,2.1-.75,2.91,0,0-.45.23-.98-.04-.42-.12-.52-.82-.52-.82l.94-1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-325",
    d: "m121.5,99.62l9.11-5.94s3.41,23.8-16.63,44.59c-7.75-2.34-9.28-14.93-9.28-14.93l16.8-23.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "m121.5,99.62s4.23-2.77,5.54-3.62c.2,9.1-2.42,8.38-2.76,15.15,0,3.93-.91,5.58-2.52,7.7-3.05,3.57-3.43,7.52-5.38,10.81-3.7,7.56-6.16,5.35-6.16,5.35l-5.53-11.67,16.8-23.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-543",
    d: "m121.5,99.62l9.11-5.94s.11.49.18,2.09c-3.97,2.6-9.59,5.74-9.59,5.74l.3-1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "m129.45,94.44l6.15-3.98s2.51,31.6-17.85,49.28c-1.22-.35-2.5-.81-3.76-1.47-.83-.24-1.3-.12-1.65-1.07,18.44-16.65,17.11-42.76,17.11-42.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "m135.58,90.46l9.48-6.17s.37,1.33,0,2.01c.19,2.97,5.2,38.47-13.47,52.46,0,0-6.37,3.22-14.18.89,20.38-15.94,18.16-49.19,18.16-49.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-772",
    d: "m135.58,90.46l9.48-6.17s.37,1.33,0,2.01c-3.28,2.25-5.51,3.64-9.48,6.33-.02-1.65,0-2.17,0-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-733",
    d: "m129.45,94.44l6.15-3.98s.54,1.16,0,2.17c-.29.19-6.16,4.04-6.16,4.04l.02-2.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-381",
    d: "m109,124.21c4.5,11.31,15.57,18.37,26.29,11.19-4.17,5.56-20.07,15.57-36.12-3.99-3.01-6.33,8.52-10.48,9.83-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m109,124.21c1.3,3.23,3.82,6.81,4.52,7.53-1.57,5.85-5.33,7.84-5.72,7.58-2.83-1.8-5.73-4.38-8.63-7.92-3.01-6.33,8.52-10.48,9.83-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m109,124.21c.52,1.3,1.13,2.53,1.84,3.72.7,1.19,1.48,2.33,2.37,3.42,1.76,2.11,3.9,3.96,6.37,5.21,1.22.63,2.53,1.11,3.87,1.39,1.35.3,2.75.39,4.13.27,2.77-.22,5.4-1.27,7.72-2.81-1.16.78-2.38,1.45-3.67,1.93-1.28.5-2.66.83-4.04.96-1.39.12-2.78.04-4.15-.23-1.37-.3-2.68-.78-3.9-1.41-2.49-1.26-4.62-3.11-6.38-5.26-.89-1.09-1.67-2.23-2.37-3.44-.69-1.21-1.28-2.45-1.79-3.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-948",
    d: "m103.07,154.46s-.97,1-.44,1.46c.55.44,1.07.87,1.18,1.35-.04-.81-.17-3.09-.17-3.09l-.58.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-605",
    d: "m101.05,135.85l1.45,19.63s0-.84,2.61-.79c2.99.05,2.36-.83,2.18-1.53-.1-.41-4.79-18.58-4.79-18.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-528",
    d: "m104.16,149.97c.03.39.04.49-.1,1.03-.11.55-.09.91.64,1.08,1.1.26,2.61.87,2.77,1.93.1-.42-.79-3.59-1.33-5.44-.23-.81-1.98,1.41-1.98,1.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "m104.02,133.02c.06,1.72,5.26,15.65,7.27,17.07-3.06.2-7.09.71-7.27,1.4-.05-.44-2.01-16.29-2.45-17.11-.43-.81,1.56-1.91,2.45-1.35Z"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(63.64 111.25) scale(.05)",
    xlinkHref: "#image-2"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(63.64 111.25) scale(.05)",
    xlinkHref: "#image-2"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-728"
  }, /*#__PURE__*/React.createElement("image", {
    width: 678,
    height: 432,
    transform: "translate(62.91 111.97) scale(.05)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAqcAAAGwCAYAAACU3sy6AAAACXBIWXMAAM+dAADPnQEv1NlxAAAEi0lEQVR4nO3BMQEAAAzDoPhXPRd7CgQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADzAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYB4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8KE66e8AAb8sjd8AAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-695",
    d: "m57.29,76.1l1.1.2.04-.11-8.89-5.87s-.52-.36-.61-.41c-.07-.04-.09,0-.02,0,.04.04,8.38,6.17,8.38,6.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-749",
    points: "57.93 76.25 54.48 76.57 48.87 69.92 57.93 76.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-345",
    points: "58.08 76 57.12 72.72 48.88 69.91 58.08 76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-533",
    d: "m79.12,88.79l-8.25-5.37s-3.1,21.56,15.08,40.44c7.03-2.14,8.41-13.56,8.41-13.56l-15.25-21.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "m76.97,88.15s-2.83-2.17-3.69-2.85c-.91,5.85,1.04,5.66.72,10.05-.33,2.55.2,3.7,1.17,5.24,1.9,2.58,1.84,5.18,2.97,7.47,2.04,5.26,4.01,4.04,4.01,4.04l4.95-7.04-10.14-16.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-277",
    d: "m79.12,88.79l-8.25-5.37s-.11.43-.15,1.89c3.58,2.35,8.68,5.19,8.68,5.19l-.28-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m71.93,84.1l-5.58-3.64s-2.28,28.68,16.2,44.7c1.1-.31,2.24-.76,3.4-1.32.76-.25,1.17-.13,1.49-.99-16.73-15.1-15.51-38.76-15.51-38.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "m66.36,80.47l-8.59-5.6s-.34,1.2,0,1.8c-.19,2.72-4.71,34.92,12.2,47.6,0,0,5.77,2.92,12.86.81-18.48-14.46-16.47-44.61-16.47-44.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m66.36,80.47l-8.59-5.6s-.34,1.2,0,1.8c2.99,2.06,4.98,3.32,8.59,5.77v-1.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-391",
    d: "m71.93,84.1l-5.58-3.64s-.49,1.07,0,1.98c.27.17,5.58,3.66,5.58,3.66v-2.01Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-910",
    d: "m90.47,111.09c-4.07,10.25-14.11,16.66-23.84,10.16,3.77,5.03,18.19,14.11,32.76-3.64,2.71-5.75-7.73-9.49-8.92-6.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m90.47,111.09c-1.16,2.94-3.47,6.17-4.09,6.82,1.41,5.32,4.8,7.12,5.17,6.88,2.57-1.64,5.19-3.98,7.84-7.19,2.71-5.75-7.73-9.49-8.92-6.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m90.47,111.09c-.46,1.17-1,2.31-1.63,3.41-.62,1.08-1.34,2.12-2.14,3.09-1.58,1.95-3.52,3.64-5.78,4.79-1.12.57-2.3,1-3.52,1.25-1.25.26-2.54.36-3.77.23-1.25-.12-2.5-.42-3.67-.85-1.17-.45-2.29-1.06-3.33-1.76,2.08,1.37,4.49,2.34,7,2.53,1.23.11,2.51.03,3.73-.23,1.23-.27,2.41-.68,3.51-1.27,2.23-1.12,4.19-2.78,5.78-4.73.8-.97,1.51-1.99,2.14-3.09.64-1.08,1.19-2.2,1.67-3.37Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-695",
    d: "m54.43,85.63l1.22.26.04-.14-9.8-6.46s-.58-.39-.69-.47c-.06-.04-.08,0,0,.03.05.05,9.24,6.79,9.24,6.79Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-348",
    points: "55.11 85.81 51.33 86.14 45.15 78.82 55.11 85.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-514",
    points: "55.27 85.53 54.23 81.92 45.16 78.81 55.27 85.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-625",
    d: "m78.49,99.62l-9.11-5.94s-3.41,23.8,16.64,44.59c7.75-2.34,9.28-14.93,9.28-14.93l-16.81-23.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "m78.49,99.62s-4.23-2.77-5.53-3.62c-.2,9.1,2.42,8.38,2.76,15.15,0,3.93.92,5.58,2.53,7.7,3.02,3.57,3.42,7.52,5.36,10.81,3.7,7.56,6.16,5.35,6.16,5.35l5.52-11.67-16.81-23.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-525",
    d: "m78.49,99.62l-9.11-5.94s-.1.49-.15,2.09c3.93,2.6,9.57,5.74,9.57,5.74l-.31-1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m70.56,94.44l-6.13-3.98s-2.53,31.6,17.83,49.28c1.22-.35,2.49-.81,3.76-1.47.85-.24,1.29-.12,1.65-1.07-18.45-16.65-17.12-42.76-17.12-42.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-897",
    d: "m64.43,90.46l-9.48-6.17s-.38,1.33,0,2.01c-.2,2.97-5.19,38.47,13.46,52.46,0,0,6.36,3.22,14.17.89-20.38-15.94-18.15-49.19-18.15-49.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-905",
    d: "m64.43,90.46l-9.48-6.17s-.38,1.33,0,2.01c3.26,2.25,5.5,3.64,9.48,6.33,0-1.65,0-2.17,0-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-827",
    d: "m70.56,94.44l-6.13-3.98s-.55,1.16,0,2.17c.29.19,6.16,4.04,6.16,4.04l-.03-2.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-400",
    d: "m91,124.21c-4.49,11.31-15.57,18.37-26.29,11.19,4.18,5.56,20.06,15.57,36.12-3.99,3.01-6.33-8.52-10.48-9.83-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m91,124.21c-1.29,3.23-3.82,6.81-4.5,7.53,1.56,5.85,5.29,7.84,5.7,7.58,2.82-1.8,5.72-4.38,8.63-7.92,3.01-6.33-8.52-10.48-9.83-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m91,124.21c-.5,1.3-1.1,2.53-1.8,3.75-.68,1.21-1.48,2.35-2.35,3.44-1.76,2.14-3.9,3.99-6.37,5.26-1.25.62-2.55,1.1-3.93,1.41-1.34.28-2.75.35-4.14.23-1.38-.13-2.73-.46-4.03-.96-1.3-.48-2.53-1.15-3.68-1.93,2.32,1.54,4.94,2.59,7.71,2.81,1.39.12,2.77.04,4.13-.27,1.35-.28,2.66-.76,3.88-1.39,2.46-1.25,4.62-3.1,6.37-5.21.88-1.08,1.66-2.22,2.37-3.42.7-1.19,1.31-2.42,1.83-3.72Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-442",
    d: "m96.66,154.46s.95,1,.41,1.46c-.54.44-1.07.87-1.17,1.35.04-.81.18-3.09.18-3.09l.59.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-639",
    d: "m98.67,135.85l-1.46,19.63s0-.84-2.61-.79c-2.98.05-2.36-.83-2.17-1.53.09-.41,4.78-18.58,4.78-18.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m95.55,149.97c0,.39-.02.49.09,1.03.13.55.12.91-.61,1.08-1.1.26-2.62.87-2.77,1.93-.12-.42.79-3.59,1.32-5.44.24-.81,1.97,1.41,1.97,1.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "m95.71,133.02c-.08,1.72-5.27,15.65-7.27,17.07,3.06.2,7.09.71,7.27,1.4.05-.44,1.99-16.29,2.44-17.11.44-.81-1.54-1.91-2.44-1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m94.6,136.41l-1.05,3.33s2.87.72,3.3,2.79c-.16,1.21.44,1.47,1.2,1.72.86,2.04,3.26.97,3.58.02.66-.21,1.25-.21,1.66-1.31,0-1.79,1.36-2.63,2.8-3.22-.44-1.9-1.45-4.34-1.45-4.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-586",
    d: "m80.65,118.79h38.69s-8.06,14.57-19.39,21.72c-12.62-8.6-19.3-21.72-19.3-21.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "m115.33,122.24c-1.35.95-3.28-1.82-4.35-2.36-.95-.48-2.25-.61-3.32-.73-.4-.05-.9-.12-1.21.18-.46.44-.1.72.38.75.94.02,2.02-.41,2.95-.17,1.06.28,1.3,1.17,2.07,1.81.44.37,1.02.49,1.4.91.17.18.41.53.51.75.08.18.04.53.2.68.44.41.69-.2.96-.64.2-.32.53-.67.4-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m114.45,126.1c-.56-.03-1.05-.54-1.61-.44-.75.13-1.17.71-.18.72-.03.38-.79.29-1.1.26-.59,0-.74-.04-1.23.3-.61.4-1.46.81-1.79,1.53.4.4.76-.05.78.77.02.3-.05.9-.33,1.08-.39.25-.79-.09-.97-.45-.06-.17.05-.49-.07-.63-.12-.16-.45-.03-.61-.12-.36-.21-.55-.89-.91-1.18-.29-.25-.62-.53-1-.62-.49-.1-.85.2-1.28.37-.47.21-1,.26-1.56.36-1.04.2-2.11.2-3.15.16-1.08-.06-1.95.09-2.95-.34-.47-.2-.87-.55-1.33-.76-.48-.2-.99-.16-1.49-.23-1.02-.11-2-.31-2.95-.71-.97-.39-1.79-1.18-2.69-1.69-.82-.44-.8-1.41-1.26-2.15-.27-.47-.7-.37-1.01-.73-.29-.29-.6-.98-.7-1.38-.11-.44.07-.89-.35-1.15-.48-.29-1.82-.11-2.4-.16-.6-.07-1.2-.18-1.2.5-.02.84.6,1.6.83,2.37.27.78.36,1.64.84,2.33.38.62.9,1.2,1.38,1.74,1.11,1.15,1.8,2.52,2.85,3.74.45.52.89,1.07,1.39,1.56.56.58.92,1.22,1.43,1.81.72.81,1.64,1.06,2.53,1.59.18-.44-.03-1.2.28-1.59.14-.17.32-.08.48-.23.18-.18.13-.45.32-.6.42-.35.72.06,1.17-.21.07-.04.52-.37.54-.51.08-.3-.26-.28-.26-.6,0-.36.83-.87,1.17-1.03.54-.23.72.09,1.16.11.74,0,.57-.68.93-.96.45-.29,1.25.12,1.68.03.18-.04.27.03.24-.29.76-.03,1.33.07,2.04-.06,1.07-.21.62.51,1.23.84,1,.53,1.14-.96,2.11-.44.51.28,1.18,1.3.19,1.27-.07.39.39.63.71.52.28.72-.69,1.55-.35,1.97.24.27.68.15.89.48.19.31.06.89.06,1.25.52-.12,1.02-.72,1.44-1.03.52-.4,1.05-.74,1.57-1.16.81-.64,1.71-1.21,2.5-1.87,1.16-.99,2.12-2.6,2.11-4.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-796",
    d: "m114.45,125.97c-.56-.04-1.05-.57-1.61-.45-.75.13-1.17.71-.18.73-.03.38-.79.29-1.1.28-.59-.03-.74-.06-1.23.27-.61.43-1.46.84-1.79,1.56.4.4.76-.06.78.77.02.31-.05.93-.33,1.1-.39.24-.79-.09-.97-.48-.06-.17.05-.47-.07-.63-.12-.14-.45,0-.61-.11-.36-.22-.55-.9-.91-1.21-.29-.26-.62-.53-1-.61-.49-.11-.85.19-1.28.36-.47.21-1,.26-1.56.37-1.04.19-2.11.19-3.15.15-1.08-.04-1.95.08-2.95-.33-.47-.2-.87-.56-1.33-.78-.48-.21-.99-.18-1.49-.23-1.02-.1-2-.32-2.95-.71-.97-.4-1.79-1.22-2.69-1.72-.82-.44-.8-1.43-1.26-2.18-.27-.45-.7-.37-1.01-.72-.29-.32-.6-1-.7-1.41-.11-.44.07-.9-.35-1.15-.48-.29-1.82-.11-2.4-.18-.6-.06-1.2-.19-1.2.52-.02.85.6,1.6.83,2.39.27.79.36,1.64.84,2.36.38.62.9,1.19,1.38,1.74,1.11,1.16,1.8,2.54,2.85,3.78.45.52.89,1.08,1.39,1.57.56.59.92,1.22,1.43,1.81.72.83,1.64,1.07,2.53,1.61.18-.44-.03-1.22.28-1.59.14-.17.32-.11.48-.25.18-.19.13-.45.32-.6.42-.36.72.06,1.17-.21.07-.05.52-.4.54-.52.08-.31-.26-.28-.26-.6,0-.37.83-.89,1.17-1.04.54-.25.72.08,1.16.1.74.02.57-.68.93-.94.45-.31,1.25.11,1.68,0,.18-.04.27,0,.24-.28.76-.04,1.33.05,2.04-.08,1.07-.2.62.52,1.23.84,1,.55,1.14-.95,2.11-.44.51.27,1.18,1.3.19,1.28-.07.41.39.63.71.52.28.76-.69,1.57-.35,1.99.24.28.68.18.89.5.19.32.06.91.06,1.27.52-.13,1.02-.72,1.44-1.05.52-.4,1.05-.77,1.57-1.16.81-.66,1.71-1.24,2.5-1.91,1.16-1,2.12-2.61,2.11-4.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-912",
    d: "m94.31,124.74h3.01s.29.79.73.87c.45.07,7.15-.12,7.15-.12l-1.01,1.08h-8.03l-.81-.92h-.75l-.29-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-908",
    d: "m104.5,125.63s.06.04.1,0h0s.05-.08.04-.1l-2.56-2.69s-.06-.04-.09.03h0s-.05.05-.03.08l2.54,2.69Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-908",
    d: "m101.81,125.77c0,.06.05.09.11.09h0c.07,0,.12-.03.12-.09v-5.16c0-.05-.05-.08-.12-.08h0c-.05,0-.11.03-.11.08v5.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-908",
    d: "m99.66,125.77c0,.06.05.09.11.09h0c.06,0,.12-.03.12-.09v-5.16c0-.05-.05-.08-.12-.08h0c-.05,0-.11.03-.11.08v5.16Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-908",
    d: "m94.62,124.84s-.04.08-.02.1h0s.08.04.12.02l4-3.37s.04-.08,0-.11h0s-.08-.04-.1-.03l-4,3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-908",
    d: "m98.09,125.96s.04.02.12.02h0c.06,0,.13,0,.13-.02v-1.97s-.07-.04-.13-.04h0c-.08,0-.12.03-.12.03v1.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-908",
    d: "m102.64,126.05s.06.03.15.03h0c.06,0,.12-.02.12-.03v-1.97s-.05-.04-.12-.04h0c-.09,0-.15.03-.15.03v1.97Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-398",
    x: 99.39,
    y: 123.36,
    width: 2.34,
    height: 1.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 97,
    y: 123.36,
    width: 2.1,
    height: 1.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-884",
    x: 102.14,
    y: 123.36,
    width: 2.12,
    height: 1.38
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-908",
    points: "101.94 120.72 102.75 121.17 101.94 121.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-908",
    points: "99.66 120.72 100.46 121.17 99.66 121.17"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-513",
    x: 100.88,
    y: 121.43,
    width: 2.12,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-297",
    x: 98.35,
    y: 121.43,
    width: 2.11,
    height: 1.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-912",
    points: "95.5 133.6 96.92 133.6 97.43 134.24 103.6 134.36 103.6 133.6 104.83 133.46 104.54 134.36 103.28 135.15 97.11 135.15 96.14 134.55 95.5 133.6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-912",
    x: 97.79,
    y: 133.99,
    width: 1.21,
    height: 1.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-912",
    x: 99.9,
    y: 133.99,
    width: 1.19,
    height: 1.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-912",
    x: 102,
    y: 133.99,
    width: 1.17,
    height: 1.01
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-912",
    d: "m98.63,134.44c0,.1-.08.17-.17.17h0c-.09,0-.15-.07-.15-.17v-3.73c0-.11.06-.17.15-.17h0c.09,0,.17.06.17.17v3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-912",
    d: "m100.66,134.44c0,.1-.08.17-.17.17h0c-.09,0-.15-.07-.15-.17v-3.73c0-.11.06-.17.15-.17h0c.09,0,.17.06.17.17v3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-912",
    d: "m102.68,134.44c0,.1-.06.17-.16.17h0c-.08,0-.15-.07-.15-.17v-3.73c0-.11.07-.17.15-.17h0c.1,0,.16.06.16.17v3.73Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-753",
    x: 97.54,
    y: 131.47,
    width: 1.72,
    height: 1.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-229",
    x: 99.63,
    y: 131.47,
    width: 1.73,
    height: 1.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 101.73,
    y: 131.47,
    width: 1.72,
    height: 1.38
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-828",
    d: "m119.41,118.51h-38.82c-3-.78-4.44-17.63-4.44-17.63h47.97s-1.96,15.85-4.71,17.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m95.83,111l-.56,1.41s4.91,2.72,8.84,1.81c3.94-.9-2.08-4.15-2.08-4.15l-6.2.93Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-680",
    points: "100.01 106.01 97.77 116.07 99.66 118.79 100.57 118.79 102.14 116 100.01 106.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m100.01,106.01s-1.43,6.5-1.59,7.17c1.92-.26,1.4-.21,3.32.85-.28-1.32-1.72-8.02-1.72-8.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-401",
    d: "m99.77,104.34s-2.77.21-3.6,3.73c-.82,3.5-.89,4.33-.89,4.33,0,0,2.58-.93,6.46-.34,1.55.34,1.08.77,1.61,2.33.67.93.65,2.01,3.55,1.5.04-1-1.56-1.19-1.69-2.05-.12-.88-.94-7.35-1.86-8.84-.9-1.51-3.58-.67-3.58-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-628"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-242",
    x: 95.17,
    y: 102.33,
    width: 12.35,
    height: 13.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "m105.59,114.39c-.89,1.21-1.93,2.22-3.02,3.03v-1.08h-7.59v-12.9h-.34c.5-.49,1.05-.96,1.59-1.35v.05h9.67v-1.09c1.73,1.27,2.54,3.42,2.49,5.84-.07,2.41-1,5.11-2.81,7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-713",
    d: "m105.58,114.39c-.89,1.2-1.93,2.21-3.02,3.02v-1.06h-7.58v-12.87h-.34c.52-.52,1.05-.96,1.6-1.37v.04h9.66v-1.09c1.7,1.29,2.53,3.42,2.46,5.83-.05,2.42-1,5.11-2.79,7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-713",
    d: "m105.57,114.39c-.89,1.2-1.92,2.2-3.01,3v-1.04h-7.58v-12.86h-.32c.51-.51,1.03-.97,1.58-1.36v.03h9.66v-1.08c1.7,1.29,2.51,3.42,2.45,5.82-.05,2.42-1,5.11-2.79,7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-710",
    d: "m105.56,114.38c-.88,1.18-1.91,2.2-2.99,3.01v-1.04h-7.58v-12.86h-.31c.51-.49,1.03-.95,1.57-1.36v.03h9.64v-1.05c1.7,1.26,2.52,3.41,2.45,5.8-.05,2.41-1.01,5.1-2.79,7.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-472",
    d: "m105.56,114.38c-.9,1.18-1.91,2.2-3.01,2.99v-1.01h-7.55v-12.85h-.3c.52-.5,1.03-.95,1.57-1.34h9.64v-1.03c1.68,1.25,2.49,3.39,2.44,5.78-.05,2.41-.99,5.1-2.78,7.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-472",
    d: "m105.55,114.38c-.9,1.18-1.92,2.18-3.01,2.99v-1.01h-7.55v-12.83h-.29c.51-.52,1.02-.97,1.56-1.37.54-.38,1.11-.74,1.66-1.03v1.03h7.96v-1.01c1.68,1.27,2.49,3.38,2.44,5.77-.06,2.4-1,5.07-2.78,7.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-472",
    d: "m105.53,114.35c-.88,1.2-1.9,2.2-2.99,3.01v-1.01h-7.55v-12.82h-.29c.51-.51,1.02-.96,1.57-1.35.56-.4,1.1-.76,1.67-1.03v1.01h7.92v-1.01c1.7,1.26,2.51,3.38,2.45,5.76-.08,2.4-1,5.07-2.78,7.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-472",
    d: "m105.53,114.35c-.89,1.19-1.91,2.19-3,2.99v-.99h-7.54v-12.82h-.29c.52-.51,1.05-.93,1.57-1.33.56-.41,1.1-.74,1.67-1.05v1.01h7.92v-.99c1.67,1.26,2.49,3.36,2.44,5.77-.07,2.38-1,5.04-2.77,7.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-472",
    d: "m105.51,114.34c-.88,1.18-1.91,2.2-2.99,3v-.99h-7.53v-12.81h-.27c.5-.5,1.02-.94,1.55-1.34.56-.39,1.1-.74,1.68-1.03v.99h7.9v-.97c1.67,1.26,2.47,3.36,2.43,5.75-.07,2.38-.99,5.03-2.77,7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-560",
    d: "m105.49,114.33c-.89,1.18-1.89,2.19-2.97,2.98v-.96h-7.53v-12.8h-.27c.51-.48,1.03-.93,1.57-1.33.54-.41,1.08-.75,1.66-1.04v.97h7.87v-.96c1.69,1.26,2.5,3.36,2.44,5.75-.07,2.37-.98,5.02-2.77,7.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m105.49,114.33c-.9,1.18-1.89,2.17-2.99,2.94v-.93h-7.52v-12.78h-.25c.49-.5,1.02-.93,1.56-1.34.53-.39,1.09-.75,1.65-1.02v.95h7.86v-.95c1.67,1.26,2.48,3.35,2.42,5.75-.04,2.37-.98,5.02-2.74,7.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-365",
    d: "m105.48,114.33c-.89,1.17-1.91,2.16-2.98,2.94v-.93h-7.52v-12.77h-.25c.49-.5,1.02-.93,1.56-1.34.53-.39,1.09-.73,1.65-1.03v.95h7.86v-.94c1.66,1.27,2.46,3.35,2.41,5.74-.05,2.37-.97,5.02-2.74,7.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-365",
    d: "m105.47,114.31c-.88,1.17-1.89,2.17-2.96,2.94v-.91h-7.52v-12.76h-.25c.52-.47,1.03-.94,1.56-1.32.55-.41,1.09-.75,1.65-1.06v.94h7.85v-.92c1.66,1.25,2.47,3.34,2.4,5.71-.05,2.37-.98,5.02-2.74,7.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-365",
    d: "m105.45,114.3c-.86,1.17-1.88,2.16-2.94,2.95v-.91h-7.52v-12.76h-.23c.5-.47,1.01-.93,1.55-1.32.54-.39,1.09-.75,1.65-1.03v.92h7.82v-.9c1.69,1.25,2.47,3.33,2.42,5.7-.05,2.36-.96,5-2.74,7.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-393",
    d: "m105.44,114.3c-.88,1.17-1.89,2.16-2.94,2.94v-.9h-7.51v-12.73h-.22c.5-.5,1.03-.94,1.54-1.34.54-.4,1.09-.74,1.65-1.02v.9h7.82v-.87c1.66,1.24,2.46,3.33,2.42,5.67-.07,2.36-.99,5-2.75,7.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-393",
    d: "m105.44,114.29c-.89,1.17-1.89,2.15-2.94,2.94v-.87h-7.51v-12.72h-.21c.49-.5,1.02-.94,1.53-1.33.54-.4,1.1-.75,1.65-1.02v.87h7.81v-.86c1.66,1.24,2.46,3.33,2.41,5.69-.07,2.33-.98,4.95-2.73,7.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-547",
    d: "m105.41,114.27c-.86,1.17-1.86,2.15-2.92,2.94v-.86h-7.51v-12.71h-.2c.49-.51,1.01-.94,1.55-1.33.52-.41,1.08-.75,1.62-1.02v.86h7.78v-.85c1.68,1.25,2.47,3.34,2.42,5.68-.07,2.34-.98,4.95-2.74,7.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "m105.41,114.26c-.86,1.16-1.88,2.15-2.93,2.94v-.85h-7.49v-12.71h-.19c.49-.48,1-.94,1.53-1.32.53-.39,1.08-.73,1.63-1.02v.85h7.77v-.84c1.67,1.24,2.45,3.33,2.4,5.67-.07,2.34-.98,4.95-2.72,7.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-825",
    d: "m105.4,114.25c-.86,1.16-1.87,2.15-2.94,2.93v-.83h-7.47v-12.69h-.19c.49-.48,1-.93,1.53-1.33.53-.38,1.08-.73,1.63-1.01v.83h7.76v-.83c1.65,1.25,2.45,3.32,2.38,5.66-.05,2.34-.95,4.95-2.7,7.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-825",
    d: "m105.4,114.25c-.88,1.16-1.88,2.14-2.94,2.93v-.83h-7.47v-12.68h-.19c.5-.49,1.01-.93,1.55-1.32.52-.39,1.06-.72,1.61-1.01v.82h7.76v-.81c1.65,1.23,2.46,3.31,2.38,5.65-.05,2.33-.96,4.94-2.7,7.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m105.4,114.24c-.88,1.16-1.88,2.14-2.94,2.93v-.82h-7.47v-12.67h-.17c.48-.49,1-.92,1.53-1.32.52-.38,1.08-.72,1.62-1v.79h7.74v-.79c1.64,1.24,2.44,3.3,2.38,5.63s-.96,4.93-2.69,7.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "m105.37,114.22c-.87,1.17-1.85,2.14-2.92,2.92v-.79h-7.46v-12.66h-.17c.5-.48,1.01-.94,1.53-1.33.52-.37,1.08-.72,1.63-1.01v.79h7.71v-.78c3.3,2.47,3.16,8.23-.32,12.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "m105.36,114.22c-.86,1.16-1.85,2.13-2.91,2.92v-.79h-7.46v-12.65h-.16c.49-.49,1.01-.93,1.52-1.33.52-.37,1.08-.71,1.63-1.01v.78h7.7v-.77c3.28,2.46,3.15,8.21-.32,12.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "m105.35,114.22c-.87,1.16-1.87,2.13-2.91,2.9v-.77h-7.45v-12.64h-.13c.46-.49.98-.93,1.5-1.31.52-.39,1.07-.72,1.62-1.01v.77h7.7v-.74c3.28,2.45,3.13,8.18-.33,12.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-945",
    d: "m105.34,114.22c-.86,1.15-1.86,2.12-2.9,2.88v-.75h-7.45v-12.63h-.13c.49-.49.99-.92,1.5-1.31.53-.39,1.07-.72,1.62-1v.74h7.69v-.74c3.28,2.47,3.14,8.18-.32,12.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-803",
    d: "m105.32,114.22c-.85,1.13-1.84,2.11-2.88,2.88v-.75h-7.45v-12.62h-.13c.49-.47.99-.92,1.5-1.3.53-.38,1.07-.73,1.62-1.01v.74h7.67v-.72c3.26,2.45,3.14,8.16-.32,12.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-745",
    d: "m105.32,114.2c-.86,1.15-1.85,2.12-2.91,2.89v-.74h-7.43v-12.6h-.12c.49-.49.98-.91,1.51-1.3.52-.4,1.08-.73,1.6-1.01v.72h7.65v-.69c3.28,2.44,3.13,8.14-.3,12.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-745",
    d: "m105.31,114.18c-.87,1.16-1.84,2.13-2.89,2.89v-.72h-7.43v-12.6h-.12c.48-.47.99-.91,1.5-1.29.52-.39,1.08-.73,1.6-1v.69h7.65v-.68c3.26,2.43,3.11,8.13-.32,12.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-344",
    d: "m105.29,114.18c-.85,1.15-1.82,2.1-2.88,2.87v-.7h-7.42v-12.57h-.11c.48-.49,1-.93,1.51-1.32.52-.38,1.06-.73,1.61-1v.68h7.61v-.68c3.25,2.43,3.11,8.12-.33,12.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-909",
    d: "m105.29,114.17c-.85,1.15-1.84,2.1-2.88,2.86v-.68h-7.42v-12.56h-.11c.49-.49,1-.93,1.51-1.31.52-.38,1.07-.7,1.61-1.01v.68h7.59v-.67c3.26,2.44,3.1,8.11-.3,12.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-721",
    d: "m105.28,114.17c-.85,1.13-1.83,2.09-2.87,2.86v-.68h-7.42v-12.56h-.09c.47-.47.99-.92,1.5-1.3.52-.37,1.06-.71,1.6-1.01v.67h7.59v-.64c3.24,2.44,3.1,8.09-.31,12.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-721",
    d: "m105.27,114.15c-.86,1.15-1.83,2.09-2.87,2.86v-.66h-7.41v-12.55h-.08c.48-.48.98-.91,1.49-1.29.52-.38,1.06-.7,1.6-.99v.63h7.57v-.63c3.24,2.43,3.1,8.08-.3,12.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "m105.25,114.14c-.84,1.14-1.82,2.11-2.85,2.86v-.65h-7.41v-12.54h-.07c.48-.47.97-.91,1.5-1.29.51-.37,1.04-.71,1.58-1v.63h7.57v-.61c3.23,2.43,3.08,8.06-.32,12.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-913",
    d: "m105.24,114.14c-.84,1.14-1.81,2.09-2.85,2.86v-.65h-7.4v-12.53h-.07c.49-.47.98-.91,1.5-1.28.51-.38,1.04-.71,1.58-1v.61h7.55v-.6c3.23,2.42,3.09,8.04-.32,12.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-913",
    d: "m105.23,114.14c-.85,1.12-1.81,2.08-2.84,2.85v-.63h-7.4v-12.51h-.05c.47-.49.98-.89,1.49-1.29,1.04-.76,2.13-1.33,3.2-1.66v1.27h5.92v-.59c3.21,2.42,3.08,8.03-.32,12.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-758",
    d: "m105.23,114.13c-.85,1.12-1.82,2.07-2.84,2.84v-.61h-7.4v-12.51h-.04c.46-.48.97-.9,1.49-1.29,1.02-.75,2.11-1.32,3.18-1.66v1.26h5.91v-.56c3.21,2.4,3.08,8.01-.3,12.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-758",
    d: "m105.22,114.13c-.84,1.11-1.82,2.07-2.83,2.82v-.6h-7.4v-12.51h-.04c.49-.47.97-.89,1.49-1.27,1.02-.76,2.11-1.32,3.18-1.67v1.25h5.91v-.55c3.2,2.41,3.06,8-.31,12.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-692",
    d: "m105.2,114.11c-.84,1.13-1.81,2.07-2.84,2.83v-.59h-7.37v-12.48h-.04c.48-.5.98-.91,1.49-1.3,1.01-.74,2.1-1.29,3.18-1.64v1.22h5.89v-.54c3.18,2.4,3.07,7.99-.31,12.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-632",
    d: "m105.19,114.09c-.85,1.12-1.81,2.08-2.83,2.84v-.58h-7.37v-12.48h-.03c.48-.47.98-.89,1.48-1.27,1.01-.76,2.1-1.31,3.18-1.65v1.21h5.87v-.52c3.2,2.38,3.05,7.96-.3,12.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-556",
    d: "m105.18,114.08c-.85,1.12-1.81,2.07-2.83,2.83v-.56h-7.36v-12.46h-.03c.48-.48.98-.9,1.48-1.26,1.02-.77,2.1-1.31,3.18-1.65v1.18h5.87v-.51c3.18,2.38,3.05,7.95-.31,12.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-911",
    d: "m105.17,114.08c-.85,1.12-1.8,2.07-2.82,2.82v-.55h-7.36v-12.45c.46-.46.95-.9,1.48-1.26,1.01-.76,2.08-1.31,3.16-1.66v1.18h5.84v-.49c3.2,2.37,3.05,7.93-.29,12.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-911",
    d: "m105.17,114.08c-.85,1.11-1.8,2.06-2.82,2.81v-.54h-7.36v-11.7h-.68c.2-.26.44-.5.68-.75.47-.45.95-.89,1.48-1.25,1.01-.76,2.08-1.3,3.16-1.64v1.15h5.83v-.49c3.18,2.39,3.05,7.96-.28,12.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-911",
    d: "m105.14,114.07c-.82,1.11-1.79,2.06-2.78,2.8v-.53h-7.36v-11.7h-.68c.23-.26.45-.49.68-.75.48-.45.97-.88,1.47-1.26,1.01-.74,2.08-1.28,3.16-1.64v1.15h5.83v-.46c3.18,2.37,3.04,7.93-.31,12.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-438",
    d: "m105.13,114.07c-.84,1.1-1.79,2.04-2.79,2.79v-.51h-7.35v-11.69h-.67c.22-.27.45-.5.68-.74.47-.46.96-.88,1.47-1.26,1-.76,2.07-1.3,3.15-1.64v1.13h5.82v-.45c3.17,2.38,3.02,7.93-.31,12.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m105.13,114.07c-.84,1.09-1.79,2.03-2.79,2.78v-.5h-7.35v-11.69h-.67c.23-.26.45-.49.7-.72.46-.46.95-.9,1.45-1.26,1.02-.73,2.1-1.31,3.15-1.65v1.12h5.82v-.44c3.15,2.38,3.01,7.91-.31,12.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-918",
    d: "m105.11,114.04c-.82,1.12-1.77,2.05-2.78,2.8v-.49h-7.35v-11.68h-.64c.21-.24.44-.48.68-.72.47-.46.96-.88,1.45-1.26,1.02-.74,2.1-1.3,3.15-1.63v1.09h5.79v-.43c3.17,2.38,3.02,7.9-.3,12.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-918",
    d: "m105.09,114.03c-.81,1.12-1.78,2.04-2.78,2.79v-.47h-7.33v-10.85h-1.28c1.65-2.22,3.8-3.76,5.91-4.43v1.09h5.78v-.42c3.14,2.38,3.01,7.89-.31,12.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-843",
    d: "m105.09,114.03c-.84,1.11-1.78,2.04-2.78,2.78v-.46h-7.33v-10.85h-1.28c1.66-2.2,3.8-3.72,5.91-4.39v1.05h5.77v-.37c3.15,2.34,3.01,7.85-.3,12.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "m105.08,114.02c-.82,1.12-1.76,2.03-2.77,2.77v-.44h-7.32v-10.84h-1.25c1.64-2.21,3.78-3.73,5.89-4.39v1.04h5.77v-.37c3.12,2.35,2.99,7.85-.32,12.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-670",
    d: "m105.08,114c-.84,1.1-1.77,2.05-2.78,2.77v-.42h-7.31v-10.83h-1.25c1.64-2.2,3.77-3.71,5.88-4.39v1.03h5.75v-.35c3.13,2.34,2.99,7.82-.3,12.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-578",
    d: "m105.06,114c-.82,1.09-1.77,2.02-2.76,2.77v-.42h-7.31v-10.83h-1.25c1.65-2.2,3.77-3.71,5.88-4.37v1.01h5.74v-.35c3.13,2.36,3,7.82-.3,12.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "m105.06,113.99c-.83,1.08-1.77,2.03-2.76,2.76v-.4h-7.31v-10.83h-1.25c1.66-2.17,3.78-3.68,5.88-4.36v1h5.73v-.32c3.11,2.33,2.98,7.79-.29,12.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-840",
    d: "m105.04,113.99c-.82,1.08-1.75,2.02-2.74,2.75v-.38h-7.31v-10.82h-1.22c1.64-2.18,3.75-3.69,5.85-4.34v.97h5.73v-.32c3.1,2.34,2.97,7.79-.31,12.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-840",
    d: "m105.01,113.99c-.79,1.08-1.74,2.01-2.73,2.74v-.37h-7.29v-10.8h-1.2c1.62-2.19,3.74-3.69,5.83-4.36v.96h5.7v-.29c3.11,2.33,2.97,7.77-.31,12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m105.01,113.99c-.82,1.07-1.75,1.99-2.73,2.73v-.37h-7.29v-10.79h-1.2c1.64-2.2,3.74-3.68,5.83-4.36v.95h5.7v-.28c3.09,2.31,2.95,7.75-.31,12.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m105.01,113.98c-.82,1.08-1.75,1.99-2.75,2.72v-.35h-7.28v-10.79h-1.19c1.64-2.19,3.73-3.68,5.83-4.35v.94h5.68v-.28c3.09,2.32,2.97,7.75-.29,12.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-658",
    d: "m105,113.95c-.82,1.08-1.75,2-2.74,2.73v-.33h-7.28v-10.79h-1.17c1.63-2.17,3.73-3.66,5.81-4.32v.92h5.67v-.25c3.09,2.3,2.95,7.72-.29,12.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-655",
    d: "m104.99,113.95c-.82,1.08-1.74,1.98-2.73,2.73v-.33h-7.27v-10.79h-1.16c1.62-2.16,3.72-3.66,5.8-4.31v.9h5.67v-.25c3.08,2.31,2.93,7.72-.3,12.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-663",
    d: "m104.97,113.95c-.81,1.08-1.73,1.98-2.71,2.71v-.31h-7.27v-10.77h-1.15c1.61-2.14,3.7-3.65,5.78-4.3v.87h5.66v-.22c3.07,2.31,2.94,7.69-.31,12.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-360",
    d: "m104.96,113.93c-.8,1.08-1.73,1.98-2.71,2.71v-.29h-7.26v-10.74h-1.15c1.62-2.16,3.72-3.66,5.78-4.31v.86h5.63v-.2c3.08,2.29,2.94,7.68-.29,11.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m104.96,113.92c-.8,1.09-1.74,1.99-2.71,2.71v-.29h-7.26v-10.74h-1.14c1.63-2.15,3.71-3.64,5.77-4.29v.84h5.63v-.19c3.07,2.31,2.94,7.66-.29,11.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m104.95,113.9c-.81,1.08-1.73,1.99-2.7,2.7v-.26h-7.26v-10.74h-1.14c1.63-2.15,3.71-3.61,5.77-4.28v.83h5.61v-.16c3.06,2.29,2.94,7.63-.29,11.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-610",
    d: "m104.92,113.9c-.79,1.09-1.72,1.98-2.7,2.7v-.25h-7.23v-10.74h-1.11c1.61-2.13,3.68-3.62,5.74-4.27v.81h5.61v-.16c3.05,2.29,2.93,7.63-.3,11.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-557",
    d: "m104.92,113.9c-.81,1.08-1.73,1.97-2.7,2.7v-.24h-7.23v-10.72h-1.11c1.62-2.14,3.68-3.62,5.74-4.27v.79h5.61v-.14c3.04,2.29,2.91,7.61-.3,11.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m104.91,113.9c-.8,1.05-1.72,1.97-2.69,2.68v-.22h-7.23v-10.72h-1.1c1.61-2.14,3.67-3.61,5.73-4.27v.79h5.6v-.14c3.02,2.29,2.89,7.61-.31,11.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m104.91,113.87c-.8,1.08-1.72,1.99-2.7,2.7v-.22h-7.22v-10.7h-1.08c1.59-2.15,3.66-3.61,5.71-4.26v.77h5.59v-.12c3.02,2.27,2.9,7.59-.29,11.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-479",
    d: "m104.88,113.87c-.8,1.07-1.71,1.97-2.67,2.68v-.2h-7.22v-10.7h-1.08c1.61-2.12,3.66-3.6,5.7-4.26v.77h5.57v-.11c3.02,2.29,2.9,7.58-.3,11.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-399",
    d: "m104.87,113.87c-.79,1.06-1.71,1.97-2.68,2.67v-.19h-7.2v-10.68h-1.06c1.59-2.14,3.66-3.6,5.68-4.25v.74h5.56v-.1c3.01,2.28,2.88,7.57-.3,11.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-877",
    d: "m104.87,113.86c-.81,1.06-1.71,1.96-2.68,2.66v-.17h-7.2v-10.67h-1.05c1.59-2.13,3.65-3.59,5.67-4.24v.72h5.56v-.07c3.01,2.26,2.88,7.54-.3,11.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m104.86,113.85c-.8,1.07-1.71,1.97-2.68,2.66v-.16h-7.2v-10.67h-1.03c1.58-2.13,3.63-3.58,5.66-4.22v.69h5.53v-.05c3.02,2.25,2.88,7.53-.28,11.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-559",
    d: "m104.85,113.85c-.8,1.05-1.7,1.94-2.67,2.65v-.15h-7.2v-10.66h-1.02c1.58-2.12,3.62-3.56,5.65-4.22v.68h5.52v-.03c3.01,2.25,2.87,7.5-.28,11.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-559",
    d: "m104.83,113.83c-.78,1.05-1.7,1.94-2.66,2.66v-.14h-7.19v-10.66h-1.02c1.58-2.11,3.62-3.56,5.65-4.21v.68h5.52v-.03c3.01,2.25,2.87,7.5-.29,11.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-902",
    d: "m104.83,113.83c-.8,1.05-1.69,1.92-2.65,2.63v-.12h-7.19v-10.65h-1c1.57-2.12,3.59-3.56,5.62-4.2v.65h5.5c3,2.23,2.88,7.47-.28,11.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-832",
    d: "m104.82,113.82c-.79,1.06-1.68,1.94-2.64,2.65v-.12h-7.19v-10.65h-1c1.59-2.12,3.6-3.55,5.62-4.18v.63h5.48c3.01,2.24,2.87,7.47-.28,11.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-942",
    d: "m104.82,113.81c-.8,1.06-1.7,1.93-2.64,2.64v-.1h-7.19v-10.63h-.98c1.57-2.1,3.58-3.55,5.6-4.2,2.01-.63,3.98-.46,5.48.65,2.97,2.22,2.85,7.45-.28,11.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "m104.81,113.81c-.79,1.04-1.7,1.92-2.65,2.61v-.07h-7.17v-10.62h-.98c1.57-2.09,3.6-3.54,5.6-4.18,1.99-.66,3.98-.48,5.46.64,2.98,2.21,2.86,7.44-.27,11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-497",
    d: "m104.79,113.8c-.78,1.05-1.68,1.92-2.65,2.61v-.06h-7.15v-10.62h-.97c1.57-2.09,3.59-3.53,5.59-4.17,1.99-.62,3.98-.48,5.46.64,2.97,2.23,2.84,7.43-.28,11.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-497",
    d: "m104.77,113.8c-.78,1.03-1.66,1.9-2.63,2.61v-.05h-7.15v-10.62h-.96c1.58-2.07,3.58-3.5,5.59-4.14,1.98-.65,3.96-.49,5.44.63,2.96,2.21,2.85,7.4-.29,11.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "m104.76,113.77c-.78,1.04-1.68,1.93-2.62,2.62v-.04h-7.15v-10.61h-.94c1.57-2.07,3.57-3.51,5.56-4.14,1.99-.63,3.97-.48,5.45.62,2.94,2.23,2.82,7.4-.29,11.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "m104.75,113.76c-.77,1.05-1.67,1.92-2.61,2.62v-.03h-7.15v-10.61h-.93c1.56-2.06,3.57-3.48,5.55-4.13,1.99-.63,3.95-.46,5.43.65,2.95,2.21,2.82,7.36-.29,11.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-798",
    d: "m104.75,113.76c-.78,1.04-1.67,1.9-2.61,2.61v-.02h-7.14v-10.58h-.91c1.54-2.08,3.55-3.5,5.52-4.14,1.99-.63,3.95-.48,5.41.63,2.95,2.22,2.85,7.36-.27,11.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-798",
    d: "m104.74,113.76c-.78,1.01-1.66,1.9-2.61,2.6h0s-7.14,0-7.14,0v-10.58h-.91c1.55-2.07,3.55-3.5,5.52-4.13,1.97-.63,3.93-.46,5.41.63,2.94,2.21,2.82,7.35-.28,11.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-798",
    d: "m104.72,113.74c-.77,1.03-1.66,1.91-2.6,2.61-.47.33-.94.65-1.46.9v-.9h-5.67v-10.58h-.89c1.54-2.06,3.53-3.47,5.51-4.11,1.97-.63,3.93-.47,5.41.62,2.93,2.21,2.8,7.34-.29,11.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-564",
    d: "m104.72,113.74c-.79,1.01-1.67,1.89-2.6,2.58-.47.36-.94.66-1.46.9v-.87h-5.67v-10.57h-.89c1.54-2.05,3.53-3.47,5.51-4.1,1.96-.63,3.92-.48,5.4.63,2.91,2.2,2.79,7.31-.28,11.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-868",
    d: "m104.7,113.74c-.77,1.01-1.66,1.89-2.6,2.57-.45.35-.95.65-1.44.9v-.86h-5.67v-10.56h-.88c1.53-2.05,3.53-3.46,5.5-4.1,1.96-.63,3.91-.48,5.38.63,2.92,2.19,2.79,7.3-.28,11.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-614",
    d: "m104.69,113.72c-.77,1.02-1.65,1.89-2.59,2.6-.45.33-.95.62-1.44.89v-.85h-5.67v-10.53h-.87c1.54-2.07,3.52-3.49,5.49-4.12,1.96-.63,3.91-.44,5.36.63,2.92,2.19,2.78,7.29-.28,11.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-737",
    d: "m104.68,113.71c-.77,1.03-1.64,1.89-2.6,2.57-.45.36-.93.65-1.42.9v-.83h-5.67v-10.53h-.85c1.53-2.05,3.5-3.46,5.46-4.09,1.96-.62,3.9-.47,5.35.62,2.9,2.18,2.78,7.28-.28,11.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "m104.68,113.69c-.78,1.03-1.65,1.9-2.59,2.58-.46.34-.94.64-1.42.9v-.82h-5.67v-10.53h-.85c1.53-2.03,3.5-3.45,5.46-4.08,1.95-.61,3.88-.45,5.35.63,2.91,2.18,2.78,7.26-.28,11.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-929",
    d: "m104.65,113.69c-.76,1.01-1.63,1.88-2.56,2.57-.46.34-.94.64-1.42.9v-.81h-5.67v-10.52h-.84c1.53-2.03,3.5-3.45,5.45-4.06,1.95-.62,3.88-.47,5.32.6,2.91,2.18,2.78,7.25-.28,11.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m104.65,113.69c-.77,1.01-1.63,1.87-2.57,2.55-.45.34-.93.65-1.42.9v-.79h-5.67v-10.52h-.81c1.52-2.03,3.5-3.42,5.43-4.05,1.95-.63,3.88-.46,5.32.62,2.9,2.15,2.77,7.22-.28,11.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "m104.64,113.69c-.77,1-1.65,1.86-2.56,2.54-.45.34-.93.64-1.42.88v-.77h-5.67v-10.5h-.81c1.52-2.04,3.5-3.43,5.43-4.04,1.94-.62,3.87-.48,5.3.6,2.89,2.15,2.77,7.21-.27,11.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "m104.63,113.67c-.77,1.02-1.64,1.87-2.56,2.55-.46.33-.92.63-1.41.87v-.75h-5.67v-10.5h-.8c1.52-2.04,3.49-3.42,5.42-4.05,1.94-.61,3.86-.45,5.3.62,2.88,2.15,2.76,7.2-.28,11.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "m104.6,113.66c-.76,1.01-1.62,1.86-2.54,2.53-.46.35-.92.65-1.41.89v-.74h-5.67v-10.49h-.79c1.52-2.02,3.48-3.42,5.41-4.03,1.94-.63,3.84-.47,5.29.61,2.87,2.14,2.75,7.18-.29,11.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "m104.6,113.66c-.76,1.01-1.62,1.86-2.53,2.53-.47.34-.93.62-1.41.88v-.73h-5.67v-10.48h-.78c1.51-2.03,3.47-3.42,5.4-4.04,1.93-.62,3.84-.46,5.27.62,2.87,2.16,2.74,7.17-.28,11.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-341",
    d: "m104.6,113.66c-.76,1.01-1.62,1.86-2.53,2.53-.47.34-.93.64-1.41.87v-.7h-5.67v-10.48h-.77c1.49-2.02,3.45-3.39,5.38-4.01,1.93-.62,3.83-.47,5.27.62,2.86,2.15,2.74,7.14-.28,11.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-736",
    d: "m104.59,113.66c-.76,1-1.63,1.85-2.53,2.52-.45.33-.93.61-1.4.87v-.69h-5.67v-10.48h-.77c1.52-2,3.45-3.38,5.38-3.99,1.93-.62,3.82-.46,5.26.6,2.86,2.16,2.73,7.14-.28,11.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-321",
    d: "m104.57,113.64c-.75,1.01-1.61,1.85-2.53,2.52-.44.34-.92.62-1.39.88v-.68h-5.67v-10.47h-.76c1.51-1.99,3.44-3.37,5.37-4,1.9-.59,3.82-.44,5.25.63,2.85,2.13,2.72,7.12-.29,11.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-321",
    d: "m104.55,113.64c-1.49,2-3.42,3.36-5.35,3.99v-1.28h-4.22v-10.45h-.73c1.49-2,3.42-3.38,5.35-3.99,1.9-.6,3.8-.44,5.23.61,2.85,2.14,2.72,7.11-.28,11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "m104.55,113.6c-1.5,2.01-3.42,3.4-5.35,4v-1.25h-4.22v-10.44h-.72c1.49-2.01,3.42-3.37,5.34-3.98,1.9-.6,3.8-.45,5.21.61,2.85,2.13,2.71,7.09-.27,11.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-541",
    d: "m104.54,113.59c-1.5,2-3.42,3.39-5.34,3.98v-1.23h-4.22v-10.44h-.71c1.49-1.98,3.41-3.36,5.33-3.96,1.9-.62,3.79-.47,5.21.6,2.83,2.12,2.7,7.08-.28,11.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-936",
    d: "m104.52,113.59c-1.48,2-3.39,3.37-5.31,3.98v-1.22h-4.22v-10.43h-.7c1.49-1.97,3.41-3.36,5.32-3.96,1.9-.6,3.78-.45,5.2.6,2.83,2.12,2.7,7.07-.29,11.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-368",
    d: "m104.52,113.58c-1.49,1.98-3.39,3.35-5.31,3.96v-1.19h-4.22v-10.43h-.69c1.5-1.97,3.4-3.34,5.31-3.92,1.89-.63,3.77-.47,5.19.58,2.82,2.13,2.7,7.05-.28,11.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "m104.5,113.58c-1.48,1.97-3.4,3.34-5.29,3.95v-1.18h-4.22v-10.41h-.68c1.49-1.99,3.38-3.34,5.29-3.95,1.89-.6,3.77-.47,5.17.6,2.82,2.1,2.7,7.03-.28,10.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "m104.5,113.58c-1.48,1.97-3.4,3.33-5.29,3.94v-1.18h-4.22v-10.4h-.67c1.48-1.97,3.38-3.33,5.28-3.94,1.89-.62,3.75-.45,5.17.61,2.8,2.1,2.69,7-.28,10.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-875",
    d: "m104.48,113.58c-1.49,1.97-3.38,3.33-5.27,3.92v-1.15h-4.23v-10.4h-.67c1.49-1.97,3.38-3.32,5.28-3.94,1.89-.6,3.75-.44,5.16.62,2.8,2.09,2.67,6.99-.28,10.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-875",
    d: "m104.48,113.55c-1.49,1.97-3.39,3.34-5.27,3.94v-1.14h-4.23v-10.39h-.64c1.47-1.97,3.37-3.32,5.26-3.92,1.87-.6,3.74-.45,5.14.6,2.8,2.09,2.68,6.98-.27,10.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-354",
    d: "m104.47,113.55c-1.48,1.97-3.38,3.32-5.26,3.93v-1.13h-4.23v-10.38h-.64c1.47-1.96,3.37-3.33,5.26-3.92,1.87-.59,3.74-.44,5.13.6,2.78,2.1,2.67,6.98-.27,10.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-354",
    d: "m104.43,113.55c-1.45,1.97-3.34,3.31-5.22,3.9v-1.09h-4.23v-10.36h-.62c1.47-1.97,3.35-3.31,5.24-3.92,1.87-.6,3.71-.43,5.12.6,2.79,2.09,2.66,6.96-.29,10.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m104.43,113.54c-1.46,1.95-3.36,3.31-5.22,3.9v-1.09h-4.23v-10.36h-.62c1.47-1.97,3.35-3.31,5.24-3.91,1.86-.6,3.71-.44,5.12.6,2.77,2.1,2.65,6.95-.29,10.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m104.43,113.53c-1.48,1.96-3.36,3.29-5.22,3.9v-1.08h-4.23v-10.35h-.61c1.46-1.97,3.34-3.3,5.23-3.9,1.86-.6,3.71-.44,5.1.6,2.78,2.08,2.64,6.93-.27,10.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m104.43,113.53c-1.47,1.95-3.35,3.29-5.2,3.86v-1.04h-4.23v-10.34h-.6c1.46-1.95,3.34-3.31,5.22-3.88,1.86-.6,3.7-.46,5.09.57,2.77,2.12,2.65,6.93-.27,10.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m104.41,113.5c-1.46,1.96-3.34,3.27-5.19,3.88v-1.03h-4.23v-10.33h-.58c1.45-1.94,3.33-3.28,5.19-3.87,1.86-.6,3.68-.45,5.07.59,2.76,2.08,2.64,6.89-.27,10.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-354",
    d: "m104.38,113.5c-1.44,1.92-3.32,3.26-5.16,3.86v-1.01h-4.23v-10.32h-.57c1.44-1.93,3.32-3.28,5.19-3.88,1.85-.59,3.67-.44,5.05.6,2.76,2.08,2.63,6.88-.28,10.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-354",
    d: "m104.38,113.49c-1.45,1.93-3.33,3.26-5.16,3.85v-.99h-4.23v-10.31h-.56c1.46-1.93,3.31-3.26,5.18-3.85,1.84-.6,3.66-.45,5.04.59,2.73,2.05,2.61,6.86-.27,10.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-875",
    d: "m104.36,113.49c-1.43,1.92-3.31,3.24-5.14,3.83v-.97h-4.23v-10.31h-.54c1.44-1.92,3.29-3.24,5.16-3.84,1.84-.57,3.66-.42,5.03.6,2.74,2.05,2.62,6.83-.27,10.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-875",
    d: "m104.35,113.48c-1.44,1.9-3.3,3.24-5.12,3.8v-.93h-4.23v-10.3h-.52c1.43-1.9,3.3-3.24,5.14-3.82,1.81-.58,3.65-.44,5,.59,2.74,2.04,2.62,6.82-.26,10.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "m104.33,113.46c-1.42,1.91-3.28,3.22-5.11,3.81v-.92h-4.23v-10.29h-.52c1.44-1.89,3.29-3.22,5.13-3.8,1.81-.6,3.64-.45,4.99.58,2.72,2.03,2.61,6.8-.27,10.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "m104.32,113.44c-1.43,1.9-3.28,3.23-5.1,3.82v-.91h-4.23v-10.27h-.5c1.42-1.9,3.28-3.22,5.11-3.81,1.81-.58,3.61-.44,4.98.59,2.71,2.03,2.61,6.78-.27,10.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-368",
    d: "m104.31,113.44c-1.43,1.89-3.27,3.2-5.09,3.79v-.88h-4.23v-10.26h-.49c1.44-1.89,3.27-3.22,5.11-3.8,1.81-.59,3.61-.43,4.95.58,2.72,2.05,2.6,6.77-.25,10.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-936",
    d: "m104.29,113.42c-1.43,1.91-3.26,3.22-5.07,3.79v-.85h-4.23v-10.26h-.48c1.43-1.89,3.26-3.19,5.1-3.77,1.81-.59,3.59-.44,4.95.58,2.7,2.03,2.59,6.74-.26,10.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-541",
    d: "m104.28,113.42c-1.43,1.89-3.25,3.18-5.06,3.76v-.83h-4.23v-10.25h-.44c2.83-3.76,7.3-5.2,10-3.18,2.69,2.03,2.56,6.72-.26,10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "m104.26,113.4c-1.41,1.89-3.24,3.18-5.03,3.77v-.82h-4.23v-10.22h-.44c2.83-3.78,7.3-5.2,9.97-3.18,2.69,2.01,2.59,6.69-.26,10.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-321",
    d: "m104.24,113.4c-1.4,1.88-3.22,3.18-5.02,3.75v-.79h-4.23v-10.21h-.43c2.81-3.77,7.27-5.2,9.94-3.18,2.69,2,2.56,6.67-.27,10.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-321",
    d: "m104.24,113.37c-1.42,1.88-3.22,3.18-5.02,3.74v-.77h-4.23v-10.21h-.43c2.82-3.76,7.26-5.17,9.94-3.16,2.66,1.99,2.55,6.65-.26,10.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-736",
    d: "m104.22,113.37c-1.41,1.87-3.2,3.17-5,3.73v-.75h-4.23v-10.2h-.39c2.79-3.74,7.21-5.14,9.88-3.15,2.66,1.98,2.54,6.64-.26,10.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-341",
    d: "m104.22,113.36c-1.41,1.87-3.2,3.15-5,3.72v-.73h-4.23v-10.18h-.39c2.79-3.72,7.21-5.14,9.87-3.16,2.63,2,2.53,6.63-.25,10.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "m104.19,113.35c-1.4,1.85-3.18,3.14-4.97,3.7v-.7h-4.23v-10.17h-.36c2.78-3.72,7.19-5.12,9.81-3.15,2.67,1.99,2.53,6.61-.24,10.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "m104.19,113.34c-1.4,1.85-3.2,3.12-4.96,3.69v-.68h-4.23v-10.17h-.36c2.78-3.7,7.18-5.11,9.81-3.14,2.63,1.98,2.53,6.59-.25,10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "m104.16,113.34c-1.37,1.84-3.18,3.1-4.94,3.66v-.66h-4.23v-10.16h-.34c2.76-3.7,7.13-5.09,9.76-3.12,2.64,1.97,2.53,6.56-.25,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "m104.16,113.32c-1.41,1.84-3.18,3.1-4.94,3.68v-.65h-4.23v-10.14h-.34c2.78-3.69,7.12-5.07,9.76-3.1,2.61,1.94,2.49,6.52-.25,10.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m104.14,113.32c-1.39,1.83-3.17,3.1-4.92,3.67v-.63h-4.23v-10.14h-.31c2.75-3.67,7.1-5.06,9.7-3.1,2.62,1.95,2.51,6.52-.24,10.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-929",
    d: "m104.11,113.3c-1.36,1.84-3.14,3.1-4.89,3.65v-.6h-4.23v-10.12h-.3c2.74-3.67,7.09-5.04,9.69-3.09,2.6,1.97,2.5,6.5-.26,10.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "m104.11,113.28c-1.38,1.84-3.13,3.09-4.88,3.65v-.58h-4.23v-10.11h-.29c2.74-3.66,7.06-5.03,9.67-3.08,2.61,1.96,2.47,6.47-.26,10.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-737",
    d: "m104.08,113.26c-1.35,1.83-3.11,3.09-4.86,3.64v-.55h-4.23v-10.11h-.27c2.73-3.61,7.04-5,9.62-3.06,2.59,1.94,2.46,6.46-.27,10.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-614",
    d: "m104.07,113.26c-1.35,1.81-3.1,3.07-4.85,3.63-1.72.54-3.45.38-4.73-.56h.5v-10.08h-.27c2.74-3.62,7.02-5,9.61-3.07,2.57,1.95,2.47,6.45-.26,10.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-868",
    d: "m104.06,113.26c-1.35,1.81-3.1,3.06-4.84,3.61-1.72.54-3.42.4-4.72-.55h.49v-10.04h-.25c2.72-3.63,6.99-4.98,9.58-3.06,2.57,1.93,2.45,6.42-.26,10.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-564",
    d: "m104.05,113.24c-1.35,1.81-3.1,3.04-4.83,3.61-1.72.54-3.42.4-4.71-.57h.48v-10h-.23c2.7-3.6,6.97-4.96,9.54-3.05,2.58,1.93,2.45,6.4-.24,10.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-798",
    d: "m104.03,113.23c-1.34,1.8-3.07,3.04-4.8,3.59-1.71.54-3.42.4-4.69-.55h.45v-9.97h-.21c2.69-3.61,6.95-4.95,9.51-3.04,2.55,1.92,2.45,6.39-.26,9.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-798",
    d: "m104.02,113.23c-1.33,1.8-3.07,3.01-4.79,3.56-1.71.56-3.41.42-4.68-.54h.44v-9.94h-.2c2.69-3.58,6.94-4.95,9.47-3.03,2.55,1.91,2.45,6.37-.24,9.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-798",
    d: "m104.01,113.22c-1.33,1.79-3.06,3.01-4.79,3.55-1.7.57-3.39.41-4.67-.54h.44v-9.91h-.19c2.68-3.58,6.91-4.93,9.45-3.02,2.54,1.9,2.42,6.35-.25,9.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "m103.99,113.21c-1.33,1.77-3.06,2.99-4.77,3.54-1.7.52-3.39.42-4.66-.53h.43v-9.9h-.17c2.66-3.57,6.89-4.9,9.42-3,2.53,1.9,2.42,6.32-.25,9.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "m103.97,113.18c-1.33,1.79-3.04,3-4.75,3.55-1.7.53-3.38.41-4.63-.54h.4v-9.85h-.16c2.67-3.56,6.88-4.91,9.39-3.01,2.53,1.89,2.41,6.31-.25,9.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-497",
    d: "m103.96,113.18c-1.33,1.76-3.03,2.99-4.72,3.53-1.7.53-3.38.4-4.64-.54h.39v-9.83h-.13c2.65-3.54,6.83-4.87,9.37-3,2.52,1.89,2.39,6.3-.26,9.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-497",
    d: "m103.95,113.18c-1.33,1.75-3.02,2.98-4.71,3.5-1.7.54-3.36.41-4.62-.52h.36v-9.8h-.13c2.65-3.51,6.82-4.87,9.34-2.99,2.51,1.88,2.38,6.28-.24,9.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "m103.93,113.17c-1.31,1.75-3.01,2.97-4.69,3.5-1.68.53-3.35.4-4.62-.53h.36v-9.77h-.12c2.64-3.5,6.8-4.84,9.31-2.97,2.49,1.89,2.38,6.25-.26,9.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-942",
    d: "m103.93,113.15c-1.33,1.75-3.01,2.95-4.69,3.5-1.68.53-3.35.4-4.59-.54h.34v-9.73h-.11c2.63-3.5,6.79-4.83,9.28-2.96,2.5,1.88,2.38,6.24-.23,9.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-832",
    d: "m103.91,113.14c-1.32,1.74-3,2.94-4.67,3.5-1.68.53-3.34.37-4.59-.55h.34v-9.7h-.09c2.62-3.5,6.77-4.82,9.26-2.94,2.46,1.87,2.37,6.2-.25,9.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-902",
    d: "m103.89,113.13c-1.31,1.74-2.98,2.94-4.65,3.47-1.68.54-3.33.4-4.56-.53h.31v-9.67h-.07c2.61-3.49,6.73-4.8,9.21-2.94,2.48,1.86,2.37,6.19-.24,9.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-559",
    d: "m103.87,113.13c-1.3,1.72-2.99,2.92-4.63,3.44-1.67.52-3.33.41-4.55-.53h.3v-9.64h-.05c2.59-3.46,6.72-4.77,9.18-2.93,2.46,1.85,2.37,6.16-.24,9.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-559",
    d: "m103.87,113.1c-1.3,1.74-2.98,2.93-4.62,3.46-1.65.53-3.3.39-4.54-.53h.29v-9.61h-.04c2.6-3.45,6.71-4.77,9.16-2.93,2.45,1.85,2.35,6.16-.24,9.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m103.85,113.1c-1.28,1.74-2.97,2.91-4.61,3.44-1.65.53-3.3.39-4.52-.53h.27v-9.59h-.03c2.58-3.43,6.66-4.75,9.12-2.89,2.46,1.83,2.36,6.12-.23,9.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-877",
    d: "m103.84,113.08c-1.3,1.73-2.96,2.92-4.6,3.44-1.65.52-3.27.39-4.5-.52h.25v-9.54h-.03c2.6-3.45,6.66-4.75,9.1-2.92,2.46,1.84,2.35,6.11-.22,9.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-399",
    d: "m103.82,113.08c-1.28,1.72-2.94,2.89-4.58,3.42-1.65.52-3.26.4-4.5-.52h.25v-8.18h-.85c.23-.45.52-.9.85-1.33,2.57-3.42,6.64-4.73,9.07-2.9,2.43,1.83,2.33,6.09-.24,9.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-479",
    d: "m103.8,113.06c-1.28,1.72-2.93,2.89-4.56,3.41-1.65.53-3.26.4-4.47-.52h.22v-8.17h-.82c.21-.45.51-.89.83-1.33,2.56-3.42,6.61-4.72,9.05-2.89,2.43,1.83,2.33,6.08-.24,9.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m103.79,113.06c-1.27,1.69-2.93,2.87-4.55,3.39-1.63.53-3.26.4-4.46-.52h.2v-8.14h-.81c.23-.45.52-.9.85-1.33,2.54-3.4,6.57-4.69,9-2.88,2.43,1.82,2.32,6.06-.23,9.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m103.79,113.04c-1.28,1.7-2.92,2.87-4.54,3.38-1.63.52-3.25.4-4.44-.51h.19v-8.12h-.8c.24-.45.52-.89.85-1.31,2.53-3.41,6.56-4.68,8.98-2.86,2.41,1.81,2.3,6.02-.23,9.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-557",
    d: "m103.76,113.03c-1.26,1.69-2.89,2.86-4.52,3.37-1.61.52-3.24.38-4.43-.51h.18v-8.1h-.78c.24-.44.52-.88.84-1.3,2.54-3.38,6.56-4.66,8.95-2.86,2.42,1.8,2.31,6-.23,9.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-610",
    d: "m103.74,113.02c-1.24,1.69-2.88,2.86-4.5,3.36-1.61.52-3.21.39-4.42-.51h.17v-8.07h-.77c.24-.45.52-.86.84-1.3,2.53-3.37,6.52-4.66,8.92-2.85,2.41,1.81,2.3,5.99-.24,9.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m103.74,113.01c-1.28,1.69-2.9,2.84-4.5,3.35-1.61.53-3.2.39-4.41-.5h.16v-8.06h-.76c.26-.43.52-.86.85-1.28,2.51-3.36,6.48-4.64,8.89-2.85,2.38,1.81,2.29,5.98-.23,9.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m103.71,113c-2.49,3.36-6.47,4.63-8.85,2.84h.13v-8.01h-.73c.24-.44.51-.87.83-1.29,2.51-3.35,6.48-4.63,8.87-2.84,2.38,1.8,2.28,5.95-.25,9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-360",
    d: "m103.71,113c-2.51,3.34-6.46,4.61-8.83,2.82h.12v-7.99h-.71c.23-.45.51-.88.84-1.3,2.5-3.34,6.45-4.6,8.84-2.82,2.36,1.79,2.26,5.93-.25,9.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-663",
    d: "m103.69,112.97c-2.49,3.34-6.44,4.6-8.81,2.82h.11v-7.96h-.7c.26-.44.52-.87.84-1.28,2.49-3.34,6.43-4.59,8.81-2.82,2.37,1.78,2.27,5.91-.24,9.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-655",
    d: "m103.69,112.97c-2.49,3.31-6.42,4.57-8.79,2.8h.09v-6.63h-1.28c.32-.89.8-1.75,1.42-2.6,2.5-3.32,6.41-4.55,8.78-2.8,2.35,1.77,2.26,5.9-.22,9.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-658",
    d: "m103.66,112.96c-2.46,3.3-6.39,4.56-8.74,2.78h.07v-6.6h-1.25c.31-.86.77-1.75,1.41-2.59,2.49-3.3,6.4-4.55,8.75-2.77,2.36,1.74,2.25,5.86-.23,9.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m103.65,112.95c-2.47,3.29-6.38,4.54-8.72,2.78h.05v-6.58h-1.25c.34-.86.8-1.75,1.41-2.57,2.48-3.3,6.39-4.54,8.73-2.78,2.35,1.75,2.25,5.85-.22,9.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m103.64,112.93c-2.46,3.3-6.35,4.53-8.7,2.79h.04v-6.57h-1.22c.33-.85.78-1.73,1.41-2.56,2.45-3.28,6.36-4.53,8.69-2.78,2.33,1.75,2.24,5.84-.22,9.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-840",
    d: "m103.63,112.92c-2.45,3.28-6.32,4.52-8.66,2.78h.03v-6.56h-1.2c.32-.85.77-1.73,1.41-2.53,2.44-3.29,6.31-4.53,8.64-2.77,2.34,1.73,2.24,5.81-.21,9.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-840",
    d: "m103.62,112.91c-2.46,3.27-6.32,4.5-8.65,2.76h.03v-6.52h-1.19c.32-.85.8-1.72,1.41-2.53,2.45-3.27,6.31-4.49,8.64-2.78,2.32,1.76,2.21,5.81-.22,9.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "m103.6,112.9c-2.45,3.26-6.3,4.48-8.61,2.76-.58-.45-1-1.01-1.28-1.68h1.28v-4.8h-1.16c.32-.87.78-1.74,1.4-2.55,2.43-3.26,6.29-4.47,8.6-2.75,2.3,1.74,2.22,5.78-.22,9.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-578",
    d: "m103.57,112.89c-2.43,3.26-6.25,4.46-8.57,2.75-.58-.44-1-1.02-1.27-1.69h1.25v-4.78h-1.15c.33-.87.78-1.73,1.39-2.54,2.45-3.26,6.26-4.48,8.57-2.75,2.31,1.74,2.22,5.76-.22,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-670",
    d: "m103.57,112.89c-2.43,3.21-6.25,4.45-8.55,2.71-.6-.42-1.01-1-1.28-1.67h1.25v-4.76h-1.14c.33-.85.79-1.71,1.38-2.54,2.45-3.23,6.26-4.44,8.56-2.73,2.3,1.73,2.2,5.75-.21,8.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "m103.55,112.87c-2.41,3.21-6.23,4.44-8.52,2.72-.57-.44-1.01-1.01-1.26-1.67h1.22v-4.75h-1.11c.32-.85.77-1.71,1.38-2.51,2.42-3.22,6.24-4.44,8.52-2.72,2.3,1.73,2.19,5.71-.22,8.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-843",
    d: "m103.54,112.86c-2.4,3.2-6.2,4.41-8.49,2.7-.55-.41-.99-.98-1.25-1.65h1.2v-4.73h-1.08c.3-.85.76-1.7,1.36-2.5,2.41-3.22,6.21-4.44,8.49-2.72,2.3,1.73,2.2,5.7-.21,8.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-918",
    d: "m103.52,112.86c-2.38,3.19-6.18,4.4-8.44,2.7-.58-.41-1-.99-1.28-1.65h1.19v-4.71h-1.07c.31-.85.76-1.7,1.37-2.51,2.38-3.19,6.17-4.4,8.45-2.7,2.29,1.7,2.17,5.68-.22,8.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-918",
    d: "m103.51,112.86c-2.38,3.17-6.17,4.38-8.43,2.67-.57-.42-.98-.99-1.25-1.65h1.16v-4.69h-1.05c.32-.85.76-1.7,1.36-2.5,2.38-3.19,6.16-4.39,8.43-2.69,2.26,1.69,2.16,5.66-.22,8.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m103.48,112.83c-2.36,3.18-6.12,4.38-8.39,2.69-.55-.44-.99-1-1.25-1.65h1.15v-4.69h-1.03c.32-.85.77-1.7,1.36-2.48,2.38-3.17,6.15-4.38,8.39-2.69,2.26,1.69,2.18,5.64-.22,8.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-438",
    d: "m103.48,112.82c-2.36,3.16-6.11,4.36-8.37,2.67-.56-.43-1-.98-1.26-1.64h1.14v-4.67h-1.01c.31-.84.76-1.68,1.34-2.47,2.38-3.17,6.14-4.36,8.39-2.68,2.24,1.7,2.15,5.62-.22,8.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-911",
    d: "m103.47,112.81c-2.37,3.16-6.09,4.35-8.34,2.67-.56-.43-.98-.99-1.24-1.63h1.11v-4.67h-1c.32-.84.75-1.68,1.35-2.46,2.36-3.17,6.1-4.35,8.34-2.66,2.22,1.67,2.13,5.6-.22,8.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-911",
    d: "m103.45,112.81c-2.36,3.12-6.08,4.3-8.31,2.65-.55-.44-.96-.98-1.24-1.65h1.08v-4.63h-.98c.31-.84.76-1.66,1.34-2.46,2.37-3.14,6.09-4.31,8.31-2.64,2.25,1.66,2.15,5.58-.21,8.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-911",
    d: "m103.44,112.78c-2.35,3.14-6.06,4.32-8.29,2.65-.55-.4-.96-.97-1.23-1.62h1.07v-4.62h-.96c.32-.85.76-1.67,1.34-2.45,2.35-3.15,6.05-4.32,8.28-2.63,2.23,1.67,2.13,5.55-.21,8.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-556",
    d: "m103.43,112.78c-2.36,3.12-6.04,4.3-8.26,2.63-.54-.42-.96-.97-1.23-1.61h1.05v-4.61h-.94c.32-.85.76-1.66,1.34-2.45,2.33-3.1,6.03-4.29,8.25-2.62,2.22,1.65,2.12,5.53-.21,8.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-632",
    d: "m103.4,112.77c-2.33,3.1-6.01,4.28-8.2,2.62-.58-.41-.98-.96-1.25-1.62h1.03v-4.58h-.91c.28-.85.74-1.65,1.32-2.43,2.32-3.1,6.01-4.28,8.23-2.63,2.22,1.66,2.11,5.52-.22,8.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-692",
    d: "m103.39,112.75c-2.33,3.11-5.99,4.29-8.19,2.62-.55-.43-.97-.97-1.23-1.61h1.01v-4.57h-.89c.29-.83.73-1.65,1.31-2.4,2.33-3.12,6-4.3,8.21-2.62,2.2,1.65,2.1,5.49-.22,8.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-758",
    d: "m103.39,112.74c-2.32,3.09-5.98,4.26-8.17,2.61-.55-.41-.95-.95-1.23-1.58h1v-4.57h-.88c.3-.82.75-1.64,1.33-2.39,2.3-3.1,5.96-4.28,8.17-2.62,2.2,1.65,2.09,5.48-.21,8.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-758",
    d: "m103.38,112.74c-2.32,3.08-5.95,4.24-8.15,2.6-.54-.42-.95-.96-1.22-1.59h.98v-4.55h-.87c.31-.82.75-1.63,1.33-2.39,2.29-3.09,5.95-4.25,8.13-2.61,2.2,1.64,2.11,5.46-.2,8.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-913",
    d: "m103.35,112.72c-2.3,3.07-5.92,4.23-8.09,2.6-.56-.42-.96-.97-1.23-1.6h.96v-4.53h-.85c.28-.82.74-1.63,1.31-2.38,2.29-3.06,5.94-4.23,8.1-2.6,2.18,1.65,2.09,5.44-.2,8.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-913",
    d: "m103.34,112.71c-2.3,3.04-5.91,4.22-8.09,2.59-.53-.42-.93-.96-1.2-1.61h.93v-4.5h-.81c.29-.8.72-1.62,1.3-2.37,2.29-3.05,5.91-4.22,8.08-2.6,2.16,1.65,2.07,5.43-.21,8.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "m103.31,112.71c-2.28,3.02-5.86,4.18-8.04,2.56-.53-.41-.92-.94-1.19-1.58h.91v-2.12h-1.28c.04-1.53.64-3.23,1.78-4.75,2.29-3.03,5.88-4.19,8.05-2.58,2.17,1.63,2.05,5.41-.22,8.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-721",
    d: "m103.31,112.69c-2.27,3.04-5.85,4.18-8.01,2.56-.55-.4-.93-.93-1.19-1.57h.89v-2.12h-1.25c.04-1.52.62-3.22,1.75-4.74,2.28-3.02,5.86-4.18,8.02-2.54,2.16,1.6,2.06,5.37-.21,8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-721",
    d: "m103.29,112.69c-2.25,3.02-5.83,4.16-7.99,2.55-1.08-.81-1.59-2.16-1.56-3.67.04-1.52.63-3.22,1.78-4.72,2.25-3.02,5.83-4.16,7.99-2.54,2.13,1.6,2.05,5.35-.22,8.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-909",
    d: "m103.29,112.68c-2.27,3.01-5.83,4.15-7.97,2.53-1.06-.8-1.57-2.13-1.54-3.64.04-1.52.6-3.22,1.75-4.71,2.25-3.01,5.83-4.15,7.95-2.54,2.14,1.61,2.06,5.35-.2,8.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-344",
    d: "m103.26,112.65c-2.24,3.01-5.8,4.13-7.92,2.54-1.07-.8-1.6-2.13-1.56-3.64.05-1.51.63-3.19,1.75-4.68,2.24-3.01,5.8-4.15,7.93-2.54,2.12,1.61,2.04,5.32-.21,8.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-745",
    d: "m103.25,112.65c-2.23,2.99-5.78,4.12-7.9,2.52-1.07-.79-1.57-2.12-1.54-3.61.04-1.51.61-3.18,1.73-4.67,2.24-3,5.78-4.14,7.92-2.54,2.12,1.61,2.03,5.31-.21,8.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-745",
    d: "m103.24,112.64c-2.22,2.97-5.76,4.09-7.88,2.52-1.05-.81-1.57-2.12-1.52-3.63.04-1.49.62-3.16,1.74-4.63,2.21-3,5.75-4.11,7.86-2.52,2.11,1.58,2.02,5.27-.2,8.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-803",
    d: "m103.22,112.64c-2.21,2.95-5.72,4.07-7.84,2.5-1.05-.8-1.55-2.13-1.52-3.61.04-1.49.62-3.16,1.73-4.63,2.23-2.95,5.73-4.08,7.84-2.51,2.12,1.6,2.01,5.27-.21,8.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-945",
    d: "m103.21,112.62c-2.22,2.93-5.7,4.06-7.81,2.48-1.05-.77-1.56-2.1-1.52-3.58.04-1.49.61-3.14,1.74-4.63,2.21-2.95,5.7-4.06,7.81-2.5,2.09,1.58,1.99,5.25-.21,8.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "m103.2,112.6c-2.22,2.95-5.69,4.07-7.79,2.48-1.04-.77-1.56-2.08-1.5-3.56.03-1.48.6-3.13,1.71-4.61,2.21-2.94,5.69-4.06,7.78-2.48,2.1,1.57,2.01,5.22-.19,8.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "m103.17,112.6c-2.2,2.93-5.66,4.04-7.74,2.46-1.06-.77-1.56-2.06-1.51-3.55.04-1.48.62-3.12,1.71-4.57,2.2-2.94,5.68-4.05,7.76-2.48,2.08,1.56,1.99,5.19-.21,8.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "m103.16,112.57c-2.19,2.94-5.64,4.03-7.72,2.48-1.03-.78-1.54-2.08-1.5-3.54.04-1.48.6-3.12,1.7-4.56,2.19-2.93,5.65-4.04,7.74-2.46,2.06,1.55,1.98,5.17-.21,8.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m103.15,112.57c-2.18,2.92-5.63,4.01-7.7,2.45-1.03-.77-1.53-2.06-1.49-3.52.03-1.47.6-3.09,1.69-4.55,2.18-2.92,5.63-4,7.69-2.45,2.06,1.55,1.99,5.16-.2,8.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-825",
    d: "m103.14,112.56c-2.17,2.9-5.61,3.99-7.66,2.45-1.05-.77-1.54-2.05-1.49-3.5.02-1.47.6-3.09,1.68-4.54,2.18-2.9,5.61-3.99,7.67-2.45,2.06,1.54,1.97,5.14-.2,8.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-825",
    d: "m103.13,112.54c-2.16,2.89-5.59,3.99-7.64,2.45-1.02-.77-1.52-2.04-1.48-3.5.02-1.45.59-3.07,1.67-4.5,2.17-2.91,5.58-3.98,7.63-2.45,2.06,1.55,1.97,5.12-.19,8.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "m103.11,112.54c-2.15,2.87-5.57,3.96-7.61,2.43-1.02-.76-1.5-2.05-1.48-3.49.04-1.45.61-3.07,1.68-4.5,2.15-2.87,5.57-3.98,7.61-2.43,2.05,1.53,1.97,5.1-.2,7.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-547",
    d: "m103.11,112.54c-2.16,2.85-5.55,3.94-7.59,2.4-1.03-.77-1.51-2.04-1.49-3.46.05-1.45.61-3.06,1.69-4.48,2.14-2.87,5.55-3.96,7.57-2.44,2.04,1.53,1.95,5.09-.18,7.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-393",
    d: "m103.07,112.52c-2.13,2.86-5.51,3.93-7.54,2.41-1.02-.76-1.5-2.03-1.48-3.45.04-1.44.6-3.05,1.66-4.47,2.14-2.84,5.52-3.93,7.56-2.42,2.03,1.51,1.95,5.07-.2,7.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-393",
    d: "m103.07,112.51c-2.14,2.84-5.51,3.91-7.53,2.41-1-.77-1.5-2.03-1.47-3.45.04-1.43.6-3.02,1.66-4.45,2.13-2.85,5.49-3.9,7.52-2.4,2.03,1.51,1.94,5.03-.19,7.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-365",
    d: "m103.05,112.5c-2.12,2.84-5.46,3.9-7.48,2.38-1.01-.75-1.49-1.99-1.46-3.42.04-1.44.59-3.02,1.65-4.44,2.12-2.84,5.47-3.9,7.49-2.38,2.02,1.5,1.93,5.01-.2,7.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-365",
    d: "m103.04,112.5c-2.11,2.82-5.45,3.88-7.45,2.37-1.02-.75-1.49-2.01-1.47-3.41.05-1.44.6-3.02,1.65-4.43,2.11-2.83,5.46-3.88,7.45-2.38,2.01,1.49,1.94,5-.19,7.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-365",
    d: "m103.02,112.47c-2.11,2.8-5.43,3.89-7.43,2.37-1-.74-1.49-1.99-1.45-3.41.04-1.41.58-3,1.65-4.39,2.09-2.81,5.43-3.87,7.42-2.38,2.01,1.51,1.91,4.99-.2,7.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m103.02,112.47c-2.11,2.78-5.43,3.85-7.41,2.37-1.01-.76-1.49-1.98-1.43-3.4.03-1.41.56-2.97,1.62-4.39,2.09-2.77,5.42-3.83,7.41-2.35,1.99,1.48,1.9,4.95-.19,7.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-560",
    d: "m102.99,112.46c-2.08,2.78-5.38,3.84-7.37,2.35-1-.74-1.47-1.98-1.43-3.39.04-1.4.58-2.95,1.63-4.38,2.09-2.76,5.38-3.83,7.37-2.34,1.98,1.5,1.89,4.95-.2,7.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-472",
    d: "m102.98,112.43c-2.09,2.8-5.37,3.84-7.35,2.37-.99-.74-1.46-1.98-1.43-3.39.03-1.39.58-2.94,1.63-4.33,2.07-2.78,5.36-3.83,7.34-2.35,1.97,1.48,1.89,4.92-.19,7.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-472",
    d: "m102.96,112.43c-2.07,2.78-5.33,3.82-7.32,2.35-.97-.75-1.44-1.97-1.41-3.38.05-1.37.58-2.92,1.61-4.31,2.07-2.76,5.36-3.81,7.33-2.34,1.97,1.49,1.88,4.91-.2,7.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-472",
    d: "m102.96,112.42c-2.07,2.77-5.33,3.81-7.29,2.33-1.96-1.47-1.88-4.88.18-7.66,2.07-2.75,5.34-3.79,7.29-2.31,1.96,1.46,1.88,4.87-.18,7.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-472",
    d: "m102.94,112.4c-2.06,2.76-5.31,3.8-7.26,2.34-1.95-1.48-1.89-4.87.18-7.62,2.06-2.74,5.32-3.78,7.28-2.3,1.94,1.44,1.87,4.84-.2,7.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-472",
    d: "m102.93,112.4c-2.05,2.74-5.29,3.77-7.23,2.3-1.96-1.45-1.86-4.84.19-7.58,2.05-2.74,5.29-3.78,7.22-2.3,1.95,1.45,1.86,4.83-.18,7.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-710",
    d: "m102.9,112.38c-2.03,2.74-5.26,3.77-7.2,2.31-1.93-1.47-1.86-4.83.18-7.56,2.06-2.74,5.27-3.76,7.22-2.3,1.93,1.45,1.85,4.84-.2,7.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-713",
    d: "m102.9,112.38c-2.03,2.7-5.22,3.72-7.18,2.29-1.93-1.44-1.84-4.82.2-7.52,2.04-2.72,5.24-3.75,7.16-2.3,1.94,1.46,1.85,4.82-.18,7.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-713",
    d: "m102.89,112.37c-2.03,2.69-5.21,3.72-7.14,2.29-1.93-1.45-1.84-4.81.17-7.51,2.04-2.7,5.23-3.71,7.16-2.29,1.93,1.45,1.83,4.8-.19,7.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "m102.86,112.37c-2,2.69-5.19,3.7-7.1,2.29-1.92-1.44-1.84-4.8.18-7.49,2.01-2.68,5.2-3.71,7.11-2.28,1.92,1.46,1.83,4.78-.19,7.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "m102.85,112.36c-2.01,2.67-5.18,3.69-7.08,2.25-1.92-1.42-1.81-4.76.17-7.44,2.02-2.68,5.19-3.68,7.1-2.26,1.91,1.43,1.83,4.76-.19,7.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-713",
    d: "m102.84,112.34c-2,2.69-5.17,3.68-7.07,2.27-1.89-1.43-1.81-4.76.2-7.41,1.99-2.69,5.17-3.71,7.07-2.26,1.89,1.41,1.81,4.73-.2,7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-713",
    d: "m102.84,112.33c-2,2.68-5.16,3.67-7.04,2.25-1.91-1.41-1.83-4.73.18-7.38,1.99-2.68,5.16-3.68,7.04-2.26,1.89,1.42,1.81,4.74-.18,7.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-710",
    d: "m102.84,112.33c-2.01,2.66-5.16,3.67-7.04,2.25-1.89-1.41-1.81-4.73.18-7.38,2-2.67,5.15-3.67,7.04-2.24,1.89,1.41,1.81,4.72-.18,7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-472",
    d: "m102.82,112.33c-1.98,2.65-5.13,3.65-7.01,2.23-1.89-1.41-1.81-4.71.18-7.36,1.99-2.65,5.14-3.66,7.01-2.23,1.9,1.41,1.82,4.71-.18,7.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-472",
    d: "m102.82,112.33c-1.99,2.64-5.12,3.64-7,2.23-1.89-1.41-1.81-4.71.17-7.36,1.99-2.65,5.14-3.66,7.01-2.24,1.89,1.42,1.81,4.71-.18,7.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-472",
    d: "m102.81,112.32c-1.98,2.62-5.11,3.63-6.99,2.22-1.88-1.41-1.8-4.7.18-7.33,1.98-2.66,5.13-3.65,7-2.24,1.88,1.41,1.8,4.71-.19,7.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-472",
    d: "m102.8,112.32c-1.97,2.61-5.1,3.61-6.96,2.21-1.88-1.41-1.81-4.69.17-7.32,1.97-2.63,5.1-3.64,6.98-2.23,1.88,1.41,1.79,4.7-.19,7.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-472",
    d: "m102.79,112.31c-1.97,2.61-5.09,3.61-6.96,2.22-1.87-1.4-1.81-4.68.19-7.31,1.96-2.63,5.08-3.63,6.95-2.21,1.88,1.39,1.79,4.67-.19,7.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-560",
    d: "m102.79,112.31c-1.97,2.61-5.09,3.6-6.95,2.2-1.87-1.41-1.79-4.66.18-7.28,1.98-2.62,5.08-3.6,6.94-2.21,1.87,1.39,1.79,4.66-.17,7.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m102.79,112.31c-1.97,2.59-5.07,3.58-6.95,2.2-1.85-1.41-1.76-4.66.19-7.27,1.97-2.62,5.06-3.61,6.93-2.21,1.86,1.39,1.79,4.65-.17,7.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-365",
    d: "m102.75,112.29c-1.93,2.62-5.03,3.59-6.89,2.21-1.85-1.4-1.78-4.64.18-7.25,1.97-2.61,5.05-3.6,6.91-2.2,1.87,1.37,1.79,4.63-.2,7.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-365",
    d: "m102.75,112.29c-1.94,2.6-5.03,3.58-6.89,2.2-1.85-1.41-1.76-4.63.18-7.24,1.97-2.6,5.05-3.58,6.9-2.2,1.87,1.41,1.78,4.63-.19,7.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-365",
    d: "m102.75,112.29c-1.94,2.59-5.03,3.58-6.88,2.2-1.85-1.41-1.77-4.63.18-7.23,1.95-2.6,5.02-3.58,6.88-2.2,1.84,1.4,1.77,4.62-.18,7.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-393",
    d: "m102.75,112.25c-1.96,2.61-5.03,3.59-6.87,2.2-1.86-1.38-1.77-4.61.17-7.2,1.95-2.59,5.02-3.58,6.88-2.19,1.84,1.39,1.76,4.62-.18,7.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-393",
    d: "m102.73,112.25c-1.93,2.6-4.99,3.58-6.84,2.19-1.84-1.38-1.77-4.59.19-7.17,1.93-2.61,4.99-3.57,6.83-2.21,1.86,1.4,1.78,4.62-.18,7.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-547",
    d: "m102.73,112.25c-1.93,2.59-4.99,3.57-6.83,2.18-1.83-1.37-1.75-4.58.18-7.16,1.93-2.57,4.99-3.56,6.83-2.17,1.84,1.37,1.75,4.58-.18,7.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "m102.72,112.25c-1.92,2.58-4.98,3.57-6.8,2.18-1.83-1.38-1.74-4.58.18-7.16,1.91-2.57,4.97-3.54,6.81-2.15,1.83,1.35,1.74,4.56-.19,7.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-825",
    d: "m102.72,112.24c-1.94,2.57-4.98,3.55-6.8,2.16-1.82-1.36-1.74-4.55.18-7.11,1.94-2.59,4.96-3.55,6.8-2.18,1.83,1.35,1.76,4.56-.17,7.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-825",
    d: "m102.71,112.23c-1.93,2.57-4.97,3.54-6.79,2.16-1.82-1.35-1.74-4.54.18-7.1,1.94-2.57,4.96-3.55,6.8-2.16,1.83,1.36,1.74,4.54-.18,7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m102.7,112.23c-1.92,2.57-4.96,3.52-6.76,2.16-1.82-1.36-1.74-4.54.18-7.1,1.92-2.56,4.93-3.5,6.76-2.15,1.82,1.35,1.73,4.54-.18,7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "m102.68,112.22c-1.9,2.55-4.92,3.51-6.74,2.16-1.82-1.37-1.73-4.54.18-7.08,1.92-2.56,4.93-3.51,6.74-2.16,1.82,1.36,1.74,4.54-.18,7.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "m102.68,112.22c-1.9,2.53-4.92,3.5-6.74,2.15-1.8-1.37-1.72-4.53.19-7.07,1.91-2.54,4.91-3.5,6.72-2.15,1.82,1.35,1.74,4.53-.17,7.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "m102.67,112.22c-1.89,2.53-4.9,3.5-6.71,2.13-1.81-1.35-1.73-4.5.16-7.04,1.91-2.54,4.91-3.5,6.72-2.15,1.81,1.36,1.74,4.52-.17,7.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-945",
    d: "m102.67,112.21c-1.9,2.53-4.9,3.5-6.71,2.14-1.79-1.35-1.71-4.5.18-7.04,1.9-2.54,4.89-3.5,6.7-2.13,1.81,1.35,1.72,4.5-.17,7.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-803",
    d: "m102.66,112.21c-1.89,2.52-4.88,3.48-6.68,2.13-1.8-1.33-1.72-4.48.18-7,1.89-2.52,4.88-3.49,6.69-2.13,1.8,1.33,1.71,4.48-.19,7.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-745",
    d: "m102.64,112.2c-1.87,2.51-4.86,3.47-6.65,2.13-1.8-1.36-1.71-4.48.18-7,1.88-2.51,4.87-3.49,6.65-2.13,1.81,1.35,1.73,4.48-.18,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-745",
    d: "m102.64,112.2c-1.89,2.51-4.86,3.46-6.65,2.13-1.78-1.36-1.71-4.48.18-7,1.89-2.5,4.87-3.46,6.65-2.11,1.78,1.33,1.72,4.46-.18,6.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-344",
    d: "m102.64,112.2c-1.89,2.5-4.86,3.44-6.64,2.11-1.77-1.34-1.7-4.46.17-6.96,1.89-2.51,4.86-3.45,6.64-2.12,1.79,1.33,1.71,4.46-.17,6.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-909",
    d: "m102.63,112.18c-1.88,2.52-4.85,3.46-6.63,2.13-1.78-1.34-1.69-4.46.18-6.95,1.88-2.51,4.84-3.45,6.62-2.12,1.79,1.33,1.7,4.45-.17,6.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-721",
    d: "m102.62,112.18c-1.87,2.49-4.83,3.43-6.6,2.11-1.79-1.33-1.7-4.44.16-6.94,1.88-2.5,4.84-3.45,6.61-2.11,1.77,1.33,1.71,4.44-.17,6.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-721",
    d: "m102.62,112.18c-1.87,2.48-4.83,3.42-6.6,2.08-1.76-1.31-1.69-4.41.18-6.9,1.86-2.49,4.82-3.43,6.59-2.12,1.76,1.34,1.69,4.44-.17,6.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "m102.59,112.16c-1.86,2.49-4.8,3.43-6.57,2.09-1.75-1.33-1.68-4.4.18-6.89,1.85-2.48,4.81-3.42,6.58-2.08,1.76,1.31,1.68,4.4-.19,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-913",
    d: "m102.59,112.15c-1.86,2.5-4.78,3.41-6.56,2.09-1.76-1.33-1.67-4.39.17-6.87,1.85-2.49,4.8-3.42,6.55-2.09,1.79,1.33,1.71,4.39-.16,6.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-913",
    d: "m102.58,112.15c-1.85,2.46-4.77,3.4-6.55,2.07-1.75-1.32-1.67-4.38.18-6.85,1.84-2.46,4.79-3.41,6.54-2.09,1.76,1.33,1.68,4.39-.17,6.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-758",
    d: "m102.58,112.15c-1.86,2.45-4.76,3.39-6.53,2.07-1.74-1.32-1.68-4.38.16-6.85,1.85-2.45,4.77-3.4,6.54-2.06,1.74,1.31,1.67,4.37-.17,6.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-758",
    d: "m102.58,112.14c-1.85,2.46-4.75,3.38-6.52,2.07-1.74-1.32-1.67-4.37.19-6.82,1.82-2.45,4.74-3.4,6.48-2.08,1.77,1.31,1.68,4.37-.15,6.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-692",
    d: "m102.57,112.14c-1.84,2.44-4.74,3.37-6.49,2.07-1.74-1.32-1.66-4.37.18-6.82,1.81-2.45,4.72-3.38,6.47-2.06,1.75,1.3,1.68,4.35-.16,6.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-632",
    d: "m102.57,112.14c-1.84,2.45-4.74,3.37-6.49,2.06-1.73-1.31-1.65-4.35.18-6.8,1.84-2.44,4.72-3.37,6.47-2.06,1.74,1.31,1.65,4.35-.16,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-556",
    d: "m102.57,112.11c-1.86,2.46-4.74,3.38-6.47,2.07-1.73-1.29-1.66-4.33.16-6.78,1.84-2.44,4.72-3.37,6.47-2.06,1.74,1.3,1.66,4.34-.15,6.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-911",
    d: "m102.54,112.11c-1.83,2.44-4.71,3.37-6.45,2.06-1.73-1.3-1.66-4.32.17-6.76,1.83-2.44,4.71-3.35,6.45-2.05,1.73,1.31,1.66,4.32-.17,6.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-911",
    d: "m102.53,112.11c-1.82,2.43-4.7,3.35-6.41,2.05-1.74-1.29-1.65-4.3.15-6.74,1.82-2.43,4.71-3.35,6.43-2.05,1.73,1.3,1.66,4.31-.17,6.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-911",
    d: "m102.52,112.1c-1.81,2.43-4.69,3.34-6.4,2.04-1.73-1.28-1.65-4.31.17-6.72,1.81-2.4,4.68-3.34,6.39-2.04,1.73,1.3,1.66,4.3-.16,6.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-438",
    d: "m102.52,112.1c-1.81,2.41-4.67,3.33-6.39,2.04-1.72-1.28-1.64-4.31.17-6.71,1.81-2.41,4.67-3.33,6.39-2.05,1.73,1.29,1.65,4.3-.16,6.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m102.5,112.09c-1.8,2.42-4.65,3.32-6.38,2.04-1.71-1.27-1.64-4.3.17-6.7,1.81-2.4,4.67-3.31,6.38-2.03,1.71,1.28,1.65,4.28-.17,6.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-918",
    d: "m102.5,112.09c-1.81,2.4-4.65,3.32-6.36,2.04-1.72-1.3-1.64-4.3.15-6.68,1.81-2.4,4.66-3.33,6.38-2.04,1.71,1.29,1.64,4.27-.17,6.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-918",
    d: "m102.5,112.09c-1.8,2.39-4.64,3.29-6.34,2.02-1.73-1.28-1.64-4.28.15-6.64,1.8-2.42,4.65-3.32,6.35-2.05,1.72,1.29,1.64,4.27-.16,6.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-843",
    d: "m102.5,112.06c-1.8,2.39-4.63,3.31-6.33,2.03-1.7-1.27-1.62-4.26.17-6.63,1.79-2.41,4.62-3.3,6.31-2.03,1.73,1.27,1.65,4.24-.14,6.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "m102.48,112.06c-1.79,2.38-4.62,3.28-6.32,2.02-1.7-1.27-1.62-4.25.17-6.62,1.79-2.4,4.62-3.3,6.31-2.03,1.71,1.28,1.62,4.24-.16,6.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-670",
    d: "m102.46,112.06c-1.77,2.38-4.6,3.29-6.3,2.02-1.67-1.26-1.61-4.24.17-6.6,1.79-2.37,4.62-3.28,6.31-2.01,1.69,1.25,1.62,4.22-.18,6.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-578",
    d: "m102.46,112.06c-1.77,2.37-4.58,3.28-6.28,2.01-1.69-1.26-1.62-4.23.17-6.59,1.77-2.37,4.58-3.27,6.27-2.01,1.7,1.27,1.62,4.22-.16,6.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "m102.45,112.05c-1.79,2.37-4.57,3.27-6.27,2.02-1.67-1.29-1.59-4.23.17-6.58,1.79-2.37,4.58-3.27,6.27-1.99,1.67,1.25,1.61,4.2-.17,6.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-840",
    d: "m102.44,112.05c-1.78,2.35-4.56,3.26-6.24,1.98-1.69-1.25-1.6-4.2.16-6.55,1.78-2.37,4.57-3.26,6.26-1.98,1.67,1.24,1.6,4.19-.18,6.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-840",
    d: "m102.44,112.05c-1.78,2.35-4.56,3.23-6.24,1.98-1.66-1.25-1.6-4.2.15-6.55,1.78-2.34,4.57-3.24,6.24-1.98,1.69,1.26,1.63,4.19-.15,6.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m102.44,112.03c-1.78,2.36-4.56,3.23-6.23,1.99-1.67-1.25-1.59-4.19.14-6.53,1.78-2.35,4.57-3.25,6.23-1.98,1.67,1.25,1.61,4.18-.14,6.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m102.42,112.03c-1.75,2.35-4.53,3.22-6.2,1.97-1.66-1.25-1.59-4.17.16-6.5,1.76-2.35,4.54-3.22,6.21-1.98,1.67,1.24,1.6,4.17-.17,6.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-658",
    d: "m102.41,112.02c-1.74,2.33-4.52,3.22-6.17,1.97-1.67-1.25-1.59-4.16.16-6.49,1.74-2.34,4.52-3.21,6.18-1.98,1.66,1.27,1.58,4.17-.17,6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-655",
    d: "m102.41,112.01c-1.75,2.33-4.52,3.22-6.16,1.97-1.65-1.24-1.59-4.15.16-6.48,1.74-2.32,4.51-3.2,6.17-1.96,1.65,1.25,1.58,4.15-.17,6.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-663",
    d: "m102.4,112.01c-1.74,2.32-4.49,3.2-6.15,1.97-1.65-1.24-1.58-4.15.15-6.47,1.74-2.32,4.51-3.21,6.16-1.97,1.65,1.25,1.57,4.14-.17,6.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-360",
    d: "m102.4,112.01c-1.74,2.32-4.49,3.18-6.15,1.97-1.65-1.25-1.57-4.15.17-6.45,1.73-2.33,4.49-3.19,6.15-1.97,1.63,1.25,1.57,4.13-.17,6.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m102.39,112.01c-1.73,2.32-4.48,3.18-6.13,1.94-1.64-1.24-1.57-4.12.16-6.42,1.73-2.3,4.47-3.18,6.12-1.97,1.65,1.25,1.57,4.13-.15,6.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m102.39,112c-1.73,2.3-4.48,3.17-6.12,1.95-1.64-1.24-1.57-4.12.17-6.41,1.71-2.31,4.45-3.18,6.09-1.96,1.65,1.24,1.57,4.11-.14,6.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-610",
    d: "m102.36,111.98c-1.71,2.3-4.45,3.18-6.09,1.95-1.63-1.22-1.55-4.1.18-6.39,1.71-2.3,4.44-3.16,6.07-1.93,1.64,1.22,1.56,4.08-.16,6.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-557",
    d: "m102.36,111.98c-1.72,2.29-4.44,3.17-6.08,1.94-1.64-1.23-1.57-4.09.16-6.39,1.73-2.3,4.43-3.16,6.07-1.93,1.64,1.22,1.56,4.08-.16,6.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m102.35,111.97c-1.71,2.3-4.43,3.18-6.06,1.93-1.63-1.21-1.56-4.06.15-6.34,1.73-2.28,4.43-3.16,6.06-1.94,1.64,1.23,1.56,4.07-.15,6.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m102.35,111.97c-1.72,2.28-4.41,3.16-6.06,1.93-1.62-1.21-1.56-4.06.17-6.33,1.71-2.29,4.41-3.17,6.04-1.93,1.63,1.21,1.56,4.06-.15,6.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-479",
    d: "m102.34,111.97c-1.7,2.26-4.39,3.13-6.03,1.9-1.61-1.19-1.54-4.04.17-6.31,1.7-2.28,4.4-3.13,6.02-1.92,1.61,1.21,1.55,4.05-.16,6.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-399",
    d: "m102.34,111.97c-1.7,2.26-4.38,3.11-6,1.9-1.64-1.19-1.56-4.04.14-6.31,1.7-2.25,4.4-3.12,6.02-1.89,1.61,1.21,1.53,4.02-.16,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-877",
    d: "m102.34,111.96c-1.72,2.26-4.38,3.1-6,1.91-1.61-1.22-1.55-4.04.16-6.3,1.7-2.26,4.38-3.1,5.99-1.89,1.6,1.2,1.54,4.01-.14,6.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m102.32,111.93c-1.7,2.29-4.37,3.12-5.98,1.92-1.62-1.2-1.54-4.02.15-6.27,1.7-2.25,4.38-3.11,5.97-1.9,1.61,1.21,1.55,4.01-.14,6.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-559",
    d: "m102.31,111.93c-1.69,2.27-4.36,3.1-5.96,1.92-1.61-1.21-1.53-4.02.14-6.27,1.7-2.24,4.37-3.1,5.97-1.9,1.6,1.2,1.53,4-.15,6.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-559",
    d: "m102.3,111.93c-1.69,2.25-4.35,3.09-5.95,1.9-1.59-1.19-1.53-4,.17-6.23,1.67-2.25,4.34-3.11,5.93-1.92,1.6,1.21,1.53,4-.15,6.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-902",
    d: "m102.3,111.92c-1.69,2.25-4.35,3.1-5.94,1.89-1.59-1.17-1.53-3.98.17-6.21,1.68-2.24,4.31-3.1,5.92-1.9,1.58,1.19,1.53,3.98-.14,6.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-832",
    d: "m102.28,111.92c-1.67,2.23-4.32,3.09-5.92,1.89-1.57-1.18-1.5-3.98.17-6.19,1.68-2.24,4.31-3.1,5.92-1.89,1.57,1.18,1.51,3.97-.16,6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-942",
    d: "m102.28,111.89c-1.67,2.24-4.32,3.09-5.91,1.9-1.57-1.2-1.51-3.97.15-6.18,1.68-2.23,4.31-3.09,5.89-1.89,1.6,1.18,1.54,3.96-.13,6.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "m102.26,111.89c-1.66,2.23-4.29,3.08-5.87,1.9-1.59-1.2-1.52-3.97.14-6.17,1.67-2.24,4.3-3.07,5.88-1.89,1.59,1.17,1.51,3.95-.15,6.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-497",
    d: "m102.26,111.89c-1.65,2.23-4.28,3.05-5.86,1.88-1.57-1.17-1.51-3.94.16-6.13,1.65-2.23,4.28-3.09,5.85-1.9,1.57,1.2,1.51,3.95-.15,6.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-497",
    d: "m102.25,111.89c-1.65,2.22-4.27,3.04-5.84,1.87-1.57-1.17-1.5-3.93.16-6.12,1.65-2.23,4.26-3.06,5.84-1.87,1.57,1.17,1.5,3.91-.16,6.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "m102.25,111.89c-1.65,2.21-4.27,3.03-5.83,1.88-1.57-1.19-1.5-3.93.14-6.12,1.65-2.21,4.26-3.06,5.84-1.87,1.56,1.17,1.49,3.91-.15,6.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "m102.25,111.88c-1.65,2.21-4.27,3.04-5.83,1.87-1.57-1.17-1.5-3.91.14-6.09,1.65-2.22,4.26-3.03,5.83-1.87,1.57,1.17,1.5,3.9-.14,6.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-798",
    d: "m102.22,111.88c-1.64,2.2-4.22,3.02-5.78,1.87-1.57-1.18-1.5-3.91.14-6.09,1.64-2.19,4.24-3.02,5.81-1.86,1.54,1.16,1.49,3.9-.17,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-798",
    d: "m102.22,111.88c-1.64,2.19-4.22,3.01-5.78,1.83-1.56-1.16-1.49-3.88.16-6.05,1.63-2.19,4.23-3.01,5.77-1.84,1.56,1.16,1.48,3.87-.15,6.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-798",
    d: "m102.21,111.86c-1.64,2.21-4.21,3.01-5.76,1.83-1.56-1.15-1.48-3.86.16-6.03,1.62-2.17,4.22-3.01,5.76-1.84,1.56,1.16,1.48,3.87-.15,6.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-564",
    d: "m102.19,111.86c-1.62,2.17-4.19,2.99-5.75,1.83-1.54-1.15-1.48-3.86.16-6.02,1.64-2.17,4.21-3.01,5.75-1.84,1.54,1.16,1.49,3.86-.16,6.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-868",
    d: "m102.19,111.86c-1.63,2.16-4.19,2.99-5.73,1.83-1.55-1.15-1.48-3.86.15-6.02,1.63-2.17,4.2-3,5.74-1.82,1.54,1.16,1.47,3.84-.16,6.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-614",
    d: "m102.18,111.86c-1.62,2.14-4.18,2.97-5.71,1.81-1.54-1.14-1.48-3.84.14-6,1.63-2.15,4.18-2.97,5.72-1.81,1.54,1.15,1.47,3.83-.15,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-737",
    d: "m102.18,111.84c-1.62,2.16-4.17,2.97-5.7,1.82-1.53-1.16-1.45-3.83.15-5.99,1.62-2.16,4.17-2.97,5.71-1.81,1.53,1.14,1.46,3.82-.16,5.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "m102.18,111.83c-1.62,2.15-4.17,2.97-5.68,1.83-1.53-1.16-1.47-3.83.13-5.99,1.62-2.15,4.17-2.95,5.71-1.81,1.5,1.15,1.45,3.82-.16,5.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-929",
    d: "m102.18,111.83c-1.62,2.15-4.15,2.94-5.68,1.82-1.53-1.16-1.45-3.82.13-5.96,1.62-2.14,4.15-2.95,5.68-1.82,1.53,1.16,1.45,3.82-.13,5.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m102.16,111.83c-1.6,2.14-4.13,2.94-5.67,1.81-1.5-1.14-1.45-3.81.16-5.94,1.59-2.13,4.13-2.95,5.66-1.8,1.52,1.13,1.44,3.79-.15,5.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "m102.14,111.83c-1.58,2.12-4.1,2.92-5.62,1.77-1.52-1.1-1.46-3.77.14-5.9,1.58-2.14,4.12-2.93,5.64-1.81,1.52,1.14,1.44,3.79-.16,5.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "m102.14,111.82c-1.58,2.13-4.1,2.92-5.61,1.77-1.5-1.12-1.45-3.76.14-5.88,1.57-2.13,4.11-2.94,5.63-1.81,1.49,1.14,1.43,3.78-.16,5.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "m102.13,111.81c-1.58,2.12-4.09,2.92-5.6,1.79-1.5-1.12-1.44-3.76.14-5.88,1.59-2.11,4.11-2.9,5.61-1.8,1.5,1.13,1.42,3.77-.15,5.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "m102.12,111.8c-1.57,2.11-4.08,2.91-5.59,1.79-1.5-1.11-1.42-3.75.15-5.87,1.57-2.11,4.08-2.89,5.58-1.77,1.51,1.1,1.44,3.74-.14,5.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-341",
    d: "m102.12,111.8c-1.57,2.1-4.08,2.91-5.57,1.79-1.51-1.12-1.44-3.75.13-5.85,1.57-2.1,4.08-2.9,5.58-1.78,1.49,1.13,1.44,3.74-.14,5.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-736",
    d: "m102.1,111.8c-1.57,2.1-4.06,2.9-5.55,1.78-1.49-1.15-1.43-3.75.13-5.84,1.58-2.11,4.06-2.9,5.57-1.78,1.49,1.12,1.43,3.73-.15,5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-321",
    d: "m102.09,111.78c-1.56,2.09-4.04,2.89-5.52,1.77-1.48-1.12-1.42-3.72.15-5.81,1.56-2.09,4.04-2.89,5.53-1.77,1.49,1.11,1.41,3.74-.16,5.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-321",
    d: "m102.09,111.77c-1.56,2.1-4.03,2.89-5.52,1.77-1.48-1.11-1.42-3.71.15-5.8,1.56-2.07,4.04-2.87,5.53-1.75,1.47,1.1,1.41,3.72-.16,5.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "m102.09,111.77c-1.57,2.08-4.03,2.88-5.51,1.76-1.47-1.11-1.43-3.7.13-5.78,1.57-2.07,4.04-2.87,5.51-1.75,1.49,1.12,1.43,3.71-.13,5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-541",
    d: "m102.08,111.77c-1.57,2.08-4.02,2.86-5.48,1.76-1.48-1.13-1.42-3.7.13-5.77,1.55-2.07,4.02-2.85,5.49-1.75,1.49,1.11,1.42,3.7-.14,5.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-936",
    d: "m102.07,111.77c-1.56,2.06-4.01,2.84-5.47,1.73-1.48-1.1-1.4-3.67.14-5.75,1.54-2.07,3.99-2.85,5.47-1.74,1.48,1.11,1.41,3.69-.14,5.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-368",
    d: "m102.07,111.74c-1.56,2.07-4.01,2.86-5.46,1.76-1.48-1.1-1.41-3.67.13-5.72,1.56-2.08,3.99-2.85,5.47-1.75,1.45,1.1,1.41,3.67-.14,5.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "m102.05,111.74c-1.54,2.06-3.98,2.84-5.43,1.74-1.48-1.1-1.41-3.66.14-5.7,1.55-2.06,3.97-2.85,5.43-1.74,1.46,1.09,1.41,3.67-.14,5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "m102.04,111.74c-1.53,2.05-3.98,2.82-5.43,1.74-1.47-1.1-1.4-3.66.16-5.69,1.53-2.06,3.95-2.84,5.41-1.75,1.47,1.11,1.39,3.67-.14,5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-875",
    d: "m102.04,111.72c-1.54,2.08-3.98,2.85-5.42,1.74-1.45-1.09-1.4-3.63.15-5.67,1.53-2.05,3.95-2.83,5.4-1.74,1.47,1.1,1.4,3.66-.13,5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-875",
    d: "m102.04,111.72c-1.54,2.05-3.95,2.82-5.42,1.72-1.42-1.08-1.37-3.61.16-5.65,1.52-2.05,3.92-2.81,5.39-1.73,1.45,1.09,1.38,3.65-.13,5.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-354",
    d: "m102.03,111.72c-1.53,2.05-3.94,2.82-5.41,1.72-1.42-1.08-1.36-3.61.17-5.64,1.51-2.03,3.91-2.79,5.38-1.73,1.44,1.09,1.38,3.63-.14,5.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-354",
    d: "m102.01,111.72c-1.5,2.03-3.91,2.8-5.35,1.72-1.44-1.08-1.38-3.6.14-5.63,1.51-2.03,3.91-2.79,5.35-1.72,1.46,1.08,1.4,3.62-.13,5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m102.01,111.72c-1.52,2.03-3.9,2.79-5.35,1.7-1.44-1.08-1.37-3.58.13-5.6,1.52-2.03,3.91-2.79,5.35-1.73,1.46,1.1,1.38,3.61-.13,5.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m102.01,111.71c-1.52,2.01-3.9,2.78-5.34,1.71-1.44-1.09-1.37-3.58.13-5.6,1.51-2,3.9-2.78,5.34-1.73,1.43,1.1,1.38,3.61-.13,5.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m101.99,111.7c-1.5,2.01-3.89,2.78-5.32,1.7-1.41-1.07-1.36-3.57.16-5.57,1.49-2.01,3.87-2.78,5.3-1.7,1.42,1.07,1.38,3.58-.14,5.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m101.99,111.7c-1.51,1.99-3.89,2.76-5.32,1.7-1.41-1.07-1.35-3.57.16-5.57,1.49-2.01,3.87-2.78,5.3-1.7,1.42,1.07,1.35,3.58-.14,5.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m101.99,111.7c-1.51,1.99-3.89,2.76-5.3,1.7-1.43-1.07-1.37-3.57.14-5.57,1.49-2.01,3.87-2.77,5.29-1.69,1.43,1.07,1.36,3.57-.13,5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m101.99,111.7c-1.51,1.99-3.89,2.74-5.3,1.69-1.42-1.07-1.37-3.56.14-5.55,1.49-2.01,3.87-2.78,5.29-1.7,1.41,1.07,1.36,3.57-.13,5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m101.99,111.7c-1.51,1.99-3.89,2.74-5.3,1.67-1.42-1.05-1.34-3.54.14-5.53,1.49-2.01,3.87-2.78,5.29-1.69,1.41,1.06,1.36,3.56-.13,5.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m101.98,111.7c-1.5,1.99-3.86,2.74-5.29,1.67-1.41-1.05-1.34-3.54.14-5.53,1.49-1.99,3.87-2.74,5.27-1.69,1.43,1.07,1.37,3.56-.12,5.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m101.98,111.69c-1.5,1.99-3.86,2.74-5.29,1.68-1.4-1.05-1.34-3.54.14-5.53,1.5-1.99,3.86-2.74,5.27-1.69,1.42,1.07,1.36,3.56-.12,5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m101.98,111.69c-1.5,1.98-3.86,2.74-5.27,1.68-1.41-1.06-1.36-3.54.14-5.53,1.49-1.98,3.84-2.74,5.26-1.69,1.41,1.07,1.36,3.56-.12,5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m101.96,111.69c-1.49,1.98-3.84,2.74-5.25,1.67-1.42-1.05-1.36-3.53.13-5.52,1.49-1.98,3.84-2.72,5.24-1.67,1.43,1.05,1.36,3.54-.12,5.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m101.96,111.69c-1.49,1.97-3.84,2.74-5.25,1.66-1.41-1.04-1.36-3.52.13-5.51,1.49-1.97,3.84-2.72,5.24-1.67,1.43,1.05,1.36,3.54-.12,5.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m101.95,111.68c-1.48,1.98-3.83,2.72-5.24,1.67-1.41-1.04-1.35-3.52.13-5.5,1.49-1.98,3.84-2.73,5.24-1.67,1.42,1.05,1.36,3.53-.13,5.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m101.95,111.68c-1.48,1.98-3.83,2.72-5.24,1.67-1.41-1.04-1.35-3.52.13-5.5,1.49-1.97,3.84-2.73,5.24-1.67,1.42,1.07,1.36,3.53-.13,5.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m101.95,111.68c-1.48,1.98-3.82,2.71-5.24,1.66-1.41-1.06-1.34-3.51.13-5.5,1.49-1.97,3.82-2.71,5.24-1.67,1.42,1.07,1.35,3.53-.13,5.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m101.95,111.68c-1.49,1.97-3.82,2.71-5.24,1.66-1.4-1.06-1.34-3.51.13-5.5,1.5-1.97,3.82-2.71,5.24-1.66,1.4,1.06,1.35,3.52-.13,5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m101.94,111.68c-1.49,1.97-3.81,2.71-5.21,1.66-1.41-1.06-1.34-3.51.13-5.49,1.49-1.98,3.8-2.71,5.21-1.66,1.41,1.05,1.35,3.51-.13,5.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m101.94,111.68c-1.49,1.96-3.81,2.7-5.21,1.66-1.41-1.06-1.34-3.51.13-5.49,1.49-1.97,3.8-2.71,5.21-1.66,1.41,1.05,1.34,3.51-.13,5.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m101.93,111.68c-1.47,1.96-3.79,2.7-5.19,1.64-1.39-1.04-1.33-3.5.14-5.47,1.48-1.97,3.79-2.7,5.19-1.66,1.41,1.05,1.35,3.51-.14,5.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m101.93,111.66c-1.47,1.97-3.79,2.71-5.19,1.66-1.4-1.04-1.34-3.5.13-5.47,1.48-1.96,3.79-2.7,5.19-1.64,1.41,1.04,1.33,3.5-.14,5.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m101.93,111.66c-1.47,1.94-3.79,2.71-5.19,1.65-1.4-1.03-1.33-3.49.13-5.44,1.48-1.97,3.79-2.71,5.19-1.66,1.4,1.04,1.33,3.5-.14,5.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m101.93,111.66c-1.47,1.94-3.79,2.69-5.19,1.65-1.4-1.07-1.33-3.49.13-5.44,1.48-1.97,3.79-2.71,5.19-1.66,1.4,1.04,1.33,3.5-.14,5.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m101.92,111.66c-1.46,1.93-3.78,2.69-5.18,1.65-1.39-1.07-1.33-3.49.13-5.44,1.48-1.97,3.79-2.7,5.19-1.66,1.38,1.06,1.33,3.5-.15,5.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m101.92,111.66c-1.46,1.93-3.78,2.69-5.18,1.65-1.39-1.07-1.33-3.49.13-5.44,1.49-1.96,3.79-2.7,5.19-1.65,1.38,1.04,1.33,3.48-.15,5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m101.92,111.65c-1.46,1.95-3.78,2.7-5.16,1.65-1.4-1.05-1.33-3.47.12-5.42,1.49-1.97,3.79-2.7,5.18-1.66,1.4,1.04,1.33,3.48-.13,5.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m101.91,111.65c-1.45,1.95-3.77,2.69-5.15,1.65-1.39-1.05-1.33-3.47.13-5.42,1.47-1.97,3.77-2.69,5.16-1.66,1.39,1.04,1.33,3.48-.14,5.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m101.91,111.65c-1.45,1.94-3.76,2.69-5.15,1.65-1.39-1.05-1.33-3.47.13-5.42,1.47-1.94,3.76-2.69,5.15-1.66,1.4,1.04,1.33,3.48-.13,5.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m101.91,111.65c-1.45,1.94-3.76,2.69-5.13,1.64-1.41-1.04-1.33-3.45.12-5.4,1.47-1.94,3.76-2.69,5.15-1.65,1.39,1.03,1.33,3.47-.13,5.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m101.91,111.65c-1.45,1.94-3.76,2.69-5.13,1.64-1.39-1.04-1.33-3.45.12-5.4,1.47-1.94,3.76-2.69,5.15-1.65,1.39,1.06,1.33,3.47-.13,5.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m101.91,111.65c-1.45,1.94-3.76,2.69-5.13,1.62-1.39-1.02-1.33-3.43.12-5.37,1.47-1.94,3.76-2.67,5.15-1.65,1.38,1.06,1.31,3.47-.13,5.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m101.9,111.65c-1.46,1.93-3.75,2.66-5.11,1.62-1.39-1.03-1.33-3.43.11-5.37,1.47-1.94,3.76-2.67,5.15-1.64,1.38,1.04,1.31,3.45-.14,5.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m101.89,111.63c-1.45,1.95-3.74,2.68-5.11,1.64-1.38-1.03-1.33-3.43.13-5.37,1.44-1.93,3.74-2.67,5.12-1.64,1.36,1.04,1.3,3.45-.15,5.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-498",
    d: "m101.89,111.63c-1.45,1.94-3.74,2.68-5.11,1.64-1.38-1.04-1.33-3.43.13-5.37,1.45-1.93,3.74-2.66,5.11-1.62,1.37,1.02,1.31,3.43-.14,5.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-498",
    d: "m101.89,111.63c-1.45,1.92-3.74,2.66-5.1,1.64-1.39-1.04-1.32-3.43.12-5.37,1.45-1.92,3.74-2.66,5.11-1.62,1.36,1.03,1.31,3.43-.14,5.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-498",
    d: "m101.89,111.63c-1.45,1.92-3.74,2.66-5.1,1.63-1.39-1.03-1.32-3.42.13-5.36,1.44-1.92,3.73-2.65,5.11-1.62,1.36,1.03,1.31,3.43-.14,5.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-674",
    d: "m101.89,111.62c-1.45,1.93-3.74,2.65-5.1,1.62-1.36-1.01-1.31-3.41.13-5.35,1.44-1.9,3.73-2.65,5.09-1.62,1.37,1.03,1.3,3.43-.12,5.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-674",
    d: "m101.89,111.62c-1.45,1.92-3.74,2.64-5.1,1.62-1.36-1.01-1.31-3.41.13-5.34,1.44-1.91,3.73-2.66,5.08-1.62,1.38,1.03,1.31,3.42-.12,5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-674",
    d: "m101.87,111.62c-1.43,1.92-3.72,2.64-5.08,1.61-1.36-1.01-1.3-3.4.13-5.33,1.44-1.91,3.73-2.62,5.08-1.62,1.37,1.03,1.31,3.42-.13,5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-674",
    d: "m101.87,111.62c-1.45,1.91-3.7,2.63-5.08,1.61-1.35-1.01-1.3-3.4.13-5.33,1.44-1.9,3.72-2.62,5.08-1.6,1.37,1.01,1.31,3.41-.13,5.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-674",
    d: "m101.87,111.62c-1.45,1.91-3.7,2.63-5.07,1.61-1.36-1.01-1.31-3.4.13-5.33,1.43-1.9,3.71-2.62,5.07-1.6,1.37,1.01,1.3,3.41-.13,5.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-674",
    d: "m101.86,111.62c-1.44,1.91-3.69,2.62-5.06,1.61-1.35-1.02-1.31-3.4.14-5.33,1.42-1.89,3.7-2.62,5.06-1.59,1.34,1.02,1.3,3.4-.14,5.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-674",
    d: "m101.86,111.62c-1.44,1.91-3.69,2.62-5.06,1.6-1.35-1.01-1.28-3.39.14-5.3,1.42-1.91,3.7-2.63,5.04-1.61,1.36,1.02,1.3,3.4-.12,5.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-674",
    d: "m101.86,111.62c-1.44,1.89-3.69,2.61-5.03,1.6-1.37-1.02-1.31-3.39.12-5.3,1.42-1.91,3.69-2.62,5.04-1.6,1.35,1.01,1.3,3.39-.12,5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-674",
    d: "m101.86,111.6c-1.43,1.9-3.68,2.62-5.03,1.62-1.37-1.02-1.31-3.39.12-5.3,1.42-1.9,3.69-2.62,5.04-1.6,1.35,1.01,1.3,3.39-.13,5.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-674",
    d: "m101.86,111.59c-1.43,1.91-3.68,2.63-5.03,1.62-1.35-1.01-1.3-3.38.12-5.27,1.44-1.92,3.69-2.62,5.04-1.62,1.35,1.01,1.3,3.39-.13,5.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-674",
    d: "m101.86,111.59c-1.43,1.91-3.68,2.62-5.03,1.62-1.35-1.01-1.3-3.38.12-5.27,1.44-1.9,3.69-2.62,5.04-1.62,1.35,1.02,1.29,3.39-.13,5.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-674",
    d: "m101.85,111.59c-1.42,1.89-3.67,2.62-5.02,1.62-1.35-1.01-1.29-3.38.14-5.27,1.41-1.9,3.66-2.62,5.02-1.62,1.33,1.02,1.27,3.39-.14,5.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-674",
    d: "m101.85,111.59c-1.42,1.89-3.67,2.62-5.02,1.62-1.34-1.01-1.29-3.38.14-5.27,1.41-1.89,3.66-2.61,5.01-1.59,1.33,1,1.28,3.36-.13,5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-674",
    d: "m101.85,111.59c-1.42,1.89-3.67,2.61-5.02,1.59-1.33-1.01-1.28-3.35.14-5.24,1.41-1.9,3.65-2.61,5.01-1.6,1.33,1,1.28,3.36-.13,5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-674",
    d: "m101.85,111.59c-1.42,1.89-3.66,2.61-5,1.59-1.35-1.01-1.3-3.35.13-5.24,1.41-1.9,3.64-2.61,5-1.6,1.33,1.01,1.28,3.36-.13,5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-674",
    d: "m101.85,111.59c-1.42,1.89-3.66,2.59-5,1.59-1.35-1.01-1.28-3.35.13-5.24,1.41-1.89,3.64-2.61,4.98-1.59,1.34,1,1.29,3.35-.12,5.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-334",
    d: "m101.85,111.59c-1.42,1.89-3.66,2.59-5,1.58-1.35-1-1.28-3.34.13-5.23,1.41-1.89,3.64-2.61,4.98-1.59,1.34,1,1.29,3.36-.12,5.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-468",
    d: "m101.82,111.57c-1.4,1.89-3.63,2.61-4.97,1.6-1.33-1-1.26-3.34.13-5.23,1.41-1.89,3.64-2.59,4.97-1.59,1.33,1,1.29,3.36-.13,5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m101.82,111.57c-1.4,1.89-3.63,2.6-4.97,1.6-1.33-1-1.26-3.34.13-5.21,1.41-1.9,3.64-2.61,4.97-1.6,1.33,1,1.29,3.35-.13,5.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m101.82,111.57c-1.4,1.87-3.63,2.6-4.97,1.6-1.33-1.01-1.26-3.34.13-5.21,1.41-1.9,3.64-2.6,4.97-1.6,1.33,1,1.27,3.35-.13,5.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m101.81,111.57c-1.39,1.88-3.62,2.59-4.95,1.6-1.33-1.01-1.28-3.34.12-5.2,1.41-1.89,3.63-2.59,4.96-1.59,1.34,1.01,1.27,3.34-.13,5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-623",
    d: "m101.81,111.57c-1.39,1.88-3.6,2.59-4.95,1.58-1.33-1-1.27-3.32.13-5.19,1.4-1.89,3.61-2.59,4.95-1.59,1.33,1.01,1.27,3.34-.13,5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-335",
    d: "m101.81,111.57c-1.39,1.88-3.6,2.57-4.95,1.58-1.33-1-1.27-3.32.13-5.18,1.4-1.89,3.61-2.59,4.95-1.58,1.32.99,1.27,3.33-.13,5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-335",
    d: "m101.81,111.57c-1.41,1.87-3.6,2.57-4.94,1.58-1.33-1-1.26-3.32.13-5.18,1.39-1.89,3.6-2.59,4.92-1.58,1.33.99,1.28,3.33-.12,5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-335",
    d: "m101.81,111.57c-1.41,1.87-3.6,2.57-4.94,1.57-1.33-.99-1.26-3.31.13-5.17,1.39-1.89,3.6-2.59,4.92-1.58,1.33.99,1.28,3.33-.12,5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-335",
    d: "m101.81,111.57c-1.41,1.85-3.6,2.56-4.94,1.57-1.33-.99-1.26-3.31.13-5.17,1.4-1.88,3.6-2.57,4.92-1.58,1.33,1,1.27,3.33-.12,5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-335",
    d: "m101.8,111.57c-1.41,1.85-3.59,2.56-4.93,1.56-1.31-.99-1.26-3.3.13-5.16,1.4-1.88,3.6-2.57,4.91-1.57,1.33,1,1.28,3.32-.12,5.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-335",
    d: "m101.8,111.57c-1.41,1.85-3.59,2.56-4.93,1.56-1.31-.99-1.25-3.3.13-5.16,1.4-1.88,3.59-2.56,4.91-1.57,1.33,1,1.27,3.32-.12,5.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-519",
    d: "m101.8,111.56c-1.41,1.86-3.59,2.55-4.93,1.57-1.29-.99-1.25-3.31.13-5.16,1.4-1.88,3.59-2.56,4.91-1.57,1.33,1,1.25,3.32-.12,5.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-519",
    d: "m101.78,111.56c-1.39,1.84-3.58,2.55-4.89,1.57-1.31-1-1.26-3.31.13-5.15,1.38-1.85,3.58-2.57,4.88-1.57,1.33.99,1.26,3.31-.12,5.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-661",
    d: "m101.78,111.56c-1.4,1.84-3.58,2.53-4.89,1.55-1.31-.97-1.25-3.28.13-5.11,1.38-1.86,3.58-2.55,4.88-1.57,1.32.98,1.26,3.3-.12,5.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-789",
    d: "m101.78,111.56c-1.4,1.84-3.58,2.53-4.89,1.54-1.31-.99-1.25-3.27.13-5.11,1.38-1.85,3.58-2.55,4.88-1.57,1.32.98,1.25,3.3-.12,5.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-789",
    d: "m101.78,111.53c-1.39,1.87-3.57,2.55-4.88,1.56-1.3-.99-1.25-3.27.13-5.11,1.39-1.85,3.58-2.55,4.88-1.57,1.31,1,1.25,3.3-.13,5.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-789",
    d: "m101.78,111.53c-1.39,1.84-3.56,2.55-4.88,1.56-1.3-.99-1.25-3.27.14-5.11,1.38-1.85,3.56-2.53,4.87-1.57,1.31,1,1.25,3.3-.13,5.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-500",
    d: "m101.78,111.53c-1.39,1.84-3.56,2.54-4.88,1.55-1.28-.97-1.24-3.26.14-5.09,1.38-1.84,3.56-2.53,4.87-1.57,1.31,1,1.25,3.3-.12,5.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-500",
    d: "m101.78,111.53c-1.39,1.84-3.56,2.54-4.86,1.55-1.31-.97-1.26-3.26.12-5.09,1.38-1.84,3.56-2.53,4.86-1.54,1.32.96,1.26,3.26-.12,5.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-500",
    d: "m101.78,111.53c-1.39,1.84-3.56,2.53-4.86,1.55-1.31-.97-1.24-3.26.12-5.09,1.38-1.84,3.56-2.53,4.86-1.54,1.31.96,1.24,3.26-.12,5.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-649",
    d: "m101.78,111.53c-1.39,1.83-3.56,2.53-4.86,1.55-1.31-.98-1.24-3.26.12-5.09,1.39-1.82,3.56-2.52,4.86-1.54,1.31.96,1.24,3.26-.12,5.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-649",
    d: "m101.76,111.53c-1.37,1.82-3.54,2.53-4.83,1.55-1.31-.98-1.24-3.26.12-5.07,1.37-1.84,3.54-2.52,4.84-1.56,1.3.98,1.24,3.26-.13,5.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-649",
    d: "m101.76,111.53c-1.37,1.82-3.53,2.51-4.83,1.53-1.31-.96-1.24-3.24.12-5.05,1.37-1.83,3.52-2.52,4.84-1.55,1.28.97,1.24,3.26-.13,5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-735",
    d: "m101.76,111.52c-1.37,1.83-3.53,2.51-4.83,1.54-1.3-.97-1.23-3.24.12-5.05,1.37-1.83,3.52-2.51,4.84-1.55,1.28.97,1.23,3.26-.13,5.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-735",
    d: "m101.74,111.52c-1.35,1.82-3.51,2.51-4.81,1.54-1.29-.97-1.23-3.24.12-5.05,1.37-1.82,3.52-2.51,4.82-1.54,1.29.96,1.24,3.25-.13,5.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-735",
    d: "m101.74,111.52c-1.35,1.82-3.51,2.51-4.81,1.54-1.29-.97-1.23-3.24.12-5.04,1.37-1.83,3.52-2.52,4.82-1.55,1.29.98,1.24,3.25-.13,5.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-414",
    d: "m101.74,111.52c-1.35,1.82-3.51,2.5-4.8,1.53-1.3-.96-1.24-3.23.12-5.03,1.37-1.82,3.52-2.51,4.82-1.55,1.29.98,1.24,3.25-.13,5.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-414",
    d: "m101.73,111.51c-1.34,1.81-3.49,2.49-4.79,1.54-1.31-.96-1.24-3.23.12-5.03,1.35-1.82,3.5-2.51,4.79-1.55,1.3,1,1.25,3.25-.13,5.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-430",
    d: "m101.73,111.51c-1.35,1.81-3.49,2.49-4.79,1.53-1.29-.95-1.23-3.22.12-5.03,1.35-1.81,3.5-2.5,4.79-1.53,1.29.98,1.25,3.23-.13,5.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-430",
    d: "m101.73,111.51c-1.35,1.81-3.49,2.49-4.79,1.53-1.29-.98-1.23-3.22.12-5.03,1.35-1.81,3.5-2.5,4.79-1.52,1.3.97,1.23,3.22-.12,5.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-899",
    d: "m101.73,111.51c-1.35,1.81-3.49,2.49-4.79,1.52-1.27-.97-1.23-3.21.12-5.02,1.37-1.81,3.5-2.5,4.79-1.52,1.28.97,1.23,3.22-.12,5.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-899",
    d: "m101.73,111.51c-1.35,1.81-3.49,2.47-4.79,1.52-1.27-.97-1.23-3.21.12-5.02,1.37-1.81,3.5-2.49,4.79-1.52,1.28.97,1.22,3.22-.12,5.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-899",
    d: "m101.73,111.51c-1.35,1.81-3.49,2.47-4.76,1.5-1.29-.95-1.23-3.19.1-4.99,1.37-1.8,3.5-2.5,4.78-1.53,1.29.97,1.23,3.22-.12,5.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "m101.72,111.5c-1.34,1.8-3.48,2.48-4.75,1.51-1.29-.96-1.23-3.19.12-4.99,1.34-1.8,3.47-2.47,4.75-1.52,1.28.97,1.23,3.21-.12,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "m101.72,111.5c-1.34,1.8-3.48,2.48-4.75,1.51-1.27-.96-1.22-3.19.12-4.99,1.34-1.8,3.46-2.47,4.75-1.52,1.27.97,1.23,3.21-.12,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-453",
    d: "m101.72,111.5c-1.35,1.8-3.48,2.48-4.74,1.5-1.28-.96-1.23-3.18.12-4.98,1.34-1.8,3.46-2.46,4.75-1.5,1.27.95,1.22,3.19-.12,4.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-453",
    d: "m101.71,111.49c-1.34,1.8-3.47,2.49-4.73,1.52-1.28-.96-1.22-3.18.12-4.97,1.34-1.8,3.46-2.47,4.75-1.51,1.26.96,1.2,3.19-.13,4.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m101.71,111.49c-1.34,1.8-3.47,2.46-4.73,1.51-1.28-.95-1.22-3.18.12-4.96,1.33-1.8,3.45-2.47,4.72-1.5,1.28.95,1.22,3.18-.12,4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-740",
    d: "m101.71,111.49c-1.34,1.78-3.47,2.46-4.73,1.51-1.27-.95-1.21-3.18.12-4.96,1.33-1.78,3.45-2.47,4.71-1.5,1.29.95,1.22,3.18-.11,4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-740",
    d: "m101.71,111.49c-1.34,1.78-3.47,2.46-4.73,1.51-1.26-.95-1.21-3.18.12-4.96,1.33-1.78,3.45-2.46,4.71-1.5,1.26.95,1.22,3.18-.11,4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-947",
    d: "m101.71,111.49c-1.34,1.78-3.47,2.46-4.73,1.51-1.26-.95-1.21-3.18.12-4.95,1.33-1.78,3.45-2.47,4.71-1.52,1.26.95,1.22,3.18-.11,4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-795",
    d: "m101.71,111.49c-1.34,1.78-3.47,2.45-4.71,1.49-1.28-.93-1.23-3.15.11-4.92,1.33-1.78,3.45-2.45,4.71-1.5,1.26.93,1.23,3.17-.1,4.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "m101.69,111.49c-1.32,1.77-3.44,2.44-4.69,1.49-1.28-.94-1.2-3.15.11-4.92,1.35-1.78,3.45-2.45,4.71-1.5,1.26.94,1.21,3.17-.12,4.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-552",
    d: "m101.69,111.49c-1.33,1.75-3.44,2.44-4.69,1.49-1.25-.94-1.2-3.15.12-4.92,1.34-1.78,3.44-2.45,4.7-1.5,1.26.95,1.21,3.17-.12,4.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-552",
    d: "m101.69,111.48c-1.33,1.76-3.44,2.43-4.68,1.49-1.26-.95-1.21-3.15.11-4.92,1.34-1.77,3.43-2.45,4.7-1.5,1.26.95,1.21,3.17-.12,4.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-447",
    d: "m101.69,111.48c-1.33,1.75-3.42,2.43-4.68,1.49-1.25-.94-1.21-3.14.12-4.91,1.33-1.77,3.42-2.44,4.69-1.49,1.25.94,1.21,3.16-.12,4.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-447",
    d: "m101.68,111.48c-1.32,1.75-3.42,2.42-4.67,1.49-1.25-.94-1.2-3.14.12-4.91,1.33-1.75,3.42-2.42,4.69-1.49,1.24.94,1.18,3.16-.13,4.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-447",
    d: "m101.68,111.48c-1.32,1.75-3.42,2.42-4.67,1.49-1.25-.95-1.19-3.14.12-4.91,1.33-1.75,3.42-2.42,4.68-1.49,1.25.94,1.19,3.16-.12,4.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-447",
    d: "m101.67,111.48c-1.31,1.75-3.41,2.42-4.66,1.49-1.25-.95-1.19-3.14.13-4.9,1.32-1.75,3.41-2.43,4.66-1.49,1.25.94,1.19,3.14-.13,4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-447",
    d: "m101.67,111.47c-1.33,1.75-3.41,2.4-4.66,1.49-1.24-.94-1.19-3.13.13-4.88,1.32-1.76,3.41-2.43,4.64-1.49,1.25.94,1.2,3.14-.12,4.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-447",
    d: "m101.67,111.47c-1.33,1.75-3.4,2.4-4.64,1.49-1.25-.94-1.19-3.13.12-4.88,1.32-1.75,3.39-2.42,4.64-1.49,1.25.93,1.2,3.13-.12,4.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-865",
    d: "m101.67,111.47c-1.33,1.74-3.4,2.4-4.64,1.49-1.25-.94-1.19-3.13.12-4.88,1.32-1.75,3.39-2.4,4.64-1.49,1.25.94,1.19,3.13-.12,4.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "m101.67,111.47c-1.33,1.74-3.4,2.4-4.64,1.45-1.23-.91-1.19-3.09.12-4.85,1.32-1.75,3.39-2.4,4.63-1.46,1.25.92,1.2,3.1-.11,4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-914",
    d: "m101.67,111.47c-1.33,1.74-3.4,2.4-4.63,1.45-1.24-.91-1.2-3.09.11-4.85,1.32-1.75,3.39-2.39,4.63-1.46,1.25.92,1.18,3.1-.11,4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-482",
    d: "m101.65,111.47c-1.32,1.74-3.38,2.38-4.62,1.44-1.24-.91-1.19-3.09.12-4.84,1.3-1.73,3.37-2.39,4.62-1.46,1.25.92,1.18,3.1-.12,4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-515",
    d: "m101.65,111.44c-1.32,1.74-3.38,2.41-4.62,1.47-1.24-.91-1.19-3.09.12-4.84,1.3-1.73,3.37-2.39,4.62-1.45,1.25.92,1.18,3.1-.12,4.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-515",
    d: "m101.65,111.44c-1.32,1.74-3.37,2.41-4.62,1.47-1.23-.91-1.19-3.09.12-4.84,1.3-1.73,3.37-2.38,4.62-1.45,1.22.92,1.18,3.1-.12,4.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-347",
    d: "m101.65,111.44c-1.32,1.73-3.37,2.41-4.6,1.47-1.25-.92-1.19-3.09.11-4.84,1.31-1.72,3.36-2.38,4.6-1.45,1.24.92,1.18,3.1-.11,4.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "m101.65,111.44c-1.32,1.73-3.37,2.39-4.6,1.47-1.24-.92-1.19-3.09.11-4.84,1.31-1.72,3.35-2.38,4.6-1.45,1.24.92,1.18,3.1-.11,4.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-385",
    d: "m101.65,111.44c-1.32,1.73-3.37,2.37-4.6,1.46-1.24-.92-1.17-3.08.11-4.83,1.31-1.72,3.35-2.37,4.6-1.44,1.24.91,1.17,3.09-.11,4.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-385",
    d: "m101.63,111.44c-1.3,1.73-3.35,2.37-4.58,1.46-1.22-.93-1.17-3.08.11-4.8,1.31-1.73,3.35-2.39,4.6-1.47,1.23.92,1.17,3.09-.12,4.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-441",
    d: "m101.62,111.42c-1.29,1.74-3.34,2.38-4.57,1.47-1.22-.93-1.17-3.07.13-4.79,1.28-1.73,3.33-2.37,4.55-1.46,1.25.93,1.19,3.08-.12,4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-418",
    d: "m101.62,111.42c-1.29,1.74-3.34,2.38-4.57,1.47-1.22-.93-1.17-3.07.13-4.79,1.28-1.73,3.33-2.37,4.55-1.46,1.24.93,1.19,3.08-.12,4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-418",
    d: "m101.62,111.42c-1.29,1.73-3.33,2.38-4.56,1.47-1.23-.93-1.17-3.07.12-4.79,1.28-1.73,3.33-2.37,4.55-1.46,1.22.93,1.16,3.08-.12,4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-418",
    d: "m101.62,111.41c-1.29,1.73-3.32,2.38-4.55,1.48-1.23-.93-1.17-3.07.12-4.79,1.27-1.71,3.32-2.37,4.54-1.46,1.23.93,1.17,3.08-.11,4.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-572",
    d: "m101.62,111.41c-1.29,1.73-3.32,2.38-4.55,1.46-1.23-.91-1.17-3.05.12-4.76,1.27-1.73,3.32-2.38,4.54-1.45,1.23.9,1.17,3.05-.11,4.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-524",
    d: "m101.61,111.41c-1.27,1.73-3.3,2.38-4.54,1.46-1.23-.92-1.16-3.05.12-4.76,1.29-1.73,3.32-2.38,4.54-1.45,1.23.91,1.17,3.05-.12,4.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m101.61,111.4c-1.27,1.73-3.3,2.37-4.54,1.47-1.21-.91-1.16-3.04.12-4.75,1.29-1.72,3.32-2.38,4.54-1.45,1.22.91,1.17,3.05-.12,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m101.61,111.4c-1.27,1.73-3.3,2.37-4.54,1.47-1.21-.91-1.16-3.04.12-4.75,1.29-1.72,3.32-2.38,4.54-1.44,1.21.9,1.16,3.04-.12,4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-392",
    d: "m101.61,111.4c-1.27,1.73-3.3,2.37-4.51,1.46-1.22-.93-1.18-3.03.11-4.74,1.28-1.72,3.31-2.34,4.52-1.44,1.21.91,1.17,3.04-.11,4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-464",
    d: "m101.6,111.4c-1.26,1.73-3.29,2.37-4.5,1.46-1.22-.93-1.16-3.03.11-4.73,1.28-1.72,3.3-2.35,4.52-1.45,1.21.91,1.16,3.04-.12,4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "m101.6,111.4c-1.27,1.7-3.29,2.37-4.5,1.46-1.21-.93-1.16-3.03.11-4.73,1.28-1.71,3.3-2.35,4.52-1.44,1.21.9,1.16,3.03-.12,4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-294",
    d: "m101.6,111.4c-1.27,1.7-3.29,2.35-4.5,1.46-1.21-.93-1.16-3.03.12-4.73,1.27-1.71,3.29-2.35,4.5-1.44,1.22.9,1.16,3.03-.12,4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-294",
    d: "m101.6,111.4c-1.29,1.7-3.29,2.35-4.49,1.44-1.22-.91-1.16-3.01.11-4.71,1.28-1.71,3.29-2.34,4.5-1.44,1.19.93,1.15,3.03-.12,4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-731",
    d: "m101.6,111.4c-1.29,1.7-3.29,2.35-4.49,1.43-1.22-.9-1.16-3.01.11-4.71,1.28-1.71,3.29-2.34,4.5-1.42,1.19.91,1.14,3.01-.12,4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-568",
    d: "m101.58,111.4c-1.27,1.68-3.27,2.35-4.47,1.43-1.21-.91-1.16-3.01.11-4.71,1.28-1.67,3.29-2.33,4.5-1.42,1.19.91,1.14,3.01-.13,4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "m101.58,111.4c-1.27,1.68-3.26,2.32-4.47,1.43-1.19-.91-1.14-3.01.11-4.69,1.28-1.69,3.27-2.32,4.5-1.43,1.19.91,1.13,3.01-.13,4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "m101.58,111.39c-1.27,1.69-3.26,2.32-4.47,1.43-1.19-.9-1.14-3,.11-4.67,1.28-1.7,3.27-2.33,4.5-1.44,1.18.91,1.13,3.01-.13,4.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-901",
    d: "m101.56,111.39c-1.25,1.69-3.25,2.32-4.45,1.42-1.2-.92-1.14-2.99.12-4.66,1.25-1.7,3.25-2.33,4.45-1.43,1.2.9,1.16,3-.12,4.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-808",
    d: "m101.56,111.39c-1.25,1.67-3.25,2.3-4.45,1.42-1.2-.92-1.14-2.99.12-4.66,1.25-1.69,3.25-2.33,4.45-1.43,1.2.91,1.16,3-.12,4.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-807",
    d: "m101.56,111.38c-1.26,1.68-3.25,2.31-4.44,1.43-1.19-.92-1.14-2.99.12-4.66,1.25-1.69,3.25-2.33,4.45-1.43,1.19.91,1.13,3-.12,4.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-483",
    d: "m101.56,111.38c-1.26,1.68-3.24,2.31-4.44,1.43-1.18-.92-1.14-2.99.12-4.66,1.25-1.68,3.24-2.32,4.43-1.43,1.2.91,1.14,3-.12,4.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-483",
    d: "m101.56,111.38c-1.26,1.68-3.24,2.31-4.44,1.42-1.18-.91-1.14-2.98.12-4.65,1.25-1.68,3.23-2.32,4.43-1.41,1.2.91,1.14,2.98-.12,4.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-842",
    d: "m101.56,111.38c-1.26,1.67-3.24,2.31-4.42,1.42-1.2-.91-1.16-2.98.11-4.65,1.25-1.68,3.23-2.3,4.43-1.41,1.18.91,1.13,2.98-.12,4.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-504",
    d: "m101.55,111.38c-1.25,1.67-3.23,2.3-4.41,1.4-1.2-.88-1.15-2.95.11-4.62,1.25-1.69,3.23-2.3,4.42-1.42,1.18.91,1.14,2.98-.12,4.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-504",
    d: "m101.55,111.38c-1.25,1.66-3.23,2.3-4.41,1.4-1.2-.89-1.14-2.95.11-4.62,1.26-1.66,3.23-2.3,4.42-1.42,1.18.91,1.13,2.98-.12,4.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "m101.55,111.38c-1.25,1.66-3.23,2.29-4.41,1.4-1.17-.89-1.14-2.95.11-4.62,1.26-1.66,3.23-2.29,4.42-1.42,1.17.91,1.13,2.98-.12,4.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-510",
    d: "m101.54,111.38c-1.25,1.65-3.21,2.29-4.4,1.4-1.17-.89-1.12-2.95.12-4.62,1.25-1.66,3.21-2.29,4.4-1.4,1.17.89,1.12,2.95-.12,4.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "m101.54,111.37c-1.25,1.66-3.21,2.29-4.4,1.4-1.16-.89-1.12-2.94.13-4.61,1.24-1.66,3.2-2.29,4.39-1.4,1.17.89,1.12,2.95-.12,4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m101.54,111.37c-1.25,1.64-3.21,2.29-4.38,1.4-1.18-.89-1.13-2.94.12-4.6,1.24-1.66,3.2-2.29,4.38-1.41,1.19.89,1.14,2.95-.11,4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-837",
    d: "m101.54,111.37c-1.25,1.64-3.21,2.29-4.38,1.38-1.17-.87-1.13-2.93.12-4.58,1.24-1.66,3.2-2.29,4.38-1.41,1.17.89,1.14,2.95-.11,4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-837",
    d: "m101.53,111.37c-1.24,1.64-3.2,2.27-4.38,1.38-1.17-.87-1.12-2.93.12-4.58,1.24-1.65,3.2-2.29,4.38-1.38,1.17.87,1.1,2.93-.12,4.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-571",
    d: "m101.53,111.35c-1.24,1.66-3.2,2.29-4.38,1.39-1.17-.86-1.12-2.92.12-4.57,1.24-1.65,3.2-2.27,4.38-1.38,1.17.87,1.1,2.93-.12,4.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-444",
    d: "m101.53,111.35c-1.24,1.65-3.18,2.29-4.38,1.39-1.17-.88-1.12-2.92.12-4.57,1.25-1.64,3.18-2.27,4.38-1.37,1.16.86,1.1,2.92-.12,4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-428",
    d: "m101.53,111.35c-1.24,1.65-3.18,2.25-4.38,1.39-1.17-.88-1.12-2.92.13-4.55,1.24-1.65,3.17-2.28,4.36-1.39,1.16.87,1.1,2.92-.12,4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-581",
    d: "m101.53,111.35c-1.24,1.65-3.18,2.24-4.35,1.39-1.18-.88-1.13-2.92.11-4.55,1.24-1.65,3.17-2.28,4.33-1.39,1.17.87,1.13,2.92-.09,4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-489",
    d: "m101.51,111.35c-1.22,1.65-3.16,2.24-4.32,1.39-1.18-.88-1.13-2.92.12-4.55,1.23-1.65,3.16-2.27,4.32-1.39,1.17.87,1.13,2.92-.12,4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-581",
    d: "m101.51,111.34c-1.22,1.63-3.16,2.25-4.32,1.38-1.16-.86-1.11-2.9.12-4.54,1.23-1.64,3.16-2.27,4.32-1.38,1.16.86,1.1,2.91-.12,4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-363",
    d: "m101.51,111.34c-1.22,1.63-3.16,2.24-4.31,1.38-1.17-.86-1.12-2.9.11-4.54,1.23-1.64,3.16-2.27,4.32-1.38,1.16.86,1.1,2.91-.12,4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-883",
    d: "m101.51,111.34c-1.22,1.63-3.15,2.24-4.31,1.37-1.17-.87-1.12-2.89.11-4.53,1.23-1.64,3.16-2.24,4.32-1.38,1.16.86,1.1,2.91-.12,4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-656",
    d: "m101.51,111.34c-1.22,1.62-3.15,2.24-4.31,1.37-1.17-.87-1.12-2.89.11-4.53,1.23-1.64,3.16-2.24,4.32-1.37,1.16.86,1.1,2.9-.12,4.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-717",
    d: "m101.51,111.33c-1.22,1.63-3.15,2.25-4.31,1.38-1.16-.87-1.1-2.89.11-4.51,1.23-1.64,3.16-2.25,4.31-1.39,1.15.86,1.11,2.9-.1,4.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "m101.49,111.33c-1.21,1.63-3.13,2.24-4.3,1.38-1.16-.88-1.1-2.89.12-4.51,1.21-1.64,3.14-2.25,4.29-1.38,1.15.85,1.11,2.89-.12,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-372",
    d: "m101.49,111.33c-1.21,1.63-3.13,2.23-4.3,1.38-1.16-.88-1.1-2.89.12-4.51,1.21-1.63,3.14-2.24,4.29-1.38,1.15.87,1.1,2.89-.12,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-810",
    d: "m101.49,111.33c-1.21,1.62-3.13,2.21-4.29,1.36-1.17-.86-1.09-2.87.12-4.49,1.21-1.63,3.14-2.23,4.28-1.38,1.16.87,1.1,2.89-.11,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-760",
    d: "m101.49,111.33c-1.21,1.63-3.13,2.22-4.29,1.36-1.15-.85-1.09-2.86.12-4.48,1.21-1.62,3.12-2.23,4.28-1.38,1.16.87,1.1,2.89-.11,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m101.49,111.33c-1.21,1.6-3.12,2.22-4.28,1.36-1.16-.85-1.09-2.86.12-4.48,1.2-1.62,3.11-2.21,4.27-1.36,1.15.86,1.08,2.87-.11,4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-719",
    d: "m101.49,111.33c-1.21,1.59-3.12,2.22-4.28,1.36-1.14-.85-1.09-2.86.12-4.48,1.21-1.59,3.11-2.21,4.27-1.36,1.13.86,1.08,2.87-.11,4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-922",
    d: "m101.47,111.33c-1.19,1.59-3.1,2.21-4.26,1.36-1.14-.86-1.08-2.86.12-4.48,1.21-1.59,3.11-2.21,4.27-1.36,1.13.86,1.08,2.87-.12,4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-835",
    d: "m101.47,111.31c-1.19,1.6-3.1,2.22-4.26,1.37-1.14-.85-1.08-2.85.12-4.47,1.21-1.58,3.1-2.21,4.24-1.36,1.15.86,1.1,2.87-.11,4.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-640",
    d: "m101.47,111.31c-1.19,1.6-3.1,2.22-4.26,1.37-1.14-.85-1.07-2.85.12-4.46,1.21-1.59,3.1-2.21,4.24-1.33,1.15.84,1.09,2.84-.11,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-333",
    d: "m101.46,111.31c-1.18,1.6-3.09,2.22-4.25,1.37-1.12-.87-1.07-2.85.12-4.46,1.21-1.59,3.1-2.21,4.24-1.33,1.14.84,1.09,2.84-.12,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m101.46,111.31c-1.18,1.6-3.09,2.2-4.22,1.34-1.15-.85-1.09-2.83.1-4.44,1.21-1.59,3.09-2.2,4.23-1.33,1.16.84,1.09,2.84-.1,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-754",
    d: "m101.46,111.3c-1.18,1.6-3.09,2.21-4.22,1.35-1.15-.85-1.09-2.83.1-4.42,1.21-1.6,3.09-2.21,4.23-1.35,1.15.84,1.09,2.84-.1,4.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-754",
    d: "m101.46,111.3c-1.19,1.6-3.09,2.21-4.22,1.35-1.12-.85-1.09-2.83.12-4.42,1.19-1.6,3.07-2.2,4.21-1.35,1.14.84,1.08,2.84-.1,4.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "m101.46,111.3c-1.19,1.59-3.09,2.19-4.22,1.35-1.13-.85-1.08-2.83.12-4.42,1.18-1.59,3.06-2.2,4.2-1.34,1.14.85,1.08,2.83-.1,4.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-791",
    d: "m101.46,111.3c-1.19,1.59-3.09,2.19-4.22,1.34-1.13-.85-1.08-2.82.12-4.41,1.18-1.59,3.06-2.19,4.2-1.34,1.12.85,1.08,2.83-.1,4.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-295",
    d: "m101.46,111.3c-1.18,1.59-3.07,2.19-4.21,1.34-1.13-.85-1.08-2.82.12-4.41,1.18-1.59,3.06-2.19,4.19-1.33,1.13.84,1.08,2.82-.1,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-295",
    d: "m101.46,111.3c-1.18,1.59-3.07,2.19-4.21,1.34-1.12-.86-1.07-2.82.12-4.41,1.17-1.56,3.05-2.19,4.18-1.33,1.13.84,1.08,2.82-.1,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-330",
    d: "m101.46,111.3c-1.18,1.57-3.07,2.18-4.21,1.34-1.12-.86-1.07-2.82.12-4.41,1.17-1.56,3.05-2.18,4.18-1.33,1.13.84,1.08,2.82-.1,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-944",
    d: "m101.45,111.3c-1.17,1.56-3.06,2.16-4.18,1.33-1.12-.86-1.08-2.81.11-4.39,1.17-1.57,3.05-2.18,4.17-1.34,1.13.84,1.08,2.82-.1,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-642",
    d: "m101.45,111.29c-1.2,1.57-3.06,2.17-4.17,1.33-1.13-.85-1.09-2.8.1-4.39,1.17-1.57,3.05-2.18,4.17-1.33,1.12.84,1.08,2.81-.1,4.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-529",
    d: "m101.45,111.29c-1.2,1.57-3.06,2.15-4.17,1.31-1.12-.83-1.08-2.77.1-4.36,1.17-1.57,3.05-2.16,4.17-1.33,1.11.85,1.08,2.81-.1,4.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "m101.42,111.29c-1.17,1.57-3.03,2.15-4.14,1.31-1.12-.83-1.07-2.77.1-4.36,1.2-1.57,3.05-2.16,4.17-1.33,1.11.84,1.05,2.8-.12,4.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m101.42,111.26c-1.17,1.59-3.02,2.18-4.14,1.33-1.11-.83-1.07-2.77.11-4.36,1.19-1.57,3.04-2.15,4.15-1.33,1.1.85,1.06,2.8-.12,4.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "m101.42,111.26c-1.17,1.59-3.02,2.17-4.14,1.33-1.11-.83-1.07-2.77.11-4.35,1.19-1.57,3.04-2.16,4.15-1.31,1.1.82,1.06,2.78-.12,4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-452",
    d: "m101.42,111.26c-1.17,1.57-3.02,2.17-4.14,1.33-1.11-.83-1.06-2.77.12-4.35,1.18-1.57,3.03-2.16,4.14-1.31,1.1.82,1.05,2.78-.12,4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-707",
    d: "m101.41,111.26c-1.17,1.56-3.02,2.15-4.12,1.33-1.13-.85-1.08-2.78.1-4.34,1.18-1.55,3.03-2.15,4.14-1.31,1.09.85,1.05,2.78-.12,4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-711",
    d: "m101.41,111.26c-1.17,1.56-3.02,2.15-4.12,1.33-1.11-.85-1.08-2.78.1-4.33,1.18-1.56,3.03-2.16,4.14-1.31,1.09.84,1.05,2.77-.12,4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-342",
    d: "m101.41,111.26c-1.17,1.56-3.02,2.15-4.11,1.31-1.12-.83-1.07-2.76.09-4.31,1.18-1.55,3.01-2.16,4.12-1.31,1.11.84,1.07,2.77-.1,4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "m101.41,111.26c-1.17,1.55-3.01,2.13-4.11,1.31-1.12-.83-1.06-2.76.11-4.31,1.16-1.55,2.99-2.13,4.1-1.31,1.11.84,1.07,2.77-.1,4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-722",
    d: "m101.41,111.26c-1.17,1.55-3.01,2.13-4.11,1.31-1.1-.83-1.06-2.76.11-4.31,1.17-1.54,2.99-2.13,4.1-1.31,1.11.85,1.06,2.77-.1,4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-546",
    d: "m101.4,111.26c-1.16,1.55-3,2.13-4.1,1.31-1.1-.84-1.05-2.76.11-4.31,1.17-1.54,2.99-2.12,4.1-1.3,1.11.84,1.06,2.76-.11,4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "m101.39,111.25c-1.16,1.56-2.99,2.13-4.09,1.31-1.09-.84-1.05-2.75.11-4.3,1.17-1.54,2.99-2.12,4.1-1.3,1.09.84,1.06,2.76-.12,4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m101.39,111.25c-1.16,1.56-2.99,2.12-4.09,1.31-1.09-.84-1.05-2.75.11-4.28,1.17-1.57,2.98-2.13,4.1-1.3,1.09.81,1.06,2.73-.12,4.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m101.39,111.25c-1.16,1.55-2.99,2.12-4.07,1.3-1.1-.84-1.06-2.74.11-4.27,1.16-1.55,2.96-2.13,4.06-1.3,1.09.81,1.05,2.73-.1,4.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-697",
    d: "m101.39,111.25c-1.16,1.53-2.98,2.13-4.07,1.3-1.1-.83-1.06-2.73.11-4.26,1.16-1.55,2.96-2.13,4.06-1.3,1.09.82,1.05,2.73-.1,4.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-509",
    d: "m101.39,111.25c-1.16,1.53-2.98,2.12-4.07,1.3-1.1-.83-1.05-2.73.11-4.26,1.16-1.55,2.96-2.12,4.06-1.3,1.09.82,1.04,2.73-.1,4.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-739",
    d: "m101.39,111.25c-1.16,1.53-2.98,2.11-4.06,1.3-1.09-.83-1.06-2.73.1-4.25,1.16-1.56,2.96-2.13,4.06-1.3,1.08.81,1.04,2.72-.1,4.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-811",
    d: "m101.39,111.25c-1.16,1.53-2.98,2.11-4.06,1.3-1.08-.83-1.04-2.73.1-4.25,1.16-1.53,2.96-2.12,4.06-1.3,1.08.81,1.03,2.72-.1,4.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-247",
    d: "m101.39,111.25c-1.16,1.52-2.97,2.1-4.06,1.3-1.08-.83-1.04-2.73.1-4.25,1.16-1.53,2.96-2.12,4.05-1.29,1.09.82,1.05,2.71-.08,4.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-700",
    d: "m101.37,111.24c-1.13,1.53-2.94,2.11-4.03,1.31-1.08-.84-1.04-2.73.1-4.25,1.15-1.53,2.95-2.11,4.04-1.29,1.09.82,1.03,2.71-.11,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-412",
    d: "m101.36,111.24c-1.12,1.51-2.94,2.11-4.02,1.28-1.08-.82-1.04-2.7.12-4.22,1.13-1.53,2.94-2.1,4.02-1.29,1.09.82,1.03,2.71-.12,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m101.36,111.24c-1.14,1.51-2.94,2.09-4.02,1.28-1.08-.82-1.04-2.7.12-4.22,1.14-1.5,2.94-2.1,4.01-1.29,1.1.83,1.04,2.71-.11,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-461",
    d: "m101.36,111.24c-1.14,1.5-2.94,2.09-4.02,1.27-1.08-.81-1.03-2.7.12-4.21,1.14-1.51,2.94-2.09,4.01-1.28,1.08.81,1.03,2.7-.11,4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "m101.36,111.22c-1.14,1.52-2.94,2.1-4.02,1.29-1.08-.81-1.03-2.7.12-4.21,1.13-1.5,2.93-2.09,4-1.28,1.08.81,1.03,2.7-.11,4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "m101.36,111.22c-1.14,1.52-2.94,2.1-4,1.28-1.09-.8-1.05-2.69.11-4.2,1.13-1.5,2.93-2.09,4-1.27,1.07.81,1.03,2.69-.11,4.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "m101.36,111.22c-1.14,1.52-2.94,2.1-3.99,1.28-1.09-.8-1.03-2.69.1-4.2,1.13-1.5,2.92-2.07,4-1.27,1.07.81,1.03,2.69-.11,4.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-417",
    d: "m101.36,111.22c-1.14,1.5-2.92,2.08-3.99,1.28-1.08-.81-1.03-2.69.1-4.2,1.13-1.5,2.92-2.07,4-1.27,1.06.81,1.01,2.69-.11,4.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-857",
    d: "m101.36,111.21c-1.14,1.51-2.92,2.09-3.99,1.29-1.08-.81-1.03-2.69.1-4.18,1.13-1.51,2.92-2.09,3.99-1.28,1.07.8,1,2.68-.1,4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m101.34,111.21c-1.12,1.5-2.9,2.07-3.97,1.29-1.08-.81-1.03-2.69.09-4.17,1.13-1.52,2.92-2.09,3.99-1.29,1.05.8,1,2.68-.12,4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-765",
    d: "m101.33,111.21c-1.11,1.5-2.89,2.07-3.96,1.26-1.08-.79-1.02-2.66.1-4.15,1.12-1.51,2.91-2.09,3.98-1.28,1.05.8,1,2.67-.12,4.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-765",
    d: "m101.33,111.2c-1.13,1.51-2.89,2.06-3.96,1.27-1.08-.79-1.02-2.66.1-4.15,1.13-1.51,2.91-2.07,3.98-1.28,1.06.8,1,2.67-.12,4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-421",
    d: "m101.31,111.2c-1.11,1.49-2.87,2.04-3.93,1.26-1.05-.8-1.02-2.65.12-4.14,1.1-1.49,2.87-2.05,3.92-1.24,1.08.77,1.02,2.63-.11,4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-854",
    d: "m101.3,111.19c-1.1,1.49-2.85,2.03-3.9,1.24-1.06-.78-1-2.61.1-4.08,1.09-1.47,2.85-2.04,3.9-1.26,1.04.8,1,2.63-.11,4.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-419",
    d: "m101.29,111.17c-1.08,1.47-2.83,2.04-3.86,1.23-1.07-.77-1.01-2.59.1-4.06,1.1-1.46,2.81-2,3.87-1.22,1.05.76,1,2.59-.11,4.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-766",
    d: "m101.29,111.17c-1.09,1.46-2.82,2.01-3.86,1.22-1.02-.77-.98-2.57.1-4.04,1.1-1.44,2.81-1.98,3.87-1.21,1.01.77.97,2.58-.11,4.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-766",
    d: "m101.27,111.17c-1.08,1.43-2.8,1.97-3.81,1.21-1.04-.77-.99-2.56.1-4,1.07-1.43,2.78-1.98,3.8-1.22,1.03.76.98,2.56-.09,4.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-537",
    d: "m101.24,111.15c-1.06,1.42-2.76,1.96-3.78,1.21-1.01-.76-.97-2.54.1-3.98,1.08-1.42,2.78-1.96,3.8-1.2,1,.77.96,2.54-.12,3.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m101.23,111.15c-1.07,1.4-2.74,1.93-3.75,1.18-1-.76-.96-2.52.11-3.94,1.05-1.41,2.72-1.94,3.75-1.19,1,.76.97,2.52-.1,3.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-822",
    d: "m101.22,111.12c-1.05,1.41-2.72,1.94-3.71,1.19-1.01-.75-.97-2.5.08-3.9,1.06-1.41,2.72-1.94,3.73-1.19,1,.76.95,2.5-.1,3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m101.2,111.1c-1.04,1.4-2.7,1.93-3.68,1.18-.99-.76-.95-2.47.1-3.87,1.03-1.39,2.69-1.92,3.69-1.18,1,.75.94,2.47-.11,3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-734",
    d: "m101.18,111.09c-1.02,1.39-2.67,1.91-3.66,1.17-.97-.72-.93-2.44.11-3.83,1.03-1.38,2.66-1.9,3.66-1.16.98.74.93,2.45-.11,3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-516",
    d: "m101.18,111.09c-1.05,1.38-2.65,1.89-3.64,1.16-.98-.73-.93-2.43.1-3.8,1.03-1.4,2.65-1.89,3.63-1.15.98.72.93,2.42-.09,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-346",
    d: "m101.15,111.08c-1.02,1.35-2.62,1.89-3.59,1.15-.96-.72-.93-2.41.12-3.78,1-1.36,2.62-1.87,3.57-1.14.98.72.93,2.41-.09,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-516",
    d: "m101.14,111.07c-1.01,1.33-2.62,1.84-3.56,1.14-.97-.72-.92-2.39.09-3.74,1.01-1.34,2.61-1.85,3.56-1.14.95.72.91,2.38-.09,3.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-410",
    d: "m101.14,111.06c-1.01,1.33-2.59,1.83-3.55,1.12-.96-.7-.9-2.37.1-3.7,1-1.34,2.6-1.84,3.54-1.14.95.71.9,2.37-.09,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m101.13,111.03c-1,1.33-2.58,1.83-3.51,1.12-.94-.68-.9-2.34.08-3.66,1-1.33,2.58-1.83,3.5-1.14.94.71.89,2.36-.07,3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-839",
    d: "m101.09,111.03c-.98,1.31-2.54,1.82-3.46,1.11-.94-.7-.9-2.33.09-3.64.99-1.31,2.53-1.82,3.48-1.12.93.68.88,2.33-.11,3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-836",
    d: "m101.07,111.02c-.96,1.31-2.5,1.79-3.43,1.08-.93-.69-.88-2.29.08-3.6.99-1.3,2.53-1.79,3.46-1.09.91.68.87,2.3-.11,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "m101.06,111.01c-.97,1.3-2.48,1.76-3.39,1.09-.93-.7-.89-2.29.06-3.58.97-1.29,2.5-1.78,3.42-1.08.92.69.89,2.29-.09,3.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-575",
    d: "m101.05,111c-.95,1.29-2.46,1.75-3.37,1.09-.9-.7-.88-2.28.09-3.57.96-1.27,2.47-1.76,3.38-1.06.9.68.86,2.26-.1,3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "m101.04,110.99c-.94,1.26-2.45,1.74-3.35,1.07-.89-.68-.85-2.24.09-3.52.95-1.26,2.45-1.73,3.35-1.06.91.68.86,2.25-.09,3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-704",
    d: "m101.02,110.98c-.93,1.25-2.43,1.73-3.33,1.07-.89-.68-.85-2.23.09-3.5.94-1.25,2.44-1.73,3.32-1.07.91.68.86,2.24-.08,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-311",
    d: "m101.01,110.95c-.93,1.25-2.41,1.73-3.29,1.06-.89-.66-.85-2.2.1-3.45.92-1.23,2.38-1.72,3.27-1.04.89.67.84,2.21-.08,3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-328",
    d: "m100.98,110.95c-.91,1.25-2.38,1.7-3.26,1.05-.88-.67-.84-2.19.1-3.43.91-1.23,2.38-1.69,3.25-1.04.88.66.84,2.2-.09,3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "m100.97,110.93c-.91,1.23-2.35,1.7-3.24,1.03-.86-.64-.82-2.15.1-3.38.93-1.23,2.36-1.69,3.22-1.02.86.64.84,2.16-.08,3.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-886",
    d: "m100.97,110.92c-.92,1.22-2.34,1.67-3.19,1.03-.88-.66-.83-2.14.08-3.36.91-1.2,2.33-1.65,3.19-1.02.87.64.83,2.15-.07,3.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-738",
    d: "m100.95,110.92c-.91,1.18-2.32,1.65-3.18,1.01-.85-.63-.8-2.12.09-3.34.9-1.18,2.32-1.64,3.18-.99.85.62.81,2.12-.09,3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-860",
    d: "m100.93,110.92c-.9,1.17-2.29,1.63-3.14.98-.85-.63-.79-2.08.09-3.27.88-1.19,2.29-1.63,3.14-1,.84.62.79,2.1-.09,3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-860",
    d: "m100.91,110.89c-.88,1.17-2.27,1.62-3.1,1-.84-.62-.81-2.07.07-3.26.87-1.16,2.28-1.6,3.09-.98.85.61.82,2.08-.07,3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m100.89,110.88c-.86,1.16-2.25,1.62-3.07.98-.82-.61-.79-2.05.08-3.21.87-1.16,2.25-1.61,3.07-.99.84.62.8,2.06-.08,3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-705",
    d: "m100.88,110.86c-.85,1.16-2.22,1.61-3.02.98-.83-.6-.8-2.03.07-3.19.87-1.15,2.23-1.6,3.04-.97.82.61.77,2.05-.09,3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-501",
    d: "m100.88,110.86c-.86,1.15-2.21,1.57-3.02.97-.81-.62-.77-2.02.09-3.16.85-1.15,2.18-1.58,3-.97.81.61.77,2.02-.07,3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "m100.86,110.85c-.85,1.14-2.18,1.56-2.98.95-.81-.6-.77-1.98.07-3.11.85-1.15,2.18-1.56,2.98-.97.8.61.78,2.01-.07,3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "m100.84,110.85c-.84,1.12-2.15,1.53-2.95.93-.78-.59-.77-1.97.08-3.09.84-1.13,2.16-1.54,2.94-.95.8.6.77,1.98-.07,3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "m100.82,110.83c-.82,1.1-2.14,1.53-2.92.94-.79-.6-.75-1.96.07-3.08.83-1.08,2.14-1.52,2.94-.93.77.59.74,1.97-.09,3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-633",
    d: "m100.82,110.83c-.84,1.07-2.12,1.5-2.9.91-.78-.57-.74-1.92.08-3.03.81-1.08,2.11-1.49,2.87-.91.79.58.75,1.93-.05,3.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-633",
    d: "m100.8,110.81c-.82,1.08-2.09,1.5-2.85.91-.79-.57-.76-1.91.05-3.01.82-1.07,2.09-1.49,2.87-.91.77.57.73,1.92-.08,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-756",
    d: "m100.78,110.79c-.8,1.07-2.05,1.48-2.83.91-.76-.57-.74-1.89.09-2.97.78-1.06,2.05-1.48,2.82-.9.77.56.72,1.89-.08,2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "m100.77,110.77c-.79,1.07-2.05,1.47-2.79.91-.77-.56-.73-1.88.06-2.94.8-1.06,2.05-1.44,2.79-.89.77.56.73,1.88-.06,2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-545",
    d: "m100.75,110.77c-.78,1.05-2.03,1.45-2.78.89-.73-.58-.7-1.86.08-2.92.78-1.04,2.04-1.43,2.77-.87.74.55.71,1.85-.07,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-838",
    d: "m100.74,110.77c-.77,1.02-2,1.42-2.73.87-.73-.56-.7-1.84.05-2.88.79-1.03,2.02-1.42,2.76-.87.73.55.69,1.83-.08,2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-696",
    d: "m100.71,110.76c-.76,1.01-1.95,1.4-2.7.86-.71-.55-.68-1.81.09-2.84.77-1.03,1.97-1.42,2.7-.88.74.57.69,1.82-.09,2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-696",
    d: "m100.71,110.74c-.76,1.01-1.95,1.41-2.67.85-.72-.53-.7-1.79.06-2.8.76-1.01,1.96-1.4,2.68-.85.71.53.68,1.79-.07,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-590",
    d: "m100.69,110.72c-.74,1-1.93,1.39-2.64.85-.71-.53-.68-1.76.07-2.77.75-1,1.92-1.39,2.63-.84.72.53.7,1.76-.06,2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "m100.66,110.71c-.73.99-1.9,1.38-2.61.85-.68-.53-.67-1.75.08-2.74.73-.99,1.89-1.35,2.62-.84.7.52.66,1.74-.09,2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "m100.66,110.71c-.72.98-1.88,1.33-2.59.82-.68-.52-.66-1.73.08-2.71.75-.98,1.89-1.33,2.58-.81.69.51.67,1.72-.07,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-864",
    d: "m100.66,110.7c-.73.96-1.88,1.32-2.56.81-.68-.52-.66-1.71.05-2.68.75-.96,1.89-1.33,2.56-.82.69.51.66,1.71-.05,2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-864",
    d: "m100.64,110.68c-.72.97-1.84,1.33-2.53.81-.68-.5-.64-1.68.07-2.63.72-.96,1.85-1.33,2.53-.82.69.52.66,1.69-.06,2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m100.62,110.67c-.7.95-1.82,1.3-2.48.81-.68-.51-.66-1.67.05-2.61.7-.96,1.82-1.3,2.47-.81.69.5.67,1.67-.04,2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m100.6,110.67c-.7.93-1.8,1.26-2.46.77-.66-.49-.62-1.64.07-2.57.69-.93,1.8-1.29,2.45-.8.67.5.64,1.65-.06,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-609",
    d: "m100.59,110.66c-.69.91-1.78,1.24-2.45.76-.64-.48-.62-1.61.07-2.54.69-.91,1.79-1.26,2.44-.78.65.49.63,1.63-.06,2.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-576",
    d: "m100.57,110.63c-.67.9-1.75,1.25-2.39.77-.65-.47-.61-1.59.07-2.51.67-.9,1.74-1.25,2.39-.77.65.47.6,1.6-.07,2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m100.56,110.63c-.68.89-1.73,1.23-2.37.75-.63-.46-.61-1.57.05-2.49.67-.88,1.73-1.22,2.38-.74.65.47.61,1.57-.06,2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "m100.55,110.62c-.67.88-1.71,1.21-2.34.75-.62-.48-.6-1.57.05-2.46.68-.88,1.72-1.21,2.34-.74.63.48.6,1.56-.05,2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-852",
    d: "m100.52,110.6c-.64.89-1.68,1.2-2.3.75-.62-.46-.59-1.54.06-2.43.67-.86,1.69-1.2,2.31-.73.62.46.59,1.54-.07,2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-402",
    d: "m100.51,110.59c-.64.88-1.66,1.18-2.27.74-.61-.46-.6-1.52.06-2.41.64-.84,1.66-1.17,2.26-.71.61.47.59,1.52-.05,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m100.5,110.57c-.63.85-1.65,1.17-2.26.73-.6-.45-.57-1.49.06-2.38.64-.83,1.65-1.14,2.25-.69.6.45.58,1.49-.05,2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "m100.48,110.57c-.62.83-1.61,1.15-2.21.69-.59-.43-.57-1.46.06-2.3.62-.85,1.63-1.16,2.22-.72.6.44.58,1.48-.07,2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "m100.46,110.56c-.61.82-1.59,1.14-2.18.69-.59-.43-.56-1.45.07-2.29.62-.82,1.58-1.13,2.16-.71.61.44.58,1.47-.05,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-258",
    d: "m100.46,110.54c-.61.83-1.57,1.14-2.15.69-.59-.43-.57-1.43.05-2.26.61-.81,1.57-1.12,2.15-.68.58.44.54,1.43-.05,2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "m100.42,110.54c-.6.8-1.53,1.1-2.11.67-.58-.42-.54-1.41.05-2.22.6-.81,1.56-1.11,2.12-.67.57.41.55,1.4-.06,2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-889",
    d: "m100.42,110.53c-.6.78-1.53,1.09-2.09.68-.56-.43-.54-1.4.05-2.21.59-.79,1.53-1.09,2.09-.67.56.42.54,1.4-.05,2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-511",
    d: "m100.4,110.53c-.57.77-1.49,1.07-2.05.65-.56-.42-.52-1.37.05-2.16.58-.78,1.49-1.07,2.05-.67.56.44.52,1.38-.06,2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-763",
    d: "m100.39,110.5c-.58.76-1.48,1.07-2.02.66-.54-.42-.53-1.35.04-2.13.59-.77,1.49-1.05,2.03-.65.54.42.52,1.35-.05,2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-606",
    d: "m100.38,110.49c-.57.76-1.47,1.04-1.99.66-.55-.43-.52-1.34.05-2.13.56-.74,1.46-1.03,1.98-.63.54.41.52,1.33-.04,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-893",
    d: "m100.37,110.48c-.56.74-1.46,1.03-1.97.62-.53-.39-.52-1.3.04-2.06.56-.74,1.44-1.02,1.98-.62.52.4.49,1.31-.05,2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-893",
    d: "m100.33,110.47c-.53.73-1.39,1.01-1.92.61-.52-.38-.51-1.28.04-2.03.54-.73,1.42-1.01,1.93-.61.52.38.5,1.28-.05,2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-893",
    d: "m100.33,110.47c-.54.7-1.39,1-1.91.6-.52-.39-.48-1.26.04-2,.53-.72,1.41-1,1.92-.6.5.38.49,1.25-.05,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-487",
    d: "m100.31,110.45c-.52.71-1.36.96-1.87.59-.49-.37-.49-1.24.05-1.97.53-.69,1.38-.97,1.88-.59.51.38.47,1.25-.06,1.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "m100.3,110.44c-.52.7-1.35.95-1.84.59-.5-.37-.48-1.24.04-1.95.54-.69,1.36-.96,1.85-.58.5.37.48,1.23-.04,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-302",
    d: "m100.29,110.44c-.51.68-1.32.93-1.82.55-.49-.37-.46-1.2.06-1.9.51-.68,1.32-.93,1.81-.58.49.37.46,1.22-.04,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-457",
    d: "m100.28,110.41c-.52.68-1.31.93-1.79.58-.49-.36-.45-1.19.04-1.88.51-.67,1.31-.92,1.77-.58.49.36.47,1.2-.03,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-631",
    d: "m100.27,110.39c-.52.68-1.3.92-1.78.56-.45-.36-.45-1.16.05-1.81.5-.67,1.28-.93,1.75-.58.48.36.45,1.17-.03,1.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-588",
    d: "m100.25,110.39c-.49.65-1.26.91-1.72.54-.47-.34-.46-1.14.04-1.8.47-.64,1.25-.91,1.72-.55.46.33.44,1.16-.04,1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-615",
    d: "m100.24,110.38c-.48.64-1.24.88-1.7.54-.47-.36-.44-1.13.04-1.78.48-.64,1.23-.89,1.7-.55.45.33.43,1.15-.04,1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-389",
    d: "m100.22,110.36c-.47.63-1.22.87-1.67.53-.44-.33-.43-1.1.04-1.75.47-.62,1.22-.85,1.68-.52.44.35.42,1.12-.05,1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-890",
    d: "m100.2,110.36c-.46.62-1.2.85-1.62.53-.44-.34-.44-1.09.02-1.71.47-.62,1.2-.85,1.64-.53.43.33.42,1.09-.04,1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "m100.18,110.35c-.46.6-1.18.83-1.6.52-.44-.32-.41-1.07.04-1.68.44-.61,1.17-.84,1.61-.51.42.32.41,1.07-.05,1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m100.17,110.34c-.45.59-1.14.83-1.57.51-.43-.32-.39-1.05.04-1.66.45-.6,1.16-.82,1.57-.5.44.32.41,1.05-.04,1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-771",
    d: "m100.16,110.31c-.45.6-1.12.82-1.53.52-.42-.33-.41-1.03.02-1.63.44-.58,1.14-.81,1.56-.5.41.32.39,1.04-.04,1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-460",
    d: "m100.13,110.31c-.42.57-1.09.77-1.5.48-.4-.3-.38-1,.04-1.57.42-.57,1.09-.79,1.51-.49.39.31.38,1.01-.05,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-460",
    d: "m100.12,110.3c-.41.56-1.08.76-1.48.47-.4-.3-.38-.98.04-1.55.4-.55,1.08-.77,1.48-.48.39.29.38,1-.04,1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-762",
    d: "m100.11,110.29c-.41.55-1.07.75-1.45.46-.39-.29-.36-.96.04-1.53.39-.53,1.05-.75,1.45-.44.37.28.36.96-.04,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-937",
    d: "m100.09,110.29c-.4.53-1.03.73-1.41.44-.37-.28-.37-.94.04-1.5.39-.53,1.03-.73,1.41-.44.38.27.36.94-.04,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-746",
    d: "m100.09,110.27c-.4.52-1.03.72-1.41.44-.36-.27-.36-.92.04-1.47.39-.52,1.02-.71,1.4-.43.36.28.36.93-.03,1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "m100.07,110.25c-.37.52-1,.7-1.36.44-.36-.28-.35-.89.05-1.41.36-.52.98-.71,1.33-.44.37.26.35.91-.03,1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-673",
    d: "m100.04,110.25c-.37.49-.97.68-1.32.42-.36-.28-.34-.87.04-1.38.36-.5.96-.7,1.33-.43.35.28.33.88-.05,1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-673",
    d: "m100.03,110.23c-.36.49-.94.68-1.3.43-.34-.27-.33-.88.04-1.35.37-.51.93-.68,1.29-.43.36.26.32.86-.04,1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "m100.01,110.22c-.36.48-.92.66-1.25.41-.34-.27-.32-.85.04-1.33.36-.49.92-.66,1.25-.42.35.26.34.85-.03,1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-885",
    d: "m100.01,110.21c-.36.45-.92.63-1.25.38-.32-.24-.3-.82.04-1.28.35-.45.91-.64,1.23-.4.34.26.33.83-.03,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-920",
    d: "m99.99,110.2c-.34.45-.89.62-1.19.38-.34-.24-.31-.81.02-1.26.35-.45.89-.62,1.21-.4.31.27.31.82-.04,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-423",
    d: "m99.98,110.19c-.35.44-.86.62-1.17.38-.31-.23-.31-.79.04-1.24.33-.44.85-.6,1.17-.36.3.22.29.77-.03,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-374",
    d: "m99.95,110.18c-.32.42-.83.6-1.14.37-.3-.23-.28-.78.04-1.19.32-.44.85-.6,1.13-.36.31.22.31.75-.03,1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-408",
    d: "m99.95,110.17c-.32.42-.83.57-1.11.36-.3-.22-.29-.77.03-1.16.31-.44.81-.57,1.11-.36.3.22.29.74-.03,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-862",
    d: "m99.93,110.16c-.31.41-.78.55-1.09.34-.28-.2-.27-.74.04-1.14.29-.39.77-.54,1.06-.34.29.21.29.72-.02,1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-856",
    d: "m99.92,110.14c-.29.4-.77.54-1.05.34-.28-.21-.27-.72.03-1.08.29-.4.77-.56,1.06-.36.27.2.25.7-.04,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-799",
    d: "m99.9,110.14c-.29.38-.74.52-1.01.33-.29-.22-.27-.71.02-1.08.29-.38.74-.52,1.01-.33.28.2.27.68-.03,1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "m99.88,110.13c-.28.37-.71.5-.98.31-.27-.21-.26-.68,0-1.04.29-.38.74-.52,1-.32.27.2.25.66-.04,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m99.87,110.13c-.27.35-.7.47-.96.28-.25-.19-.24-.65.04-1,.26-.36.68-.5.95-.32.26.21.23.65-.03,1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m99.85,110.09c-.25.37-.68.48-.91.3-.27-.18-.26-.63,0-.97.28-.36.68-.5.93-.28.25.18.24.6-.03.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m99.85,110.08c-.27.36-.67.48-.9.28-.24-.18-.22-.6.03-.92.25-.36.65-.48.9-.3.22.19.22.6-.03.93Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "m124.34,78.4c-1.33,0,.68.21-.66.21-7.77,10.22-23.5,1.56-23.5,1.56,0,0-15.69,8.66-23.46-1.56h-1.33c-.34,22.23-1.67,46.37,24.71,62.6,24.07-15.06,26.22-39.26,24.25-62.81Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 75.49,
    y: 100.52,
    width: 49.13,
    height: 1.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 80.6,
    y: 118.51,
    width: 38.64,
    height: 1.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-475",
    d: "m125.02,78.61h-1.33c-7.77,10.22-23.5,1.56-23.5,1.56,0,0-15.69,8.66-23.46-1.56h-1.33c-.11,7.57-.36,15.2.45,22.65,13.55-.27,35.56-.37,48.37-.41.78-6.15,1.09-13.46.82-22.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "m109.27,74.11s-.2-1.01.4-1.21c-.11.16-.11.3-.13.52-.02.21.07.67.07.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-387",
    d: "m109.38,74.13s-.07-.93.29-1.23c-.11.16-.11.3-.13.52-.02.21.07.67.07.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m109.08,75.99s0-.91.09-1.12c.06-.23-.28-.91.14-1.03.42-.1.82.04.61.6-.21.56.11.57-.13,1.03-.25.47-.71.52-.71.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-730",
    d: "m107.46,74.78s-.2-1.02.4-1.21c-.12.17-.12.3-.13.52-.03.2.05.66.05.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-641",
    d: "m107.56,74.79s-.08-.93.3-1.22c-.12.17-.12.3-.13.52-.03.2.05.66.05.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-386",
    d: "m107.25,76.65s0-.9.07-1.13c.08-.22-.26-.92.15-1.02.43-.11.82.04.62.6-.21.56.09.58-.14,1.03-.23.45-.7.52-.7.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-847",
    d: "m110.42,79.03s.12,1.03.73,1.05c-.15-.11-.19-.25-.26-.45-.07-.19-.13-.65-.13-.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-425",
    d: "m110.54,78.98s.18.94.61,1.1c-.15-.11-.19-.25-.26-.45-.07-.19-.13-.65-.13-.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-595",
    d: "m109.73,77.28s.26.87.39,1.07c.13.2-.03.95.44.94.43-.02.77-.26.42-.75-.37-.46-.06-.58-.41-.95-.38-.37-.84-.31-.84-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-931",
    d: "m111.68,73.57s-.04-.83.47-.89c-.11.12-.12.22-.16.38-.03.15-.02.52-.02.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-322",
    d: "m111.78,73.59s.04-.76.37-.92c-.11.12-.12.22-.16.38-.03.15-.02.52-.02.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "m111.32,75s.1-.72.19-.87c.1-.16-.13-.75.24-.76.37-.04.7.14.46.55-.24.4.02.46-.23.78-.26.34-.66.3-.66.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-366",
    d: "m90.76,81.45s-.2-1.01-.83-.98c.17.1.21.24.3.42.1.2.2.64.2.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-685",
    d: "m90.68,81.5s-.29-.9-.74-1.03c.17.1.21.24.3.42.1.2.2.64.2.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "m91.64,83.11s-.34-.84-.5-1.02c-.15-.17-.1-.94-.51-.87-.45.04-.76.34-.36.77.41.44.11.59.51.91.4.33.85.22.85.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "m92.7,81.36s-.21-1.01-.84-.95c.17.1.22.21.31.42.12.18.2.63.2.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-473",
    d: "m92.61,81.42s-.29-.91-.75-1.01c.17.1.22.21.31.42.12.18.2.63.2.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-671",
    d: "m93.59,83.04s-.36-.85-.51-1.01c-.14-.2-.09-.94-.52-.9-.45.05-.76.34-.34.79.4.44.12.56.51.9.4.34.85.22.85.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-508",
    d: "m88.31,81.83s-.27-.75-.77-.61c.14.04.2.13.29.29.1.12.21.48.21.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-726",
    d: "m88.26,81.92s-.35-.68-.72-.7c.14.04.2.13.29.29.1.12.21.48.21.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-388",
    d: "m89.19,83.04s-.35-.63-.49-.74c-.16-.12-.16-.74-.53-.62-.35.11-.59.4-.21.68.38.29.14.45.52.64.36.2.71.04.71.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "m124.29,78.4c-1.33,0,.69.21-.66.21-7.8,10.22-23.59,1.56-23.59,1.56,0,0-15.73,8.66-23.54-1.56h-1.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "m100.49,140.14c25.92-17.52,24.6-39.9,24.26-61.98h-1.33c-6.25,8.24-17.62,4.23-21.85,2.35-.74-.33-1.27-.6-1.49-.72,0,0-.17.09-.68.32-3.24,1.6-15.93,6.92-22.67-1.95h-1.33c-.34,22.08-1.65,44.45,24.25,61.97.18.13.44.31.44.31,0,0,.22-.18.41-.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-841",
    x: 75.49,
    y: 100.08,
    width: 49.13,
    height: 1.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-841",
    x: 80.6,
    y: 118.08,
    width: 39.3,
    height: 1.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m75.71,77.12c-.12.03-.23.06-.34.06-.04-.02-.06-.03-.07-.04v-.09c0-.07-.02-.12-.08-.16-.1-.05-.21-.09-.33-.09-.12-.02-.24-.02-.35-.02h0c-.06,3.06-.13,6.16-.14,9.21-.02,3.09,0,6.15.12,9.21.23,6.13,1.05,12.28,2.96,18.12.94,2.92,2.16,5.75,3.65,8.43,1.47,2.7,3.21,5.25,5.17,7.61,1.96,2.37,4.13,4.55,6.44,6.57,2.31,2.02,4.77,3.87,7.33,5.6-2.57-1.71-5.04-3.54-7.37-5.55-2.31-2.02-4.48-4.2-6.45-6.57-1.96-2.36-3.72-4.91-5.19-7.59-1.49-2.71-2.72-5.55-3.66-8.47-1.91-5.85-2.71-12.01-2.94-18.15-.22-6.13-.09-12.27.1-18.42v-.02h0c.11,0,.23.02.35.02.12.02.23.04.35.11.04.04.07.09.06.16,0,.02,0,.05,0,.09,0,.02.03.03.06.03.11.02.22-.02.34-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m100.03,78.8c-1.86,1.03-3.82,1.85-5.85,2.47-2.04.62-4.14,1.02-6.27,1.06-2.11.03-4.25-.33-6.18-1.22-.97-.44-1.89-1-2.7-1.68-.81-.68-1.54-1.47-2.19-2.31,1.31,1.68,2.99,3.07,4.92,3.93,1.92.87,4.06,1.22,6.15,1.17,2.12-.04,4.23-.41,6.26-1.01,1.01-.33,1.99-.67,2.97-1.09,1-.4,1.95-.83,2.89-1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m123.59,77.12c-.69.83-1.45,1.57-2.29,2.24-.84.66-1.75,1.25-2.71,1.73-1.96.9-4.12,1.32-6.27,1.27-2.15-.03-4.29-.44-6.32-1.08-2.04-.66-4.04-1.47-5.91-2.47.94.5,1.93.93,2.92,1.32.99.4,2.01.77,3.02,1.09,2.04.61,4.16,1.03,6.3,1.06,2.13.04,4.3-.36,6.23-1.26,1.94-.9,3.65-2.27,5.05-3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m100.07,141.59c2.44-1.79,4.89-3.56,7.21-5.53,2.31-1.96,4.49-4.07,6.43-6.41,3.87-4.63,6.76-10.09,8.67-15.83,1.9-5.76,2.69-11.81,3.03-17.84.17-3.03.23-6.06.23-9.09s-.05-6.06-.15-9.09h0c-.3-.09-.54-.33-.72-.58.18.25.42.49.73.57h0c.21,6.06.32,12.13,0,18.19-.17,3.02-.45,6.05-.92,9.05-.47,3-1.14,5.97-2.08,8.84-1.93,5.74-4.84,11.18-8.74,15.84-1.93,2.33-4.12,4.45-6.44,6.4-2.33,1.97-4.79,3.71-7.25,5.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m74.44,80.61l-.05,2.05,1.83-.23-.03.36,2.47-.85-.04-.61,2.48-.6s-1.69-.78-2.62-2.11c-.37-.85-4.05,1.99-4.05,1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m125.69,80.61c0,.38.03,2.05.03,2.05l-1.79-.22.02.36-2.48-.85.04-.61-2.46-.58s2.22-1.09,2.6-2.13c.37-.85,4.08,1.93,4.06,1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m97.19,80.15l.96,1.49v.46s.58.84,1.15.84-.45-1.16-.45-1.16l.05-.44-1-1.54-.7.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-779",
    d: "m97.67,54.53c-1.96-.31-4.2,1.57-3.13,1.77-.8.89-.86,1.58-1.44,2.71-1.11,2.11-.85,2.92,0,2.66-1.51,3.67-1.29,4.31-.68,4.08-1.06,2.21.63,1.77.63,1.77,0,0-1.89,4.98-.68,4.29.5,1.41-.27,3.42.9,2.64.36.95.54,2.09,1.32,1.54,1.32.2,1.71-1.5,1.71-1.5,0,0,.9.49,1.02-1.03.12-1.51.5-1.57,1.32-1.65,1.47-.53,2.51,2.56,2.5,1.24.76,1,2.19,1,2.19,1,0,0,1.34.72,1.73,0,.84-.28.18-2.24.18-2.24,0,0,.53.3.32-1.01.67-.42-1.09-2.57-1-3.04.61-.28.09-1.47.35-1.51.59.3.5-1.79.5-1.79,0,0,.81-.39.11-3.2,1.01-.72-1.08-3-.42-3.5.64-.52-.45-2.48-2.42-3.37.27-1.3-5.18-.58-5,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-619",
    d: "m102.67,69.22c.17.83.5,1.39.77,1.3.25-.11.3-.85.13-1.65-.17-.81-.5-1.39-.76-1.28-.24.1-.31.84-.14,1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "m101.81,69.89c.1.84.4,1.44.65,1.38.27-.05.38-.78.27-1.62-.11-.84-.41-1.44-.66-1.38-.26.06-.38.8-.26,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-751",
    d: "m100.81,70.6c.1.83.4,1.47.65,1.38.26-.04.38-.78.27-1.59-.11-.85-.4-1.46-.67-1.41-.24.06-.37.8-.25,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-898",
    d: "m99.81,70.83c-.02.85.17,1.54.43,1.56.25.02.49-.65.52-1.49.03-.85-.16-1.54-.42-1.55-.26-.03-.51.63-.52,1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-390",
    d: "m98.95,70.62c-.04.85.14,1.54.41,1.55.27.02.5-.64.52-1.49.02-.84-.17-1.54-.41-1.56-.27-.02-.5.65-.52,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "m97.82,70.7c-.04.84.14,1.55.41,1.56.26.02.5-.65.53-1.49.02-.85-.17-1.55-.44-1.56-.27-.03-.49.66-.51,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "m96.93,70.03c-.04.85.14,1.55.41,1.56.28.02.5-.66.52-1.49.03-.84-.16-1.53-.41-1.55-.27-.02-.51.64-.52,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-377",
    d: "m96.15,68.98c-.21.8-.17,1.54.06,1.65.26.13.61-.42.82-1.2.21-.8.17-1.54-.06-1.66-.26-.13-.62.44-.82,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-873",
    d: "m95.67,67.7c-.27.75-.3,1.48-.06,1.65.23.16.64-.33.91-1.08.27-.76.28-1.49.06-1.65-.24-.17-.64.32-.91,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-603",
    d: "m102.67,67.44c.17.83.5,1.38.77,1.29.25-.11.3-.84.13-1.64-.17-.8-.5-1.37-.76-1.28-.24.1-.31.85-.14,1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-339",
    d: "m101.81,68.12c.1.81.4,1.44.65,1.36.27-.05.38-.77.27-1.61-.11-.83-.41-1.44-.66-1.38-.26.06-.38.78-.26,1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-352",
    d: "m100.81,68.81c.1.84.4,1.47.65,1.4.26-.06.38-.78.27-1.62-.11-.82-.4-1.45-.67-1.38-.24.07-.37.78-.25,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-471",
    d: "m99.81,69.07c-.02.83.17,1.53.43,1.54.25.02.49-.64.52-1.49.03-.84-.16-1.53-.42-1.55-.26-.02-.51.66-.52,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "m98.95,68.85c-.04.84.14,1.53.41,1.56.27,0,.5-.66.52-1.5.02-.84-.17-1.53-.41-1.54-.27,0-.5.66-.52,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-821",
    d: "m97.82,68.92c-.04.83.14,1.53.41,1.54.26.02.5-.64.53-1.49.02-.85-.17-1.54-.44-1.56-.27,0-.49.67-.51,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-580",
    d: "m96.93,68.27c-.04.84.14,1.52.41,1.53.28.03.5-.64.52-1.49.03-.84-.16-1.53-.41-1.55-.27,0-.51.66-.52,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m96.15,67.21c-.21.78-.17,1.54.06,1.65.26.12.61-.43.82-1.23.21-.77.17-1.51-.06-1.65-.26-.1-.62.44-.82,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "m95.67,65.92c-.27.77-.3,1.49-.06,1.65.23.17.64-.32.91-1.07.27-.76.28-1.51.06-1.67-.24-.14-.64.35-.91,1.09Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-773",
    d: "m94.88,72.92c0,.91-.33,1.65-.74,1.65s-.73-.75-.73-1.65.33-1.65.73-1.65.74.73.74,1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m96.62,72.27c0,1.06-.36,1.95-.82,1.95s-.84-.89-.84-1.95.38-1.9.84-1.9.82.86.82,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-432",
    d: "m95.52,70.81c0,1.06-.37,1.91-.83,1.91s-.82-.85-.82-1.91.38-1.91.82-1.91.83.85.83,1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-882",
    d: "m97.79,70.81c0,1.06-.36,1.93-.81,1.93s-.83-.87-.83-1.93.37-1.91.83-1.91.81.85.81,1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-802",
    d: "m96.69,69.57c0,1.04-.36,1.91-.83,1.91s-.82-.87-.82-1.91.36-1.93.82-1.93.83.87.83,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-660",
    d: "m94.41,69.48c-.18.9-.59,1.57-.93,1.5-.33-.06-.46-.85-.3-1.74.2-.9.6-1.57.93-1.51.34.06.48.85.3,1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m95.3,67.96c-.17.83-.56,1.46-.87,1.39-.31-.06-.42-.76-.26-1.59.15-.83.53-1.46.85-1.39.29.06.43.77.28,1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "m95.32,66.1c-.15.83-.53,1.44-.84,1.38-.3-.06-.45-.76-.29-1.59.18-.82.55-1.44.85-1.38.32.04.44.76.28,1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-422",
    d: "m95.5,64.72c-.15.82-.53,1.43-.85,1.38-.3-.06-.43-.78-.29-1.59.18-.82.55-1.45.86-1.4.31.06.44.79.27,1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-684",
    d: "m96.93,66.42c-.19,1.05-.72,1.81-1.16,1.73-.45-.09-.65-1-.45-2.04.2-1.03.72-1.81,1.17-1.73.45.09.65,1.01.44,2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-577",
    d: "m98.12,68.22c-.08,1.03-.51,1.88-.96,1.84-.45-.04-.76-.92-.68-1.97.09-1.05.52-1.89.98-1.86.45.04.76.91.67,1.98Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-924",
    d: "m104.36,72.92c.23.87.73,1.5,1.13,1.4.39-.09.52-.89.28-1.78-.22-.88-.73-1.5-1.12-1.41-.39.1-.52.91-.28,1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-743",
    d: "m102.52,72.74c.27,1.01.85,1.75,1.28,1.64.44-.12.58-1.05.3-2.06-.27-1.01-.85-1.76-1.26-1.63-.44.1-.59,1.03-.32,2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m103.21,71.04c.28,1.02.85,1.75,1.29,1.64.43-.11.58-1.05.31-2.07-.27-1.01-.85-1.74-1.29-1.64-.44.12-.58,1.05-.31,2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m101.02,71.62c.27,1.01.83,1.76,1.28,1.64.43-.11.56-1.03.29-2.06-.26-1.01-.84-1.75-1.28-1.63-.44.1-.58,1.03-.29,2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m101.76,70.12c.28,1.01.84,1.77,1.28,1.64.44-.12.59-1.04.3-2.06-.27-1.03-.84-1.75-1.27-1.65-.44.12-.58,1.05-.31,2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-407",
    d: "m103.82,69.48c.4.8,1,1.31,1.35,1.15.36-.16.32-.96-.08-1.73-.39-.79-1.01-1.31-1.35-1.15-.36.17-.32.96.08,1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "m102.36,68.38c.35.75.86,1.25,1.17,1.09.3-.14.27-.9-.07-1.66-.35-.77-.88-1.27-1.17-1.12-.31.16-.27.91.06,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-591",
    d: "m102.58,65.88c.46.94,1.16,1.56,1.57,1.36.41-.19.38-1.13-.1-2.07-.44-.95-1.16-1.57-1.56-1.39-.42.19-.37,1.13.08,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-327",
    d: "m100.73,67.15c.45.95,1.16,1.57,1.57,1.38.41-.2.37-1.14-.09-2.09-.47-.96-1.17-1.57-1.57-1.36-.4.19-.36,1.13.09,2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-687",
    d: "m100.03,69.18c.35,1.01.98,1.69,1.41,1.54.41-.15.48-1.08.13-2.07-.35-1.01-.97-1.69-1.4-1.55-.43.16-.49,1.1-.15,2.08Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-336",
    d: "m102.28,66.35c.12.84.51,1.43.8,1.37.32-.08.47-.79.34-1.62-.14-.83-.52-1.46-.83-1.38-.31.06-.45.8-.31,1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-405",
    d: "m101.05,67.05c.15.83.51,1.43.82,1.39.31-.05.47-.8.32-1.62-.12-.84-.47-1.46-.79-1.39-.33.07-.48.8-.35,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-681",
    d: "m99.83,67.28c-.03.84.2,1.53.51,1.54.33.04.62-.64.64-1.49.04-.84-.2-1.53-.5-1.55-.32-.02-.6.66-.65,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "m98.76,67.07c-.04.85.21,1.56.52,1.56.33.03.6-.66.64-1.49.04-.84-.2-1.52-.52-1.55-.32-.02-.6.66-.63,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-608",
    d: "m97.37,67.14c-.04.85.2,1.53.52,1.57.32,0,.6-.67.64-1.49.04-.84-.2-1.54-.53-1.57-.31,0-.6.67-.63,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-869",
    d: "m96.3,66.46c-.04.84.2,1.57.51,1.57.32,0,.6-.66.65-1.49.03-.85-.2-1.55-.52-1.57-.31,0-.6.66-.63,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-395",
    d: "m103.34,64.34c.21.79.63,1.38.94,1.27.3-.09.37-.84.18-1.65-.22-.79-.63-1.38-.94-1.26-.3.09-.38.83-.18,1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-602",
    d: "m102.28,65c.12.83.51,1.44.8,1.39.32-.09.47-.8.34-1.63-.14-.84-.52-1.44-.83-1.38-.31.07-.45.8-.31,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-834",
    d: "m101.05,65.71c.15.84.51,1.43.82,1.39.31-.06.47-.8.32-1.63-.12-.84-.47-1.44-.79-1.39-.33.08-.48.8-.35,1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-876",
    d: "m99.83,65.94c-.03.85.2,1.54.51,1.56.33.04.62-.65.64-1.49.04-.84-.2-1.55-.5-1.57-.32,0-.6.68-.65,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "m98.76,65.74c-.04.83.21,1.54.52,1.54.33.02.6-.64.64-1.49.04-.85-.2-1.53-.52-1.54-.32-.02-.6.64-.63,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "m97.37,65.81c-.04.84.2,1.55.52,1.56.32,0,.6-.66.64-1.49.04-.85-.2-1.54-.53-1.57-.31,0-.6.67-.63,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-582",
    d: "m96.3,65.14c-.04.85.2,1.55.51,1.57.32,0,.6-.66.65-1.49.03-.85-.2-1.54-.52-1.57-.31,0-.6.67-.63,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-257",
    d: "m95.58,64.4c-.24.78-.21,1.53.09,1.64.3.14.75-.42,1-1.21.26-.78.2-1.53-.09-1.65-.31-.12-.75.43-1,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "m95.8,63.37c.32-.76.36-1.49.06-1.65-.28-.15-.78.32-1.1,1.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "m102.68,63.22c.16.84.58,1.45.93,1.39.36-.07.52-.8.36-1.63-.15-.85-.57-1.45-.92-1.37-.35.06-.52.78-.37,1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-891",
    d: "m103.39,62.49c.16.82.57,1.43.93,1.37.36-.07.51-.8.36-1.61-.17-.83-.58-1.45-.93-1.38-.36.06-.51.79-.36,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-806",
    d: "m101.3,63.93c.16.84.56,1.46.92,1.39.36-.06.53-.78.37-1.61-.14-.84-.54-1.45-.91-1.39-.37.06-.53.79-.37,1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "m99.93,64.17c-.04.85.22,1.55.58,1.56.36.02.69-.65.73-1.49.04-.85-.22-1.53-.58-1.56-.37-.03-.7.65-.73,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-917",
    d: "m98.71,63.95c-.04.85.24,1.55.59,1.57.36.02.68-.65.72-1.49.03-.86-.21-1.56-.58-1.57-.37,0-.68.64-.73,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-520",
    d: "m97.14,64.03c-.04.84.22,1.53.58,1.55.35.03.68-.65.72-1.49.04-.84-.22-1.52-.58-1.56-.36,0-.68.67-.72,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-435",
    d: "m95.91,63.37c-.04.85.23,1.54.58,1.55.36.02.69-.65.72-1.49.04-.84-.21-1.53-.59-1.54-.36-.03-.68.64-.71,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-338",
    d: "m94.83,62.32c-.28.79-.23,1.54.12,1.65.35.12.85-.41,1.13-1.21.28-.78.23-1.53-.1-1.65-.35-.13-.85.43-1.15,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-903",
    d: "m94.18,61.04c-.38.74-.41,1.49-.08,1.65.31.16.89-.34,1.25-1.1.37-.74.41-1.49.09-1.65-.32-.15-.89.34-1.25,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "m103.69,60.56c.22.82.66,1.39,1,1.29.33-.1.41-.85.19-1.65-.22-.82-.68-1.39-1-1.3-.34.12-.41.85-.19,1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-451",
    d: "m102.54,61.22c.14.84.53,1.45.88,1.38.32-.07.47-.79.33-1.61-.15-.85-.53-1.44-.87-1.39-.34.08-.48.8-.34,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-669",
    d: "m101.23,61.93c.16.82.53,1.45.85,1.39.36-.07.5-.79.36-1.62-.13-.83-.53-1.46-.86-1.4-.34.09-.49.79-.35,1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-454",
    d: "m99.93,62.17c-.04.84.2,1.53.55,1.56.35,0,.65-.67.68-1.51.04-.83-.2-1.53-.54-1.54-.33-.03-.64.64-.68,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-844",
    d: "m98.8,61.95c-.04.85.2,1.55.54,1.57.36,0,.64-.67.68-1.5.03-.84-.2-1.51-.54-1.55-.35-.02-.65.66-.68,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-781",
    d: "m97.3,62.04c-.03.83.21,1.54.55,1.54.34.02.64-.65.68-1.49.05-.84-.2-1.53-.55-1.54-.34-.03-.64.64-.68,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-775",
    d: "m96.14,61.36c-.03.85.2,1.53.54,1.56.35,0,.65-.66.68-1.49.04-.85-.21-1.54-.54-1.55-.34-.02-.65.64-.68,1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-755",
    d: "m95.13,60.31c-.27.79-.22,1.55.1,1.66.32.12.8-.42,1.07-1.21.27-.79.23-1.54-.1-1.65-.32-.13-.79.42-1.07,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-585",
    d: "m94.5,59.03c-.35.76-.38,1.49-.08,1.65.3.17.85-.32,1.19-1.08.34-.75.37-1.49.09-1.65-.33-.16-.85.33-1.2,1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-613",
    d: "m103.69,58.78c.22.81.66,1.4,1,1.28.33-.11.41-.85.19-1.64-.22-.83-.68-1.39-1-1.3-.34.11-.41.85-.19,1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-243",
    d: "m102.54,59.45c.14.83.53,1.44.88,1.36.32-.05.47-.77.33-1.61-.15-.84-.53-1.44-.87-1.38-.34.07-.48.8-.34,1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "m101.23,60.15c.16.85.53,1.46.85,1.39.36-.07.5-.79.36-1.62-.13-.82-.53-1.43-.86-1.38-.34.07-.49.8-.35,1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "m99.93,60.4c-.04.83.2,1.54.55,1.55s.65-.66.68-1.49c.04-.85-.2-1.55-.54-1.56-.33,0-.64.66-.68,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m98.8,60.19c-.04.84.2,1.53.54,1.54.36.02.64-.65.68-1.49.03-.84-.2-1.53-.54-1.54-.35-.03-.65.65-.68,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-554",
    d: "m97.3,60.24c-.03.85.21,1.53.55,1.55.34.04.64-.65.68-1.49.05-.83-.2-1.54-.55-1.55-.34-.02-.64.64-.68,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-648",
    d: "m96.14,59.58c-.03.85.2,1.55.54,1.55.35.02.65-.62.68-1.47.04-.86-.21-1.56-.54-1.56-.34-.02-.65.65-.68,1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "m95.13,58.54c-.27.8-.22,1.53.1,1.66.32.11.8-.43,1.07-1.23.27-.79.23-1.52-.1-1.64-.32-.13-.79.43-1.07,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-589",
    d: "m94.5,57.25c-.35.76-.38,1.49-.08,1.65.3.16.85-.33,1.19-1.08.34-.77.37-1.5.09-1.65-.33-.16-.85.32-1.2,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "m105.91,74.08c1.01,1.24,3.03,3.67,4.15,4.31-.06.19-1.28.53-1.28.53-.88-1.25-4.63-4.7-4.63-4.7,0,0,.19-.28.22-.6.04-.31.12-.31.12-.31,0,0,1.06.3,1.41.76Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-870",
    d: "m108.96,78.47c-.18-.16.12-.64.4-.47.52.32.88.29.87.54-.03.22-.04.12-.2.27-.15.14-.24.43-.54.14-.31-.28-.41-.36-.52-.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-499",
    d: "m108.81,78.37c-.2-.19.1-.68.41-.46.57.36.96.33.96.6,0,.23,0,.12-.18.28-.17.15-.26.44-.6.12-.33-.32-.46-.41-.6-.53"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-870",
    d: "m108.6,78.15c-.19-.11.08-.64.37-.48.49.24.84.16.85.41,0,.21-.02.14-.16.29-.16.17-.24.47-.52.21-.32-.26-.44-.32-.53-.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-712",
    d: "m108.46,78.08c-.2-.15.04-.67.36-.49.56.27.93.2.96.47,0,.22-.02.12-.18.3-.16.14-.22.45-.56.18-.36-.28-.46-.36-.59-.46"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-870",
    d: "m108.06,77.6c-.17-.18.13-.64.44-.44.51.39.9.36.89.62-.02.21-.04.12-.21.27-.17.12-.28.42-.58.1-.29-.32-.42-.42-.53-.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-689",
    d: "m107.91,77.47c-.19-.19.11-.68.44-.42.6.42.98.42.98.69,0,.24-.02.13-.2.25-.17.15-.28.44-.62.1-.34-.37-.46-.46-.6-.62"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-870",
    d: "m107.66,77.11c-.15-.2.28-.67.52-.41.45.44.87.45.8.72-.04.25-.04.14-.26.26-.22.11-.38.42-.63.05-.24-.36-.36-.48-.44-.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "m107.53,76.97c-.16-.23.26-.71.53-.41.53.49.94.53.9.82-.05.25-.05.13-.27.25-.22.12-.37.43-.67.04-.28-.42-.38-.53-.5-.69"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-870",
    d: "m107.17,76.58c-.15-.19.28-.65.52-.38.47.42.88.45.81.71-.05.24-.05.14-.28.25-.2.13-.37.43-.62.06-.24-.38-.36-.48-.44-.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "m107.06,76.46c-.18-.23.24-.69.52-.42.52.51.97.54.9.84-.06.24-.05.13-.27.26-.2.12-.37.42-.66.02-.29-.41-.39-.53-.49-.69"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-870",
    d: "m106.75,76.16c-.13-.19.28-.66.53-.39.46.44.87.45.8.73-.06.24-.05.12-.26.25-.21.11-.37.41-.62.04-.26-.35-.36-.46-.45-.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-780",
    d: "m106.62,76.03c-.15-.23.26-.68.53-.41.52.5.94.53.89.84-.04.24-.04.12-.26.26-.21.11-.37.4-.65.02-.29-.42-.4-.53-.52-.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-870",
    d: "m106.35,75.73c-.15-.19.28-.66.54-.43.45.43.89.45.8.74-.05.22-.04.12-.27.26-.21.13-.4.44-.63.07-.27-.38-.36-.48-.44-.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "m106.22,75.6c-.18-.23.26-.7.54-.42.52.47.97.52.9.81-.07.26-.05.15-.29.26-.22.12-.38.42-.66.04-.29-.4-.41-.53-.5-.68"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-870",
    d: "m105.96,75.28c-.14-.2.29-.68.54-.42.47.42.88.43.82.72-.07.23-.06.14-.28.26-.22.14-.41.43-.64.07-.25-.36-.35-.47-.44-.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m105.82,75.14c-.16-.22.29-.71.57-.42.51.49.95.53.89.82-.05.26-.05.13-.28.26-.2.13-.39.44-.68.02-.27-.38-.37-.52-.49-.68"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-870",
    d: "m105.51,74.94c-.16-.2.3-.76.57-.53.5.38.94.36.86.67-.06.23-.05.14-.29.3-.23.17-.41.51-.69.15-.26-.34-.37-.45-.45-.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-350",
    d: "m105.38,74.8c-.19-.22.26-.79.57-.52.55.44,1.02.44.95.76-.06.25-.04.15-.28.3-.23.16-.41.5-.71.12-.32-.38-.42-.5-.53-.65"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-870",
    d: "m105.08,74.5c-.17-.19.3-.76.57-.51.52.38.93.33.88.64-.07.27-.07.15-.29.32-.24.16-.42.5-.68.16-.27-.36-.37-.47-.48-.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "m104.95,74.4c-.19-.24.27-.8.58-.53.55.43,1.01.42.94.74-.04.28-.04.16-.28.32-.23.16-.4.52-.7.12-.31-.4-.44-.5-.54-.65"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-870",
    d: "m104.68,74.08c-.18-.2.24-.75.52-.51.51.38.92.35.88.66-.05.23-.05.13-.27.3-.22.13-.37.46-.64.12-.29-.35-.4-.44-.49-.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-439",
    d: "m104.55,73.96c-.2-.22.21-.76.52-.5.55.43,1.01.43.96.73-.04.27-.04.14-.27.3-.21.14-.37.47-.68.11-.32-.37-.45-.5-.54-.64"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-870",
    d: "m104.85,73.11c.49.42.91.38.83.69-.05.26-.05.13-.28.3-.22.14-.4.48-.66.12-.27-.36,0-.64-.1-.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-776",
    d: "m104.46,73.08c.55.47,1.25.36,1.18.68-.05.26-.05.15-.28.3-.23.16-.41.49-.69.09-.29-.39-.08-.4-.18-.55"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-870",
    d: "m104.68,72.99c.33.21.68.09.6.34-.08.24-.05.14-.27.32-.18.18-.32.46-.52.27-.09-.09.15-.49.09-.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "m104.38,72.95c.09-.04.16-.05.21,0,.39.22.73.12.66.37-.07.24-.05.12-.24.32-.2.17-.37.5-.58.26-.03-.07-.06-.11-.11-.15.02-.21.1-.5.05-.79"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "m127.08,68.92s-2.1,2.18-1.22,3.58c.9,1.41,2.51,4.19,2.51,4.19l3.27-1.11s1.26-1.37.25-2.78c-1-1.39-4.09-2.44-3.52-3.88.54-1.46-1.29,0-1.29,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-624",
    d: "m101.55,79.45c2.07.97,3.17,1.31,3.17,1.31,0,0,4.98-2.87,13.88-1.16,4.86,1.3,8.2,2.68,10.28,1.3,1.5-.96,2.27-3.34,2.62-4.92-5.05,1.34-1.53,1.59-10.74-1.3-12.18-3.82-18.89,4.56-19.21,4.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-630",
    d: "m101.27,79.39c1.77.85,3.27,1.33,3.27,1.33,0,0,5.11-2.96,14.24-1.21,4.97,1.33,8.4,2.73,10.53,1.33,2.4-1.54,2.98-6.58,2.98-6.58,0,0-1.85,3.18-11.29.24-11.14-3.47-17.83,2.95-19.35,4.54-.19.2-.36.34-.38.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "m132.31,74.22c-.2.28-.49.5-.78.68-.28.18-.6.32-.93.44-.66.21-1.36.32-2.05.37-1.38.08-2.78-.08-4.13-.36-1.37-.25-2.72-.67-4.03-1.07-1.33-.39-2.7-.64-4.07-.76-2.77-.22-5.57.18-8.14,1.17-1.28.52-2.53,1.16-3.66,1.94-1.14.77-2.18,1.68-3.16,2.68v-.02c1.85-2.05,4.19-3.68,6.78-4.71,2.57-1.02,5.41-1.39,8.17-1.13,1.38.13,2.75.41,4.08.77,1.33.4,2.66.8,4.03,1.04,1.35.25,2.74.43,4.12.35.68-.04,1.37-.13,2.03-.35.32-.11.64-.24.94-.41.29-.19.58-.4.78-.68l.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-823",
    d: "m73.36,68.91s2.11,2.18,1.22,3.58c-.89,1.42-2.5,4.18-2.5,4.18l-3.28-1.09s-1.26-1.39-.27-2.78c1.02-1.39,4.11-2.45,3.55-3.9-.56-1.44,1.28,0,1.28,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-624",
    d: "m98.89,79.35c-2.98,1.3-3.14,1.33-3.14,1.33,0,0-5.01-2.89-13.91-1.18-4.85,1.32-8.2,2.68-10.28,1.32-1.5-.98-2.27-3.34-2.62-4.93,5.04,1.35,1.53,1.58,10.73-1.31,12.19-3.82,18.92,4.55,19.23,4.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-819",
    d: "m99.15,79.27c-1.79.84-3.22,1.34-3.22,1.34,0,0-5.14-2.93-14.26-1.18-4.99,1.31-8.42,2.71-10.55,1.33-2.39-1.54-2.97-6.6-2.97-6.6,0,0,1.86,3.21,11.3.25,12.48-3.89,19.35,4.66,19.69,4.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "m68.15,74.15c.2.28.49.49.78.66.29.19.62.32.93.44.68.2,1.35.32,2.05.34,1.39.07,2.76-.1,4.12-.34,1.36-.27,2.7-.65,4.02-1.03,1.34-.39,2.71-.67,4.09-.78,2.77-.28,5.6.11,8.19,1.14,2.59,1.01,4.93,2.66,6.8,4.7h-.03c-.98-.99-2.02-1.89-3.16-2.69-1.15-.76-2.37-1.41-3.66-1.91-2.57-1.02-5.38-1.4-8.15-1.18-1.38.12-2.75.37-4.07.75-.66.2-1.33.43-2,.59-.67.21-1.34.36-2.02.5-1.36.28-2.75.44-4.15.34-.7-.04-1.41-.13-2.06-.37-.33-.1-.64-.24-.93-.42-.29-.2-.58-.41-.77-.71h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-912",
    d: "m76.39,79.08h.11l-.3,1.17-2.68.43v-.12h.13c.16-.02.26-.11.31-.23.04-.08.05-.22.05-.46l-.04-2.67c0-.27-.03-.43-.07-.47-.07-.09-.18-.12-.31-.1h-.12s0-.09,0-.09l1.57-.25v.11c-.18.03-.31.06-.38.12-.07.05-.12.12-.16.2,0,.06-.04.22-.02.47l.02,2.62c0,.17.03.28.05.34.03.04.04.06.09.09.04,0,.18,0,.4-.04l.26-.04c.26-.04.44-.1.55-.17.12-.05.21-.15.29-.29.09-.13.16-.35.25-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-912",
    d: "m77.85,76.73l.02,1.98c0,.13,0,.24.04.29.03.06.04.08.1.08.04.03.12,0,.23-.02v.07l-1.17.43v-.12c.12-.02.2-.06.23-.11.04-.04.08-.09.11-.16.02-.05.02-.16.02-.33v-.95c0-.27,0-.44-.02-.5,0-.07-.04-.09-.07-.11,0-.02-.04-.02-.1,0-.04.02-.12.04-.18.12l-.04-.1.73-.56.12-.02Zm-.22-1.25c.08-.03.13-.03.19,0,.05.05.09.11.09.18,0,.08-.04.14-.09.22-.05.08-.11.12-.18.14-.08.04-.14.04-.2,0-.04-.04-.08-.1-.08-.17s.04-.14.08-.23c.05-.05.11-.11.19-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-912",
    d: "m79.05,76.74c.24-.44.51-.7.79-.81.28-.11.5-.11.7.04.19.13.28.39.28.76,0,.42-.18.83-.47,1.22-.27.33-.56.54-.87.68-.15.08-.31.1-.45.11-.14.02-.31,0-.46-.03l.02-2.53c0-.27,0-.44,0-.5-.04-.05-.04-.09-.06-.1-.04,0-.08,0-.12,0-.05.04-.11.06-.19.12l-.05-.08.78-.59.12-.07v1.78Zm0,.17l-.03,1.45c.1.04.2.07.3.08.1,0,.2,0,.31-.04.16-.08.33-.23.47-.45.13-.25.22-.53.22-.88,0-.3-.07-.51-.21-.62-.14-.12-.3-.12-.48-.04-.11.04-.2.1-.3.18-.08.07-.18.17-.28.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-912",
    d: "m81.84,76.48c0,.41.1.71.31.9.2.18.43.22.68.18.19-.06.36-.14.48-.28.14-.13.25-.34.36-.6l.07.06c-.03.25-.16.54-.36.82-.19.28-.45.44-.76.52-.32.07-.62.02-.85-.18-.22-.2-.35-.5-.35-.94.02-.46.12-.85.37-1.17.24-.34.54-.53.92-.62.29-.07.55-.04.75.11.21.16.31.4.28.74l-1.9.46Zm0-.16l1.27-.32c0-.18-.02-.29-.04-.36-.05-.09-.13-.16-.23-.2-.1-.04-.21-.04-.3,0-.16.02-.33.13-.45.29-.14.16-.2.35-.24.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-912",
    d: "m84.94,75.12v.58c.24-.4.49-.58.72-.58.12,0,.2.04.29.1.07.05.12.12.12.21,0,.06-.04.14-.09.19-.05.04-.12.08-.19.08-.08,0-.16-.04-.23-.1-.11-.06-.16-.11-.21-.11-.04,0-.08.03-.12.07-.09.06-.18.2-.28.36v1.25c0,.14.02.25.06.32.03.05.07.1.13.13.08.04.18.04.3.04v.11h-1.46v-.11c.15,0,.26,0,.33-.06.04-.03.09-.06.11-.14,0-.04,0-.11,0-.27v-1.01c0-.3,0-.48,0-.54-.02-.04-.04-.09-.09-.12-.03-.04-.08-.05-.12-.05-.07,0-.16,0-.23.05l-.03-.1.85-.32h.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-912",
    d: "m87.16,74.73v.77h.69v.2h-.69v1.55c0,.16.03.26.08.31.06.05.13.08.21.08s.13,0,.22-.05c.05-.03.1-.09.14-.16h.12c-.09.18-.18.31-.31.39-.14.08-.28.13-.44.13-.1,0-.2-.03-.28-.07-.1-.05-.17-.11-.23-.19-.04-.09-.04-.22-.04-.38v-1.61h-.48v-.09c.12-.04.23-.12.37-.2.12-.09.24-.19.34-.31.04-.06.11-.19.2-.37h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-912",
    d: "m89.55,77.73c-.25.18-.38.3-.44.32-.1.04-.2.07-.3.07-.17,0-.29-.06-.39-.17-.11-.12-.16-.26-.16-.44,0-.11.02-.21.07-.29.07-.12.2-.25.37-.34.16-.11.46-.23.85-.37v-.11c0-.23-.03-.39-.12-.47-.06-.1-.18-.13-.32-.13-.1,0-.2.02-.26.09-.06.04-.09.12-.09.19v.14c0,.09-.02.15-.06.2-.03.03-.08.04-.14.04-.07,0-.12-.02-.17-.05-.04-.04-.05-.11-.05-.2,0-.14.07-.28.23-.41.13-.11.35-.18.61-.18.2,0,.39.04.52.12.1.04.18.13.22.24.03.08.04.22.04.46v.79c0,.22,0,.36.02.42,0,.05.02.08.04.11.02,0,.04.02.08.02.03,0,.04,0,.06-.02.04-.03.11-.08.2-.19v.14c-.18.26-.36.37-.54.37-.07,0-.15,0-.18-.06-.06-.08-.09-.19-.09-.31Zm0-.17v-.9c-.27.1-.43.18-.49.22-.14.07-.25.16-.29.23-.07.09-.09.18-.09.27,0,.12.04.23.12.31.06.08.15.12.24.12.13,0,.3-.09.52-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-912",
    d: "m91.8,78.37c-.11.12-.2.19-.28.24-.1.05-.2.07-.31.07-.2,0-.41-.1-.56-.28-.18-.22-.26-.47-.26-.79s.09-.6.28-.86c.18-.27.42-.37.69-.37.19,0,.33.05.44.18v-.4c0-.26,0-.42-.02-.47,0-.05-.02-.1-.05-.11-.02-.03-.04-.04-.1-.04-.03,0-.08.02-.13.04l-.04-.09.6-.26h.09v2.53c0,.25.03.4.04.47,0,.06.03.1.05.11.03.04.06.04.08.04.04,0,.1,0,.16-.05l.02.1-.59.27h-.11v-.31Zm0-.16v-1.15c-.02-.11-.04-.21-.08-.29-.04-.11-.1-.16-.18-.21-.08-.04-.13-.05-.2-.05-.14,0-.25.05-.35.19-.13.15-.2.4-.2.72s.05.57.2.73c.12.18.27.29.42.29.12,0,.26-.09.38-.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-912",
    d: "m105.85,76.25l1.15-.32v.11l-.03.02c-.1.02-.16.05-.2.09-.03.05-.05.1-.05.15,0,.07.04.14.1.25l.65,1.03.51-1.45c.04-.07.04-.15.04-.22,0-.02,0-.04,0-.04,0-.04-.04-.04-.07-.04s-.1,0-.18.02v-.08l.83-.2v.08c-.07.03-.12.04-.17.09-.03.04-.06.08-.1.14-.02.04-.05.11-.09.22l-.94,2.6c-.09.27-.21.45-.38.61-.15.17-.29.27-.44.29-.11.03-.2.03-.26,0-.09-.04-.12-.1-.12-.18s.03-.13.06-.19c.05-.06.12-.09.2-.13.06,0,.14,0,.26,0h.13c.05,0,.1-.05.16-.12.07-.05.13-.18.2-.35l.15-.46-.96-1.53c-.04-.05-.07-.11-.13-.16-.05-.05-.08-.08-.12-.09-.05-.03-.1-.05-.2-.04v-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-912",
    d: "m113.66,73.87c.46,0,.86.19,1.21.56.36.38.51.85.51,1.41,0,.6-.15,1.08-.51,1.46-.36.38-.77.56-1.26.56s-.92-.16-1.25-.54c-.34-.37-.52-.85-.52-1.45s.2-1.1.59-1.49c.34-.33.75-.5,1.24-.5Zm-.05.21c-.33,0-.6.13-.78.37-.25.31-.37.79-.37,1.38,0,.63.12,1.12.37,1.45.2.27.45.38.78.38s.61-.15.85-.42c.21-.28.32-.73.32-1.32,0-.67-.12-1.16-.36-1.48-.2-.24-.47-.37-.81-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-912",
    d: "m116.95,75.35v.6c.21-.36.43-.52.63-.49.11.03.19.08.25.16.06.08.1.15.1.24,0,.07-.04.13-.08.18-.03.04-.1.07-.16.04-.06,0-.13-.05-.21-.13-.07-.09-.12-.13-.16-.14-.04,0-.07,0-.11.05-.09.06-.17.17-.26.34l-.02,1.27c0,.16.02.28.05.36.03.05.05.12.12.16.05.05.14.07.26.11v.09l-1.24-.24v-.12c.1.03.2.03.26,0,.05-.04.07-.05.11-.13v-.28l.03-1.04c0-.3-.02-.49-.03-.56,0-.06-.04-.1-.05-.14-.04-.04-.08-.05-.11-.05-.07,0-.14,0-.2,0v-.12l.71-.18.11.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-912",
    d: "m119.81,78.28c-.11.13-.22.21-.33.26-.13.05-.25.07-.38.04-.25-.03-.5-.19-.68-.46-.19-.29-.29-.61-.26-1.01,0-.38.12-.74.36-1.04.22-.3.51-.42.85-.37.21.03.39.12.53.29l.02-.51c0-.3,0-.51,0-.57,0-.1-.04-.13-.05-.16-.04-.03-.07-.04-.1-.04-.06-.02-.12,0-.19.02l-.03-.12.73-.23.12.02-.1,3.17c-.02.32-.02.52,0,.59.02.08.04.13.05.17.02.03.07.05.11.05.04,0,.1,0,.18-.04l.04.12-.72.26-.12-.03v-.4Zm0-.2l.04-1.41c0-.14-.03-.26-.09-.4-.03-.11-.11-.19-.19-.27-.1-.06-.18-.1-.25-.11-.17-.03-.3.04-.44.18-.16.19-.25.48-.27.87,0,.4.05.73.21.96.14.23.32.36.51.38.17.03.31-.04.46-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-912",
    d: "m121.5,77.73c0,.37.07.71.27,1,.19.28.42.45.68.54.18.05.31.04.45,0,.13-.05.23-.19.33-.4l.09.09c-.04.26-.17.47-.36.61-.2.15-.43.19-.73.1-.32-.09-.59-.28-.8-.6-.23-.33-.34-.69-.34-1.11,0-.46.12-.77.35-.97.23-.16.52-.2.86-.1.29.09.53.27.73.53.19.26.29.53.29.87l-1.81-.55Zm0-.18l1.19.37c0-.18-.02-.31-.05-.37-.05-.13-.12-.24-.2-.32-.08-.09-.2-.17-.29-.19-.15-.06-.3-.04-.44.05-.13.09-.2.23-.2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-912",
    d: "m124.51,78.22c.29-.34.58-.49.85-.47.13.03.25.07.36.15.11.09.18.2.23.38.04.12.08.3.08.52v1.11c0,.16,0,.27.02.33.02.04.05.09.11.11.05.05.14.06.25.08v.12l-1.25-.14v-.12h.05c.12,0,.2,0,.26-.04.04-.02.08-.07.09-.14,0-.02,0-.11,0-.27v-1.05c0-.24-.02-.4-.09-.52-.06-.13-.15-.19-.29-.2-.22-.02-.46.07-.67.29v1.37c0,.18,0,.28.03.32.03.05.07.1.12.12.04.04.12.06.28.07v.1l-1.27-.12v-.12h.05c.14.03.24,0,.28-.05.04-.05.07-.19.07-.38v-.95c0-.31-.02-.51-.03-.58,0-.05-.04-.1-.05-.15-.03,0-.08-.04-.12-.04-.05,0-.11,0-.19.04l-.03-.11.76-.24.12.03v.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m92.99,74.82c-.1.29-.04.8,0,1.08,0,.11.12.17.13.27.04.13-.03.22-.03.34.03.2.02.4.04.59.11.81.27,1.81.04,2.6.31.03.68.22.95.32,0-1.39,0-2.77,0-4.15,0-.54.03-.59-.46-.83-.23-.12-.48-.25-.71-.27.02.05-.04.09-.04.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "m93.71,74.43s.44,5.19-.12,6.88c.55-.16.59-.1,1.29-.35v-.06c-.19-1.52.32-6.59.32-6.59l-.87-.43-.62.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-926",
    d: "m94.49,80.51c.02-.26-.52-.44-.61-.05-.13.47-.35.74-.36.92.51-.14.47-.09.9-.25.04-.31.05-.45.07-.61"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-870",
    d: "m94.51,80.23c.04-.22-.49-.43-.6-.13-.2.52-.53.69-.36.9.14.15.11.09.33.1.22,0,.49.18.53-.2.05-.38.09-.53.1-.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-815",
    d: "m94.56,80.08c.04-.25-.48-.47-.6-.14-.23.61-.58.79-.4,1,.14.18.1.09.31.12.23,0,.49.19.55-.23.07-.46.12-.58.13-.74"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-870",
    d: "m94.54,79.45c0-.27-.53-.38-.61-.02-.14.6-.43.85-.24,1.03.15.15.1.09.32.05.22,0,.5.13.5-.31s.04-.59.04-.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-331",
    d: "m94.56,79.27c.03-.29-.53-.43-.6-.04-.17.7-.46.97-.28,1.18.16.17.1.08.33.05.21-.03.49.13.52-.36,0-.5.03-.65.03-.84"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-870",
    d: "m94.5,78.82c0-.26-.65-.32-.66.04-.05.63-.34.93-.11,1.08.2.14.12.07.36,0,.25-.04.55.06.5-.38-.05-.44-.05-.59-.1-.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-933",
    d: "m94.5,78.63c0-.28-.65-.35-.66.05-.05.71-.34,1.03-.11,1.21.2.16.12.07.36.03.25-.08.55.04.5-.44-.05-.5-.05-.66-.1-.85"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-870",
    d: "m94.54,78.1c-.04-.25-.67-.31-.69.04-.06.65-.33.93-.11,1.09.21.12.13.06.36.02.26-.07.57.04.52-.4-.06-.42-.06-.57-.08-.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-607",
    d: "m94.54,77.93c-.04-.29-.67-.34-.69.04-.06.72-.33,1.04-.11,1.21.21.17.13.08.36,0,.26-.04.57.08.52-.42-.06-.48-.06-.66-.08-.84"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-870",
    d: "m94.55,77.51c-.04-.26-.65-.3-.67.05-.06.62-.34.92-.1,1.07.2.13.12.08.36,0,.22-.03.55.07.5-.37-.05-.44-.05-.57-.09-.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "m94.55,77.33c-.04-.28-.65-.36-.67.05-.06.71-.34,1.03-.1,1.2.2.15.12.08.36.03.22-.07.55.05.5-.44-.05-.47-.05-.65-.09-.84"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-870",
    d: "m94.56,76.93c-.02-.27-.68-.35-.68.03-.06.63-.36.92-.11,1.09.2.12.12.04.37,0,.23-.05.58.04.51-.38-.05-.44-.05-.58-.09-.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "m94.56,76.73c-.02-.28-.68-.36-.68.04-.06.71-.36,1.04-.11,1.21.2.15.12.07.37,0,.23-.05.58.06.51-.42-.05-.49-.05-.65-.09-.85"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-870",
    d: "m94.56,76.32c-.02-.24-.68-.32-.71.05-.06.61-.35.92-.11,1.07.21.14.13.06.37.02.25-.04.6.05.53-.39-.05-.42-.05-.59-.09-.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "m94.56,76.13c-.02-.28-.68-.36-.71.07-.06.68-.35,1.02-.11,1.2.21.15.13.06.37,0,.25-.04.6.05.53-.44-.05-.5-.05-.66-.09-.85"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-870",
    d: "m94.65,75.76c0-.26-.73-.36-.77,0-.13.61-.46.88-.21,1.04.22.16.15.09.44.04.27,0,.64.12.6-.33-.04-.44-.02-.58-.04-.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m94.67,75.58c-.02-.3-.73-.41-.78,0-.12.69-.47,1-.2,1.18.2.18.13.08.42.04.27-.04.64.12.6-.37-.02-.49,0-.66-.03-.85"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-870",
    d: "m94.69,75.16c0-.25-.72-.37-.77-.02-.12.63-.48.89-.2,1.08.22.15.14.07.41.04.29-.04.66.12.62-.35-.04-.43-.04-.59-.05-.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-356",
    d: "m94.7,74.96c0-.28-.72-.38-.77,0-.12.69-.46,1.01-.21,1.19.22.16.14.09.41.05.29-.05.66.1.62-.39-.04-.5-.02-.65-.04-.85"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-870",
    d: "m94.7,74.57c0-.26-.67-.38-.73-.03-.12.62-.44.89-.2,1.07.2.14.12.06.38.04.26-.04.6.11.57-.34-.03-.43,0-.58-.03-.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-440",
    d: "m94.72,74.4c0-.29-.68-.43-.73-.03-.14.7-.47,1-.22,1.2.2.16.12.06.4.04.25-.04.59.11.57-.38-.02-.49,0-.65-.02-.84"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-870",
    d: "m94.69,73.96c-.02-.26-.72-.36-.76,0-.09.63-.43.91-.19,1.08.23.13.16.06.44.04.25-.04.62.07.56-.36-.04-.46-.04-.59-.05-.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "m94.7,73.75c-.02-.28-.7-.37-.76.03-.1.7-.44,1.01-.17,1.2.22.15.13.07.41.02.25-.04.62.1.56-.4-.04-.47-.02-.64-.04-.85"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-870",
    d: "m94.7,73.84c0-.13-.67-.29-.73-.08-.12.39-.44.52-.2.67.2.12.12.04.37.06.27,0,.6.12.58-.16-.03-.27,0-.36-.03-.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "m94.72,73.74c0-.19-.68-.32-.73-.09-.14.45-.47.59-.22.75.2.11.12.05.4.06.24,0,.59.12.57-.2-.02-.29-.02-.39-.02-.52"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-817",
    d: "m54.02,60.92s-8.36,5.95-8.69,8.43c-.33,2.47,8.29-6.12,9.88-6.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-527",
    d: "m56.32,59.22s-8.22,6.13-8.49,8.63c-.29,2.48,8.14-6.3,9.71-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-657",
    d: "m57.98,59.77s-7.81,6.02-7.95,8.22c-.12,2.19,7.75-6.18,9.27-7.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-782",
    d: "m64.53,58.37s-7.83,6.03-7.98,8.22c-.14,2.18,7.76-6.17,9.28-7.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-690",
    d: "m61.13,59.06s-7.82,6.02-7.96,8.22c-.13,2.19,7.76-6.18,9.27-7.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-601",
    d: "m60.62,56.34s-9.21,5.5-9.96,8.44c-.76,2.95,9.21-5.71,10.92-6.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "m62.16,57.4s-8.81,5.45-9.37,8.08c-.54,2.62,8.8-5.67,10.45-6.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-778",
    d: "m64.21,58.05s-8.83,5.48-9.37,8.08c-.55,2.63,8.79-5.66,10.45-6.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-324",
    d: "m68.85,57.22s-8.83,5.48-9.36,8.09c-.56,2.61,8.77-5.67,10.43-6.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "m71.88,57.01s-8.83,5.47-9.37,8.09c-.55,2.62,8.77-5.66,10.44-6.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "m64.9,52.23s-9.22,5.49-9.97,8.44c-.77,2.94,9.18-5.72,10.9-6.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-714",
    d: "m66.42,53.26s-8.81,5.48-9.37,8.1c-.53,2.61,8.79-5.67,10.46-6.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "m68.47,53.91s-8.82,5.49-9.37,8.1c-.54,2.61,8.79-5.66,10.45-6.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-600",
    d: "m71.07,54.35s-8.82,5.48-9.37,8.09c-.55,2.63,8.79-5.67,10.44-6.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-361",
    d: "m73.68,54.76s-8.82,5.47-9.37,8.09c-.55,2.62,8.79-5.66,10.45-6.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m76.28,55.2s-8.83,5.47-9.37,8.08c-.56,2.62,8.77-5.67,10.44-6.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-906",
    d: "m78.89,54.99s-7.66,4.81-8.13,7.15c-.48,2.3,7.61-5.01,9.06-5.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "m81.94,53.64s-7.64,4.84-8.11,7.13c-.47,2.33,7.61-5,9.05-5.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-542",
    d: "m71.39,47.88s-9.65,4.69-10.64,7.56c-1.01,2.89,9.62-4.91,11.4-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-304",
    d: "m72.82,49.05s-9.25,4.71-10.01,7.28c-.77,2.56,9.21-4.93,10.93-5.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-312",
    d: "m74.81,49.87s-9.25,4.71-10.02,7.28c-.77,2.55,9.22-4.92,10.95-5.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "m77.36,50.52s-9.24,4.7-10,7.28c-.77,2.56,9.21-4.92,10.94-5.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-759",
    d: "m79.92,51.16s-9.25,4.71-10.02,7.27c-.77,2.57,9.21-4.9,10.95-5.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-653",
    d: "m82.47,51.79s-9.25,4.73-10.01,7.28c-.76,2.56,9.22-4.92,10.94-5.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "m85.1,51.81s-8.02,4.16-8.71,6.44c-.65,2.27,8.02-4.36,9.5-4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-872",
    d: "m88.26,50.72s-8.03,4.18-8.7,6.44c-.67,2.28,8-4.34,9.5-4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-563",
    d: "m77.49,44.56s-10,3.93-11.22,6.73c-1.21,2.78,10.01-4.15,11.81-4.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-677",
    d: "m78.84,45.84s-9.6,3.98-10.57,6.48c-.96,2.5,9.58-4.16,11.37-4.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "m80.76,47s-9.61,3.98-10.58,6.47c-.95,2.51,9.57-4.17,11.36-4.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-599",
    d: "m83.25,47.67s-9.6,3.98-10.56,6.47c-.97,2.48,9.57-4.16,11.34-4.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-450",
    d: "m85.75,48.49s-9.6,4-10.56,6.49c-.96,2.5,9.57-4.18,11.34-4.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-446",
    d: "m88.23,49.34s-9.58,3.98-10.55,6.49c-.96,2.5,9.59-4.18,11.34-4.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "m90.84,49.55s-8.33,3.54-9.17,5.75c-.85,2.2,8.32-3.72,9.86-4.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-785",
    d: "m77.98,54.72l-1.21-.84s-2.42,2.2-1.8,4.13c.82,1.59,3.01-3.28,3.01-3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-748",
    d: "m78.97,55.58l-1.21-.86s-2.43,2.21-1.8,4.14c.81,1.59,3.01-3.27,3.01-3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "m79.8,56.38l-1.25-.76s-2.26,2.37-1.49,4.26c.92,1.52,2.75-3.5,2.75-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "m82.08,57.32l-1.59-1.08s-3.68,2.38-2.14,5.71c1.17,2.12,3.74-4.62,3.74-4.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-462",
    d: "m82.71,57.35l-1.72-.66s-2.34,3.36-.99,5.51c1.48,1.66,2.71-4.85,2.71-4.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-531",
    d: "m83.32,57.37l-1.35-.54s-1.85,2.72-.78,4.44c1.17,1.35,2.13-3.9,2.13-3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-323",
    d: "m84.38,57.9l-1.13-.5s-1.49,2.33-.59,3.85c.98,1.17,1.72-3.35,1.72-3.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-276",
    d: "m85.28,58.22l-1.12-.22s-1.33,2.06-.41,3.13c1.01.8,1.53-2.91,1.53-2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-741",
    d: "m86.22,58.79l-1.12-.79s-1.16,2.51-.34,2.99c1.08.62,1.46-2.2,1.46-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-548",
    d: "m87.29,59.6l-1.07-.94s-1.33,1.54-.45,3.1c.89,1.56,1.52-2.16,1.52-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-895",
    d: "m87.89,60.18c0-.1-1.11-1.02-1.11-1.02,0,0-1.01,2.37-.2,3.69.83,1.37,1.09-.18,1.32-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-818",
    d: "m90.11,60.4l-1.45-1.61s-2.21,3.85-.44,5.11c1.28,1.09,1.16.53,1.44-1.02.29-1.55.44-2.48.44-2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "m92.18,61.26l-2.06-1.34s-1.49,4.22,1.03,4.86c1.48.34,1.03-3.05,1.03-3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-764",
    d: "m93.81,60.1l-1.58-.82s-1.18,4.5.8,5.5c1.99,1.01.47-2.35.78-4.68Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "m82.17,50.54l-.86-1.49s-5.73,3.84-4.67,5.46c1.05,1.65,3.54-2.62,5.53-3.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-315",
    d: "m83.32,51.31l-.87-1.49s-5.73,3.83-4.68,5.47c1.07,1.64,3.54-2.63,5.55-3.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-637",
    d: "m83.87,52.06l-1.09-1.37s-5.1,4.64-3.82,6.1c1.29,1.48,3.11-3.11,4.9-4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-566",
    d: "m84.98,52.91l-1.08-1.37s-5.11,4.65-3.82,6.09c1.28,1.48,3.11-3.12,4.9-4.72Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "m85.38,54.09l-1.2-1.33s-3.39,3.79-2,5.22c1.39,1.45,2-2.58,3.2-3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-567",
    d: "m86.53,54.72l-1.18-1.31s-3.37,3.78-2,5.21c1.39,1.44,2-2.57,3.18-3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m87.22,55.38l-1.3-1.17s-2.63,4.46-1.12,5.73c1.5,1.28,1.49-2.99,2.42-4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-829",
    d: "m88.39,56.09l-1.3-1.18s-2.63,4.47-1.11,5.75c1.49,1.27,1.49-3.01,2.41-4.56Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-413",
    d: "m89.73,56.87l-1.38-.93s-2.75,3.58-1.16,4.58c1.6,1.01,1.57-2.37,2.53-3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-668",
    d: "m90.99,57.26l-1.39-.93s-2.74,3.58-1.16,4.58c1.59,1.01,1.57-2.38,2.54-3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-496",
    d: "m91.76,57.71l-1.48-.81s-1.87,4.05-.18,4.89c1.67.85,1-2.68,1.65-4.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-351",
    d: "m93.01,58.15l-1.47-.83s-1.89,4.06-.18,4.89c1.68.88,1-2.67,1.65-4.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-579",
    d: "m77.55,44.19s-5.25,2.04-6.08,3.58c-.85,1.53.46.77,1.28.71.84-.07,5.35-2.99,5.56-3.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-535",
    d: "m78.54,45.08s-5.25,2.05-6.08,3.57c-.85,1.54.46.77,1.28.72.84-.04,5.36-2.97,5.56-3.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-800",
    d: "m77.94,46.82s-5.04,2.5-5.75,3.91c-.71,1.43.51.59,1.33.43.8-.18,5.06-3.33,5.25-3.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-849",
    d: "m81.36,42.64s-6.47,1.49-7.69,2.98c-1.22,1.52.41.88,1.4.93.99.02,6.74-2.48,7-2.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-907",
    d: "m82.96,42.6s-6.47,1.48-7.7,2.97c-1.25,1.52.41.86,1.4.92.98.03,6.75-2.49,6.99-2.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m80.09,46.06s-4.96,2.61-5.64,4.16c-.67,1.55.54.65,1.36.5.82-.18,4.97-3.54,5.16-3.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m83.57,46.15s-5.86,1.43-6.97,3.22c-1.13,1.78.36,1.08,1.24,1.18.88.12,6.12-2.64,6.34-2.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-634",
    d: "m85.57,46.34s-5.84,1.45-6.98,3.22c-1.12,1.79.38,1.1,1.25,1.2.89.11,6.11-2.64,6.32-2.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-659",
    d: "m93.99,57.59l-1.29.56s-1.73,4.77.14,4.7c1.44-.04,1.36-3.79,1.15-5.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-880",
    d: "m86.53,46.79s-4.77,1.11-5.76,2.82c-.98,1.74.26,1.12.96,1.28.7.15,5.04-2.32,5.2-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-517",
    d: "m87.11,48.25s-4.17,1.31-4.94,2.92c-.77,1.58.3.99.93,1.07.64.09,4.31-2.4,4.47-2.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "m87.4,49.94s-3.57,1.15-4.21,2.58c-.64,1.41.27.86.8.94.54.09,3.68-2.11,3.81-2.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-720",
    d: "m87.76,51.26s-2.76,1-3.25,2.29c-.48,1.27.2.8.62.87.43.08,2.83-1.89,2.93-1.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m87.96,52.23s-2.45,1.21-2.8,2.65c-.36,1.44.24.86.63.95.4.08,2.48-2.19,2.57-2.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-396",
    d: "m88.4,53.02s-1.66,1.48-1.65,3c0,1.51.36.85.68.91.33.04,1.49-2.48,1.57-2.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-384",
    d: "m88.99,53.82s-1.57,2.05-.6,3.12c.95,1.06,1.72-1.92,1.72-1.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-879",
    d: "m90.22,54.44s-1.58,2.05-.61,3.1c.95,1.07,1.73-1.92,1.73-1.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-672",
    d: "m91.24,55.22s-1.57,2.05-.6,3.12c.93,1.06,1.73-1.92,1.73-1.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "m93.21,55.13s-2.73,3.41-1.76,4.46c.96,1.08,2.12-2.33,2.12-2.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "m93.34,55.97c-.04.7-1.48,3.5-.63,4.65,2.17,2.97,1.07-3.77,1.03-3.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "m82.66,42.42c-.58.46-1.49.73-2.15.92-.3.11-.76.3-.81.64-.15.69.86.55,1.26.45.8-.19,1.48-.3,2.36-.21,1.28.13,2.54.41,3.84.4.6-.03,1.2-.16,1.79,0,.72.18,1.37.6,1.8,1.22.8,1.2.6,2.65.33,3.95-.08.39-.21,1.78.52,1.39.88-.48.9-2.37.93-3.24,0-1.2.33-2.34.36-3.54.02-.7-.52-1.13-1.16-1.31-1.66-.53-3.27-.97-5.03-.94-.78,0-1.6.05-2.37.2-.6.12-1.48.08-2.01.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-305",
    d: "m76.19,47.97c.24.35,1.49-.04,2.8-.83.64-.38,1.17-.77,1.51-1.15.4-.4-.21-1.08-.9-.83-.44.17-.94.4-1.45.74-1.33.78-2.19,1.72-1.97,2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "m78.9,47.97c.22.35,1.49-.04,2.82-.83.61-.38,1.12-.77,1.48-1.15.4-.4-.19-1.08-.9-.83-.43.17-.94.4-1.44.74-1.32.78-2.2,1.72-1.97,2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m81.33,47.97c.22.35,1.49-.04,2.81-.83.62-.38,1.13-.77,1.49-1.15.4-.4-.2-1.08-.89-.83-.44.17-.93.4-1.45.74-1.32.78-2.2,1.72-1.96,2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m83.48,48.22c.24.35,1.49-.02,2.81-.83.63-.37,1.14-.79,1.49-1.14.4-.41-.21-1.09-.89-.84-.43.18-.94.42-1.44.74-1.33.79-2.2,1.73-1.97,2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "m85.62,48.56c.23.34,1.5-.04,2.82-.84.62-.36,1.14-.77,1.49-1.14.4-.4-.2-1.08-.9-.83-.45.17-.94.43-1.45.73-1.32.78-2.19,1.73-1.97,2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-480",
    d: "m86.66,50.1c.32.29,1.46-.32,2.58-1.37.51-.49.93-1,1.19-1.41.29-.47-.46-1.01-1.08-.63-.38.26-.82.61-1.25,1-1.09,1.06-1.73,2.14-1.44,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "m76.43,46.85c.23.35,1.5-.03,2.81-.83.6-.37,1.14-.78,1.49-1.13.39-.4-.22-1.08-.9-.83-.44.16-.93.42-1.44.73-1.32.77-2.2,1.72-1.97,2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-569",
    d: "m79.12,46.85c.25.35,1.49-.03,2.81-.83.63-.37,1.16-.78,1.49-1.13.41-.4-.22-1.08-.9-.83-.44.16-.94.42-1.45.73-1.33.77-2.18,1.72-1.96,2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-490",
    d: "m81.54,46.85c.25.35,1.49-.03,2.81-.83.62-.37,1.15-.78,1.5-1.13.39-.4-.22-1.08-.91-.83-.44.16-.93.42-1.45.73-1.32.77-2.19,1.72-1.96,2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-651",
    d: "m83.69,47.1c.25.36,1.49,0,2.82-.81.61-.37,1.13-.78,1.49-1.14.41-.41-.22-1.09-.9-.82-.45.15-.94.38-1.45.69-1.33.81-2.2,1.73-1.97,2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-786",
    d: "m85.85,47.45c.24.34,1.5-.04,2.81-.85.62-.36,1.14-.76,1.48-1.13.41-.41-.19-1.08-.89-.82-.44.16-.95.41-1.46.71-1.32.82-2.19,1.73-1.95,2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "m86.91,49.01c.28.28,1.44-.34,2.55-1.38.51-.49.93-1,1.19-1.43.3-.47-.45-1.01-1.06-.63-.41.27-.85.61-1.25,1.01-1.11,1.05-1.74,2.12-1.43,2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-532",
    d: "m87.3,50.6c.32.27,1.42-.4,2.46-1.5.5-.53.88-1.05,1.12-1.47.27-.49-.52-1-1.08-.58-.4.27-.8.63-1.2,1.07-1.04,1.1-1.62,2.22-1.29,2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-397",
    d: "m87.23,51.92c.28.23,1.22-.35,2.1-1.28.42-.44.74-.89.94-1.25.23-.41-.43-.85-.93-.49-.32.24-.66.53-1,.92-.89.92-1.39,1.87-1.11,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "m87.18,53.55c.31.23,1.24-.3,2.08-1.2.4-.43.71-.87.91-1.23.2-.41-.51-.88-1-.53-.31.22-.65.5-1,.85-.84.92-1.29,1.84-1,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-851",
    d: "m87.19,55.17c.27.21,1.12-.29,1.89-1.14.36-.38.66-.79.83-1.12.2-.38-.44-.8-.89-.48-.28.2-.6.49-.91.81-.77.83-1.18,1.69-.92,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-794",
    d: "m88.07,55.73c.26.22.95-.09,1.53-.71.27-.28.46-.59.57-.84.12-.3-.5-.73-.86-.51-.22.13-.45.33-.68.55-.56.61-.83,1.29-.56,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "m88.83,56.66c.27.21.96-.1,1.51-.72.29-.27.48-.59.59-.84.12-.29-.5-.73-.85-.51-.21.13-.46.32-.68.54-.58.62-.82,1.29-.56,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-699",
    d: "m89.92,57.26c.27.22.94-.09,1.52-.7.27-.29.46-.59.59-.85.1-.29-.52-.72-.86-.51-.23.13-.47.31-.69.55-.57.61-.83,1.3-.55,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "m91.15,57.67c.27.21.96-.1,1.53-.72.27-.28.47-.58.56-.85.13-.28-.48-.72-.85-.52-.21.13-.45.34-.68.57-.58.61-.84,1.27-.57,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-797",
    d: "m92.12,58c.27.21.96-.11,1.53-.72.27-.28.46-.58.57-.84.13-.32-.49-.73-.85-.52-.21.12-.47.31-.68.57-.57.59-.84,1.27-.57,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-584",
    d: "m93.39,58.86c.35.12.87-.42,1.21-1.17.14-.36.22-.73.23-1,.03-.32-.71-.5-.98-.18-.16.19-.32.44-.44.75-.33.79-.33,1.49-.03,1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "m78.04,46.05c.25.35,1.5-.03,2.81-.84.62-.36,1.14-.77,1.49-1.14.4-.39-.2-1.08-.9-.81-.43.15-.94.41-1.45.71-1.33.82-2.19,1.73-1.96,2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m80.76,46.05c.21.35,1.49-.03,2.8-.84.62-.36,1.13-.77,1.5-1.14.38-.39-.21-1.08-.91-.81-.44.15-.95.41-1.44.71-1.32.82-2.21,1.73-1.96,2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "m83.16,46.05c.25.35,1.51-.03,2.82-.84.62-.36,1.15-.77,1.49-1.14.41-.39-.2-1.08-.89-.81-.45.15-.94.41-1.44.71-1.33.82-2.21,1.73-1.97,2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-652",
    d: "m85.32,46.31c.24.35,1.5-.02,2.82-.84.61-.36,1.14-.77,1.5-1.13.38-.39-.21-1.09-.92-.83-.43.17-.94.4-1.44.71-1.32.8-2.21,1.74-1.97,2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-465",
    d: "m87.49,46.64c.22.36,1.49-.04,2.79-.82.62-.38,1.16-.79,1.49-1.15.4-.41-.2-1.08-.9-.82-.43.15-.94.39-1.45.71-1.33.8-2.19,1.73-1.94,2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-686",
    d: "m88.53,48.2c.3.29,1.44-.32,2.55-1.38.52-.49.94-.99,1.21-1.42.28-.48-.48-1-1.08-.6-.39.23-.83.57-1.26.98-1.1,1.05-1.74,2.13-1.42,2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m88.92,49.81c.32.27,1.42-.41,2.47-1.5.48-.52.86-1.04,1.12-1.48.27-.49-.52-.99-1.11-.57-.38.27-.79.64-1.18,1.06-1.05,1.09-1.63,2.23-1.3,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "m88.86,51.12c.27.23,1.2-.36,2.1-1.29.41-.44.73-.89.94-1.25.22-.41-.44-.84-.93-.45-.31.21-.68.53-1.01.89-.88.92-1.36,1.88-1.09,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-539",
    d: "m88.86,52.78c.27.23,1.09-.23,1.83-1.02.35-.37.62-.76.76-1.07.2-.37-.44-.77-.86-.47-.27.18-.58.44-.86.74-.74.78-1.14,1.61-.87,1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m88.81,54.35c.27.22.95-.09,1.53-.7.27-.28.47-.6.58-.85.11-.29-.51-.74-.85-.53-.23.14-.45.34-.68.57-.58.61-.84,1.3-.57,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-512",
    d: "m89.36,55.33c.29.23.96-.09,1.52-.69.27-.29.47-.6.58-.84.12-.3-.5-.76-.85-.54-.22.12-.45.33-.68.56-.59.62-.83,1.29-.57,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-506",
    d: "m89.92,56.33c.27.23.94-.09,1.52-.71.27-.29.46-.59.59-.85.1-.28-.52-.73-.86-.51-.23.13-.47.32-.69.57-.57.6-.83,1.26-.55,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-792",
    d: "m91.15,56.84c.27.21.96-.11,1.53-.72.27-.27.47-.58.56-.85.13-.29-.48-.73-.85-.51-.21.13-.45.32-.68.57-.58.6-.84,1.26-.57,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-941",
    d: "m92.47,57.13c.28.22.95-.09,1.54-.71.27-.29.46-.58.55-.85.13-.28-.48-.71-.83-.5-.23.13-.47.32-.68.55-.6.61-.85,1.3-.58,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-635",
    d: "m93.74,57.19c.28.21.95-.11,1.53-.69.28-.29.48-.59.57-.85.13-.31-.49-.74-.84-.53-.22.13-.45.33-.68.56-.58.61-.84,1.3-.58,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-863",
    d: "m79.7,45.12c.21.35,1.4-.04,2.65-.83.58-.4,1.07-.8,1.42-1.16.37-.41-.21-1.1-.86-.82-.4.16-.88.41-1.37.72-1.25.81-2.06,1.75-1.84,2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-403",
    d: "m82.25,45.12c.19.35,1.41-.04,2.65-.83.57-.4,1.08-.8,1.41-1.16.37-.41-.2-1.1-.85-.82-.41.16-.88.41-1.36.72-1.25.81-2.06,1.75-1.84,2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-357",
    d: "m84.53,45.12c.23.35,1.41-.04,2.66-.83.59-.4,1.08-.8,1.41-1.16.38-.41-.19-1.1-.84-.82-.42.16-.89.41-1.38.72-1.25.81-2.07,1.75-1.85,2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-813",
    d: "m86.56,45.36c.24.36,1.42-.02,2.67-.83.6-.37,1.07-.77,1.41-1.14.38-.4-.2-1.08-.85-.83-.42.16-.89.42-1.38.73-1.24.79-2.07,1.73-1.86,2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-861",
    d: "m88.59,45.7c.22.35,1.41-.02,2.67-.82.59-.38,1.08-.8,1.41-1.16.37-.4-.2-1.08-.86-.82-.4.15-.88.41-1.36.73-1.25.79-2.06,1.73-1.86,2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-716",
    d: "m89.6,47.27c.28.3,1.37-.32,2.43-1.38.46-.5.87-1,1.12-1.43.28-.46-.44-1.01-1.02-.6-.36.23-.77.58-1.16,1-1.04,1.05-1.65,2.13-1.36,2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "m89.96,48.89c.31.28,1.36-.4,2.34-1.51.46-.52.84-1.04,1.05-1.49.25-.49-.47-1-1.04-.56-.35.27-.74.63-1.12,1.07-.99,1.1-1.53,2.23-1.23,2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-491",
    d: "m89.92,50.2c.25.21,1.13-.35,1.97-1.29.4-.44.69-.89.9-1.25.2-.42-.41-.84-.89-.49-.3.23-.63.53-.94.91-.85.93-1.3,1.89-1.04,2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-371",
    d: "m89.92,51.88c.25.2,1.01-.23,1.73-1.03.32-.36.59-.76.74-1.08.16-.35-.44-.77-.84-.47-.27.2-.54.44-.8.75-.72.8-1.09,1.62-.83,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-646",
    d: "m89.87,53.45c.25.23.9-.09,1.44-.72.27-.29.45-.58.54-.84.12-.3-.48-.73-.81-.52-.2.14-.44.33-.65.55-.54.62-.78,1.3-.52,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m90.38,54.44c.26.22.9-.1,1.43-.71.27-.28.44-.59.55-.84.11-.29-.46-.73-.79-.52-.22.13-.44.33-.66.55-.55.62-.77,1.3-.53,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-493",
    d: "m90.91,55.43c.24.24.91-.09,1.44-.71.26-.28.44-.59.55-.84.1-.29-.47-.73-.81-.51-.22.13-.44.32-.65.57-.56.6-.78,1.28-.53,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "m92.08,55.93c.24.25.9-.08,1.44-.71.25-.28.44-.56.53-.83.12-.3-.46-.74-.79-.52-.21.13-.45.32-.66.55-.55.61-.79,1.3-.52,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-319",
    d: "m93.33,56.24c.25.21.9-.12,1.44-.7.26-.29.44-.6.55-.86.12-.29-.46-.73-.81-.51-.21.12-.43.33-.66.55-.53.61-.77,1.3-.52,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-299",
    d: "m94.54,56.3c.24.23.89-.1,1.43-.7.26-.29.44-.59.55-.85.1-.3-.49-.74-.81-.52-.22.13-.45.34-.64.57-.57.6-.79,1.28-.53,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-742",
    d: "m100.28,53.77c-3.34-.03-3.34-.04-4.94.04-1.71.07-3.57-.47-2.69-3.58,1.52-5.3,2.33-8.08-4.65-8.66-2.98-.25-5.49.43-7.36,1.27-1.83.97.81.99,2.25.67,1.49-.34,6.17-1.51,8.45.75,1.5,1.73-.52,5.7-.52,7.82-.22,3.82,5.3,3.59,5.3,3.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-455",
    d: "m88.3,41.92c-3.09-.76-8.46.56-9.4,2.05-.95,1.46,3.13-1.33,9.64-1.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-420",
    d: "m87.37,41.84c.94.35.76.73-2.54.95-1.44.22-2.64.17-2.68-.12-.06-.3,1.06-.71,2.53-.96,1.44-.22,1.76-.2,2.7.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-592",
    d: "m89.79,42.03c0,.3-1.2.54-2.65.54s-2.65-.24-2.65-.54c0-.28,1.17-.53,2.65-.53s2.65.26,2.65.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-431",
    d: "m90.13,42.29c-.05.28-.94.38-1.97.22-1.07-.15-1.89-.51-1.86-.76.04-.28.93-.37,1.97-.23,1.07.17,1.89.51,1.86.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-503",
    d: "m145.15,60.92s8.33,5.95,8.68,8.43c.34,2.47-8.27-6.12-9.89-6.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-777",
    d: "m142.83,59.22s8.22,6.13,8.51,8.63c.28,2.48-8.17-6.3-9.74-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-313",
    d: "m141.17,59.77s7.84,6.02,7.95,8.22c.14,2.19-7.73-6.18-9.25-7.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-650",
    d: "m134.63,58.37s7.83,6.03,7.96,8.22c.13,2.18-7.76-6.17-9.27-7.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m138.03,59.06s7.81,6.02,7.95,8.22c.15,2.19-7.75-6.18-9.26-7.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-622",
    d: "m138.53,56.34s9.22,5.5,9.96,8.44c.76,2.95-9.19-5.71-10.91-6.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-362",
    d: "m137,57.4s8.82,5.45,9.37,8.08-8.78-5.67-10.44-6.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-784",
    d: "m134.94,58.05s8.82,5.48,9.37,8.08c.54,2.63-8.77-5.66-10.45-6.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-486",
    d: "m130.31,57.22s8.82,5.48,9.37,8.09c.55,2.61-8.77-5.67-10.44-6.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "m127.28,57.01s8.82,5.47,9.37,8.09c.57,2.62-8.76-5.66-10.42-6.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-643",
    d: "m134.26,52.23s9.23,5.49,9.99,8.44c.75,2.94-9.21-5.72-10.92-6.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-858",
    d: "m132.73,53.26s8.83,5.48,9.37,8.1c.55,2.61-8.78-5.67-10.44-6.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-774",
    d: "m130.7,53.91s8.81,5.49,9.35,8.1c.55,2.61-8.76-5.66-10.44-6.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-703",
    d: "m128.09,54.35s8.81,5.48,9.36,8.09c.54,2.63-8.79-5.67-10.45-6.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-507",
    d: "m125.47,54.76s8.83,5.47,9.38,8.09c.55,2.62-8.79-5.66-10.44-6.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-463",
    d: "m122.87,55.2s8.83,5.47,9.37,8.08c.54,2.62-8.78-5.67-10.46-6.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-349",
    d: "m120.28,54.99s7.64,4.81,8.11,7.15c.47,2.3-7.61-5.01-9.06-5.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-570",
    d: "m117.22,53.64s7.65,4.84,8.11,7.13c.48,2.33-7.6-5-9.06-5.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m127.78,47.88s9.65,4.69,10.64,7.56c.99,2.89-9.65-4.91-11.42-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-904",
    d: "m126.33,49.05s9.25,4.71,10.02,7.28c.75,2.56-9.22-4.93-10.94-5.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-353",
    d: "m124.35,49.87s9.24,4.71,10.02,7.28c.75,2.55-9.23-4.92-10.96-5.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-665",
    d: "m121.79,50.52s9.25,4.7,10.02,7.28c.77,2.56-9.21-4.92-10.95-5.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-682",
    d: "m119.24,51.16s9.25,4.71,10.01,7.27c.77,2.57-9.22-4.9-10.93-5.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-250",
    d: "m116.67,51.79s9.25,4.73,10.02,7.28c.76,2.56-9.22-4.92-10.96-5.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-469",
    d: "m114.07,51.81s8.03,4.16,8.69,6.44c.66,2.27-8.01-4.36-9.5-4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-662",
    d: "m110.89,50.72s8.02,4.18,8.7,6.44c.67,2.28-8.01-4.34-9.51-4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-555",
    d: "m121.68,44.56s9.98,3.93,11.2,6.73c1.23,2.78-10.01-4.15-11.81-4.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-809",
    d: "m120.34,45.84s9.57,3.98,10.55,6.48c.95,2.5-9.59-4.16-11.34-4.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "m118.42,47s9.6,3.98,10.55,6.47c.97,2.51-9.57-4.17-11.34-4.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-701",
    d: "m115.91,47.67s9.6,3.98,10.55,6.47c.98,2.48-9.57-4.16-11.32-4.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-427",
    d: "m113.43,48.49s9.58,4,10.55,6.49c.96,2.5-9.58-4.18-11.35-4.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m110.92,49.34s9.58,3.98,10.56,6.49c.96,2.5-9.58-4.18-11.35-4.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-278",
    d: "m108.32,49.55s8.33,3.54,9.16,5.75c.85,2.2-8.32-3.72-9.85-4.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "m121.19,54.72l1.18-.84s2.45,2.2,1.8,4.13c-.79,1.59-2.98-3.28-2.98-3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-470",
    d: "m120.2,55.58l1.18-.86s2.43,2.21,1.81,4.14c-.83,1.59-3-3.27-3-3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m119.36,56.38l1.24-.76s2.27,2.37,1.5,4.26c-.92,1.52-2.75-3.5-2.75-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-706",
    d: "m117.07,57.32l1.61-1.08s3.68,2.38,2.13,5.71c-1.17,2.12-3.75-4.62-3.75-4.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-949",
    d: "m116.44,57.35l1.72-.66s2.34,3.36,1.01,5.51c-1.48,1.66-2.72-4.85-2.72-4.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-934",
    d: "m115.83,57.37l1.37-.54s1.84,2.72.76,4.44c-1.17,1.35-2.13-3.9-2.13-3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-293",
    d: "m114.77,57.9l1.13-.5s1.49,2.33.6,3.85c-.99,1.17-1.72-3.35-1.72-3.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-616",
    d: "m113.88,58.22l1.12-.22s1.35,2.06.4,3.13c-1,.8-1.52-2.91-1.52-2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-343",
    d: "m112.94,58.79l1.12-.79s1.17,2.51.33,2.99c-1.08.62-1.45-2.2-1.45-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "m111.87,59.6l1.07-.94s1.35,1.54.44,3.1c-.88,1.56-1.51-2.16-1.51-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-938",
    d: "m111.28,60.18c-.02-.1,1.11-1.02,1.11-1.02,0,0,.99,2.37.18,3.69-.81,1.37-1.07-.18-1.29-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-318",
    d: "m109.04,60.4l1.45-1.61s2.22,3.85.44,5.11c-1.27,1.09-1.16.53-1.44-1.02-.29-1.55-.44-2.48-.44-2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-612",
    d: "m106.99,61.26l2.05-1.34s1.49,4.22-1.03,4.86c-1.47.34-1.02-3.05-1.02-3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "m105.23,59.67l1.57-.82s1.19,4.5-.78,5.5c-1.99,1-.49-2.33-.79-4.68Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "m116.98,50.54l.86-1.49s5.74,3.84,4.68,5.46c-1.07,1.65-3.53-2.62-5.54-3.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-805",
    d: "m115.83,51.31l.88-1.49s5.73,3.83,4.67,5.47c-1.06,1.64-3.54-2.63-5.55-3.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-793",
    d: "m115.29,52.06l1.07-1.37s5.12,4.64,3.82,6.1c-1.27,1.48-3.11-3.11-4.89-4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-768",
    d: "m114.18,52.91l1.06-1.37s5.11,4.65,3.83,6.09c-1.28,1.48-3.11-3.12-4.89-4.72Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-747",
    d: "m113.79,54.09l1.18-1.33s3.37,3.79,2.01,5.22c-1.38,1.45-2.01-2.58-3.19-3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-881",
    d: "m112.63,54.72l1.17-1.31s3.39,3.78,2,5.21c-1.37,1.44-2-2.57-3.18-3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-604",
    d: "m111.94,55.38l1.3-1.17s2.62,4.46,1.1,5.73c-1.49,1.28-1.49-2.99-2.4-4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-946",
    d: "m110.78,56.09l1.29-1.18s2.63,4.47,1.12,5.75c-1.5,1.27-1.5-3.01-2.41-4.56Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "m109.43,56.87l1.37-.93s2.74,3.58,1.16,4.58c-1.58,1.01-1.57-2.37-2.53-3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-237",
    d: "m108.17,57.26l1.38-.93s2.75,3.58,1.16,4.58c-1.59,1.01-1.57-2.38-2.53-3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "m107.41,57.71l1.46-.81s1.89,4.05.2,4.89c-1.69.85-1-2.68-1.65-4.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "m106.12,58.15l1.49-.83s1.88,4.06.19,4.89c-1.69.88-1-2.67-1.67-4.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m121.6,44.19s5.26,2.04,6.09,3.58c.85,1.53-.45.77-1.29.71-.85-.07-5.35-2.99-5.56-3.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m120.61,45.08s5.25,2.05,6.09,3.57c.83,1.54-.46.77-1.3.72-.83-.04-5.35-2.97-5.55-3.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "m121.23,46.82s5.02,2.5,5.75,3.91c.72,1.43-.52.59-1.32.43-.81-.18-5.05-3.33-5.27-3.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "m117.78,42.64s6.48,1.49,7.69,2.98c1.24,1.52-.41.88-1.4.93-.98.02-6.73-2.48-6.97-2.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-594",
    d: "m116.19,42.6s6.48,1.48,7.7,2.97c1.23,1.52-.42.86-1.4.92-.99.03-6.74-2.49-6.99-2.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "m119.06,46.06s4.97,2.61,5.65,4.16c.66,1.55-.54.65-1.35.5-.81-.18-4.98-3.54-5.17-3.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-459",
    d: "m115.59,46.15s5.85,1.43,6.97,3.22c1.14,1.78-.36,1.08-1.24,1.18-.89.12-6.13-2.64-6.34-2.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "m113.59,46.34s5.85,1.45,6.99,3.22c1.11,1.79-.37,1.1-1.25,1.2-.89.11-6.12-2.64-6.33-2.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-445",
    d: "m104.11,57.26l2.35.89s1.64,4.18-.15,4.7c-1.81.53-.96-2.75-2.2-5.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-415",
    d: "m112.63,46.79s4.79,1.11,5.77,2.82c.97,1.74-.27,1.12-.97,1.28-.71.15-5.03-2.32-5.22-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "m112.05,48.25s4.17,1.31,4.94,2.92c.76,1.58-.3.99-.94,1.07-.64.09-4.3-2.4-4.47-2.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m111.77,49.94s3.55,1.15,4.19,2.58c.65,1.41-.25.86-.8.94-.54.09-3.68-2.11-3.81-2.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-761",
    d: "m111.42,51.26s2.74,1,3.23,2.29c.49,1.27-.2.8-.63.87-.41.08-2.83-1.89-2.93-1.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "m111.19,52.23s2.46,1.21,2.82,2.65c.36,1.44-.25.86-.64.95-.41.08-2.47-2.19-2.58-2.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-688",
    d: "m110.76,53.02s1.66,1.48,1.66,3c0,1.51-.37.85-.68.91-.32.04-1.49-2.48-1.57-2.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "m110.16,53.82s1.57,2.05.61,3.12c-.96,1.06-1.73-1.92-1.73-1.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-373",
    d: "m108.94,54.44s1.57,2.05.6,3.1c-.96,1.07-1.72-1.92-1.72-1.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "m107.91,55.22s1.57,2.05.62,3.12c-.96,1.06-1.73-1.92-1.73-1.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-443",
    d: "m105.96,55.13s2.71,3.41,1.74,4.46c-.95,1.08-2.12-2.33-2.12-2.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-433",
    d: "m105.81,55.97c.04.7,1.76,3.78.62,4.65-1.13.85-1.36-2.21-1.36-2.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-538",
    d: "m116.5,42.42c.57.46,1.48.73,2.15.92.29.11.74.3.83.64.13.69-.89.55-1.28.45-.83-.19-1.5-.3-2.37-.21-1.27.13-2.53.41-3.83.4-.59-.03-1.21-.16-1.79,0-.72.18-1.35.6-1.79,1.22-.81,1.2-.59,2.65-.34,3.95.09.39.23,1.78-.51,1.39-.88-.48-.92-2.37-.92-3.24-.03-1.2-.36-2.34-.37-3.54-.03-.7.52-1.13,1.14-1.31,1.66-.53,3.28-.97,5.03-.94.81,0,1.61.05,2.39.2.6.12,1.46.08,2,.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-550",
    d: "m122.95,47.97c-.23.35-1.49-.04-2.81-.83-.61-.38-1.13-.77-1.49-1.15-.42-.4.2-1.08.89-.83.44.17.93.4,1.46.74,1.31.78,2.2,1.72,1.95,2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-831",
    d: "m120.26,47.97c-.24.35-1.49-.04-2.8-.83-.62-.38-1.15-.77-1.51-1.15-.38-.4.22-1.08.9-.83.44.17.95.4,1.47.74,1.31.78,2.18,1.72,1.95,2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-830",
    d: "m117.83,47.97c-.23.35-1.49-.04-2.81-.83-.6-.38-1.14-.77-1.49-1.15-.41-.4.2-1.08.9-.83.44.17.94.4,1.44.74,1.32.78,2.2,1.72,1.96,2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m115.68,48.22c-.23.35-1.49-.02-2.81-.83-.62-.37-1.13-.79-1.5-1.14-.38-.41.22-1.09.9-.84.45.18.94.42,1.46.74,1.33.79,2.19,1.73,1.96,2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-448",
    d: "m113.53,48.56c-.24.34-1.49-.04-2.82-.84-.62-.36-1.14-.77-1.49-1.14-.39-.4.21-1.08.91-.83.44.17.93.43,1.44.73,1.33.78,2.19,1.73,1.97,2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "m112.48,50.1c-.31.29-1.46-.32-2.56-1.37-.52-.49-.92-1-1.19-1.41-.31-.47.44-1.01,1.06-.63.39.26.82.61,1.24,1,1.11,1.06,1.74,2.14,1.45,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m122.72,46.85c-.22.35-1.48-.03-2.79-.83-.62-.37-1.15-.78-1.5-1.13-.4-.4.21-1.08.92-.83.42.16.92.42,1.44.73,1.32.77,2.18,1.72,1.94,2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-298",
    d: "m120.04,46.85c-.23.35-1.49-.03-2.82-.83-.6-.37-1.13-.78-1.49-1.13-.4-.4.2-1.08.9-.83.44.16.93.42,1.45.73,1.32.77,2.19,1.72,1.96,2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m117.61,46.85c-.23.35-1.48-.03-2.81-.83-.61-.37-1.14-.78-1.49-1.13-.41-.4.2-1.08.9-.83.44.16.93.42,1.44.73,1.33.77,2.2,1.72,1.96,2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "m115.46,47.1c-.23.36-1.49,0-2.81-.81-.61-.37-1.14-.78-1.49-1.14-.4-.41.2-1.09.9-.82.44.15.94.38,1.45.69,1.33.81,2.2,1.73,1.96,2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-715",
    d: "m113.31,47.45c-.24.34-1.5-.04-2.82-.85-.6-.36-1.13-.76-1.49-1.13-.4-.41.22-1.08.9-.82.44.16.94.41,1.46.71,1.32.82,2.19,1.73,1.96,2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "m112.26,49.01c-.32.28-1.46-.34-2.56-1.38-.52-.49-.93-1-1.19-1.43-.3-.47.45-1.01,1.07-.63.37.27.82.61,1.24,1.01,1.1,1.05,1.75,2.12,1.44,2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-804",
    d: "m111.86,50.6c-.32.27-1.44-.4-2.47-1.5-.48-.53-.88-1.05-1.11-1.47-.28-.49.51-1,1.1-.58.36.27.78.63,1.18,1.07,1.04,1.1,1.63,2.22,1.3,2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m111.92,51.92c-.28.23-1.22-.35-2.09-1.28-.42-.44-.76-.89-.96-1.25-.23-.41.44-.85.93-.49.32.24.68.53,1.01.92.9.92,1.39,1.87,1.1,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "m111.98,53.55c-.29.23-1.23-.3-2.08-1.2-.41-.43-.72-.87-.9-1.23-.21-.41.49-.88.99-.53.31.22.66.5.99.85.85.92,1.3,1.84,1,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "m111.98,55.17c-.26.21-1.13-.29-1.9-1.14-.36-.38-.64-.79-.82-1.12-.2-.38.44-.8.89-.48.29.2.6.49.89.81.79.83,1.21,1.69.94,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "m111.1,55.73c-.28.22-.95-.09-1.53-.71-.26-.28-.47-.59-.57-.84-.13-.3.49-.73.85-.51.22.13.46.33.69.55.57.61.82,1.29.56,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-553",
    d: "m110.32,56.66c-.26.21-.94-.1-1.52-.72-.27-.27-.48-.59-.58-.84-.12-.29.5-.73.85-.51.23.13.46.32.68.54.58.62.82,1.29.56,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-693",
    d: "m109.24,57.26c-.27.22-.94-.09-1.51-.7-.27-.29-.47-.59-.59-.85-.12-.29.51-.72.86-.51.22.13.46.31.68.55.58.61.83,1.3.56,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-436",
    d: "m108,57.67c-.26.21-.93-.1-1.52-.72-.27-.28-.46-.58-.57-.85-.12-.28.5-.72.84-.52.24.13.48.34.71.57.56.61.82,1.27.54,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-488",
    d: "m107.03,58c-.29.21-.95-.11-1.53-.72-.28-.28-.46-.58-.58-.84-.11-.32.49-.73.85-.52.22.12.48.31.7.57.58.59.83,1.27.56,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m105.76,58.86c-.35.12-.86-.42-1.19-1.17-.16-.36-.24-.73-.24-1,0-.32.71-.5.96-.18.17.19.34.44.44.75.35.79.35,1.49.03,1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-536",
    d: "m121.11,46.05c-.24.35-1.49-.03-2.8-.84-.62-.36-1.16-.77-1.51-1.14-.39-.39.21-1.08.9-.81.44.15.94.41,1.47.71,1.31.82,2.18,1.73,1.95,2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m118.41,46.05c-.25.35-1.5-.03-2.81-.84-.61-.36-1.14-.77-1.49-1.14-.39-.39.22-1.08.91-.81.42.15.93.41,1.44.71,1.33.82,2.19,1.73,1.96,2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-492",
    d: "m115.99,46.05c-.23.35-1.49-.03-2.81-.84-.62-.36-1.14-.77-1.49-1.14-.39-.39.21-1.08.9-.81.43.15.94.41,1.44.71,1.33.82,2.21,1.73,1.97,2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-874",
    d: "m113.84,46.31c-.23.35-1.5-.02-2.81-.84-.61-.36-1.14-.77-1.5-1.13-.39-.39.22-1.09.9-.83.45.17.94.4,1.45.71,1.32.8,2.2,1.74,1.97,2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-816",
    d: "m111.68,46.64c-.23.36-1.5-.04-2.81-.82-.63-.38-1.14-.79-1.49-1.15-.41-.41.2-1.08.9-.82.42.15.94.39,1.45.71,1.31.8,2.2,1.73,1.96,2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-426",
    d: "m110.64,48.2c-.32.29-1.47-.32-2.56-1.38-.52-.49-.94-.99-1.2-1.42-.3-.48.44-1,1.06-.6.39.23.83.57,1.26.98,1.09,1.05,1.74,2.13,1.44,2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-409",
    d: "m110.24,49.81c-.32.27-1.43-.41-2.47-1.5-.49-.52-.88-1.04-1.11-1.48-.27-.49.5-.99,1.09-.57.37.27.8.64,1.2,1.06,1.04,1.09,1.62,2.23,1.3,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-544",
    d: "m110.3,51.12c-.27.23-1.22-.36-2.11-1.29-.4-.44-.73-.89-.93-1.25-.23-.41.44-.84.93-.45.32.21.67.53,1.01.89.87.92,1.37,1.88,1.09,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-871",
    d: "m110.3,52.78c-.27.23-1.08-.23-1.83-1.02-.36-.37-.6-.76-.78-1.07-.18-.37.45-.77.88-.47.29.18.57.44.87.74.74.78,1.13,1.61.86,1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-752",
    d: "m110.35,54.35c-.27.22-.95-.09-1.52-.7-.28-.28-.46-.6-.59-.85-.11-.29.5-.74.85-.53.22.14.47.34.69.57.57.61.82,1.3.56,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-744",
    d: "m109.8,55.33c-.26.23-.94-.09-1.52-.69-.28-.29-.48-.6-.58-.84-.12-.3.49-.76.85-.54.22.12.46.33.68.56.58.62.84,1.29.57,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-683",
    d: "m109.24,56.33c-.27.23-.94-.09-1.51-.71-.27-.29-.47-.59-.59-.85-.12-.28.51-.73.86-.51.22.13.46.32.68.57.58.6.83,1.26.56,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-679",
    d: "m108,56.84c-.26.21-.93-.11-1.52-.72-.27-.27-.46-.58-.57-.85-.12-.29.5-.73.84-.51.24.13.48.32.71.57.56.6.82,1.26.54,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-380",
    d: "m106.68,57.13c-.27.22-.94-.09-1.5-.71-.29-.29-.48-.58-.59-.85-.12-.28.49-.71.85-.5.22.13.45.32.68.55.57.61.82,1.3.55,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-694",
    d: "m105.4,57.19c-.27.21-.94-.11-1.53-.69-.26-.29-.45-.59-.57-.85-.13-.31.49-.74.85-.53.22.13.47.33.69.56.56.61.83,1.3.55,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-394",
    d: "m119.48,45.12c-.25.35-1.42-.04-2.67-.83-.59-.4-1.09-.8-1.41-1.16-.38-.41.2-1.1.85-.82.41.16.87.41,1.36.72,1.25.81,2.07,1.75,1.87,2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m116.9,45.12c-.2.35-1.4-.04-2.63-.83-.6-.4-1.09-.8-1.42-1.16-.39-.41.2-1.1.85-.82.42.16.9.41,1.37.72,1.25.81,2.09,1.75,1.84,2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-702",
    d: "m114.62,45.12c-.2.35-1.41-.04-2.64-.83-.59-.4-1.08-.8-1.41-1.16-.38-.41.19-1.1.84-.82.42.16.89.41,1.37.72,1.25.81,2.08,1.75,1.84,2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-378",
    d: "m112.58,45.36c-.21.36-1.41-.02-2.64-.83-.6-.37-1.08-.77-1.42-1.14-.37-.4.2-1.08.85-.83.43.16.9.42,1.38.73,1.24.79,2.06,1.73,1.84,2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-245",
    d: "m110.56,45.7c-.23.35-1.41-.02-2.66-.82-.59-.38-1.09-.8-1.42-1.16-.37-.4.2-1.08.86-.82.4.15.88.41,1.35.73,1.25.79,2.08,1.73,1.87,2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m109.57,47.27c-.29.3-1.38-.32-2.41-1.38-.5-.5-.9-1-1.14-1.43-.28-.46.43-1.01,1.01-.6.36.23.77.58,1.18,1,1.05,1.05,1.65,2.13,1.36,2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-814",
    d: "m109.2,48.89c-.31.28-1.37-.4-2.35-1.51-.46-.52-.83-1.04-1.05-1.49-.26-.49.49-1,1.03-.56.36.27.74.63,1.13,1.07.98,1.1,1.53,2.23,1.24,2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m109.26,50.2c-.27.21-1.16-.35-1.99-1.29-.38-.44-.7-.89-.89-1.25-.21-.42.42-.84.88-.49.3.23.63.53.95.91.84.93,1.3,1.89,1.05,2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-866",
    d: "m109.24,51.88c-.24.2-1.01-.23-1.73-1.03-.32-.36-.59-.76-.72-1.08-.19-.35.41-.77.82-.47.25.2.54.44.81.75.71.8,1.08,1.62.82,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "m109.3,53.45c-.25.23-.9-.09-1.44-.72-.27-.29-.45-.58-.54-.84-.12-.3.46-.73.79-.52.21.14.44.33.65.55.55.62.78,1.3.54,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-484",
    d: "m108.77,54.44c-.25.22-.89-.1-1.44-.71-.25-.28-.44-.59-.53-.84-.12-.29.46-.73.8-.52.22.13.44.33.64.55.55.62.8,1.3.53,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-718",
    d: "m108.24,55.43c-.24.24-.9-.09-1.43-.71-.27-.28-.44-.59-.55-.84-.1-.29.48-.73.82-.51.2.13.44.32.65.57.54.6.78,1.28.52,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-645",
    d: "m107.08,55.93c-.24.25-.88-.08-1.44-.71-.24-.28-.44-.56-.54-.83-.11-.3.48-.74.82-.52.21.13.43.32.63.55.56.61.8,1.3.53,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-925",
    d: "m105.82,56.24c-.25.21-.9-.12-1.44-.7-.25-.29-.43-.6-.54-.86-.11-.29.48-.73.81-.51.22.12.44.33.64.55.56.61.79,1.3.53,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-573",
    d: "m104.63,56.3c-.26.23-.9-.1-1.46-.7-.24-.29-.44-.59-.53-.85-.12-.3.47-.74.81-.52.2.13.43.34.63.57.56.6.79,1.28.55,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-790",
    d: "m101.54,53.38s6.46,2.13,4.95-3.16c-1.52-5.3-2.33-8.08,4.66-8.66,2.98-.25,5.48.43,7.37,1.27,1.81.97-.82.99-2.26.67-1.49-.34-6.18-1.51-8.44.75-1.51,1.73.52,5.7.52,7.82.21,3.82-5.31,3.59-5.31,3.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-698",
    d: "m110.87,41.92c3.09-.76,8.43.56,9.38,2.05.94,1.46-3.13-1.33-9.62-1.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m111.79,41.84c-.94.35-.77.73,2.53.95,1.45.22,2.66.17,2.7-.12.04-.3-1.08-.71-2.52-.96-1.46-.22-1.77-.2-2.71.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-476",
    d: "m109.36,42.03c0,.3,1.2.54,2.65.54s2.65-.24,2.65-.54c0-.28-1.18-.53-2.65-.53s-2.65.26-2.65.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "m109.04,42.29c.04.28.91.38,1.97.22,1.05-.15,1.88-.51,1.84-.76-.04-.28-.93-.37-1.98-.23-1.07.17-1.88.51-1.83.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-494",
    d: "m125.65,71.6c1.79-2.25,4.26-1.94,5.26-1.62,1.89.58,4.43,2.45,7.42.94,2.49-1.46,3.31-3.26,3.31-3.26l-3.26.07.44-3.42s-1.41,1.72-2.18,2.18c-.67.37-1.33.89-3.82.05-2.78-.94-4.22-.18-5.02.99-.8,1.13-2.12,2.66-2.14,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-878",
    d: "m74.81,71.58c-1.8-2.28-4.27-1.95-5.27-1.61-1.9.57-4.43,2.44-7.41.93-2.51-1.47-3.34-3.27-3.34-3.27l3.28.09-.45-3.43s1.42,1.7,2.16,2.16c.69.38,1.35.92,3.84.08,2.78-.96,4.22-.18,5.02.97.82,1.16,2.13,2.69,2.16,4.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-424",
    d: "m97.43,83.31l.72,1.91,3.64.2s1.26-1.51,1.21-1.56c-.05-.02-1.5.19-1.5.19l-.52-.86-.96.86-.7-.86-.42.86-1.47-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "m102.99,83.87c-.12,0-.24.04-.37.05l-.37.04-.76.11h-.02s-.52-.87-.52-.87h.03s-.95.87-.95.87l-.02.03-.03-.03-.69-.86h.04s-.44.85-.44.85h0s0,0,0,0c-.5-.25-.99-.49-1.47-.75.5.22.99.47,1.47.71h-.03s.43-.84.43-.84l.02-.02.03.02.69.84h-.04l.98-.85h.02s.52.86.52.86h-.02c.24-.03.5-.06.76-.1l.37-.02c.13-.03.26-.04.37-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-927",
    d: "m97.43,83.31c.26.62.52,1.25.76,1.88l-.04-.02,1.83.1,1.81.13h-.03l.63-.76.31-.37c.11-.12.23-.25.29-.4-.06.15-.18.29-.27.42l-.28.39-.63.78v.02h-.03l-1.81-.11-1.83-.11h-.02l-.02-.03c-.22-.64-.45-1.28-.68-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-562",
    d: "m99.15,90.91c2.46,3.16,1.73,5.34,1.72,8.08-.26-.15-.74-.39-1.16-.78.82-5.58-1.18-7.13-1.18-7.13,0,0,.28-.49.62-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-927",
    d: "m100.87,98.99c-.41-.21-.83-.44-1.16-.77h0v-.02c.15-1.23.23-2.48.11-3.71-.05-.64-.17-1.23-.36-1.82-.1-.3-.21-.59-.37-.85-.13-.29-.31-.54-.54-.75.47.4.76.98.97,1.56.21.59.33,1.21.4,1.84.08.62.08,1.25.05,1.88-.03.62-.11,1.25-.2,1.87l-.02-.03c.34.31.74.57,1.13.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "m98.53,91.07c.06-.11.15-.2.27-.27.06-.02.12-.03.19,0,.06,0,.11.04.17.09h0c.45.54.83,1.15,1.14,1.79.31.64.53,1.34.62,2.05.11.71.11,1.42.06,2.12-.03.71-.1,1.43-.11,2.14,0-.7.04-1.42.08-2.14.02-.69.02-1.41-.08-2.12-.12-.71-.31-1.4-.62-2.03-.29-.66-.68-1.25-1.12-1.79h0c-.04-.05-.09-.09-.14-.12-.07-.02-.12,0-.18.02-.12.04-.2.14-.28.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-300",
    d: "m100.61,95.02c.92-2.87.92-3.17,3.86-4.83-.68,4.19-2.8,4.51-3.86,4.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "m100.61,95.02c.16-.51.3-1.03.49-1.54.19-.5.39-1.01.75-1.43.33-.44.77-.74,1.23-1.04.44-.3.91-.55,1.4-.82-.48.28-.93.55-1.39.84-.45.3-.87.64-1.21,1.06-.34.41-.56.91-.74,1.41-.19.51-.36,1.02-.52,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-927",
    d: "m104.47,90.19c-.09.55-.19,1.1-.36,1.64-.15.52-.4,1.03-.71,1.49-.32.47-.72.87-1.22,1.15-.25.14-.5.24-.76.35-.27.06-.53.14-.8.2.53-.18,1.06-.33,1.52-.64.46-.27.86-.67,1.17-1.11.32-.45.53-.95.72-1.48.2-.52.32-1.07.44-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-769",
    d: "m100.28,95.88c-1.48-2.84-1.52-3.14-4.88-4.38,1.45,4.28,3.7,4.22,4.88,4.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "m100.28,95.88c-.28-.5-.54-1.01-.81-1.49-.29-.51-.6-.97-1.03-1.36-.44-.38-.93-.65-1.46-.88-.52-.23-1.07-.44-1.58-.64.54.18,1.08.37,1.6.6.52.24,1.04.51,1.47.88.44.39.76.86,1.02,1.37.28.51.53,1.01.79,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-927",
    d: "m95.4,91.5c.21.54.44,1.09.72,1.59.29.53.61,1.01,1.02,1.43.4.41.89.76,1.43.97.53.22,1.13.3,1.71.38-.3-.02-.59-.04-.89-.08-.29-.04-.58-.12-.85-.21-.56-.21-1.07-.57-1.48-.98-.4-.45-.75-.94-1.01-1.47-.27-.52-.47-1.08-.64-1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-355",
    d: "m101.14,85.12c-.09-.12-.37.04-.49.1-.29.12-.56.38-.58.72-.04.36.09.71.08,1.07-.03.36-.1.73-.18,1.08-.12.57-.17,1.16-.53,1.65-.2.29-.53.45-.44.87.09.3.61.69.92.48.18-.12.36-.48.45-.66.2-.38.23-.82.34-1.24.17-.52.47-1.02.62-1.57.14-.52.18-1.08.14-1.64,0-.34-.14-.44-.38-.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m101.55,90.16c-.2,0-.36-.02-.53-.06-.18-.04-.36-.13-.54-.09-.26.04-.72.32-.67.61-.16,0-.29-.02-.42.07-.12.12-.17.25-.3.36-.14.11-.36.22-.2.41.09.58,1.93.33,2.46-.34.15-.13.32-.37.36-.57.04-.19-.07-.26-.17-.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-522",
    d: "m101.86,87.75c-.31-.14-.55-.12-.9-.12-.12,0-.29-.04-.4,0-.13.04-.22.21-.34.3-.28.18-.24.53-.24.85,0,.48.51.45.85.28.19-.1.31-.25.5-.32.2-.1.44-.12.6-.28.12-.09.16-.22.15-.38,0-.13-.15-.19-.16-.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "m98.26,86.99c-.17-.09.34-.36.47-.36.18,0,.31.09.36.27.15.57-.15.79-.44,1.25-.2.34-.77,1.14-1.25.81-.34-.22-.25-.76-.03-1,.15-.2.31-.26.53-.31.11-.06.32-.13.37-.27.06-.09-.02-.18-.02-.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-915",
    d: "m101.85,86.86c-.16-.23-.72-.24-.92-.06-.12.13-.15.29-.22.42-.04.12-.2.29-.2.39.04.28.56.26.76.26.29,0,.61.15.72-.26.05-.27,0-.51-.1-.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-636",
    d: "m101.51,85.66c-.15,0-.31-.13-.47-.07-.18.06-.27.34-.31.52-.04.25-.11.6.22.66.56.13,1.23-.33.78-.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-783",
    d: "m100.84,85.95c.03-.29-.15-.68-.51-.45-.12.1-.22.3-.33.41-.12.12-.35.32-.37.5-.06.43.66.32.92.36.33.05.29-.28.29-.54v-.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-495",
    d: "m101.22,85.1c0-.24-.2-.28-.38-.28s-.29.08-.45.14c-.12.06-.26.12-.23.29,0,.14.12.32.23.36.12.04.25,0,.35.04.11.02.21.11.31.08.2-.04.37-.46.22-.6-.03,0-.04-.04-.05-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "m100.3,84.19c-.08-.04-.02.08-.2-.05-.21-.17-.61-.08-.82.02-.28.15-.28.13-.18.47.11.3.51.38.73.54.18.13.34.29.56.17.09-.04.16-.11.23-.17.09-.04.19-.06.26-.13.16-.11.14-.26,0-.39-.15-.17-.37-.31-.54-.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-456",
    d: "m101.87,88.58c-.22-.19-.64-.04-.85.11-.15.12-.33.14-.36.35-.12-.03-.2-.1-.32-.08-.14.03-.38.03-.52.08-.25.1-.2.85-.16,1.09.04.16.06.23.25.26.3.08.61.04.92.04.6,0,1.04-.26,1.23-.88.09-.29.09-.63-.07-.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-549",
    d: "m97.46,90.15c-.04-.24.24-.39.44-.39.23,0,.43.09.64.18.26.08.69.12.9.32.27.26-.04.67-.19.88-.19.25-.39.29-.7.29-.37,0-.66-.23-.87-.5-.13-.15-.53-.67-.25-.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-932",
    d: "m97.52,86.51s-.02-.02-.03-.03c.15-.17.44.03.57.12.16.05.39.1.48.25.14.24.04.66-.19.8-.32.2-.86.6-1.26.34-.31-.17-.32-.78-.2-1.07.12-.24.27-.44.53-.51.05-.03.1-.05.16-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "m99.15,84.3c-.26.06-.66.35-.88.52-.23.19-.44.46-.64.68-.38.45-.15.86.25,1.2.45.37,1.25.36,1.73-.02.37-.34,1.01-.93.69-1.5-.12-.24-.42-.39-.59-.6-.11-.16-.59-.53-.74-.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-411",
    d: "m99.26,87.6c-.4-.32-.73.22-.92.5-.16.23-.43.39-.65.56-.19.12-.44.28-.41.52.06.52.77.77,1.19.89.24.05.48.12.7.18.13.04.41.12.54.08.19-.07.19-.35.21-.5.03-.21.08-.44.17-.66.11-.26.33-.63.29-.92-.09-.53-.78-.52-1.17-.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "m100.75,86.63c-.12-.12-.29-.02-.44-.04-.18-.02-.34-.15-.52-.18-.39-.07-.63.3-.87.54-.25.29-.07.74.29.84.24.06.5.08.75.17.12.04.29.18.42.12.2-.06.32-.55.38-.74.04-.13.12-.29.13-.43.04-.19.03-.19-.13-.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-927",
    d: "m99.95,91.78c.35-.05.71-.16,1.06-.28.35-.13.67-.3.97-.52.59-.42,1.05-1.01,1.31-1.7.25-.68.37-1.42.25-2.13-.12-.72-.52-1.39-1.09-1.86.3.21.57.5.76.81.2.32.35.66.42,1.03.06.37.08.74.03,1.12-.05.35-.13.72-.27,1.08-.27.68-.75,1.31-1.37,1.71-.61.42-1.35.66-2.06.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-708",
    d: "m99.95,91.78s3.39-.2,3.67-3.91c.16-3.34-3.67-3.8-3.67-3.8,0,0,1.85.98,1.72,4.04-.13,3.05-1.72,3.67-1.72,3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "m99.95,84.06c.62.39,1.09,1.01,1.36,1.7.29.68.4,1.41.4,2.15-.04.75-.15,1.49-.4,2.19-.13.34-.29.68-.53.97-.22.28-.5.54-.83.7.33-.17.6-.44.82-.75.2-.27.37-.6.52-.94.25-.68.34-1.42.36-2.17.02-.72-.09-1.47-.36-2.14-.14-.35-.32-.67-.55-.96-.22-.29-.46-.54-.78-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-927",
    d: "m99.52,91.78c-.84-.08-1.67-.39-2.34-.93-.68-.54-1.11-1.34-1.3-2.16-.19-.84-.14-1.75.28-2.52.2-.36.51-.7.85-.97.33-.25.71-.44,1.09-.6-.77.34-1.48.87-1.86,1.63-.2.36-.31.76-.36,1.17-.04.44,0,.84.1,1.27.18.8.61,1.58,1.25,2.12.32.27.67.49,1.07.65.38.18.78.29,1.22.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-727",
    d: "m99.52,91.78s-3.41-.2-3.69-3.91c-.13-3.34,3.69-3.8,3.69-3.8,0,0-1.85.98-1.73,4.04.13,3.05,1.73,3.67,1.73,3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "m99.52,84.06c-.32.2-.58.45-.8.75-.23.29-.41.61-.55.96-.27.68-.36,1.42-.35,2.14,0,.75.1,1.49.36,2.17.12.34.3.68.52.94.2.3.47.58.82.75-.35-.16-.62-.43-.84-.7-.22-.29-.41-.63-.53-.97-.27-.7-.37-1.44-.37-2.19,0-.75.09-1.48.36-2.15.28-.68.76-1.31,1.39-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "m95.98,86.63c.24-.75.8-1.41,1.48-1.85.67-.44,1.46-.67,2.26-.76h0c.82.03,1.62.29,2.3.75.35.22.65.5.93.81.24.32.46.68.52,1.08-.06-.4-.28-.75-.54-1.06-.27-.3-.57-.59-.92-.79-.66-.45-1.48-.72-2.28-.71h0c-.8.06-1.57.29-2.25.71-.34.22-.63.49-.9.79-.26.33-.44.66-.59,1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "m118.13,86.84c.68.62.82,1.57.3,2.14-.5.55-1.45.52-2.13-.07-.69-.61-.81-1.57-.31-2.14.51-.55,1.47-.52,2.14.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "m118.01,88.9c1.1,1.2,1.31,2.84.43,3.62-.85.78-2.45.43-3.56-.78-1.12-1.23-1.31-2.84-.43-3.64.85-.79,2.45-.44,3.56.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-676",
    d: "m117.69,91.94c.65,1.87.07,3.77-1.3,4.26-1.38.48-3.03-.65-3.7-2.53-.64-1.85-.06-3.75,1.32-4.24,1.37-.48,3.02.65,3.68,2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-900",
    d: "m115.45,94.19c0,2.34-1.49,4.23-3.33,4.23s-3.34-1.89-3.34-4.23,1.48-4.21,3.34-4.21,3.33,1.91,3.33,4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "m112.55,94.53c0,2.66-1.81,4.81-4.04,4.81s-4.04-2.15-4.04-4.81,1.81-4.79,4.04-4.79,4.04,2.15,4.04,4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "m110.94,94.6c0,2.11-1.31,3.82-2.94,3.82s-2.94-1.71-2.94-3.82,1.32-3.82,2.94-3.82,2.94,1.71,2.94,3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m110.93,94.88c-.08,1.3-.63,2.38-1.42,3.02-1.1-1.48-1.39-4.36.11-6.44.87.71,1.41,1.99,1.32,3.42Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-596",
    d: "m108.08,98.24c0,.09.04.13.08.18.25.27.85-.18,1.08-.31.1-.09.2-.15.29-.22.04-.03.08-.06.13-.11.09-.08.19-.18.26-.26.16-.15.29-.32.41-.49.06-.12.15-.24.2-.37.09-.16.12-.34.18-.5.13-.29.16-.78.22-1.03,0-.17.03-.3.03-.35.02-.28-.03-.55-.03-.78-.02-.28-.06-.53-.13-.75-.05-.26-.15-.49-.31-.67-.09-.1-.32-.22-.51-.3-.08-.03-.4-.07-.45-.1-.12-.03,0,0-.17,0-.51-.02-.8.13-1.21.44-.08.05-.17.12-.23.2-.2.24-.36.47-.49.75-.06.24-.13.51-.17.78,0,.26,0,.52.04.79.09.58.4,1.07.55,1.65.07.2.11.4.12.59.02.15.04.31.04.43.04.2.04.34.09.45Z"
  }), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 7,
    transform: "translate(106.87 92)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAHCAYAAADAp4fuAAAACXBIWXMAAAsSAAALEgHS3X78AAAAkklEQVQImR2NMQ7BYBiGn+/vT4IYTIbfGSQSJC5gEWdwCHewcIneQJ2A3WAySQxYGpFoKU01n7Tjm+fJ87LejnW1mejtUNGZP1AA023VETGkuRSbAphG1ZIDi+OIphSiYj0Uj4h27Yc7J7hPhvVPd96vFHeN6Icxw+VFzHy6E30kdL4ZLk7Lri3fgN7+iQtCAfgDtVMxjBNRaOYAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-848",
    d: "m108.68,97.66c0,1.08-.89,1.96-1.98,1.96s-1.99-.87-1.99-1.96.88-1.95,1.99-1.95,1.98.87,1.98,1.95Z"
  }), /*#__PURE__*/React.createElement("image", {
    width: 4,
    height: 3,
    transform: "translate(100.87 95)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAACXBIWXMAAAsSAAALEgHS3X78AAAANUlEQVQImWN82RX6n4GRkYGRiYXh/9/fDEwMIPD/H8OfX9/BTJZPb18xfPjwGaSIQVCQnwEAvUIQiMmW6rUAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-518",
    d: "m105.59,98.12c.07.81-.68,1.5-1.68,1.56-1.01.08-1.84-.51-1.9-1.3-.05-.78.71-1.49,1.7-1.57,1-.05,1.85.52,1.89,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "m103.89,97.51s-.11-.08-.27-.04c-.16.02-.23.23-.25.13,0-.12.06-.24.06-.24,0,0-.24-.04-.28-.06.15-.1.32-.1.32-.1,0,0,.04-.16.07-.17.07-.04.15.12.15.12,0,0,.14-.07.3,0-.12.04-.22.12-.22.12,0,0,.13.12.11.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "m103.71,97.28s-.04.04-.09.06c-.06,0-.1,0-.11-.04,0-.03.03-.05.09-.09.05,0,.09.03.11.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-593",
    d: "m81.88,86.84c-.69.62-.84,1.57-.34,2.14.52.55,1.48.52,2.15-.07.68-.61.82-1.57.32-2.14-.5-.55-1.46-.52-2.13.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "m81.99,88.9c-1.11,1.2-1.31,2.84-.45,3.62.88.78,2.47.43,3.58-.78,1.09-1.23,1.31-2.84.44-3.64-.87-.79-2.46-.44-3.57.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-788",
    d: "m82.31,91.94c-.65,1.87-.06,3.77,1.31,4.26,1.38.48,3.03-.65,3.67-2.53.66-1.85.08-3.75-1.31-4.24-1.38-.48-3.01.65-3.67,2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m84.56,94.19c0,2.34,1.48,4.23,3.34,4.23s3.33-1.89,3.33-4.23-1.49-4.21-3.33-4.21-3.34,1.91-3.34,4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-382",
    d: "m87.45,94.53c0,2.66,1.8,4.81,4.04,4.81s4.05-2.15,4.05-4.81-1.82-4.79-4.05-4.79-4.04,2.15-4.04,4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-429",
    d: "m89.05,94.6c0,2.11,1.32,3.82,2.94,3.82s2.95-1.71,2.95-3.82-1.33-3.82-2.95-3.82-2.94,1.71-2.94,3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-523",
    d: "m89.05,94.6c0,1.27.48,2.39,1.23,3.09,1.21-1.41,1.67-4.26.32-6.43-.93.64-1.55,1.89-1.55,3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-826",
    d: "m92.11,96.62c0,.31-.65.54-1.43.54s-1.41-.23-1.41-.54c0-.14-.05-.52.09-.55.14-.04.89,0,1.33,0,.47,0,1.14-.12,1.41.03.04.08.03.4.03.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "m92.11,96.21c0,.32-.65.6-1.43.6s-1.41-.28-1.41-.6.64-.59,1.41-.59,1.43.27,1.43.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m98.04,98.47c0,.3-.63.56-1.41.56s-1.41-.26-1.41-.56c0-.14-.04-.51.09-.56.14-.04.88,0,1.33,0,.48,0,1.14-.11,1.38.03.04.09.04.4.04.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-853",
    d: "m98.04,98.06c0,.33-.63.6-1.41.6s-1.41-.27-1.41-.6c0-.31.63-.59,1.41-.59s1.41.28,1.41.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m96.89,97.36c0,.32-.62.58-1.41.58s-1.41-.26-1.41-.58c0-.12-.06-.51.1-.53.13-.04.86,0,1.31,0,.48,0,1.13-.12,1.39.02.04.09.02.41.02.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "m96.89,96.98c0,.32-.62.59-1.41.59s-1.41-.27-1.41-.59.61-.61,1.41-.61,1.41.29,1.41.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "m92.9,97.89c0,.31-.63.57-1.41.57s-1.43-.26-1.43-.57c0-.12-.04-.51.11-.54.12-.04.87,0,1.33,0s1.13-.12,1.39.02c.04.11.02.42.02.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-620",
    d: "m92.9,97.49c0,.35-.63.61-1.41.61s-1.43-.27-1.43-.61c0-.32.64-.58,1.43-.58s1.41.26,1.41.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-449",
    d: "m94.86,98.93c0,.29-.63.53-1.42.53s-1.41-.24-1.41-.53c0-.14-.05-.53.09-.56.13-.04.87,0,1.32,0,.48,0,1.15-.12,1.39.02.04.1.04.42.04.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-940",
    d: "m94.86,98.52c0,.32-.63.6-1.42.6s-1.41-.28-1.41-.6.62-.6,1.41-.6,1.42.28,1.42.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-618",
    d: "m96.24,98.27c0,.29-.63.55-1.42.55s-1.43-.26-1.43-.55c0-.13-.04-.52.12-.57.13-.04.86,0,1.32,0,.48,0,1.12-.1,1.39.04.04.1.04.41.04.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m96.24,97.85c0,.34-.63.6-1.42.6s-1.43-.27-1.43-.6.64-.57,1.43-.57,1.42.25,1.42.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-845",
    d: "m94.86,97.59c0,.28-.63.54-1.42.54s-1.41-.26-1.41-.54c0-.12-.05-.52.09-.56.13-.04.87,0,1.32,0,.48,0,1.15-.11,1.39,0,.04.12.04.43.04.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-458",
    d: "m94.86,97.19c0,.32-.63.6-1.42.6s-1.41-.28-1.41-.6c0-.34.62-.6,1.41-.6s1.42.27,1.42.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-833",
    d: "m95.31,96.61c0,.29-.63.54-1.42.54s-1.41-.25-1.41-.54c0-.14-.04-.52.1-.57.13-.04.86,0,1.32,0,.48,0,1.14-.1,1.41.03.03.11.02.41.02.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "m95.31,96.2c0,.32-.63.6-1.42.6s-1.41-.28-1.41-.6.64-.59,1.41-.59,1.42.26,1.42.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "m97,96.2c0,.3-.64.55-1.41.55s-1.41-.25-1.41-.55c0-.13-.05-.52.09-.55.12-.04.87,0,1.33,0s1.13-.11,1.39.03c.04.09.03.41.03.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-565",
    d: "m97,95.81c0,.32-.64.58-1.41.58s-1.41-.26-1.41-.58c0-.35.63-.61,1.41-.61s1.41.27,1.41.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-309",
    d: "m93.37,96.2c0,.3-.65.55-1.42.55s-1.42-.25-1.42-.55c0-.13-.04-.52.09-.55.15-.04.88,0,1.33,0s1.14-.11,1.39.03c.04.09.04.41.04.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-329",
    d: "m93.37,95.81c0,.32-.65.58-1.42.58s-1.42-.26-1.42-.58c0-.35.62-.61,1.42-.61s1.42.27,1.42.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-664",
    d: "m94.94,95.28c0,.31-.63.54-1.42.54s-1.41-.23-1.41-.54c0-.13-.05-.51.1-.54.13-.06.88,0,1.32,0,.47,0,1.13-.12,1.4,0,.04.1.03.41.03.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-485",
    d: "m94.94,94.87c0,.33-.63.6-1.42.6s-1.41-.27-1.41-.6.63-.59,1.41-.59,1.42.27,1.42.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m95.29,77.83c.51,1.15.62,2.22.29,2.36-.36.16-1.04-.65-1.57-1.79-.5-1.17-.63-2.22-.28-2.38.34-.13,1.03.65,1.55,1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "m96.76,80.3s-.87-1.81-.43-1.84c.45-.03,1.56,1.33,1.56,1.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m96.04,76.67s.94,1.61,1.24.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m100.66,79.11s-.49,3.33.07,3.37c.58.04.94-2.45,1-2.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "m93.16,55.5c.14,1.63-.07,3.01-.45,3.03-.41.04-.85-1.27-.99-2.93-.14-1.65.06-3.02.46-3.05.4-.04.84,1.27.98,2.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-627",
    d: "m92.7,58.54c-.41.04-.85-1.27-.99-2.93-.14-1.65.06-3.02.46-3.05.19,2.75.35,3.78.52,5.98Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "m89.75,57c-.41,1.55-.41,2.88-.02,2.97.38.1,1.03-1.07,1.41-2.61.43-1.56.43-2.91.04-2.99-.39-.09-1.03,1.08-1.43,2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-627",
    d: "m89.73,59.97c.38.1,1.03-1.07,1.41-2.61.43-1.56.43-2.91.04-2.99-.62,2.59-.94,3.55-1.45,5.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "m93.01,60.81c.36,1.62.34,3.01-.04,3.09-.4.1-1.01-1.16-1.38-2.77-.36-1.62-.34-2.99.03-3.08.41-.11,1,1.14,1.39,2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-627",
    d: "m92.98,63.91c-.4.1-1.01-1.16-1.38-2.77-.36-1.62-.34-2.99.03-3.08.58,2.7.86,3.69,1.35,5.84Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "m89.83,62.79c-.17,1.58,0,2.93.39,2.96.42.04.88-1.22,1.06-2.82.18-1.57,0-2.91-.4-2.94-.4-.06-.86,1.2-1.05,2.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-627",
    d: "m90.22,65.75c.42.04.88-1.22,1.06-2.82.18-1.57,0-2.91-.4-2.94-.24,2.63-.43,3.64-.66,5.76Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "m93.69,65.23c.59,1.48.77,2.76.43,2.89-.35.14-1.1-.92-1.69-2.37-.59-1.45-.78-2.74-.44-2.87.36-.14,1.12.91,1.7,2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-627",
    d: "m94.12,68.12c-.35.14-1.1-.92-1.69-2.37-.59-1.45-.78-2.74-.44-2.87.93,2.43,1.36,3.32,2.13,5.24Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "m91.02,67.56c.07,1.5.44,2.71.82,2.69.36-.02.63-1.26.57-2.78-.07-1.5-.44-2.71-.82-2.7-.37.02-.63,1.27-.57,2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-627",
    d: "m91.84,70.25c.36-.02.63-1.26.57-2.78-.07-1.5-.44-2.71-.82-2.7.17,2.5.13,3.46.25,5.47Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "m94.65,70.21c.71,1.4,1.02,2.65.69,2.85-.35.15-1.2-.84-1.91-2.23-.69-1.39-1-2.67-.67-2.83.34-.18,1.17.82,1.89,2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-627",
    d: "m95.35,73.05c-.35.15-1.2-.84-1.91-2.23-.69-1.39-1-2.67-.67-2.83,1.14,2.34,1.64,3.18,2.58,5.06Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "m92.53,73.21c.36,1.47.92,2.6,1.29,2.52.37-.11.39-1.36.05-2.83-.35-1.48-.91-2.61-1.28-2.51-.38.09-.38,1.34-.06,2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-627",
    d: "m93.81,75.73c.37-.11.39-1.36.05-2.83-.35-1.48-.91-2.61-1.28-2.51.62,2.44.76,3.39,1.23,5.34Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "m96.61,74.86c.92,1.25,1.43,2.45,1.13,2.66-.31.23-1.3-.59-2.24-1.86-.93-1.24-1.43-2.45-1.13-2.68.3-.21,1.31.62,2.24,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-627",
    d: "m97.74,77.52c-.31.23-1.3-.59-2.24-1.86-.93-1.24-1.43-2.45-1.13-2.68,1.51,2.13,2.16,2.88,3.37,4.54Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "m95.02,78.18c.56,1.4,1.31,2.41,1.66,2.26.35-.14.16-1.41-.43-2.8-.56-1.41-1.33-2.4-1.66-2.24-.36.15-.17,1.39.43,2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-627",
    d: "m96.69,80.43c.35-.14.16-1.41-.43-2.8-.56-1.41-1.33-2.4-1.66-2.24,1.01,2.29,1.3,3.2,2.09,5.04Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "m97.88,80.61c.88,1.22,1.83,2.05,2.14,1.83.31-.22-.15-1.4-1.02-2.64-.88-1.22-1.84-2.05-2.15-1.82-.29.23.16,1.4,1.03,2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-627",
    d: "m100.02,82.44c.31-.22-.15-1.4-1.02-2.64-.88-1.22-1.84-2.05-2.15-1.82,1.51,2.02,2,2.83,3.18,4.46Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "m89.94,52.77c-.54,1.09-.65,2.09-.28,2.24.37.12,1.1-.62,1.63-1.74.55-1.08.68-2.08.29-2.23-.36-.14-1.1.63-1.64,1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-627",
    d: "m89.66,55.01c.37.12,1.1-.62,1.63-1.74.55-1.08.68-2.08.29-2.23-.83,1.84-1.24,2.5-1.91,3.97Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "m99.71,54.39c-.44-.35-.87-.52-1.44-.62-.18-.04-.44-.08-.63-.04-.25.04-.28.22-.48.33-.37.21-.94.11-1.32.52-.28.33-.38.99-.23,1.41-.66.71-.59,2.17.39,2.56.07.91.66,1.6,1.52,1.87-.05-.08-.06-.18-.1-.28.21.2.45.36.67.54-.03-.21,0-.39.03-.58.12.22.32.48.48.67.07-.21.16-.41.27-.59.16.18.26.43.26.67.12-.2.19-.51.27-.7.11.21.14.45.15.7.18-.26.25-.63.44-.88.05.26.05.63.15.84.2-.26.33-.61.49-.92.11.3.2.59.36.86,0-.35-.06-.74.22-1.01,0,.27.04.51.09.77.32-.14.69-.7.85-1.02.06.27,0,.61.12.86.11-.44.15-.77.43-1.09.05.24.13.53.35.68.03-.28.05-.53.29-.73.12.19.16.41.16.63.19-.18.49-.72.49-.99.18.16.27.44.28.7.19-.33.19-.69.33-1.01.12.22.09.17.2.52.18-.73.94-.73.78-2.27.29-.74-.03-2.11-.84-2.22-.25-1.3-1.24-1.62-2.02-1.4-.74-.13-1.39-.35-1.83.32-.67.05-.9.24-1.22.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m102.94,55.43c.3,0,.6.08.86.23.27.16.49.36.68.62.34.51.44,1.12.43,1.72-.04-.29-.08-.59-.16-.87-.09-.28-.2-.54-.37-.79-.15-.24-.36-.45-.62-.6-.24-.17-.52-.29-.82-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m102.7,55.65c.29,0,.59.08.85.22.28.15.5.36.68.62.32.53.45,1.12.45,1.72-.04-.29-.09-.6-.18-.86-.09-.29-.2-.57-.36-.8-.16-.24-.37-.46-.61-.62-.26-.14-.52-.24-.82-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m102.45,55.87c.3,0,.6.07.86.23.26.14.49.37.66.6.34.53.46,1.15.44,1.73-.03-.28-.08-.59-.17-.85-.08-.3-.19-.55-.35-.81-.16-.24-.37-.44-.63-.6-.24-.16-.52-.27-.81-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m102.19,56.09c.31-.02.6.09.88.23.27.13.48.37.66.62.33.51.45,1.12.43,1.72-.03-.3-.08-.59-.17-.86-.07-.29-.2-.56-.35-.8-.16-.25-.38-.44-.62-.61-.23-.15-.52-.27-.83-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m102.18,56.18c.28.03.58.16.81.36.24.17.44.44.55.7.25.56.28,1.19.17,1.78,0-.29,0-.59-.04-.86-.04-.3-.11-.59-.22-.87-.12-.25-.28-.51-.51-.69-.21-.2-.48-.35-.76-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m102.01,56.3c.29.08.53.25.75.44.2.2.38.47.5.75.1.28.17.57.19.86,0,.3,0,.59-.06.89.02-.59,0-1.18-.24-1.72-.1-.27-.25-.5-.45-.71-.18-.22-.42-.41-.68-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m101.73,56.3c.28.09.52.27.72.48.19.21.36.46.48.75.11.27.18.55.2.84.02.29,0,.6-.05.88.03-.59-.04-1.16-.27-1.67-.1-.28-.24-.52-.43-.72-.2-.24-.4-.41-.66-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m101.46,56.3c.27.11.5.29.69.52.2.21.36.44.48.71.24.54.3,1.14.18,1.72.03-.3,0-.59-.03-.85-.06-.29-.13-.57-.25-.81-.1-.26-.26-.5-.45-.71-.18-.21-.37-.42-.62-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m101.33,56.24c.22.17.4.37.57.63.17.21.29.48.41.73.1.29.15.57.19.84.03.3,0,.58-.05.85.02-.54-.04-1.11-.25-1.64-.09-.24-.21-.48-.36-.72-.14-.24-.32-.46-.5-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m101.05,56.36c.23.18.41.37.57.61.18.22.29.48.42.75.09.28.15.54.18.83.03.29,0,.57-.04.84.04-.55-.04-1.12-.25-1.64-.08-.25-.21-.51-.36-.72-.15-.26-.32-.47-.51-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m100.97,56.6c.2.19.38.44.52.68.12.26.22.52.28.81.07.28.12.55.1.86,0,.28-.03.57-.1.84.04-.57.04-1.12-.1-1.68-.05-.25-.17-.52-.27-.77-.12-.27-.27-.5-.44-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m100.64,56.62c.19.22.35.46.5.71.13.26.22.52.28.8.07.27.12.57.12.84s-.04.58-.12.83c.05-.54.05-1.1-.08-1.65-.06-.29-.15-.55-.29-.78-.12-.27-.25-.51-.41-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m100.38,56.66c.18.2.33.45.44.71.12.25.21.53.25.81.11.57.07,1.17-.11,1.7.04-.29.07-.55.07-.85,0-.28-.02-.55-.06-.83-.04-.28-.13-.53-.22-.81-.1-.25-.23-.52-.37-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m103.13,55.2c.3-.02.61.07.86.22.27.14.49.36.66.62.34.52.46,1.13.45,1.73-.04-.28-.08-.59-.17-.87-.09-.28-.2-.56-.36-.8-.15-.23-.37-.44-.6-.59-.25-.18-.53-.29-.83-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m100.42,57.05c.09.45.15.9.21,1.37.03.45.07.92.09,1.36-.09-.44-.16-.9-.21-1.35-.04-.47-.09-.92-.09-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m100.25,56.94c-.08.54-.09,1.06-.08,1.59,0,.53.03,1.06.04,1.59-.04-.25-.08-.52-.11-.79-.03-.27-.05-.54-.05-.8,0-.28,0-.53.05-.82.03-.27.07-.52.15-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m99.98,56.87c-.1.52-.12,1.06-.12,1.58,0,.55.02,1.08.02,1.61-.06-.27-.08-.52-.11-.79,0-.27-.03-.53-.03-.82,0-.25.02-.52.05-.78.04-.28.09-.54.19-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m99.72,56.86c-.12.52-.2,1.04-.24,1.57-.04.53-.09,1.07-.12,1.6-.03-.28-.03-.53-.03-.82,0-.26,0-.52.03-.79.03-.26.07-.53.12-.81.05-.25.13-.52.23-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m99.47,56.88c-.13.52-.2,1.05-.25,1.56-.05.54-.07,1.08-.12,1.61-.03-.27-.03-.53-.03-.8s.02-.54.03-.82c.03-.26.07-.52.12-.8.05-.24.13-.51.25-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m99.22,56.92c-.15.5-.22,1.03-.25,1.57-.06.52-.08,1.06-.12,1.59-.03-.28-.04-.53-.04-.8s0-.54.04-.8c.02-.27.06-.54.12-.8.05-.27.12-.52.25-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m98.95,56.94c-.09.25-.17.51-.22.77-.06.25-.1.53-.13.8-.05.52-.04,1.06,0,1.59-.06-.26-.11-.53-.13-.81-.02-.26,0-.53,0-.8.06-.55.21-1.09.48-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m98.71,56.95c-.24.46-.35.98-.43,1.48-.06.51-.07,1.02-.06,1.56-.04-.27-.08-.52-.08-.79,0-.26,0-.52.04-.77.07-.52.22-1.03.53-1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m98.59,56.7c-.29.53-.49,1.11-.64,1.69-.07.28-.12.58-.18.89-.05.29-.09.6-.12.9,0-.3.03-.61.04-.91.04-.31.09-.61.17-.91.07-.29.15-.59.29-.86.12-.28.27-.56.45-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m98.49,56.48c-.19.25-.36.51-.52.77-.15.27-.29.55-.39.85-.11.28-.18.59-.21.9-.04.3-.05.61-.04.93-.06-.3-.07-.63-.04-.94.03-.31.09-.61.19-.91.21-.61.56-1.15,1.01-1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m98.26,56.34c-.2.22-.37.44-.54.69-.16.23-.29.47-.4.74-.12.27-.21.53-.26.81-.05.29-.05.59-.09.87-.03-.29-.03-.58,0-.88.03-.3.12-.57.22-.85.25-.52.62-1.01,1.06-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m98.4,55.97c-.21.2-.44.38-.64.59-.2.2-.39.43-.56.66-.15.23-.28.5-.37.76-.12.28-.17.56-.27.82.05-.27.1-.55.18-.85.09-.28.2-.55.37-.79.35-.5.79-.89,1.29-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m98.37,55.83c-.23.17-.48.33-.69.52-.21.18-.43.37-.6.6-.18.24-.33.46-.44.74-.13.26-.2.53-.33.82.06-.29.15-.58.26-.84.11-.29.25-.54.44-.77.37-.48.85-.83,1.37-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m98.35,55.65c-.26.12-.5.28-.72.46-.24.19-.47.38-.65.59-.19.21-.36.45-.49.69-.13.24-.24.53-.36.78.08-.28.17-.56.29-.81.12-.29.29-.52.47-.76.41-.42.92-.75,1.46-.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m98.53,55.52c-.29.12-.55.23-.81.37-.24.13-.48.3-.71.48-.21.17-.41.36-.59.62-.17.2-.33.46-.48.7.12-.28.24-.52.41-.77.17-.24.36-.46.6-.65.46-.36,1.01-.61,1.58-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m98.36,55.4c-.27.12-.53.21-.79.36-.25.13-.5.29-.72.48-.22.18-.41.38-.59.62-.19.22-.32.47-.49.72.12-.28.26-.52.41-.78.17-.23.38-.45.61-.67.45-.36,1-.6,1.57-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m98.21,55.27c-.27.11-.53.24-.8.37-.25.12-.49.28-.72.45-.21.19-.42.4-.58.63-.18.21-.31.46-.49.69.12-.24.24-.51.41-.75.17-.26.37-.47.6-.66.47-.36,1.01-.62,1.58-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m98.04,55.13c-.27.12-.53.25-.79.38-.24.14-.49.27-.71.46-.23.18-.42.4-.6.62-.17.23-.32.48-.48.72.12-.27.25-.53.42-.77.16-.25.37-.46.6-.67.45-.37,1-.6,1.57-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m97.88,55.02c-.25.1-.52.22-.77.36-.26.13-.5.29-.73.47-.21.2-.41.39-.58.61-.19.24-.34.48-.5.73.13-.27.25-.53.42-.78.17-.22.36-.44.59-.65.48-.36,1.02-.6,1.57-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m98.05,54.8c-.27.08-.52.13-.77.23-.24.09-.48.19-.71.35-.21.13-.41.32-.6.5-.17.2-.34.41-.52.62.14-.23.27-.45.44-.67.18-.22.37-.4.62-.54.46-.3,1-.44,1.53-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m98.32,54.66c-.26,0-.49,0-.73.06-.25.04-.49.1-.72.19-.24.09-.44.21-.63.36-.2.16-.37.34-.55.49.15-.2.3-.38.5-.54.18-.19.42-.31.65-.42.47-.19,1-.21,1.49-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m98.46,54.59c-.24-.03-.48-.04-.69-.03-.24,0-.46.02-.69.08-.22.04-.42.13-.62.26-.19.12-.37.28-.56.41.15-.19.33-.33.52-.47.2-.15.43-.25.65-.3.46-.13.95-.09,1.41.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m98.46,54.5c-.21-.05-.45-.1-.68-.11-.22-.04-.44-.04-.67,0-.22.02-.44.1-.64.18-.21.1-.4.23-.6.34.16-.15.34-.31.56-.4.19-.13.43-.2.67-.23.46-.05.93.05,1.35.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m98.49,54.42c-.23-.07-.44-.19-.64-.27-.12-.05-.22-.06-.33-.09-.12-.02-.22,0-.36,0,.23-.11.52-.11.72-.02.12.05.22.11.33.17.1.06.19.13.29.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m98.4,54.22c-.17-.07-.3-.18-.44-.27-.07-.04-.12-.08-.21-.1-.06-.04-.15-.04-.24-.04.07-.04.18-.06.27-.05.09,0,.18.05.24.1.15.09.28.22.39.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m103.11,55.02c.28-.03.58,0,.85.11.27.12.52.27.72.48.2.22.34.46.43.75.1.26.13.56.13.84-.04-.28-.11-.58-.22-.81-.09-.27-.24-.5-.42-.68-.19-.2-.44-.37-.68-.48-.26-.11-.53-.19-.81-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m102.81,54.88c.27-.08.57-.12.85-.08.28.04.57.12.82.28.25.14.44.36.6.6.15.25.28.52.33.78-.11-.25-.23-.52-.39-.74-.18-.2-.37-.41-.6-.54-.22-.15-.49-.25-.76-.29-.27-.05-.56-.05-.84,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m102.67,54.84c.23-.15.52-.25.8-.28.28-.03.58,0,.85.1.27.1.52.25.73.45.19.2.36.43.5.67-.16-.21-.36-.43-.55-.6-.21-.19-.45-.34-.71-.42-.27-.09-.54-.12-.81-.1-.28,0-.55.06-.81.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m102.67,54.54c.14-.1.31-.15.49-.21.17-.05.36-.07.52-.07.37,0,.74.13,1.01.34-.16-.06-.32-.12-.48-.18-.2-.03-.36-.05-.53-.05-.35,0-.69.05-1.01.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m102.67,54.4c.12-.12.27-.19.41-.27.16-.05.32-.09.49-.12.32-.05.67.02.97.17-.17-.04-.32-.08-.49-.08-.16,0-.31,0-.48.02-.31.05-.61.15-.9.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m102.52,54.23c.12-.13.23-.2.38-.29.14-.08.3-.16.47-.2.31-.09.65-.08.95.04-.14-.02-.31-.02-.46-.02-.16,0-.31.04-.47.09-.31.09-.59.21-.87.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m102.44,54.08c.1-.13.23-.23.36-.32.13-.11.28-.18.44-.22.3-.12.67-.12.97,0-.16-.03-.33-.03-.48,0-.14,0-.3.04-.45.11-.3.09-.58.25-.84.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m102.14,54.22c.08-.16.18-.29.28-.4.12-.13.24-.24.38-.32.28-.18.62-.29.94-.26-.17.04-.31.08-.46.13-.14.06-.28.12-.42.21-.28.17-.5.39-.72.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m101.99,54.33c0-.12.02-.27.08-.42.02-.11.11-.24.19-.36.1-.12.2-.2.31-.29.12-.06.24-.12.37-.16-.23.14-.44.31-.59.52-.17.2-.29.44-.37.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m101.85,54.32c-.04-.11-.04-.23-.04-.36,0-.1.04-.21.06-.33.08-.21.21-.42.44-.52-.06.1-.13.17-.19.27-.05.1-.12.2-.13.3-.08.2-.11.42-.14.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m101.61,54.09c-.03-.09-.04-.18-.04-.27s.02-.18.04-.28c.05-.18.16-.35.31-.44-.04.08-.09.14-.12.23-.03.08-.05.17-.07.25-.04.15-.06.33-.11.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m101.46,53.74c-.05-.1-.06-.21-.04-.36.04-.11.09-.23.2-.29-.04.12-.07.22-.09.31-.03.12-.04.23-.07.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m99.1,57.41c-.05.07-.2.59-.07.68.18.12.24-.27.31-.37,0,.18-.04.5.11.61.07-.16.04-.38.16-.51,0,.15.03.28.03.43.07-.12.06-.32.13-.45.04.12.08.25.15.36.09-.12.06-.33.12-.47.05.14.05.31.09.47,0-.11.03-.22.05-.29.05.2,0,.51.15.65.09-.14.09-.34.11-.51.07.12.12.28.2.43.02-.1,0-.28.02-.43.04.1.07.25.16.33,0-.15,0-.27,0-.4.04.11.24.56.38.49.18-.12,0-.56-.09-.67.11.19.27.35.41.52-.03-.14-.04-.29-.06-.42.07.1.12.21.2.32.05-.13.02-.32-.02-.46.03.12.11.22.2.29-.04-.14-.07-.29-.12-.43.06.12.17.25.31.25.02-.2.07-.5-.06-.63.15.13.27.34.45.41-.09-.25-.26-.54-.44-.76.24.2.44.4.63.61-.02-.12-.06-.29-.05-.42.1.1.23.23.37.29,0-.2-.12-.38-.23-.55.09.11.23.21.38.22-.07-.18-.27-.38-.41-.52.26.25.58.47.82.76-.04-.19-.08-.36-.12-.53.08.06.2.24.29.35.02-.13-.04-.28-.12-.37.12.12.26.33.42.32.03-.14-.04-.3-.12-.41.05.11.15.18.27.19.03-.16,0-.29-.05-.44.12.07.21.14.33.14-.06-.25-.21-.51-.39-.7.04.13.18.19.31.24.1-.19-.04-.6-.25-.67.29.36.69.41.88.88.1.23.28.65.27.87,0-.23-.1-.49-.3-.65,0,.14,0,.28.04.42-.06-.21-.25-.42-.37-.63-.04.14.04.29.08.42,0-.1-.04-.19-.12-.27,0,.34.15.61.14.93,0-.17-.09-.34-.14-.49-.12.08-.05.31,0,.43-.04-.13-.09-.39-.26-.44-.05.12,0,.31.04.44,0-.07-.04-.18-.07-.23-.02.16-.02.32-.02.46,0-.12-.05-.26-.11-.39-.16.03-.12.22-.08.32-.03-.1-.08-.2-.13-.28,0,.15,0,.34,0,.48-.07-.12-.12-.33-.27-.38-.07.21-.03.44.04.65-.04-.08-.17-.5-.3-.44-.12.04-.04.35,0,.44-.04-.18-.12-.53-.34-.57,0,.1,0,.25.03.36-.04-.14-.12-.28-.22-.35-.15.2-.04.62.05.85-.04-.24-.2-.54-.37-.68-.03.23.04.55.14.78-.09-.14-.17-.33-.31-.41,0,.29.03.53.08.82-.09-.22-.2-.47-.34-.64-.04.12-.03.29-.04.4-.08-.1-.14-.26-.21-.36-.14.26-.13.6-.28.86,0-.21.02-.41.03-.6-.14.2-.15.56-.2.79,0-.2.04-.44-.02-.64-.16.1-.18.42-.25.6,0-.2-.04-.42-.07-.64-.2.1-.2.6-.29.81,0-.21.04-.42.02-.63-.14.13-.13.41-.19.6,0-.24,0-.47,0-.7-.07.15-.09.37-.21.5-.03-.21,0-.43-.05-.61-.09.19-.13.4-.2.61v-.47c-.12.04-.18.36-.25.52-.08-.21-.09-.52-.21-.69-.1.14-.11.31-.15.48-.04-.18-.04-.4-.04-.58-.12.19-.2.44-.29.65.03-.2,0-.47-.09-.65-.15.06-.22.39-.27.57,0-.21.04-.44.07-.63-.17.04-.25.32-.29.47,0-.24.04-.46.06-.7v.2c0-.23.07-.47.29-.6"
  }), /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 9,
    transform: "translate(91.87 48)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAJCAYAAADkZNYtAAAACXBIWXMAAAsSAAALEgHS3X78AAABEUlEQVQYlXWQuUoDURRAz/O9SRyGGE0IRBNwKwQ/QcHCSlFEEf/BQhSs/ATB1koQP8BCQa3srMXKNYU7iCGiJhmHZJYnMxaOEE91i8O9hytu1he0YaZwnRpCKhJWGqswiP1wTd/ytiBGWzgGvovWGmUk+ai8QuDR+KoSLorLylUmxdEZvCDgYGuDfDbL1dE+zabLxORU3CU6c7w6ri8fX0ib7RRzXZyWnujOpCLZLj8zsLITeX+aQg6XxnTCkOQzneQK/Ti1d1ynztDaroia40xvngglJZ7vc39XQgiBmc7+ZrRib3FEl6s287NzvN1eII3kzzdaIgSVqkPp/IyE1QFo1H/ucG8PUhoo7dOofwLwDbzPWhigLzVYAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m94.05,48.67c.36-.02.82-.29,1.16-.27.33.05.48.33.84.2.17-.04.26-.14.43-.2.15-.03.28.06.4.06.23,0,.68-.09.85-.21.65-.45-.07-1.2-.67-1.12-.38.03-.69.17-1.03.28-.3.12-.63.05-.96.04-.07-.31-.41-.32-.68-.29-.35.03-.5.29-.78.38-.22.08-.54-.07-.8-.06-.29,0-.56.06-.83.19-.7.34-.77,1.15.02,1.48.29.11.59.1.87,0,.26-.09.52-.31.74-.35.2,0,.28-.11.45-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m100.48,56.94c.35-.41.79-.74,1.28-.94.49-.22,1.03-.33,1.56-.35-.52.17-1.01.28-1.5.47-.48.21-.92.49-1.33.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m98.85,56.86c.24-.19.58-.31.9-.31s.64.12.86.37c-.13-.08-.28-.15-.42-.19-.16-.04-.29-.07-.44-.07-.14,0-.3.02-.45.04-.14.04-.29.09-.44.16Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-383",
    d: "m96.25,49.2c-.07.22-.27.41-.59.41s-.46-.2-.59-.41c-.16-.26-.04-.3.53-.55.57-.27.84.03.64.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-437",
    d: "m96.25,49.2c-.04.14-.13.28-.28.35-.14.09-.3.11-.45.06-.16-.02-.29-.13-.38-.27-.05-.06-.1-.12-.12-.19-.04-.04-.06-.09-.04-.13,0-.04.04-.09.05-.12.12-.1.28-.15.41-.22.16-.04.29-.12.44-.13.09,0,.16,0,.23.03.08.04.13.1.17.18.05.14,0,.3-.04.45Zm0,0c.04-.15.09-.31.04-.45-.07-.16-.25-.2-.39-.18-.14.02-.28.1-.42.17-.13.06-.28.12-.4.2-.05.06-.05.12-.04.2.04.06.09.12.13.19.08.12.2.23.35.27.15.04.31.02.45-.04.14-.07.23-.2.28-.35Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "m94.95,49.15c.04.09.09.18.16.25.06.09.14.14.2.19.18.11.38.12.57.1-.09.04-.19.04-.29.04-.1,0-.2-.04-.29-.08-.18-.12-.3-.31-.35-.5Z"
  }), /*#__PURE__*/React.createElement("image", {
    width: 4,
    height: 2,
    transform: "translate(89.87 50)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAACCAYAAAB/qH1jAAAACXBIWXMAAAsSAAALEgHS3X78AAAAKUlEQVQImWN82R32//+/fwx/GBgZWBkZGJgY/v9nAIE5N5gZ/v//zwAA9XQNPREPUQEAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    width: 4,
    height: 4,
    transform: "translate(89.87 49)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAACXBIWXMAAAsSAAALEgHS3X78AAAARUlEQVQImWN82RX6n4GBgaHu8CeGCDVWBiYQRyipn+H3n38MWuKcDEyfnQoYbO18GCRYfjCsu/yOgWF6QTxYCxgwMDAAALnDEhk7CU21AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "m93.41,51.48c0-.13,0-.27.02-.4v-.39c.09.12.12.27.1.4,0,.14-.05.29-.12.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "m92.56,49.05c.18-.03.36.05.51.16.14.12.25.28.3.44.06.17.1.35.11.52,0,.18,0,.35-.04.52-.02-.34-.04-.69-.15-1.01-.07-.17-.14-.3-.27-.43-.12-.11-.28-.19-.45-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "m95.98,49.05c0,.18-.14.32-.34.32-.16,0-.29-.14-.29-.32s.13-.31.29-.31c.2,0,.34.14.34.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "m95.93,49.06c0,.17-.13.3-.3.3s-.28-.13-.28-.3.11-.3.28-.3.3.13.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-732",
    d: "m95.91,48.93s-.07.07-.14.07-.14-.03-.14-.07.07-.06.14-.06.14.02.14.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-820",
    d: "m95.35,49.15c.09.07.18.11.25.14.07.03.16,0,.25-.04,0,.07-.04.09-.1.12-.04.03-.12.03-.18.03-.07-.02-.12-.06-.16-.08-.04-.07-.05-.12-.06-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-364",
    d: "m94.7,49.15c.11-.12.22-.22.34-.3.12-.1.24-.18.4-.27.15-.04.31-.1.46-.09.18.03.35.09.41.24-.12-.06-.27-.07-.41-.06-.12.03-.26.07-.37.12-.12.05-.26.13-.39.2-.14.06-.28.11-.44.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-654",
    d: "m93.09,49.07c.12.08.2.19.29.31.06.12.1.27.13.39.06.28.07.55.03.83,0-.28,0-.55-.07-.82-.04-.12-.08-.27-.13-.38-.06-.11-.15-.24-.24-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "m93.43,55.73c.68,1.49,1.52,2.53,1.89,2.39.37-.17.12-1.51-.58-2.96-.66-1.49-1.5-2.57-1.89-2.42-.36.17-.09,1.51.58,2.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-627",
    d: "m95.32,58.13c.37-.17.12-1.51-.58-2.96-.66-1.49-1.5-2.57-1.89-2.42,1.17,2.46,1.53,3.43,2.46,5.38Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "m97.14,55.4c1.1,1.15,1.77,2.29,1.49,2.55-.3.27-1.43-.44-2.55-1.57-1.08-1.16-1.75-2.28-1.45-2.55.29-.27,1.41.44,2.52,1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-627",
    d: "m98.63,57.95c-.3.27-1.43-.44-2.55-1.57-1.08-1.16-1.75-2.28-1.45-2.55,1.8,1.93,2.53,2.59,4,4.13Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "m96.16,60.23c.45,1.56,1.14,2.72,1.52,2.62.37-.1.32-1.45-.14-3.01-.47-1.57-1.15-2.74-1.54-2.62-.37.11-.3,1.45.16,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-627",
    d: "m97.68,62.85c.37-.1.32-1.45-.14-3.01-.47-1.57-1.15-2.74-1.54-2.62.83,2.57,1.05,3.56,1.68,5.63Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "m99.88,60.41c.94,1.26,1.43,2.5,1.09,2.72-.32.23-1.34-.62-2.29-1.91-.92-1.27-1.41-2.48-1.09-2.71.33-.24,1.35.61,2.29,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-627",
    d: "m100.97,63.13c-.32.23-1.34-.62-2.29-1.91-.92-1.27-1.41-2.48-1.09-2.71,1.5,2.16,2.16,2.92,3.38,4.62Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "m97.72,64.35c.19,1.53.65,2.71,1.01,2.69.38-.07.53-1.33.34-2.85-.2-1.52-.66-2.74-1.03-2.67-.37.03-.52,1.31-.32,2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-627",
    d: "m98.73,67.04c.38-.07.53-1.33.34-2.85-.2-1.52-.66-2.74-1.03-2.67.37,2.52.42,3.5.69,5.51Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "m101.15,65.07c.69,1.32.95,2.53.62,2.69-.36.16-1.17-.79-1.85-2.11-.68-1.33-.94-2.54-.61-2.7.35-.17,1.17.78,1.84,2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-627",
    d: "m101.78,67.76c-.36.16-1.17-.79-1.85-2.11-.68-1.33-.94-2.54-.61-2.7,1.08,2.24,1.57,3.02,2.46,4.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "m99.28,69.07c.06,1.53.42,2.75.79,2.75.37-.04.63-1.26.58-2.82-.05-1.52-.41-2.75-.77-2.74-.39.03-.65,1.28-.6,2.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-627",
    d: "m100.07,71.82c.37-.04.63-1.26.58-2.82-.05-1.52-.41-2.75-.77-2.74.13,2.55.1,3.52.2,5.56Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "m102.59,70.63c.43,1.43.47,2.65.11,2.75-.37.1-.99-.96-1.41-2.39-.43-1.42-.46-2.67-.11-2.76.36-.11,1,.98,1.41,2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-627",
    d: "m102.7,73.38c-.37.1-.99-.96-1.41-2.39-.43-1.42-.46-2.67-.11-2.76.64,2.38.98,3.26,1.52,5.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "m99.85,73.97c-.21,1.52-.06,2.79.31,2.83.36.05.83-1.14,1.04-2.65.2-1.52.07-2.79-.32-2.84-.37-.06-.84,1.14-1.03,2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-627",
    d: "m100.16,76.8c.36.05.83-1.14,1.04-2.65.2-1.52.07-2.79-.32-2.84-.28,2.53-.49,3.48-.72,5.49Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "m102.85,76.07c.17,1.45,0,2.7-.36,2.73-.41.04-.83-1.13-1-2.6-.18-1.47-.02-2.7.36-2.74.36-.04.83,1.13,1,2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-627",
    d: "m102.5,78.8c-.41.04-.83-1.13-1-2.6-.18-1.47-.02-2.7.36-2.74.23,2.47.43,3.37.64,5.34Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "m101.53,79.54c-.18,1.46-.62,2.61-.99,2.56-.38-.03-.56-1.27-.38-2.75.17-1.47.6-2.61.98-2.57.39.04.54,1.27.39,2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-627",
    d: "m100.55,82.1c-.38-.03-.56-1.27-.38-2.75.17-1.47.6-2.61.98-2.57-.32,2.44-.37,3.37-.6,5.32Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "m94.92,51.87c1,.68,1.61,1.49,1.33,1.78-.26.29-1.26,0-2.26-.7-1-.68-1.61-1.47-1.34-1.77.25-.31,1.27.02,2.27.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-627",
    d: "m96.25,53.65c-.26.29-1.26,0-2.26-.7-1-.68-1.61-1.47-1.34-1.77,1.63,1.17,2.3,1.55,3.6,2.47Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-369",
    d: "m20.36,160.48C7.04,142.97,0,122.06,0,100c0-4.5.3-9.02.9-13.44l1.16.16c-.59,4.37-.89,8.84-.89,13.29,0,21.8,6.96,42.47,20.12,59.77l-.94.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-369",
    d: "m179.64,160.48l-.94-.71c13.16-17.3,20.12-37.97,20.12-59.77,0-4.03-.25-8.08-.73-12.05l1.17-.14c.49,4.02.74,8.12.74,12.2,0,22.06-7.04,42.97-20.36,60.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-729",
    d: "m100,200c-15.89,0-31.08-3.62-45.16-10.75-13.42-6.8-25.35-16.75-34.48-28.76l.94-.71c18.88,24.82,47.56,39.05,78.71,39.05s59.83-14.23,78.71-39.05l.94.71c-9.14,12.01-21.06,21.96-34.48,28.76-14.07,7.14-29.27,10.75-45.16,10.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-574",
    d: "m198.1,87.95C192.08,38.48,149.91,1.18,100,1.18S8.61,37.95,2.06,86.71l-1.16-.16c3.2-23.78,14.92-45.66,33.01-61.6C52.17,8.86,75.64,0,100,0c50.5,0,93.18,37.75,99.26,87.8l-1.17.14Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-725",
    x: 91.46,
    y: 173.31,
    width: 5.69,
    height: 4.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-369",
    x: 97.15,
    y: 173.31,
    width: 5.69,
    height: 4.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-551",
    x: 102.85,
    y: 173.31,
    width: 5.69,
    height: 4.35
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMinciencias);
export default __webpack_public_path__ + "static/media/icon-minciencias.750cbec9169b8142d5cd5888058fc95f.svg";
export { ForwardRef as ReactComponent };